import { ApiModule, NotificationModule, UberSearch, CustomModal, AlertViewer, StyleMixin, AddressResource, WebAccountResource, StateManager, StateWrapper, SubscriptionsManager, EventsManager, LoginForm, RegistrationWizard } from 'spiritweb.packages.web-account';
import { debounce, cloneDeep, isEqual as isEqual$1 } from 'lodash';
import VSelect from 'vue-select';
import axios from 'axios';
import Uri from 'urijs';
import { Vue } from '@sentry/integrations';
import { Integrations } from '@sentry/tracing';
import { init, setContext, Severity, addBreadcrumb as addBreadcrumb$1 } from '@sentry/browser';

var _isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject = function (it) {
  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var _descriptors = !_fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

var _global = createCommonjsModule(function (module) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var document$1 = _global.document;
// typeof document.createElement is 'object' in old IE
var is = _isObject(document$1) && _isObject(document$1.createElement);
var _domCreate = function (it) {
  return is ? document$1.createElement(it) : {};
};

var _ie8DomDefine = !_descriptors && !_fails(function () {
  return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
});

// 7.1.1 ToPrimitive(input [, PreferredType])

// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var _toPrimitive = function (it, S) {
  if (!_isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP = Object.defineProperty;

var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject(O);
  P = _toPrimitive(P, true);
  _anObject(Attributes);
  if (_ie8DomDefine) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var _objectDp = {
	f: f
};

var dP$1 = _objectDp.f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || _descriptors && dP$1(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});

var _core = createCommonjsModule(function (module) {
var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});
var _core_1 = _core.version;

var _propertyDesc = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide = _descriptors ? function (object, key, value) {
  return _objectDp.f(object, key, _propertyDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty = {}.hasOwnProperty;
var _has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var id = 0;
var px = Math.random();
var _uid = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

var _shared = createCommonjsModule(function (module) {
var SHARED = '__core-js_shared__';
var store = _global[SHARED] || (_global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: _core.version,
  mode:  'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});
});

var _functionToString = _shared('native-function-to-string', Function.toString);

var _redefine = createCommonjsModule(function (module) {
var SRC = _uid('src');

var TO_STRING = 'toString';
var TPL = ('' + _functionToString).split(TO_STRING);

_core.inspectSource = function (it) {
  return _functionToString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) _has(val, 'name') || _hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) _has(val, SRC) || _hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === _global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    _hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    _hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || _functionToString.call(this);
});
});

var _aFunction = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

// optional / simple context binding

var _ctx = function (fn, that, length) {
  _aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] || (_global[name] = {}) : (_global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? _ctx(out, _global) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
    // extend global
    if (target) _redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) _hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
_global.core = _core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
var _export = $export;

var toString$1 = {}.toString;

var _cof = function (it) {
  return toString$1.call(it).slice(8, -1);
};

// fallback for non-array-like ES3 and non-enumerable old V8 strings

// eslint-disable-next-line no-prototype-builtins
var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof(it) == 'String' ? it.split('') : Object(it);
};

// 7.2.1 RequireObjectCoercible(argument)
var _defined = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

// to indexed object, toObject with fallback for non-array-like ES3 strings


var _toIobject = function (it) {
  return _iobject(_defined(it));
};

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
var _toInteger = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

// 7.1.15 ToLength

var min = Math.min;
var _toLength = function (it) {
  return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;
var _toAbsoluteIndex = function (index, length) {
  index = _toInteger(index);
  return index < 0 ? max(index + length, 0) : min$1(index, length);
};

// false -> Array#indexOf
// true  -> Array#includes



var _arrayIncludes = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = _toIobject($this);
    var length = _toLength(O.length);
    var index = _toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var shared = _shared('keys');

var _sharedKey = function (key) {
  return shared[key] || (shared[key] = _uid(key));
};

var arrayIndexOf = _arrayIncludes(false);
var IE_PROTO = _sharedKey('IE_PROTO');

var _objectKeysInternal = function (object, names) {
  var O = _toIobject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) _has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (_has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

// IE 8- don't enum bug keys
var _enumBugKeys = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)

var hiddenKeys = _enumBugKeys.concat('length', 'prototype');

var f$1 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return _objectKeysInternal(O, hiddenKeys);
};

var _objectGopn = {
	f: f$1
};

var f$2 = Object.getOwnPropertySymbols;

var _objectGops = {
	f: f$2
};

// all object keys, includes non-enumerable and symbols



var Reflect$1 = _global.Reflect;
var _ownKeys = Reflect$1 && Reflect$1.ownKeys || function ownKeys(it) {
  var keys = _objectGopn.f(_anObject(it));
  var getSymbols = _objectGops.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

var f$3 = {}.propertyIsEnumerable;

var _objectPie = {
	f: f$3
};

var gOPD = Object.getOwnPropertyDescriptor;

var f$4 = _descriptors ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = _toIobject(O);
  P = _toPrimitive(P, true);
  if (_ie8DomDefine) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (_has(O, P)) return _propertyDesc(!_objectPie.f.call(O, P), O[P]);
};

var _objectGopd = {
	f: f$4
};

var _createProperty = function (object, index, value) {
  if (index in object) _objectDp.f(object, index, _propertyDesc(0, value));
  else object[index] = value;
};

// https://github.com/tc39/proposal-object-getownpropertydescriptors






_export(_export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = _toIobject(object);
    var getDesc = _objectGopd.f;
    var keys = _ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) _createProperty(result, key, desc);
    }
    return result;
  }
});

// 7.1.13 ToObject(argument)

var _toObject = function (it) {
  return Object(_defined(it));
};

// 19.1.2.14 / 15.2.3.14 Object.keys(O)



var _objectKeys = Object.keys || function keys(O) {
  return _objectKeysInternal(O, _enumBugKeys);
};

// most Object methods by ES6 should accept primitives



var _objectSap = function (KEY, exec) {
  var fn = (_core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  _export(_export.S + _export.F * _fails(function () { fn(1); }), 'Object', exp);
};

// 19.1.2.14 Object.keys(O)



_objectSap('keys', function () {
  return function keys(it) {
    return _objectKeys(_toObject(it));
  };
});

var _global$1 = createCommonjsModule(function (module) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var _core$1 = createCommonjsModule(function (module) {
var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});
var _core_1$1 = _core$1.version;

var _aFunction$1 = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

// optional / simple context binding

var _ctx$1 = function (fn, that, length) {
  _aFunction$1(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var _isObject$1 = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject$1 = function (it) {
  if (!_isObject$1(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails$1 = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var _descriptors$1 = !_fails$1(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

var document$2 = _global$1.document;
// typeof document.createElement is 'object' in old IE
var is$1 = _isObject$1(document$2) && _isObject$1(document$2.createElement);
var _domCreate$1 = function (it) {
  return is$1 ? document$2.createElement(it) : {};
};

var _ie8DomDefine$1 = !_descriptors$1 && !_fails$1(function () {
  return Object.defineProperty(_domCreate$1('div'), 'a', { get: function () { return 7; } }).a != 7;
});

// 7.1.1 ToPrimitive(input [, PreferredType])

// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var _toPrimitive$1 = function (it, S) {
  if (!_isObject$1(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject$1(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject$1(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject$1(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP$2 = Object.defineProperty;

var f$5 = _descriptors$1 ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject$1(O);
  P = _toPrimitive$1(P, true);
  _anObject$1(Attributes);
  if (_ie8DomDefine$1) try {
    return dP$2(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var _objectDp$1 = {
	f: f$5
};

var _propertyDesc$1 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide$1 = _descriptors$1 ? function (object, key, value) {
  return _objectDp$1.f(object, key, _propertyDesc$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty$1 = {}.hasOwnProperty;
var _has$1 = function (it, key) {
  return hasOwnProperty$1.call(it, key);
};

var PROTOTYPE$1 = 'prototype';

var $export$1 = function (type, name, source) {
  var IS_FORCED = type & $export$1.F;
  var IS_GLOBAL = type & $export$1.G;
  var IS_STATIC = type & $export$1.S;
  var IS_PROTO = type & $export$1.P;
  var IS_BIND = type & $export$1.B;
  var IS_WRAP = type & $export$1.W;
  var exports = IS_GLOBAL ? _core$1 : _core$1[name] || (_core$1[name] = {});
  var expProto = exports[PROTOTYPE$1];
  var target = IS_GLOBAL ? _global$1 : IS_STATIC ? _global$1[name] : (_global$1[name] || {})[PROTOTYPE$1];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && _has$1(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? _ctx$1(out, _global$1)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE$1] = C[PROTOTYPE$1];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? _ctx$1(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export$1.R && expProto && !expProto[key]) _hide$1(expProto, key, out);
    }
  }
};
// type bitmap
$export$1.F = 1;   // forced
$export$1.G = 2;   // global
$export$1.S = 4;   // static
$export$1.P = 8;   // proto
$export$1.B = 16;  // bind
$export$1.W = 32;  // wrap
$export$1.U = 64;  // safe
$export$1.R = 128; // real proto method for `library`
var _export$1 = $export$1;

// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
_export$1(_export$1.S + _export$1.F * !_descriptors$1, 'Object', { defineProperty: _objectDp$1.f });

var $Object = _core$1.Object;
var defineProperty = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};

var defineProperty$1 = defineProperty;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    defineProperty$1(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

// 7.2.2 IsArray(argument)

var _isArray = Array.isArray || function isArray(arg) {
  return _cof(arg) == 'Array';
};

var _wks = createCommonjsModule(function (module) {
var store = _shared('wks');

var Symbol = _global.Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
};

$exports.store = store;
});

var SPECIES = _wks('species');

var _arraySpeciesConstructor = function (original) {
  var C;
  if (_isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || _isArray(C.prototype))) C = undefined;
    if (_isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)


var _arraySpeciesCreate = function (original, length) {
  return new (_arraySpeciesConstructor(original))(length);
};

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex





var _arrayMethods = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || _arraySpeciesCreate;
  return function ($this, callbackfn, that) {
    var O = _toObject($this);
    var self = _iobject(O);
    var f = _ctx(callbackfn, that, 3);
    var length = _toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = _wks('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) _hide(ArrayProto, UNSCOPABLES, {});
var _addToUnscopables = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)

var $find = _arrayMethods(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
_export(_export.P + _export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
_addToUnscopables(KEY);

var _stringWs = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var space = '[' + _stringWs + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = _fails(function () {
    return !!_stringWs[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : _stringWs[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  _export(_export.P + _export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(_defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

var _stringTrim = exporter;

var $parseInt = _global.parseInt;
var $trim = _stringTrim.trim;

var hex = /^[-+]?0[xX]/;

var _parseInt = $parseInt(_stringWs + '08') !== 8 || $parseInt(_stringWs + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;

// 20.1.2.13 Number.parseInt(string, radix)
_export(_export.S + _export.F * (Number.parseInt != _parseInt), 'Number', { parseInt: _parseInt });

var _iterStep = function (done, value) {
  return { value: value, done: !!done };
};

var _iterators = {};

var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  _anObject(O);
  var keys = _objectKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) _objectDp.f(O, P = keys[i++], Properties[P]);
  return O;
};

var document$3 = _global.document;
var _html = document$3 && document$3.documentElement;

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])



var IE_PROTO$1 = _sharedKey('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE$2 = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = _domCreate('iframe');
  var i = _enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  _html.appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE$2][_enumBugKeys[i]];
  return createDict();
};

var _objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE$2] = _anObject(O);
    result = new Empty();
    Empty[PROTOTYPE$2] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = createDict();
  return Properties === undefined ? result : _objectDps(result, Properties);
};

var def = _objectDp.f;

var TAG = _wks('toStringTag');

var _setToStringTag = function (it, tag, stat) {
  if (it && !_has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
_hide(IteratorPrototype, _wks('iterator'), function () { return this; });

var _iterCreate = function (Constructor, NAME, next) {
  Constructor.prototype = _objectCreate(IteratorPrototype, { next: _propertyDesc(1, next) });
  _setToStringTag(Constructor, NAME + ' Iterator');
};

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


var IE_PROTO$2 = _sharedKey('IE_PROTO');
var ObjectProto = Object.prototype;

var _objectGpo = Object.getPrototypeOf || function (O) {
  O = _toObject(O);
  if (_has(O, IE_PROTO$2)) return O[IE_PROTO$2];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

var ITERATOR = _wks('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

var _iterDefine = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  _iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = _objectGpo($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      _setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if ( typeof IteratorPrototype[ITERATOR] != 'function') _hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ( (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    _hide(proto, ITERATOR, $default);
  }
  // Plug for library
  _iterators[NAME] = $default;
  _iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) _redefine(proto, key, methods[key]);
    } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
var es6_array_iterator = _iterDefine(Array, 'Array', function (iterated, kind) {
  this._t = _toIobject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return _iterStep(1);
  }
  if (kind == 'keys') return _iterStep(0, index);
  if (kind == 'values') return _iterStep(0, O[index]);
  return _iterStep(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
_iterators.Arguments = _iterators.Array;

_addToUnscopables('keys');
_addToUnscopables('values');
_addToUnscopables('entries');

var ITERATOR$1 = _wks('iterator');
var TO_STRING_TAG = _wks('toStringTag');
var ArrayValues = _iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = _objectKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME$1 = collections[i];
  var explicit = DOMIterables[NAME$1];
  var Collection = _global[NAME$1];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR$1]) _hide(proto, ITERATOR$1, ArrayValues);
    if (!proto[TO_STRING_TAG]) _hide(proto, TO_STRING_TAG, NAME$1);
    _iterators[NAME$1] = ArrayValues;
    if (explicit) for (key in es6_array_iterator) if (!proto[key]) _redefine(proto, key, es6_array_iterator[key], true);
  }
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
});

var es6_object_toString = /*#__PURE__*/Object.freeze({
  __proto__: null
});

// 7.1.4 ToInteger
var ceil$1 = Math.ceil;
var floor$1 = Math.floor;
var _toInteger$1 = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor$1 : ceil$1)(it);
};

// 7.2.1 RequireObjectCoercible(argument)
var _defined$1 = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

// true  -> String#at
// false -> String#codePointAt
var _stringAt = function (TO_STRING) {
  return function (that, pos) {
    var s = String(_defined$1(that));
    var i = _toInteger$1(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

var _library = true;

var _redefine$1 = _hide$1;

var _iterators$1 = {};

var toString$2 = {}.toString;

var _cof$1 = function (it) {
  return toString$2.call(it).slice(8, -1);
};

// fallback for non-array-like ES3 and non-enumerable old V8 strings

// eslint-disable-next-line no-prototype-builtins
var _iobject$1 = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof$1(it) == 'String' ? it.split('') : Object(it);
};

// to indexed object, toObject with fallback for non-array-like ES3 strings


var _toIobject$1 = function (it) {
  return _iobject$1(_defined$1(it));
};

// 7.1.15 ToLength

var min$2 = Math.min;
var _toLength$1 = function (it) {
  return it > 0 ? min$2(_toInteger$1(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

var max$1 = Math.max;
var min$3 = Math.min;
var _toAbsoluteIndex$1 = function (index, length) {
  index = _toInteger$1(index);
  return index < 0 ? max$1(index + length, 0) : min$3(index, length);
};

// false -> Array#indexOf
// true  -> Array#includes



var _arrayIncludes$1 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = _toIobject$1($this);
    var length = _toLength$1(O.length);
    var index = _toAbsoluteIndex$1(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var _shared$1 = createCommonjsModule(function (module) {
var SHARED = '__core-js_shared__';
var store = _global$1[SHARED] || (_global$1[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: _core$1.version,
  mode:  'pure' ,
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});
});

var id$1 = 0;
var px$1 = Math.random();
var _uid$1 = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id$1 + px$1).toString(36));
};

var shared$1 = _shared$1('keys');

var _sharedKey$1 = function (key) {
  return shared$1[key] || (shared$1[key] = _uid$1(key));
};

var arrayIndexOf$1 = _arrayIncludes$1(false);
var IE_PROTO$3 = _sharedKey$1('IE_PROTO');

var _objectKeysInternal$1 = function (object, names) {
  var O = _toIobject$1(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO$3) _has$1(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (_has$1(O, key = names[i++])) {
    ~arrayIndexOf$1(result, key) || result.push(key);
  }
  return result;
};

// IE 8- don't enum bug keys
var _enumBugKeys$1 = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

// 19.1.2.14 / 15.2.3.14 Object.keys(O)



var _objectKeys$1 = Object.keys || function keys(O) {
  return _objectKeysInternal$1(O, _enumBugKeys$1);
};

var _objectDps$1 = _descriptors$1 ? Object.defineProperties : function defineProperties(O, Properties) {
  _anObject$1(O);
  var keys = _objectKeys$1(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) _objectDp$1.f(O, P = keys[i++], Properties[P]);
  return O;
};

var document$4 = _global$1.document;
var _html$1 = document$4 && document$4.documentElement;

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])



var IE_PROTO$4 = _sharedKey$1('IE_PROTO');
var Empty$1 = function () { /* empty */ };
var PROTOTYPE$3 = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict$1 = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = _domCreate$1('iframe');
  var i = _enumBugKeys$1.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  _html$1.appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict$1 = iframeDocument.F;
  while (i--) delete createDict$1[PROTOTYPE$3][_enumBugKeys$1[i]];
  return createDict$1();
};

var _objectCreate$1 = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty$1[PROTOTYPE$3] = _anObject$1(O);
    result = new Empty$1();
    Empty$1[PROTOTYPE$3] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$4] = O;
  } else result = createDict$1();
  return Properties === undefined ? result : _objectDps$1(result, Properties);
};

var _wks$1 = createCommonjsModule(function (module) {
var store = _shared$1('wks');

var Symbol = _global$1.Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid$1)('Symbol.' + name));
};

$exports.store = store;
});

var def$1 = _objectDp$1.f;

var TAG$1 = _wks$1('toStringTag');

var _setToStringTag$1 = function (it, tag, stat) {
  if (it && !_has$1(it = stat ? it : it.prototype, TAG$1)) def$1(it, TAG$1, { configurable: true, value: tag });
};

var IteratorPrototype$1 = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
_hide$1(IteratorPrototype$1, _wks$1('iterator'), function () { return this; });

var _iterCreate$1 = function (Constructor, NAME, next) {
  Constructor.prototype = _objectCreate$1(IteratorPrototype$1, { next: _propertyDesc$1(1, next) });
  _setToStringTag$1(Constructor, NAME + ' Iterator');
};

// 7.1.13 ToObject(argument)

var _toObject$1 = function (it) {
  return Object(_defined$1(it));
};

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


var IE_PROTO$5 = _sharedKey$1('IE_PROTO');
var ObjectProto$1 = Object.prototype;

var _objectGpo$1 = Object.getPrototypeOf || function (O) {
  O = _toObject$1(O);
  if (_has$1(O, IE_PROTO$5)) return O[IE_PROTO$5];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto$1 : null;
};

var ITERATOR$2 = _wks$1('iterator');
var BUGGY$1 = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR$1 = '@@iterator';
var KEYS$1 = 'keys';
var VALUES$1 = 'values';

var returnThis$1 = function () { return this; };

var _iterDefine$1 = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  _iterCreate$1(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY$1 && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS$1: return function keys() { return new Constructor(this, kind); };
      case VALUES$1: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES$1;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR$2] || proto[FF_ITERATOR$1] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = _objectGpo$1($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      _setToStringTag$1(IteratorPrototype, TAG, true);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES$1) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if (( FORCED) && (BUGGY$1 || VALUES_BUG || !proto[ITERATOR$2])) {
    _hide$1(proto, ITERATOR$2, $default);
  }
  // Plug for library
  _iterators$1[NAME] = $default;
  _iterators$1[TAG] = returnThis$1;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES$1),
      keys: IS_SET ? $default : getMethod(KEYS$1),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) _redefine$1(proto, key, methods[key]);
    } else _export$1(_export$1.P + _export$1.F * (BUGGY$1 || VALUES_BUG), NAME, methods);
  }
  return methods;
};

var $at = _stringAt(true);

// 21.1.3.27 String.prototype[@@iterator]()
_iterDefine$1(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

var _iterStep$1 = function (done, value) {
  return { value: value, done: !!done };
};

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
var es6_array_iterator$1 = _iterDefine$1(Array, 'Array', function (iterated, kind) {
  this._t = _toIobject$1(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return _iterStep$1(1);
  }
  if (kind == 'keys') return _iterStep$1(0, index);
  if (kind == 'values') return _iterStep$1(0, O[index]);
  return _iterStep$1(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
_iterators$1.Arguments = _iterators$1.Array;

var TO_STRING_TAG$1 = _wks$1('toStringTag');

var DOMIterables$1 = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i$1 = 0; i$1 < DOMIterables$1.length; i$1++) {
  var NAME$2 = DOMIterables$1[i$1];
  var Collection$1 = _global$1[NAME$2];
  var proto$1 = Collection$1 && Collection$1.prototype;
  if (proto$1 && !proto$1[TO_STRING_TAG$1]) _hide$1(proto$1, TO_STRING_TAG$1, NAME$2);
  _iterators$1[NAME$2] = _iterators$1.Array;
}

// getting tag from 19.1.3.6 Object.prototype.toString()

var TAG$2 = _wks$1('toStringTag');
// ES3 wrong here
var ARG = _cof$1(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

var _classof = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG$2)) == 'string' ? T
    // builtinTag case
    : ARG ? _cof$1(O)
    // ES3 arguments fallback
    : (B = _cof$1(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

var _anInstance = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

// call something on iterator step with safe closing on error

var _iterCall = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(_anObject$1(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) _anObject$1(ret.call(iterator));
    throw e;
  }
};

// check on default Array iterator

var ITERATOR$3 = _wks$1('iterator');
var ArrayProto$1 = Array.prototype;

var _isArrayIter = function (it) {
  return it !== undefined && (_iterators$1.Array === it || ArrayProto$1[ITERATOR$3] === it);
};

var ITERATOR$4 = _wks$1('iterator');

var core_getIteratorMethod = _core$1.getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR$4]
    || it['@@iterator']
    || _iterators$1[_classof(it)];
};

var _forOf = createCommonjsModule(function (module) {
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : core_getIteratorMethod(iterable);
  var f = _ctx$1(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (_isArrayIter(iterFn)) for (length = _toLength$1(iterable.length); length > index; index++) {
    result = entries ? f(_anObject$1(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = _iterCall(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;
});

// 7.3.20 SpeciesConstructor(O, defaultConstructor)


var SPECIES$1 = _wks$1('species');
var _speciesConstructor = function (O, D) {
  var C = _anObject$1(O).constructor;
  var S;
  return C === undefined || (S = _anObject$1(C)[SPECIES$1]) == undefined ? D : _aFunction$1(S);
};

// fast apply, http://jsperf.lnkit.com/fast-apply/5
var _invoke = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};

var process$1 = _global$1.process;
var setTask = _global$1.setImmediate;
var clearTask = _global$1.clearImmediate;
var MessageChannel = _global$1.MessageChannel;
var Dispatch = _global$1.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      _invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (_cof$1(process$1) == 'process') {
    defer = function (id) {
      process$1.nextTick(_ctx$1(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(_ctx$1(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = _ctx$1(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (_global$1.addEventListener && typeof postMessage == 'function' && !_global$1.importScripts) {
    defer = function (id) {
      _global$1.postMessage(id + '', '*');
    };
    _global$1.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in _domCreate$1('script')) {
    defer = function (id) {
      _html$1.appendChild(_domCreate$1('script'))[ONREADYSTATECHANGE] = function () {
        _html$1.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(_ctx$1(run, id, 1), 0);
    };
  }
}
var _task = {
  set: setTask,
  clear: clearTask
};

var macrotask = _task.set;
var Observer = _global$1.MutationObserver || _global$1.WebKitMutationObserver;
var process$2 = _global$1.process;
var Promise$1 = _global$1.Promise;
var isNode = _cof$1(process$2) == 'process';

var _microtask = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process$2.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process$2.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(_global$1.navigator && _global$1.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise$1.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(_global$1, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};

// 25.4.1.5 NewPromiseCapability(C)


function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = _aFunction$1(resolve);
  this.reject = _aFunction$1(reject);
}

var f$6 = function (C) {
  return new PromiseCapability(C);
};

var _newPromiseCapability = {
	f: f$6
};

var _perform = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

var navigator = _global$1.navigator;

var _userAgent = navigator && navigator.userAgent || '';

var _promiseResolve = function (C, x) {
  _anObject$1(C);
  if (_isObject$1(x) && x.constructor === C) return x;
  var promiseCapability = _newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var _redefineAll = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else _hide$1(target, key, src[key]);
  } return target;
};

var SPECIES$2 = _wks$1('species');

var _setSpecies = function (KEY) {
  var C = typeof _core$1[KEY] == 'function' ? _core$1[KEY] : _global$1[KEY];
  if (_descriptors$1 && C && !C[SPECIES$2]) _objectDp$1.f(C, SPECIES$2, {
    configurable: true,
    get: function () { return this; }
  });
};

var ITERATOR$5 = _wks$1('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR$5]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

var _iterDetect = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR$5]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR$5] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

var task = _task.set;
var microtask = _microtask();




var PROMISE = 'Promise';
var TypeError$1 = _global$1.TypeError;
var process$3 = _global$1.process;
var versions = process$3 && process$3.versions;
var v8 = versions && versions.v8 || '';
var $Promise = _global$1[PROMISE];
var isNode$1 = _classof(process$3) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = _newPromiseCapability.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[_wks$1('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode$1 || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && _userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return _isObject$1(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError$1('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(_global$1, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = _perform(function () {
        if (isNode$1) {
          process$3.emit('unhandledRejection', value, promise);
        } else if (handler = _global$1.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = _global$1.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode$1 || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(_global$1, function () {
    var handler;
    if (isNode$1) {
      process$3.emit('rejectionHandled', promise);
    } else if (handler = _global$1.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError$1("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, _ctx$1($resolve, wrapper, 1), _ctx$1($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    _anInstance(this, $Promise, PROMISE, '_h');
    _aFunction$1(executor);
    Internal.call(this);
    try {
      executor(_ctx$1($resolve, this, 1), _ctx$1($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = _redefineAll($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(_speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode$1 ? process$3.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = _ctx$1($resolve, promise, 1);
    this.reject = _ctx$1($reject, promise, 1);
  };
  _newPromiseCapability.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

_export$1(_export$1.G + _export$1.W + _export$1.F * !USE_NATIVE, { Promise: $Promise });
_setToStringTag$1($Promise, PROMISE);
_setSpecies(PROMISE);
Wrapper = _core$1[PROMISE];

// statics
_export$1(_export$1.S + _export$1.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
_export$1(_export$1.S + _export$1.F * (_library ), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return _promiseResolve( this === Wrapper ? $Promise : this, x);
  }
});
_export$1(_export$1.S + _export$1.F * !(USE_NATIVE && _iterDetect(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = _perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      _forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = _perform(function () {
      _forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

_export$1(_export$1.P + _export$1.R, 'Promise', { 'finally': function (onFinally) {
  var C = _speciesConstructor(this, _core$1.Promise || _global$1.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return _promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return _promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });

// https://github.com/tc39/proposal-promise-try




_export$1(_export$1.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = _newPromiseCapability.f(this);
  var result = _perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });

getCjsExportFromNamespace(es6_object_toString);

var promise = _core$1.Promise;

var promise$1 = promise;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    promise$1.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new promise$1(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var _meta = createCommonjsModule(function (module) {
var META = _uid$1('meta');


var setDesc = _objectDp$1.f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !_fails$1(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!_isObject$1(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!_has$1(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!_has$1(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !_has$1(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};
});
var _meta_1 = _meta.KEY;
var _meta_2 = _meta.NEED;
var _meta_3 = _meta.fastKey;
var _meta_4 = _meta.getWeak;
var _meta_5 = _meta.onFreeze;

var f$7 = _wks$1;

var _wksExt = {
	f: f$7
};

var defineProperty$2 = _objectDp$1.f;
var _wksDefine = function (name) {
  var $Symbol = _core$1.Symbol || (_core$1.Symbol =  {} );
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty$2($Symbol, name, { value: _wksExt.f(name) });
};

var f$8 = Object.getOwnPropertySymbols;

var _objectGops$1 = {
	f: f$8
};

var f$9 = {}.propertyIsEnumerable;

var _objectPie$1 = {
	f: f$9
};

// all enumerable object keys, includes symbols



var _enumKeys = function (it) {
  var result = _objectKeys$1(it);
  var getSymbols = _objectGops$1.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = _objectPie$1.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

// 7.2.2 IsArray(argument)

var _isArray$1 = Array.isArray || function isArray(arg) {
  return _cof$1(arg) == 'Array';
};

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)

var hiddenKeys$1 = _enumBugKeys$1.concat('length', 'prototype');

var f$a = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return _objectKeysInternal$1(O, hiddenKeys$1);
};

var _objectGopn$1 = {
	f: f$a
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window

var gOPN = _objectGopn$1.f;
var toString$3 = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

var f$b = function getOwnPropertyNames(it) {
  return windowNames && toString$3.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(_toIobject$1(it));
};

var _objectGopnExt = {
	f: f$b
};

var gOPD$1 = Object.getOwnPropertyDescriptor;

var f$c = _descriptors$1 ? gOPD$1 : function getOwnPropertyDescriptor(O, P) {
  O = _toIobject$1(O);
  P = _toPrimitive$1(P, true);
  if (_ie8DomDefine$1) try {
    return gOPD$1(O, P);
  } catch (e) { /* empty */ }
  if (_has$1(O, P)) return _propertyDesc$1(!_objectPie$1.f.call(O, P), O[P]);
};

var _objectGopd$1 = {
	f: f$c
};

// ECMAScript 6 symbols shim





var META = _meta.KEY;





















var gOPD$2 = _objectGopd$1.f;
var dP$3 = _objectDp$1.f;
var gOPN$1 = _objectGopnExt.f;
var $Symbol = _global$1.Symbol;
var $JSON = _global$1.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE$4 = 'prototype';
var HIDDEN = _wks$1('_hidden');
var TO_PRIMITIVE = _wks$1('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = _shared$1('symbol-registry');
var AllSymbols = _shared$1('symbols');
var OPSymbols = _shared$1('op-symbols');
var ObjectProto$2 = Object[PROTOTYPE$4];
var USE_NATIVE$1 = typeof $Symbol == 'function' && !!_objectGops$1.f;
var QObject = _global$1.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE$4] || !QObject[PROTOTYPE$4].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = _descriptors$1 && _fails$1(function () {
  return _objectCreate$1(dP$3({}, 'a', {
    get: function () { return dP$3(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD$2(ObjectProto$2, key);
  if (protoDesc) delete ObjectProto$2[key];
  dP$3(it, key, D);
  if (protoDesc && it !== ObjectProto$2) dP$3(ObjectProto$2, key, protoDesc);
} : dP$3;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _objectCreate$1($Symbol[PROTOTYPE$4]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE$1 && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto$2) $defineProperty(OPSymbols, key, D);
  _anObject$1(it);
  key = _toPrimitive$1(key, true);
  _anObject$1(D);
  if (_has$1(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!_has$1(it, HIDDEN)) dP$3(it, HIDDEN, _propertyDesc$1(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (_has$1(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _objectCreate$1(D, { enumerable: _propertyDesc$1(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP$3(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  _anObject$1(it);
  var keys = _enumKeys(P = _toIobject$1(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _objectCreate$1(it) : $defineProperties(_objectCreate$1(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = _toPrimitive$1(key, true));
  if (this === ObjectProto$2 && _has$1(AllSymbols, key) && !_has$1(OPSymbols, key)) return false;
  return E || !_has$1(this, key) || !_has$1(AllSymbols, key) || _has$1(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = _toIobject$1(it);
  key = _toPrimitive$1(key, true);
  if (it === ObjectProto$2 && _has$1(AllSymbols, key) && !_has$1(OPSymbols, key)) return;
  var D = gOPD$2(it, key);
  if (D && _has$1(AllSymbols, key) && !(_has$1(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN$1(_toIobject$1(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!_has$1(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto$2;
  var names = gOPN$1(IS_OP ? OPSymbols : _toIobject$1(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (_has$1(AllSymbols, key = names[i++]) && (IS_OP ? _has$1(ObjectProto$2, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE$1) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = _uid$1(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto$2) $set.call(OPSymbols, value);
      if (_has$1(this, HIDDEN) && _has$1(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, _propertyDesc$1(1, value));
    };
    if (_descriptors$1 && setter) setSymbolDesc(ObjectProto$2, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  _redefine$1($Symbol[PROTOTYPE$4], 'toString', function toString() {
    return this._k;
  });

  _objectGopd$1.f = $getOwnPropertyDescriptor;
  _objectDp$1.f = $defineProperty;
  _objectGopn$1.f = _objectGopnExt.f = $getOwnPropertyNames;
  _objectPie$1.f = $propertyIsEnumerable;
  _objectGops$1.f = $getOwnPropertySymbols;

  if (_descriptors$1 && !_library) {
    _redefine$1(ObjectProto$2, 'propertyIsEnumerable', $propertyIsEnumerable);
  }

  _wksExt.f = function (name) {
    return wrap(_wks$1(name));
  };
}

_export$1(_export$1.G + _export$1.W + _export$1.F * !USE_NATIVE$1, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)_wks$1(es6Symbols[j++]);

for (var wellKnownSymbols = _objectKeys$1(_wks$1.store), k = 0; wellKnownSymbols.length > k;) _wksDefine(wellKnownSymbols[k++]);

_export$1(_export$1.S + _export$1.F * !USE_NATIVE$1, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return _has$1(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

_export$1(_export$1.S + _export$1.F * !USE_NATIVE$1, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = _fails$1(function () { _objectGops$1.f(1); });

_export$1(_export$1.S + _export$1.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return _objectGops$1.f(_toObject$1(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && _export$1(_export$1.S + _export$1.F * (!USE_NATIVE$1 || _fails$1(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!_isObject$1(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!_isArray$1(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE$4][TO_PRIMITIVE] || _hide$1($Symbol[PROTOTYPE$4], TO_PRIMITIVE, $Symbol[PROTOTYPE$4].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
_setToStringTag$1($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
_setToStringTag$1(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
_setToStringTag$1(_global$1.JSON, 'JSON', true);

var getOwnPropertySymbols = _core$1.Object.getOwnPropertySymbols;

var getOwnPropertySymbols$1 = getOwnPropertySymbols;

// most Object methods by ES6 should accept primitives



var _objectSap$1 = function (KEY, exec) {
  var fn = (_core$1.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  _export$1(_export$1.S + _export$1.F * _fails$1(function () { fn(1); }), 'Object', exp);
};

// 19.1.2.14 Object.keys(O)



_objectSap$1('keys', function () {
  return function keys(it) {
    return _objectKeys$1(_toObject$1(it));
  };
});

var keys = _core$1.Object.keys;

var keys$1 = keys;

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};

  var sourceKeys = keys$1(source);

  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (getOwnPropertySymbols$1) {
    var sourceSymbolKeys = getOwnPropertySymbols$1(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */


var check = function (O, proto) {
  _anObject(O);
  if (!_isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
var _setProto = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = _ctx(Function.call, _objectGopd.f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

var setPrototypeOf = _setProto.set;
var _inheritIfRequired = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && _isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};

var gOPN$2 = _objectGopn.f;
var gOPD$3 = _objectGopd.f;
var dP$4 = _objectDp.f;
var $trim$1 = _stringTrim.trim;
var NUMBER = 'Number';
var $Number = _global[NUMBER];
var Base = $Number;
var proto$2 = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = _cof(_objectCreate(proto$2)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = _toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim$1(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? _fails(function () { proto$2.valueOf.call(that); }) : _cof(that) != NUMBER)
        ? _inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys$2 = _descriptors ? gOPN$2(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j$1 = 0, key$1; keys$2.length > j$1; j$1++) {
    if (_has(Base, key$1 = keys$2[j$1]) && !_has($Number, key$1)) {
      dP$4($Number, key$1, gOPD$3(Base, key$1));
    }
  }
  $Number.prototype = proto$2;
  proto$2.constructor = $Number;
  _redefine(_global, NUMBER, $Number);
}

// 20.1.2.3 Number.isInteger(number)

var floor$2 = Math.floor;
var _isInteger = function isInteger(it) {
  return !_isObject(it) && isFinite(it) && floor$2(it) === it;
};

// 20.1.2.3 Number.isInteger(number)


_export(_export.S, 'Number', { isInteger: _isInteger });

// true  -> String#at
// false -> String#codePointAt
var _stringAt$1 = function (TO_STRING) {
  return function (that, pos) {
    var s = String(_defined(that));
    var i = _toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

var at = _stringAt$1(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
var _advanceStringIndex = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};

// getting tag from 19.1.3.6 Object.prototype.toString()

var TAG$3 = _wks('toStringTag');
// ES3 wrong here
var ARG$1 = _cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet$1 = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

var _classof$1 = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet$1(O = Object(it), TAG$3)) == 'string' ? T
    // builtinTag case
    : ARG$1 ? _cof(O)
    // ES3 arguments fallback
    : (B = _cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
var _regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (_classof$1(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};

// 21.2.5.3 get RegExp.prototype.flags

var _flags = function () {
  var that = _anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', _flags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

var _regexpExec = patchedExec;

_export({
  target: 'RegExp',
  proto: true,
  forced: _regexpExec !== /./.exec
}, {
  exec: _regexpExec
});

var SPECIES$3 = _wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !_fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

var _fixReWks = function (KEY, length, exec) {
  var SYMBOL = _wks(KEY);

  var DELEGATES_TO_SYMBOL = !_fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !_fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$3] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      _defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === _regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    _redefine(String.prototype, KEY, strfn);
    _hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};

// @@match logic
_fixReWks('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = _anObject(regexp);
      var S = String(this);
      if (!rx.global) return _regexpExecAbstract(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = _regexpExecAbstract(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = _advanceStringIndex(S, _toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

var HttpService = ApiModule.HttpService;

var instance = new HttpService("umbraco/api/Basket/");
/* eslint-disable arrow-body-style */

/**
 * Add a product to the basket.
 * @param {*} productId The product identifier.
 * @param {*} quantity An optional quantity.
 * @param {*} options Optional paramaters.
 */

var addProduct = function addProduct(productId, quantity, options) {
  var endpoint = "AddProductByCode";
  var isGuid = false;
  var guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  if ("".concat(productId).match(guidPattern)) {
    isGuid = true;
  }

  var isInt = Number.isInteger(Number.parseInt(productId, 10));

  if (isGuid) {
    endpoint = "AddProductByGuid";
  } else if (isInt) {
    endpoint = "AddProductByIntId";
  }

  return instance.post(endpoint, options, {
    productId: productId,
    quantity: quantity
  });
};
/**
 * Add multiple products to the basket.
 * @param {*} products The list of products to add.
 */

var bulkAddProducts = function bulkAddProducts(products) {
  var endPoint = "BulkAddProductsByCode";
  var isGuid = false;
  var guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  if (products && products.length > 0) {
    var firstId = products[0].id;

    if ("".concat(firstId).match(guidPattern)) {
      isGuid = true;
    }

    var isInt = Number.isInteger(Number.parseInt(firstId, 10));

    if (isGuid) {
      endPoint = "BulkAddProductsByGuid";
    } else if (isInt) {
      endPoint = "BulkAddProductsByInt";
    }
  }

  return instance.post(endPoint, products);
};
/**
 * Sets the quantity to a specified amount.
 * @param {*} orderLineId The order line to update.
 * @param {*} quantity The new quantity to set.
 */

var setQuantity = function setQuantity(orderLineId, quantity) {
  return instance.put("SetQuantity", null, {
    orderLineId: orderLineId,
    quantity: quantity
  });
};
/**
 * Lists the items in basket.
 * @param {*} includeCarriage Whether to include carriage lines or not
 */

var listItems = function listItems() {
  var includeCarriage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return instance.get("ListItemsInBasket?includeCarriage=".concat(includeCarriage));
};
/**
 * Get a list of basket itens and basket configuration data
 * @param {Boolean} includeCarriage Whether to include carriage lines or not
 */

var listItemsEx = function listItemsEx() {
  var includeCarriage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return instance.get("ListItemsInBasketEx", {
    includeCarriage: includeCarriage
  });
};
/**
 * Get the basket item count.
 */

var getItemCount = function getItemCount() {
  return instance.get("GetItemCount");
};
/**
 * Removes an order line from the basket.
 * @param {*} orderLineId The order line to remove.
 */

var removeItem = function removeItem(orderLineId) {
  return instance.delete("RemoveItem", {
    orderLineId: orderLineId
  });
};
/**
 * Removes all products from the basket.
 */

var clearBasket = function clearBasket() {
  return instance.delete("EmptyBasket");
};
/**
 * Applies the given voucher code to the basket
 * @param {string} voucherCode The voucher code to apply
 * @param {bool} removeExistingVouchers Should we remove existing vouchers?
 */

var applyVoucher = function applyVoucher(voucherCode) {
  var removeExistingVouchers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return instance.post("ApplyVoucher", null, {
    voucherCode: voucherCode,
    removeExistingVouchers: removeExistingVouchers
  });
};
/**
 * Gets the voucher codes applied to the basker.
 */

var getVoucher = function getVoucher() {
  return instance.get("GetVoucher");
};
/**
 * Removes a voucher code from the basket.
 * @param {string} code The voucher code to remove
 */

var removeVoucher = function removeVoucher(code) {
  return instance.delete("RemoveVoucher", {
    code: code
  });
};
/**
 * Load data needed to use the alternate delivery address for basket lines
 * @param {Number} productId The product ID we want to link a delivery address to
 * @param {Array} orderLines A list of current order lines in the basket, saves having to
 *                            load them each time the modal is displayed which greatly speeds
 *                            things up
 */

var getDeliveryAddressSetup = function getDeliveryAddressSetup(productId, orderLines) {
  return instance.post("LoadDeliveryAddressSetup", orderLines, {
    productId: productId
  });
};
/**
 * Update an existing order lines delivery address
 * @param {Object} lineAddress Address aetails to save against the order line, contains:
 *
 * {
 *  addressId: <the id of the address linked to the order line>
 *  orgId: the id of the org linked to the order line
 *  orderLineId: the id of the order line
 *  addNew: If this is true then we will split the order line and create a new
 *          order line for the new address instead of updating the existing order line
 *  newAddress: If this populated and the addressId is null then these details are used
 *              to create a new address first before updating the order line
 * }
 */

var updateLineDeliveryAddress = function updateLineDeliveryAddress(lineAddress) {
  return instance.post("UpdateLineDeliveryAddress", lineAddress);
};
/**
 * Update all lines in the basket that do not have a delivery address to have a default
 * delivery organisation and address
 * @param {string} orgId The ID of the organisation to set against all order lines
 * @param {string} addressId The ID of the organisations address to set against all order lines
 */

var setDefaultLineDeliveryAddress = function setDefaultLineDeliveryAddress(orgId, addressId) {
  return instance.post("SetDefaultLineDeliveryAddress", {
    orgId: orgId,
    addressId: addressId
  });
};
/**
 * Load a list of delivery addresses to use for order lines when sending different order lines
 * to different delivery addresses
 */

var loadOrderLineAddresses = function loadOrderLineAddresses() {
  return instance.post("LoadOrderLineAddresses");
};
/**
 * Update an existing order line with a delivery person
 * @param {Object} linePerson Person details to save against the order line
 */

var updateLineDeliveryPerson = function updateLineDeliveryPerson(linePerson) {
  return instance.post("UpdateLineDeliveryPerson", linePerson);
};
var removeLineDeliveryPerson = function removeLineDeliveryPerson(orderLineId) {
  return instance.post("RemoveLineDeliveryPerson", null, {
    orderLineId: orderLineId
  });
};
/**
 * Load a person details in a format that can be edited in an order line
 * @param {String} personId The ID of the person to load
 */

var loadOrderLineDeliveryPerson = function loadOrderLineDeliveryPerson(personId) {
  return instance.get("LoadOrderLineDeliveryPerson", {
    personId: personId
  });
};

var basket = {
  REQUEST: "sw::basket::request",
  RESPONSE: "sw::basket::response",
  SUCCESS: "sw::basket::success",
  FAILURE: "sw::basket::failure",
  addToBasket: {
    REQUEST: "sw::addToBasket::request",
    RESPONSE: "sw::addToBasket::response",
    SUCCESS: "sw::addToBasket::success",
    FAILURE: "sw::addToBasket::failure"
  },
  refreshBasket: {
    REQUEST: "sw::refreshBasket::request"
  },
  removeFromBasket: {
    REQUEST: "sw::removeFromBasket::request",
    RESPONSE: "sw::removeFromBasket::response",
    SUCCESS: "sw::removeFromBasket::success",
    FAILURE: "sw::removeFromBasket::failure"
  },
  clearBasket: {
    REQUEST: "sw::clearBasket::request",
    RESPONSE: "sw::clearBasket::response",
    SUCCESS: "sw::clearBasket::success",
    FAILURE: "sw::clearBasket::failure"
  },
  setBasketItemQuantity: {
    REQUEST: "sw::setBasketItemQuantity::request",
    RESPONSE: "sw::setBasketItemQuantity::response",
    SUCCESS: "sw::setBasketItemQuantity::success",
    FAILURE: "sw::setBasketItemQuantity::failure",
    START: "sw::setBasketItemQuantity::start",
    STOP: "sw::setBasketItemQuantity::stop",
    UPDATE: "sw::setBasketItemQuantity::update"
  },
  orderLineDeliveryAddress: {
    ADDNEW: "sw::orderLineDeliveryAddress::addnew",
    SPLIT: "sw::orderLineDeliveryAddress::split",
    REQUEST: "sw::orderLineDeliveryAddress::request",
    RESPONSE: "sw::orderLineDeliveryAddress::response",
    SUCCESS: "sw::orderLineDeliveryAddress::success",
    FAILURE: "sw::orderLineDeliveryAddress::failure"
  },
  orderLineDeliveryPerson: {
    REQUEST: "sw::orderLineDeliveryPerson::request",
    RESPONSE: "sw::orderLineDeliveryPerson::response",
    SUCCESS: "sw::orderLineDeliveryPerson::success",
    FAILURE: "sw::orderLineDeliveryPerson::failure"
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var script = {
  name: "AddToBasket",
  props: {
    // eslint-disable-next-line vue/require-prop-types
    productId: {
      default: null
    },
    quantity: {
      type: Number,
      default: 1,
      validator: function validator(val) {
        return val > 0;
      }
    },
    stackSize: {
      type: Number,
      default: null
    },
    bulkProducts: {
      type: Array,
      default: null
    },
    stock: {
      type: Number,
      default: null
    },
    pricingScheduleId: {
      type: Number,
      default: null
    },
    productFormatId: {
      type: Number,
      default: null
    },
    productLicenceTypeId: {
      type: Number,
      default: null
    },
    hideLoading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      requesting: false,
      internalStock: null
    };
  },
  computed: {
    listeners: function listeners() {
      var _this$$listeners = this.$listeners,
          click = _this$$listeners.click,
          requestAdd = _this$$listeners.requestAdd,
          remainingListeners = _objectWithoutProperties(_this$$listeners, ["click", "requestAdd"]);

      return remainingListeners;
    },
    classes: function classes() {
      var result = [];

      if (this.requesting) {
        result.push("add-to-basket--requesting");
      }

      if (!this.hasStock) {
        result.push("add-to-basket--out-of-stock");
      }

      return result;
    },
    hasStock: function hasStock() {
      return this.internalStock === null || this.internalStock > 0;
    }
  },
  watch: {
    stock: {
      immediate: true,
      handler: function handler(val) {
        this.internalStock = val;
      }
    }
  },
  created: function created() {
    var _this = this;

    this.mutable = this.initValue;
    this.$root.$on(basket.addToBasket.SUCCESS, function (payload) {
      if (_this.productId === payload.productId) {
        if (_this.internalStock !== null) {
          _this.internalStock -= _this.quantity;
        }
      }
    });
  },
  methods: {
    onFail: function onFail(error) {
      var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var showUser = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      this.$root.$emit(basket.addToBasket.FAILURE, error, code, showUser);
      this.$emit("failure", error, code, showUser);
    },
    onSuccess: function onSuccess(payload) {
      this.$root.$emit(basket.addToBasket.SUCCESS, payload);
      this.$emit("success", payload);
    },
    onResponse: function onResponse(product) {
      this.$root.$emit(basket.addToBasket.RESPONSE, product);
      this.$emit("response", product);
      this.requesting = false;
    },
    onRequest: function onRequest(product) {
      this.$root.$emit(basket.addToBasket.REQUEST, product);
      this.$emit("request");
      this.requesting = true;
    },
    onClick: function onClick() {
      var _this2 = this;

      this.$emit("click");

      if (this.$listeners.requestAdd) {
        new Promise(function (resolve, reject) {
          _this2.$emit("requestAdd", resolve, reject);
        }).then(function () {
          _this2.addToBasket();
        }).catch(function () {}); // Do nothing when we reject the promise
      } else {
        this.addToBasket();
      }
    },
    addToBasket: function () {
      var _addToBasket = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var products;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!this.requesting && this.hasStock)) {
                  _context.next = 9;
                  break;
                }

                products = this.bulkProducts;

                if (!products) {
                  _context.next = 7;
                  break;
                }

                _context.next = 5;
                return this.addBulkProducts(products);

              case 5:
                _context.next = 9;
                break;

              case 7:
                _context.next = 9;
                return this.addSingleProduct();

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function addToBasket() {
        return _addToBasket.apply(this, arguments);
      }

      return addToBasket;
    }(),
    addBulkProducts: function () {
      var _addBulkProducts = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(products) {
        var _this3 = this;

        var _yield$bulkAddProduct, data, productsAdded;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                products.forEach(function (p) {
                  return _this3.onRequest(p);
                });
                _context2.prev = 1;
                _context2.next = 4;
                return bulkAddProducts(products);

              case 4:
                _yield$bulkAddProduct = _context2.sent;
                data = _yield$bulkAddProduct.data;
                productsAdded = [];
                products.forEach(function (p) {
                  var successPayload = {
                    id: p.id,
                    pricingScheduleId: p.pricingScheduleId,
                    productFormatId: p.productFormatId,
                    productLicenceTypeId: p.pricingScheduleId,
                    quantity: p.quantity,
                    stackSize: p.stackSize
                  };
                  var intId = Number.parseInt(p.id, 10);
                  var resultData = data.find(function (d) {
                    return d.orderLineResult.productId === intId;
                  });

                  if (resultData && resultData.orderLineResult.errorCode === 100) {
                    productsAdded.push(resultData);

                    _this3.onSuccess(successPayload);
                  } else {
                    _this3.onFail(new Error(resultData.orderLineResult.errorMessage), resultData.orderLineResult.errorCode, true);
                  }
                });
                _context2.next = 10;
                return this.$gtag.onAddToBasket(productsAdded);

              case 10:
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](1);
                products.forEach(function () {
                  return _this3.onFail(_context2.t0);
                });

              case 15:
                _context2.prev = 15;
                products.forEach(function (p) {
                  return _this3.onResponse(p);
                });
                return _context2.finish(15);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 12, 15, 18]]);
      }));

      function addBulkProducts(_x) {
        return _addBulkProducts.apply(this, arguments);
      }

      return addBulkProducts;
    }(),
    addSingleProduct: function () {
      var _addSingleProduct = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this4 = this;

        var product, options, _yield$addProduct, data, orderLineIds, errors, successPayload;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                product = {
                  id: this.productId,
                  pricingScheduleId: this.pricingScheduleId,
                  productFormatId: this.productFormatId,
                  productLicenceTypeId: this.productLicenceTypeId,
                  quantity: this.quantity
                };
                this.onRequest(product);
                options = {
                  pricingScheduleId: this.pricingScheduleId,
                  productFormatId: this.productFormatId,
                  productLicenceTypeId: this.productLicenceTypeId,
                  stackSize: this.stackSize
                };
                _context3.prev = 3;
                _context3.next = 6;
                return addProduct(product.id, product.quantity, options);

              case 6:
                _yield$addProduct = _context3.sent;
                data = _yield$addProduct.data;
                orderLineIds = data.filter(function (d) {
                  return d.orderLineResult.errorCode === 100;
                });
                errors = data.filter(function (d) {
                  return d.orderLineResult.errorCode !== 100;
                });
                successPayload = _objectSpread({}, product, {
                  orderLineIds: orderLineIds
                });

                if (!(errors === undefined || errors === null || errors.length === 0)) {
                  _context3.next = 17;
                  break;
                }

                _context3.next = 14;
                return this.$gtag.onAddToBasket(data);

              case 14:
                this.onSuccess(successPayload);
                _context3.next = 18;
                break;

              case 17:
                errors.forEach(function (e) {
                  _this4.onFail(new Error(e.orderLineResult.errorMessage));
                });

              case 18:
                _context3.next = 23;
                break;

              case 20:
                _context3.prev = 20;
                _context3.t0 = _context3["catch"](3);
                this.onFail(_context3.t0);

              case 23:
                _context3.prev = 23;
                this.onResponse(product);
                return _context3.finish(23);

              case 26:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 20, 23, 26]]);
      }));

      function addSingleProduct() {
        return _addSingleProduct.apply(this, arguments);
      }

      return addSingleProduct;
    }()
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('button', _vm._g({
    staticClass: "add-to-basket",
    class: _vm.classes,
    attrs: {
      "disabled": !_vm.hasStock
    },
    on: {
      "click": _vm.onClick
    }
  }, _vm.listeners), [_vm.requesting && !_vm.hideLoading ? [_vm._t("loading", [_vm._v("\n      Loading...\n    ")])] : [_vm.hasStock ? _vm._t("default", [_vm._v("\n      Add to basket\n    ")]) : _vm._t("out-of-stock", [_vm._v("\n      Out of stock\n    ")])]], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = "data-v-425509e4";
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

var script$1 = {
  name: "ApplyVoucher",
  props: {
    appliedVoucherCodes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: "Voucher code"
    },
    inputClass: {
      type: String,
      default: "form-control"
    },
    btnClass: {
      type: String,
      default: "btn"
    },
    timeoutDuration: {
      type: Number,
      default: 2000
    },
    canRemoveVoucher: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      voucherCode: null,
      submitting: false,
      submitted: false,
      error: false,
      errorRemoving: false,
      internalAppliedCodes: []
    };
  },
  computed: {
    appliedHeading: function appliedHeading() {
      var result = "Code";

      if (this.internalAppliedCodes && this.internalAppliedCodes.length > 1) {
        result = "Codes";
      }

      return "".concat(result, " applied:");
    }
  },
  watch: {
    error: function error(val) {
      var _this = this;

      if (val) {
        window.setTimeout(function () {
          _this.error = false;
        }, this.timeoutDuration);
      }
    },
    submitted: function submitted(val) {
      if (val) {
        window.setTimeout(function () {}, this.timeoutDuration);
      }
    },
    appliedVoucherCodes: {
      deep: true,
      immediate: true,
      handler: function handler(val) {
        this.internalAppliedCodes = val;
      }
    }
  },
  methods: {
    removeVoucher: function removeVoucher$1(code) {
      var _this2 = this;

      this.errorRemoving = false;
      this.$emit("request", "remove");

      removeVoucher(code).then(function (response) {
        if (response.data) {
          _this2.internalAppliedCodes = _this2.internalAppliedCodes.filter(function (c) {
            return c !== code;
          });

          _this2.$emit("response", response.data, "remove");

          _this2.$emit("update", "remove");
        } else {
          _this2.errorRemoving = true;
        }
      }).catch(function (err) {
        _this2.errorRemoving = true;

        _this2.$emit("onError", err, "remove");

        console.error(err);
      }).finally(function () {
        _this2.$emit("complete", "remove");
      });
    },
    applyVoucher: function applyVoucher$1() {
      var _this3 = this;

      this.submitting = true;
      this.$emit("request", "apply");

      applyVoucher(this.voucherCode).then(function (response) {
        if (response.data) {
          _this3.error = false;

          if (!response.data.valid) {
            _this3.error = true;
          }

          if (!_this3.error) {
            _this3.submitted = true;
            window.setTimeout(function () {
              _this3.submitted = false;
            }, 3000);

            _this3.internalAppliedCodes.push(_this3.voucherCode);

            _this3.voucherCode = null;
          }

          _this3.$emit("response", response.data, "apply");

          _this3.$emit("update", "apply");
        }
      }).catch(function (err) {
        _this3.error = true;

        _this3.$emit("onError", err, "apply");
      }).finally(function () {
        _this3.submitting = false;

        _this3.$emit("complete", "apply");
      });
    }
  }
};

/* script */
var __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('form', {
    staticClass: "apply-voucher",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.applyVoucher($event);
      }
    }
  }, [_vm.internalAppliedCodes && _vm.internalAppliedCodes.length ? _c('div', {
    staticClass: "apply-voucher__applied"
  }, [_c('span', {
    staticClass: "apply-voucher__applied-heading"
  }, [_vm._v(_vm._s(_vm.appliedHeading))]), _vm._v(" "), _c('ul', {
    staticClass: "applied-voucher__list"
  }, _vm._l(_vm.internalAppliedCodes, function (code) {
    return _c('li', {
      key: code,
      staticClass: "apply-voucher__item"
    }, [_vm._v("\n        " + _vm._s(code) + "\n        "), _vm.canRemoveVoucher ? _c('div', {
      staticClass: "apply-voucher__remove-code",
      attrs: {
        "title": "Remove voucher code"
      },
      on: {
        "click": function click($event) {
          return _vm.removeVoucher(code);
        }
      }
    }, [_vm._t("remove-voucher-icon", [_vm._v("\n            x\n          ")])], 2) : _vm._e()]);
  }), 0), _vm._v(" "), _vm.errorRemoving ? _c('div', {
    staticClass: "apply-voucher__error-removing"
  }, [_vm._v("\n      Unable to remove the voucher code.\n    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "apply-voucher__input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.voucherCode,
      expression: "voucherCode"
    }],
    staticClass: "apply-voucher__input",
    class: _vm.inputClass,
    attrs: {
      "placeholder": _vm.placeholder,
      "aria-label": "Enter your voucher code here"
    },
    domProps: {
      "value": _vm.voucherCode
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.voucherCode = $event.target.value;
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "for": "submit-button"
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "apply-voucher__button",
    class: _vm.btnClass,
    attrs: {
      "id": "submit-button"
    }
  }, [_vm.submitting ? _vm._t("submitting", [_vm._v("\n        Applying...\n      ")]) : _vm.submitted && !_vm.error ? _vm._t("submitted", [_vm._v("\n        Applied!\n      ")]) : _vm.error ? _vm._t("error", [_vm._v("\n        Error applying\n      ")]) : _vm._t("default", [_vm._v("\n        Apply\n      ")])], 2)])]);
};

var __vue_staticRenderFns__$1 = [];
/* style */

var __vue_inject_styles__$1 = undefined;
/* scoped */

var __vue_scope_id__$1 = "data-v-7f115c12";
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)


_export$1(_export$1.S, 'Array', { isArray: _isArray$1 });

var isArray = _core$1.Array.isArray;

var isArray$1 = isArray;

function _arrayWithHoles(arr) {
  if (isArray$1(arr)) return arr;
}

var core_getIterator = _core$1.getIterator = function (it) {
  var iterFn = core_getIteratorMethod(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return _anObject$1(iterFn.call(it));
};

var getIterator = core_getIterator;

var getIterator$1 = getIterator;

var ITERATOR$6 = _wks$1('iterator');

var core_isIterable = _core$1.isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR$6] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || _iterators$1.hasOwnProperty(_classof(O));
};

var isIterable = core_isIterable;

var isIterable$1 = isIterable;

function _iterableToArrayLimit(arr, i) {
  if (!(isIterable$1(Object(arr)) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = getIterator$1(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)

var $find$1 = _arrayMethods(6);
var KEY$1 = 'findIndex';
var forced$1 = true;
// Shouldn't skip holes
if (KEY$1 in []) Array(1)[KEY$1](function () { forced$1 = false; });
_export(_export.P + _export.F * forced$1, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
_addToUnscopables(KEY$1);

// 20.1.2.1 Number.EPSILON


_export(_export.S, 'Number', { EPSILON: Math.pow(2, -52) });

var script$2 = {
  name: "BaseBasket",
  props: {
    poll: {
      type: Boolean,
      default: false
    },
    refresh: {
      type: Boolean,
      default: false
    },
    showCarriage: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      orderLines: [],
      allowSelectDeliveryAddress: false,
      allowMultiDeliveryAddress: false,
      allowSelectDeliveryPerson: false,
      hasDeliveryAddresses: false,
      multiShipEnabled: false,
      voucherCodes: [],
      optimistic: 0,
      loading: true,
      initialLoading: true,
      expectingNewLine: false,
      interval: null,
      debouncedRefreshData: null,
      messages: [],
      sopAddresses: [],
      defaultSopAddress: {},
      sopAddressesLoaded: false,
      accountPerson: null
    };
  },
  computed: {
    totals: function totals() {
      var result = [];

      if (this.orderLines) {
        var totalExcVat = this.orderLines.map(function (x) {
          return x.priceExcVat;
        }).reduce(function (acc, val) {
          return acc + val;
        }, 0);

        if (this.discountValue) {
          result.push({
            text: "Discount",
            price: this.discountValue
          });
        }

        result.push({
          text: "Total",
          price: totalExcVat
        });
        var totalIncVat = this.orderLines.map(function (x) {
          return x.priceIncVat;
        }).reduce(function (acc, val) {
          return acc + val;
        }, 0);
        var totalVat = Math.round((totalIncVat - totalExcVat + Number.EPSILON) * 100) / 100;
        result.push({
          text: "VAT",
          price: totalVat
        });
        result.push({
          text: "Total (including VAT)",
          price: totalIncVat
        });
      }

      return result;
    },
    filteredOrderLines: function filteredOrderLines() {
      var result = this.orderLines;

      if (!this.showCarriage) {
        result = result.filter(function (o) {
          return !o.carriage;
        });
      }

      return result;
    },
    discountValue: function discountValue() {
      var result = 0;

      if (this.orderLines && this.orderLines.length > 0) {
        for (var i = 0; i < this.orderLines.length; i += 1) {
          var orderLine = this.orderLines[i];

          if (orderLine.addedByVoucher) {
            result += Math.abs(orderLine.priceExcVat);
          } else {
            result += orderLine.discountValue;
          }
        }
      }

      return result;
    },

    /**
     * Generate a dictionary of product IDs against wether or not they can be split
     * to have alternate delivery destinations. A product must have a quantity on one of its
     * lines of at least 2 to be splittable
     *
     * example response:
     *
     * {
     *  1: true,
     *  2: true,
     *  3: false,
     * }
     */
    splittableProducts: function splittableProducts() {
      var lines = this.orderLines || [];
      var hasAddress = {};
      var splittable = lines.reduce(function (acc, curr) {
        if (!Object.prototype.hasOwnProperty.call(acc, curr.productId)) {
          // Initialise the object property with a value of false if it
          // does not exist
          acc[curr.productId] = false;
          hasAddress[curr.productId] = true;
        } // Record if we have a delivery address for this product on this line


        hasAddress[curr.productId] = hasAddress[curr.productId] && !!curr.deliveryAddressId; // A product is splittable IF the quantity is > 1 and it has an address

        acc[curr.productId] = curr.quantity > 1 && hasAddress[curr.productId];
        return acc;
      }, {});
      return splittable;
    },

    /**
     * Generate a dictionary of product IDs where each ID has hav an array of address
     * IDs currently linked to it. This is so we can prevent a product having multiple
     * order lines with the same address
     *
     * example response:
     *
     * {
     *  1: [x,y,z],
     *  2: [x],
     *  3: [x,z],
     * }
     */
    productAddresses: function productAddresses() {
      var lines = this.orderLines || [];
      var addresses = lines.reduce(function (acc, curr) {
        if (curr.deliveryAddressId) {
          if (!Object.prototype.hasOwnProperty.call(acc, curr.productId)) {
            // Initialise the object with the current product ID as an array
            // containing the delivery address
            acc[curr.productId] = [curr.deliveryAddressId];
          } else {
            // Add the delivery address from the current line to the object
            // with the current lines product ID
            acc[curr.productId].push(curr.deliveryAddressId);
          }
        }

        return acc;
      }, {});
      return addresses;
    },

    /**
     * True if at least one of the order lines has a missing delivery address
     */
    missingDeliveryAddresses: function missingDeliveryAddresses() {
      var hasMissingAddresses = false;

      if (this.allowSelectDeliveryAddress) {
        hasMissingAddresses = this.orderLines.some(function (line) {
          return !line.deliveryAddressId;
        });
      }

      return hasMissingAddresses;
    }
  },
  watch: {
    refresh: function refresh(val) {
      if (val) {
        this.refreshData();
      }
    },

    /**
     * If "allowSelectDeliveryAddress" is flipped to true then do a one time load
     * of the SOP Addresses for this web account and select the default address
     */
    allowSelectDeliveryAddress: function allowSelectDeliveryAddress(val) {
      if (val && !this.sopAddressesLoaded) {
        this.loadSopAddresses();
      }
    }
  },
  created: function created() {
    var _this = this;

    this.debouncedRefreshData = debounce(function debouncedRefreshData() {
      this.refreshData();
    }, 1000);
    this.debouncedRefreshData(); // Requests

    this.$root.$on(basket.addToBasket.REQUEST, this.increaseProductQuantity);
    this.$root.$on(basket.clearBasket.REQUEST, this.clearOrderLines);
    this.$root.$on(basket.refreshBasket.REQUEST, this.refreshData); // Grouped Requests

    var incrementOptimism = function incrementOptimism() {
      _this.optimistic += 1;
    };

    var decrementOptimism = function decrementOptimism() {
      _this.optimistic -= 1;
    };

    this.$root.$on(basket.setBasketItemQuantity.START, incrementOptimism);
    this.$root.$on(basket.setBasketItemQuantity.STOP, decrementOptimism);
    this.$root.$on(basket.setBasketItemQuantity.UPDATE, this.onSetBasketItemQuantity);
    this.$root.$on(basket.setBasketItemQuantity.FAILURE, this.onSetBasketItemQuantityFail); // Responses

    this.$root.$on(basket.setBasketItemQuantity.RESPONSE, this.onResponse); // Optimistic Responses

    var onOptimisticResponse = function onOptimisticResponse() {
      _this.optimistic -= 1;

      _this.onResponse();
    }; // Line Delivery Address


    this.$root.$on(basket.orderLineDeliveryAddress.SUCCESS, this.onSetLineDeliveryAddress); // Line Delivery Person

    this.$root.$on(basket.orderLineDeliveryPerson.SUCCESS, this.onSetLineDeliveryPerson);
    this.$root.$on(basket.addToBasket.RESPONSE, onOptimisticResponse);
    this.$root.$on(basket.removeFromBasket.RESPONSE, onOptimisticResponse);
    this.$root.$on(basket.clearBasket.RESPONSE, onOptimisticResponse);

    if (this.poll) {
      this.interval = window.setInterval(function () {
        _this.debouncedRefreshData();
      }, 5000);
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    clearOrderLines: function clearOrderLines() {
      this.optimistic += 1;
      this.orderLines = [];
    },
    increaseProductQuantity: function increaseProductQuantity(payload) {
      this.optimistic += 1;
      var matchingLine = this.getMatchingOrderLine(payload);

      if (matchingLine > -1) {
        var currentPrice = this.orderLines[matchingLine].priceExcVat;
        var currentQuantity = this.orderLines[matchingLine].quantity;
        var baseItemPrice = currentPrice / currentQuantity;
        this.orderLines[matchingLine].quantity += payload.quantity;
        this.orderLines[matchingLine].priceExcVat += baseItemPrice * payload.quantity;
      } else {
        this.expectingNewLine = true;
      }
    },
    onSetBasketItemQuantityFail: function onSetBasketItemQuantityFail(_ref) {
      var message = _ref.message,
          isSpiritError = _ref.isSpiritError;
      // console.groupCollapsed( "BaseBasket>onSetBasketItemQuantityFail:" );
      console.warn({
        message: message,
        isSpiritError: isSpiritError
      });

      if (message) {
        var newAlertMode = true;

        try {
          var alert = new NotificationModule.SwAlert(message, {
            namespace: "basket"
          });
          this.$notifications.add(alert.danger());
        } catch (error) {
          newAlertMode = false;
          console.warn(error.message);
        }

        if (!newAlertMode) {
          // console.log( "legacyAlertMode" );
          this.messages.push(message);
        }
      } // console.groupEnd();

    },
    onSetBasketItemQuantity: function onSetBasketItemQuantity(payload) {
      var matchingLine = this.getMatchingOrderLine(payload);

      if (matchingLine > -1) {
        var currentPrice = this.orderLines[matchingLine].priceExcVat;
        var currentQuantity = this.orderLines[matchingLine].quantity;
        var baseItemPrice = currentPrice / currentQuantity;
        this.orderLines[matchingLine].quantity = payload.quantity;
        this.orderLines[matchingLine].priceExcVat = baseItemPrice * payload.quantity;
      }
    },
    onSetLineDeliveryAddress: function onSetLineDeliveryAddress(payload) {
      var index = this.orderLines.findIndex(function (line) {
        return line.id === (payload === null || payload === void 0 ? void 0 : payload.orderLineId);
      });

      if (index > -1) {
        var _payload$addresses;

        if (payload.addNew) {
          // Find the order line we have subtracted 1 from the quantityt of
          var donorIndex = this.orderLines.findIndex(function (line) {
            return line.id === payload.donorLineId;
          });

          if (donorIndex > -1) {
            // Subtract one from the quantity of the line line in memory
            // to match what is the database
            this.orderLines[donorIndex].quantity -= 1; // We have created a new order line based on the existing one

            var newOrderLine = cloneDeep(this.orderLines[index]);
            newOrderLine.id = payload.newOrderLineId;
            newOrderLine.deliveryOrgId = payload.orgId;
            newOrderLine.deliveryAddressId = payload.addressId;
            newOrderLine.deliveryOrgName = payload.orgName; // New order line will always have a quantity of 1 so we need to adjust
            // the cloned order lines price and quantity

            newOrderLine.priceExcVat /= newOrderLine.quantity;
            newOrderLine.quantity = 1;
            this.orderLines.splice(index, 0, newOrderLine);
          }
        } else {
          // We have just updated the exsiting order line
          this.orderLines[index].deliveryOrgId = payload.orgId;
          this.orderLines[index].deliveryAddressId = payload.addressId;
          this.orderLines[index].deliveryOrgName = payload.orgName;
        }

        if (((_payload$addresses = payload.addresses) === null || _payload$addresses === void 0 ? void 0 : _payload$addresses.length) > 0) {
          // We have an updated list of SOP Addresses for the basket to use
          this.sopAddresses = payload.addresses;
        } // Org or address has changed so blank out the delivery person


        this.orderLines[index].deliveryPersonId = null;
        this.orderLines[index].deliveryPersonName = null;
      }
    },

    /**
     * Update an order line with new delivery person details
     * @param {Object} payload Details about the new delivery person
     */
    onSetLineDeliveryPerson: function onSetLineDeliveryPerson(payload) {
      var index = this.orderLines.findIndex(function (line) {
        return line.id === (payload === null || payload === void 0 ? void 0 : payload.orderLineId);
      });

      if (index > -1) {
        this.orderLines[index].deliveryPersonId = payload.personId;
        this.orderLines[index].deliveryPersonName = payload.personName;
      }
    },
    getMatchingOrderLine: function getMatchingOrderLine(payload) {
      return this.orderLines.findIndex(function (x) {
        return (x.productId === payload.id || x.productIdGuid === payload.productIdGuid) && x.pricingScheduleId === payload.pricingScheduleId && x.productFormatId === payload.productFormatId && x.productLicenceTypeId === payload.productLicenceTypeId;
      });
    },
    onResponse: function onResponse() {
      if (this.optimistic <= 0) {
        this.debouncedRefreshData();
      }
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.loading = true;
      this.$root.$emit(basket.REQUEST);
      this.$emit("request");
      listItemsEx(this.showCarriage).then(function (response) {
        _this2.orderLines = response.data.items;
        _this2.allowSelectDeliveryAddress = response.data.allowSelectDeliveryAddress;
        _this2.allowMultiDeliveryAddress = response.data.allowMultiDeliveryAddress;
        _this2.hasDeliveryAddresses = response.data.hasDeliveryAddresses;
        _this2.allowSelectDeliveryPerson = response.data.allowSelectDeliveryPerson;
        _this2.accountPerson = response.data.accountPerson;

        _this2.$root.$emit(basket.SUCCESS, _this2.orderLines);

        _this2.$emit("success", _this2.orderLines);

        return getVoucher();
      }).then(function (response) {
        if (response && response.data && response.data) {
          _this2.voucherCodes = Object.keys(response.data);
        }
      }).catch(function (error) {
        _this2.$root.$emit(basket.FAILURE, error);

        _this2.$emit("failure", error);
      }).finally(function () {
        _this2.$root.$emit(basket.RESPONSE, _this2.orderLines);

        _this2.$emit("response", _this2.orderLines);

        _this2.loading = false;
        _this2.initialLoading = false;
        _this2.expectingNewLine = false;

        _this2.$emit("refreshed");
      });
    },
    clearMessages: function clearMessages() {
      this.messages = [];
    },

    /**
     * Load SOP Addresses
     */
    loadSopAddresses: function loadSopAddresses() {
      var _this3 = this;

      loadOrderLineAddresses().then(function (response) {
        _this3.sopAddresses = response.data;
      }).catch(function () {
        _this3.sopAddresses = [];
      }).finally(function () {
        // Select the default address
        _this3.selectDefaultAddress(); // Make sure we only attempt to do this once


        _this3.sopAddressesLoaded = false;
      });
    },

    /**
     * Try and select the default address
     */
    selectDefaultAddress: function selectDefaultAddress() {
      var _this$sopAddresses;

      if (((_this$sopAddresses = this.sopAddresses) === null || _this$sopAddresses === void 0 ? void 0 : _this$sopAddresses.length) > 0) {
        // Find the address tagged as default
        this.defaultSopAddress = this.sopAddresses.find(function (address) {
          return address.isDefault;
        }) || null;

        if (!this.defaultSopAddress) {
          // No address found, so just pick the first one
          var _this$sopAddresses2 = _slicedToArray(this.sopAddresses, 1);

          this.defaultSopAddress = _this$sopAddresses2[0];
        }
      }

      if (!this.defaultSopAddress) {
        // If there are no addresses then select an empty object
        this.defaultSopAddress = {};
      } else if (this.hasDeliveryAddresses) {
        // Basket has existing lines that have delivery addresses so fire an event to check
        // other lines are set up correctly (if we need to)
        this.$emit("checkDefaultSopAddress", this.defaultSopAddress);
      }
    }
  },

  /**
   * Render this component.
   */
  render: function render(h) {
    var bindings = [];

    if (this.$scopedSlots.default) {
      bindings.push(this.$scopedSlots.default({
        orderLines: this.filteredOrderLines,
        allowSelectDeliveryAddress: this.allowSelectDeliveryAddress,
        allowMultiDeliveryAddress: this.allowMultiDeliveryAddress,
        allowSelectDeliveryPerson: this.allowSelectDeliveryPerson,
        accountPerson: this.accountPerson,
        hasDeliveryAddresses: this.hasDeliveryAddresses,
        voucherCodes: this.voucherCodes,
        totals: this.totals,
        refreshData: this.refreshData,
        expectingNewLine: this.expectingNewLine,
        optimistic: this.optimistic,
        loading: this.loading,
        initialLoading: this.initialLoading,
        messages: this.messages,
        clearMessages: this.clearMessages,
        defaultSopAddress: this.defaultSopAddress,
        sopAddresses: this.sopAddresses,
        productAddresses: this.productAddresses,
        splittableProducts: this.splittableProducts,
        missingDeliveryAddresses: this.missingDeliveryAddresses
      }));
    } else {
      bindings.push(this.$slots.default);
    }

    return h("div", bindings);
  }
};

/* script */
var __vue_script__$2 = script$2;
/* template */

/* style */

var __vue_inject_styles__$2 = undefined;
/* scoped */

var __vue_scope_id__$2 = "data-v-0351fafe";
/* module identifier */

var __vue_module_identifier__$2 = undefined;
/* functional template */

var __vue_is_functional_template__$2 = undefined;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$2 = /*#__PURE__*/normalizeComponent({}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
var script$3 = {
  name: "BaseQuantity",
  props: {
    value: {
      type: null,
      default: 1
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: null
    },
    step: {
      type: Number,
      default: 1
    },
    stock: {
      type: Number,
      default: null
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      internalValue: 0,
      enableValidation: true,
      hasFocus: false,
      focusedValue: 0
    };
  },
  computed: {
    stockOrMax: function stockOrMax() {
      var result = this.max;

      if (this.stock !== null) {
        result = Math.min(this.stock, this.max);
      }

      return result;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(val) {
        this.internalValue = this.clampValue(val);
      }
    },
    min: {
      immediate: true,
      handler: function handler() {
        this.internalValue = this.clampValue(this.internalValue);
      }
    },
    max: {
      immediate: true,
      handler: function handler() {
        this.internalValue = this.clampValue(this.internalValue);
      }
    },
    internalValue: {
      handler: function handler() {
        if (!this.hasFocus) {
          this.onLostFocus();
        }
      }
    }
  },
  methods: {
    changeQuantity: function changeQuantity(amount) {
      var newVal = Number.parseInt(this.internalValue, 10) + amount;
      this.internalValue = this.clampValue(newVal);
    },
    clampValue: function clampValue(input) {
      var internalInput = input;

      if (this.enableValidation) {
        if (this.min !== null && internalInput < this.min) {
          internalInput = this.min;
        } else if (this.stockOrMax !== null && internalInput > this.stockOrMax) {
          internalInput = this.stockOrMax;
        }
      }

      return internalInput;
    },

    /**
     * When the component loses focus, enable validation and force
     * one final validation to run to make sure what the user have entered is
     * correct
     */
    onLostFocus: function onLostFocus() {
      this.hasFocus = false; // Only fire an input event if the internal value has changed

      if (this.internalValue !== this.focusedValue) {
        this.enableValidation = true;
        this.internalValue = this.clampValue(this.internalValue);
        this.$emit("input", this.internalValue);
      }
    },

    /**
     * Disable validation upon focus so the user can type what they like without
     * fighting the validation system
     */
    onFocus: function onFocus() {
      this.focusedValue = this.internalValue;
      this.enableValidation = false;
      this.hasFocus = true;
    },

    /**
     * Get the clamped value
     */
    getValue: function getValue() {
      return this.clampValue(this.internalValue);
    }
  }
};

/* script */
var __vue_script__$3 = script$3;
/* template */

var __vue_render__$2 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.internalValue,
      expression: "internalValue"
    }],
    staticClass: "base-quantity",
    attrs: {
      "type": "number",
      "min": _vm.min,
      "max": _vm.stockOrMax,
      "step": _vm.step,
      "disabled": _vm.readOnly,
      "aria-label": "Base quantity"
    },
    domProps: {
      "value": _vm.internalValue
    },
    on: {
      "blur": _vm.onLostFocus,
      "focus": _vm.onFocus,
      "input": function input($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.internalValue = $event.target.value;
      }
    }
  });
};

var __vue_staticRenderFns__$2 = [];
/* style */

var __vue_inject_styles__$3 = undefined;
/* scoped */

var __vue_scope_id__$3 = "data-v-408f7572";
/* module identifier */

var __vue_module_identifier__$3 = undefined;
/* functional template */

var __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

// 20.1.2.4 Number.isNaN(number)


_export(_export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});

var _events;
var script$4 = {
  name: "BasketItemQuantity",
  events: (_events = {}, _defineProperty(_events, basket.addToBasket.REQUEST, function (payload) {
    this.incrementValue(payload);
  }), _defineProperty(_events, basket.clearBasket.REQUEST, function () {
    this.resetValue();
  }), _defineProperty(_events, basket.setBasketItemQuantity.REQUEST, function (payload) {
    this.setValue(payload);
  }), _defineProperty(_events, basket.setBasketItemQuantity.START, function () {
    this.optimistic += 1;
  }), _defineProperty(_events, basket.setBasketItemQuantity.STOP, function () {
    this.optimistic -= 1;
  }), _defineProperty(_events, basket.setBasketItemQuantity.UPDATE, function (payload) {
    this.setValue(payload);
  }), _defineProperty(_events, basket.setBasketItemQuantity.RESPONSE, function () {
    this.debouncedRefreshData();
  }), _defineProperty(_events, basket.addToBasket.RESPONSE, function () {
    this.optimistic -= 1;
    this.debouncedRefreshData();
  }), _defineProperty(_events, basket.removeFromBasket.RESPONSE, function () {
    this.optimistic -= 1;
    this.debouncedRefreshData();
  }), _defineProperty(_events, basket.clearBasket.RESPONSE, function () {
    this.optimistic -= 1;
    this.debouncedRefreshData();
  }), _events),
  props: {
    value: {
      type: Number,
      default: 0
    },
    fetchInitValue: {
      type: Boolean,
      default: false
    },
    poll: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      mutable: [],
      optimistic: 0,
      estimatedAdjustor: 0,
      interval: null
    };
  },
  computed: {
    quantity: function quantity() {
      var result = this.estimatedAdjustor;

      if (this.mutable && Array.isArray(this.mutable)) {
        var sum = this.mutable.map(function (x) {
          return x.quantity;
        }).reduce(function (acc, val) {
          return acc + val;
        }, 0);

        if (sum > -1) {
          result += sum;
        }
      }

      if (Number.isNaN(result)) {
        result = 0;
      }

      return result;
    },
    classes: function classes() {
      var result = [];

      if (this.optimistic > 0) {
        result.push("basket-total-items--optimistic");
      }

      return result;
    }
  },
  watch: {
    quantity: function quantity(val) {
      this.$emit("input", val);
    }
  },
  created: function () {
    var _created = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this = this;

      var promise;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.estimatedAdjustor = this.initValue;
              Object.keys(this.$options.events).forEach(function (x) {
                _this.$root.$on(x, _this.$options.events[x].bind(_this));
              });
              _context.next = 4;
              return this.debouncedRefreshData();

            case 4:
              promise = _context.sent;

              if (this.poll) {
                this.interval = window.setInterval(function () {
                  _this.debouncedRefreshData();
                }, 30000);
              }

              return _context.abrupt("return", promise);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    resetValue: function resetValue() {
      this.optimistic += 1;
      this.mutable = [];
    },
    incrementValue: function incrementValue(payload) {
      this.optimistic += 1;
      var matchingLine = this.getMatchingLine(payload);

      if (matchingLine > -1) {
        this.mutable[matchingLine].quantity += payload.quantity;
      } else {
        this.estimatedAdjustor += payload.quantity;
      }
    },
    setValue: function setValue(payload) {
      var matchingLine = this.getMatchingLine(payload);

      if (matchingLine > -1) {
        this.mutable[matchingLine].quantity = payload.quantity;
      }
    },
    getMatchingLine: function getMatchingLine(payload) {
      return this.mutable.findIndex(function (x) {
        return (x.productId === payload.id || x.productIdGuid === payload.productIdGuid) && x.pricingScheduleId === payload.pricingScheduleId && x.productFormatId === payload.productFormatId && x.productLicenceTypeId === payload.productLicenceTypeId;
      });
    },
    debouncedRefreshData: debounce(function refreshData() {
      this.refreshData();
    }, 1000),
    refreshData: function () {
      var _refreshData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$listItems;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!(this.optimistic <= 0)) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 4;
                return listItems();

              case 4:
                _yield$listItems = _context2.sent;
                this.mutable = _yield$listItems.data;
                this.estimatedAdjustor = 0;

              case 7:
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                console.error(_context2.t0);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9]]);
      }));

      function refreshData() {
        return _refreshData.apply(this, arguments);
      }

      return refreshData;
    }()
  }
};

/* script */
var __vue_script__$4 = script$4;
/* template */

var __vue_render__$3 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', {
    staticClass: "basket-total-items",
    class: _vm.classes
  }, [_vm._v("\n  " + _vm._s(_vm.quantity) + "\n")]);
};

var __vue_staticRenderFns__$3 = [];
/* style */

var __vue_inject_styles__$4 = undefined;
/* scoped */

var __vue_scope_id__$4 = undefined;
/* module identifier */

var __vue_module_identifier__$4 = undefined;
/* functional template */

var __vue_is_functional_template__$4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, undefined, undefined, undefined);

var script$5 = {
  name: "AddressDisplay",
  props: {
    /**
     * Address
     */
    value: {
      type: Object,
      default: function _default() {}
    },

    /**
     * If true then fields are disabled
     */
    disabled: {
      type: Boolean,
      default: false
    },

    /**
     * Whether we show validation messages
     */
    showValidation: {
      type: Boolean,
      default: false
    },

    /**
     * List of countries for manual address entry
     */
    countries: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      address: {}
    };
  },
  computed: {
    /**
     * Whether validation can be run
     */
    isValidated: function isValidated() {
      return this.showValidation && !this.disabled;
    },

    /**
     * Whether a country has been selected
     */
    countrySelected: function countrySelected() {
      return this.address.countryId && Number(this.address.countryId) !== 0;
    }
  },
  watch: {
    /**
     * Value has been changed so create a copy for internal use
     */
    value: {
      deep: true,
      immediate: true,
      handler: function handler(val) {
        if (!isEqual$1(val, this.address)) {
          if (val) {
            this.address = cloneDeep(val);
          } else {
            this.address = {};
          }
        }
      }
    },

    /**
     * Internal address has changed so pass it to the parent
     */
    address: {
      deep: true,
      handler: function handler() {
        if (!this.disabled && !isEqual$1(this.value, this.address)) {
          // Internal address does not match the external value, so it has changed
          // internally
          this.$emit("addressChanged");
        }

        this.$emit("input", this.address);
      }
    }
  }
};

/* script */
var __vue_script__$5 = script$5;
/* template */

var __vue_render__$4 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "address-display"
  }, [_c('div', {
    staticClass: "address-display__field"
  }, [_c('label', [_vm._v("Organisation name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": _vm.disabled ? null : 'Organisation name',
      "type": "text",
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.address.orgName,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "orgName", $$v);
      },
      expression: "address.orgName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "address-display__field"
  }, [_c('label', [_vm._v("Address line 1")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": _vm.disabled ? null : 'Address line 1',
      "type": "text",
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.address.line1,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "line1", $$v);
      },
      expression: "address.line1"
    }
  }), _vm._v(" "), _vm.isValidated && !_vm.address.line1 ? _c('div', {
    staticClass: "validation-message"
  }, [_vm._v("\n      Please enter your address.\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "address-display__field"
  }, [_c('label', [_vm._v("Address line 2")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": _vm.disabled ? null : 'Address line 2',
      "type": "text",
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.address.line2,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "line2", $$v);
      },
      expression: "address.line2"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "address-display__field"
  }, [_c('label', [_vm._v("Address line 3")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": _vm.disabled ? null : 'Address line 3',
      "type": "text",
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.address.line3,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "line3", $$v);
      },
      expression: "address.line3"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "address-display__field"
  }, [_c('label', [_vm._v("Town")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": _vm.disabled ? null : 'Town',
      "type": "text",
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.address.town,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "town", $$v);
      },
      expression: "address.town"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "address-display__field"
  }, [_c('label', [_vm._v("Region")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": _vm.disabled ? null : 'County',
      "type": "text",
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.address.region,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "region", $$v);
      },
      expression: "address.region"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "address-display__field"
  }, [_c('label', [_vm._v("Postcode")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": _vm.disabled ? null : 'Postcode',
      "type": "text",
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.address.postcode,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "postcode", $$v);
      },
      expression: "address.postcode"
    }
  }), _vm._v(" "), _vm.isValidated && !_vm.address.postcode ? _c('div', {
    staticClass: "validation-message"
  }, [_vm._v("\n      Please enter your postcode.\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "address-display__field"
  }, [_c('label', [_vm._v("Country")]), _vm._v(" "), _c('b-form-select', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.address.countryId,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "countryId", $$v);
      },
      expression: "address.countryId"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null,
      "selected": ""
    }
  }, [_vm._v("\n        Please select\n      ")]), _vm._v(" "), _vm._l(_vm.countries, function (country, index) {
    return _c('b-form-select-option', {
      key: index,
      attrs: {
        "value": country.countryId
      }
    }, [_vm._v("\n        " + _vm._s(country.countryName) + "\n      ")]);
  })], 2), _vm._v(" "), _vm.isValidated && !_vm.countrySelected ? _c('div', {
    staticClass: "validation-message"
  }, [_vm._v("\n      Please select your country.\n    ")]) : _vm._e()], 1)]);
};

var __vue_staticRenderFns__$4 = [];
/* style */

var __vue_inject_styles__$5 = undefined;
/* scoped */

var __vue_scope_id__$5 = "data-v-89621622";
/* module identifier */

var __vue_module_identifier__$5 = undefined;
/* functional template */

var __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, undefined, undefined, undefined);

var script$6 = {
  name: "BasketOrderLineAddress",
  components: {
    AddressDisplay: __vue_component__$5,
    UberSearch: UberSearch
  },
  props: {
    /**
     * A list of existing order lines. Saves having to load them each
     * time the dialog is displayed
     */
    orderLines: {
      type: Array,
      default: null
    },

    /**
     * A list of existing SOP Addresses so that we can filter them out when adding
     * new ones
     */
    sopAddresses: {
      type: Array,
      default: null
    }
  },
  data: function data() {
    return {
      address: {},
      config: {},
      productId: null,
      orderLineId: null,
      loading: false,
      loaded: false,
      showValidation: false
    };
  },
  computed: {
    /**
     * The current web account user type
     */
    userType: function userType() {
      var _this$config;

      return ((_this$config = this.config) === null || _this$config === void 0 ? void 0 : _this$config.userType) || {};
    },

    /**
     * All new addresses get added with this org type
     */
    orgTypeId: function orgTypeId() {
      var _this$userType;

      return (_this$userType = this.userType) === null || _this$userType === void 0 ? void 0 : _this$userType.defaultOrgTypeId;
    },

    /**
     * Whether we can search for existing addresses
     */
    canSearchForAddress: function canSearchForAddress() {
      var _this$userType2, _this$userType3;

      return !!((_this$userType2 = this.userType) !== null && _this$userType2 !== void 0 && _this$userType2.allowOrgSearch || (_this$userType3 = this.userType) !== null && _this$userType3 !== void 0 && _this$userType3.allowExternalOrgSearch && this.orgTypeId);
    },

    /**
     * Whether we can add a manual address
     */
    canAddManualAddress: function canAddManualAddress() {
      var _this$userType4, _this$userType6;

      var allowManualAdditionOfAddress = (_this$userType4 = this.userType) === null || _this$userType4 === void 0 ? void 0 : _this$userType4.allowManualAdditionOfDeliveryAddress;

      if (allowManualAdditionOfAddress === null || allowManualAdditionOfAddress === undefined) {
        var _this$userType5;

        // No value set specifically for invoice or delivery address so fall back to the
        // old property that covered both
        allowManualAdditionOfAddress = (_this$userType5 = this.userType) === null || _this$userType5 === void 0 ? void 0 : _this$userType5.allowManualAdditionOfAddress;
      }

      return !!(this.orgTypeId && ((_this$userType6 = this.userType) !== null && _this$userType6 !== void 0 && _this$userType6.allowManualOrgEntry || allowManualAdditionOfAddress));
    },

    /**
     * List of existing sop IDs to exclude when showing lists of addresses
     */
    existingSopAddressIds: function existingSopAddressIds() {
      var sopAddresses = this.sopAddresses || [];
      return sopAddresses.map(function (address) {
        return address.addressId;
      });
    },

    /**
     * Whether or not we can add an address of any type
     */
    canAddAddress: function canAddAddress() {
      return this.canAddManualAddress || this.canSearchForAddress;
    },

    /**
     * Label to use for the OK button
     */
    okTitle: function okTitle() {
      return this.canAddAddress ? "Save Address" : "Cancel";
    }
  },
  created: function created() {
    this.$root.$on(basket.orderLineDeliveryAddress.ADDNEW, this.open);
  },
  methods: {
    /**
     * Called when the modal is opened via a global event
     * @param {object} payload Data sent from whatever opened the modal
     */
    open: function open(payload) {
      this.orderLineId = payload === null || payload === void 0 ? void 0 : payload.orderLineId;
      this.productId = payload === null || payload === void 0 ? void 0 : payload.productId;
      this.$bvModal.show("order-line-address");
    },

    /**
     * Save the new address and update the order line
     */
    onSave: function onSave() {
      var _this = this;

      if (this.canAddAddress && this.validate()) {
        // Make sure all the address data makes sense for adding a new delivery address
        this.prepareAddressForSaving();
        var addressPayload = {
          newAddress: this.address,
          orderLineId: this.orderLineId
        };
        this.$root.$emit(basket.orderLineDeliveryAddress.REQUEST, addressPayload);
        this.loading = true;
        updateLineDeliveryAddress(addressPayload).then(function (result) {
          if (result !== null && result !== void 0 && result.data) {
            // The result will contain the new address details as well as an updated
            // list of SOP addresses for the basket to use
            var newAddressPayload = {
              orderLineId: _this.orderLineId,
              newOrderLineId: result.data.lineId,
              donorLineId: null,
              addressId: result.data.addressId,
              orgId: result.data.orgId,
              addresses: result.data.addresses
            };

            _this.$root.$emit(basket.orderLineDeliveryAddress.SUCCESS, newAddressPayload);

            _this.$bvModal.hide("order-line-address");
          } else {
            _this.$root.$emit(basket.orderLineDeliveryAddress.FAILURE, addressPayload);
          }
        }).catch(function (err) {
          _this.$root.$emit(basket.orderLineDeliveryAddress.FAILURE, err);
        }).finally(function () {
          _this.$root.$emit(basket.orderLineDeliveryAddress.RESPONSE);

          _this.loading = false;
        });
      } else if (!this.canAddAddress) {
        // We cannot add an address at all so simply close the popup
        this.$nextTick(function () {
          _this.$bvModal.hide("order-line-address");
        });
      }
    },

    /**
     * Set additional properties on the address before it is saved
     */
    prepareAddressForSaving: function prepareAddressForSaving() {
      if (this.address) {
        // Set this as a delivery address "D"
        this.address.addressType = "D";

        if (!this.address.orgId) {
          // If we have no OrgId then we will create a new org, so we need
          // to supply an organisation type
          this.address.orgTypeId = this.orgTypeId;
        }

        if (!this.address.orgName) {
          // If org name is does not exist, then make sure it is set
          // to an empty string
          this.address.orgName = "";
        }
      }
    },

    /**
     * When the modal is loaded populate it with data
     */
    onShown: function onShown() {
      var _this2 = this;

      this.loading = true;
      getDeliveryAddressSetup(this.productId, this.orderLines, this.existingSopAddressIds).then(function (result) {
        _this2.config = (result === null || result === void 0 ? void 0 : result.data) || {};
      }).catch(function () {
        _this2.config = {};
      }).finally(function () {
        _this2.loading = false;
        _this2.loaded = true;
      });
    },

    /**
     * Clean up when the modal is closed
     */
    onHidden: function onHidden() {
      this.address = {};
      this.config = {};
      this.productId = null;
      this.orderLineId = null;
      this.loading = false;
      this.loaded = false;
      this.showValidation = false;
    },

    /**
     * The user has edited the address. We need to blank out ID values so that it will
     * force a new address to be saved
     */
    onManualAddressChanged: function onManualAddressChanged() {
      var _this$address;

      if ((_this$address = this.address) !== null && _this$address !== void 0 && _this$address.orgId) {
        this.address.orgId = null;
        this.address.addressId = null;
        this.address.sopAddressId = null;
      }
    },

    /**
     * Validate the address we have
     */
    validate: function validate() {
      this.showValidation = true;
      return this.address.line1 && this.address.countryId && Number(this.address.countryId) !== 0 && this.address.postcode;
    }
  }
};

/* script */
var __vue_script__$6 = script$6;
/* template */

var __vue_render__$5 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('b-modal', {
    staticClass: "order-line-address",
    attrs: {
      "id": "order-line-address",
      "title": "Add new Delivery Address",
      "ok-only": !_vm.canAddAddress,
      "ok-title": _vm.okTitle,
      "ok-variant": "primary"
    },
    on: {
      "shown": _vm.onShown,
      "hidden": _vm.onHidden,
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.onSave($event);
      }
    }
  }, [_vm.loading ? _c('div', {
    staticClass: "order-line-address__loading"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.canAddAddress || !_vm.loaded ? _c('div', {
    staticClass: "order-line-address__details"
  }, [_vm.canSearchForAddress ? _c('UberSearch', {
    staticClass: "order-line-address__search",
    attrs: {
      "show-validation": _vm.showValidation,
      "user-type": _vm.config.userType
    },
    model: {
      value: _vm.address,
      callback: function callback($$v) {
        _vm.address = $$v;
      },
      expression: "address"
    }
  }) : _c('label', {
    staticClass: "order-line-address__manual"
  }, [_vm._v("\n      Please enter the address details below\n    ")]), _vm._v(" "), _c('AddressDisplay', {
    staticClass: "address-selector__current",
    attrs: {
      "disabled": !_vm.canAddManualAddress,
      "show-validation": _vm.showValidation,
      "countries": _vm.config.countries
    },
    on: {
      "addressChanged": _vm.onManualAddressChanged
    },
    model: {
      value: _vm.address,
      callback: function callback($$v) {
        _vm.address = $$v;
      },
      expression: "address"
    }
  })], 1) : _c('div', {
    staticClass: "order-line-address__details"
  }, [_vm._t("cannotAddAddresses", [_c('p', [_vm._v("\n        Your account can only add certain addresses to your delivery address list.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        All of the addresses that you can add are already in your list.\n      ")])])], 2)]);
};

var __vue_staticRenderFns__$5 = [];
/* style */

var __vue_inject_styles__$6 = undefined;
/* scoped */

var __vue_scope_id__$6 = undefined;
/* module identifier */

var __vue_module_identifier__$6 = undefined;
/* functional template */

var __vue_is_functional_template__$6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, undefined, undefined, undefined);

/* script */
var __vue_script__$7 = script$4;
/* template */

var __vue_render__$6 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', {
    staticClass: "basket-total-items",
    class: _vm.classes
  }, [_vm._v("\n  " + _vm._s(_vm.quantity) + "\n")]);
};

var __vue_staticRenderFns__$6 = [];
/* style */

var __vue_inject_styles__$7 = undefined;
/* scoped */

var __vue_scope_id__$7 = undefined;
/* module identifier */

var __vue_module_identifier__$7 = undefined;
/* functional template */

var __vue_is_functional_template__$7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, undefined, undefined, undefined);

//
var script$7 = {
  name: "BasketQuantity",
  components: {
    BasketItemQuantity: __vue_component__$7
  },
  data: function data() {
    return {
      loaded: false,
      count: 0
    };
  },
  computed: {
    noun: function noun() {
      var result = "items";

      if (this.count === 1) {
        result = "item";
      }

      return result;
    }
  },
  created: function created() {
    var _this = this;

    getItemCount().then(function (response) {
      _this.count = response.data;
    }).finally(function () {
      _this.loaded = true;
    });
  }
};

/* script */
var __vue_script__$8 = script$7;
/* template */

var __vue_render__$7 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', {
    staticClass: "basket-quantity"
  }, [_vm.loaded ? [_c('basket-item-quantity', {
    model: {
      value: _vm.count,
      callback: function callback($$v) {
        _vm.count = $$v;
      },
      expression: "count"
    }
  })] : _vm._e(), _vm._v("\n  " + _vm._s(_vm.noun) + "\n")], 2);
};

var __vue_staticRenderFns__$7 = [];
/* style */

var __vue_inject_styles__$8 = undefined;
/* scoped */

var __vue_scope_id__$8 = "data-v-41a16c48";
/* module identifier */

var __vue_module_identifier__$8 = undefined;
/* functional template */

var __vue_is_functional_template__$8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
var script$8 = {
  name: "ConvertToBasket",
  props: {
    orderId: {
      type: String,
      required: true
    }
  },
  methods: {
    convertToBasket: function convertToBasket() {}
  }
};

/* script */
var __vue_script__$9 = script$8;
/* template */

var __vue_render__$8 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('form', {
    staticClass: "convert-to-basket",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.convertToBasket($event);
      }
    }
  }, [_c('button', [_vm._t("default", [_vm._v("\n      Convert to basket\n    ")])], 2)]);
};

var __vue_staticRenderFns__$8 = [];
/* style */

var __vue_inject_styles__$9 = undefined;
/* scoped */

var __vue_scope_id__$9 = "data-v-fe1f7388";
/* module identifier */

var __vue_module_identifier__$9 = undefined;
/* functional template */

var __vue_is_functional_template__$9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$9 = {
  name: "DebugPanel",
  props: {
    value: {
      type: Object,
      default: function _default() {}
    },
    headings: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isDebug: false
    };
  },
  computed: {
    datasets: function datasets() {
      var result = {};
      var counter = 1;

      if (Array.isArray(this.value)) {
        this.value.forEach(function (v) {
          // eslint-disable-next-line no-plusplus
          result["data-".concat(counter++)] = v;
        });
      } else if (this.headings) {
        result = this.value;
      } else {
        // eslint-disable-next-line no-plusplus
        result["data-".concat(counter++)] = this.value;
      }

      return result;
    }
  },
  created: function created() {
    this.isDebug = this.checkDebug();
  },
  methods: {
    checkDebug: function checkDebug() {
      var url = new URL(window.location);
      var params = url.searchParams;
      return Boolean(params.get("evtd"));
    },
    getValueClass: function getValueClass(value) {
      var result = "";

      if (value === true) {
        result += "debug-panel__data-value--true";
      } else if (value === false) {
        result += "debug-panel__data-value--false";
      } else if (!Number.isNaN(Number(value))) {
        result += "debug-panel__data-value--number";
      }

      return result;
    }
  }
};

/* script */
var __vue_script__$a = script$9;
/* template */

var __vue_render__$9 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.isDebug ? _c('div', {
    staticClass: "debug-panel"
  }, _vm._l(_vm.datasets, function (set, name) {
    return _c('div', {
      key: name,
      staticClass: "debug-panel__dataset"
    }, [_vm.headings ? _c('h2', {
      staticClass: "debug-panel__dataset-title"
    }, [_vm._v("\n      " + _vm._s(name) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm._l(set, function (val, key) {
      return _c('div', {
        key: key,
        staticClass: "debug-panel__data",
        class: {
          checked: ''
        }
      }, [_c('input', {
        staticClass: "debug-panel__data-checkbox",
        attrs: {
          "type": "checkbox"
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "debug-panel__data-key"
      }, [_vm._v(_vm._s(key) + ":")]), _vm._v(" "), _c('pre', {
        staticClass: "debug-panel__data-value",
        class: _vm.getValueClass(val)
      }, [_vm._v(_vm._s(val))])]);
    })], 2);
  }), 0) : _vm._e();
};

var __vue_staticRenderFns__$9 = [];
/* style */

var __vue_inject_styles__$a = undefined;
/* scoped */

var __vue_scope_id__$a = undefined;
/* module identifier */

var __vue_module_identifier__$a = undefined;
/* functional template */

var __vue_is_functional_template__$a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, undefined, undefined, undefined);

//
var script$a = {
  name: "DeleteAllOrderLines",
  data: function data() {
    return {
      requesting: false
    };
  },
  methods: {
    deleteAllOrderLines: function deleteAllOrderLines() {
      var _this = this;

      this.$root.$emit(basket.clearBasket.REQUEST);
      this.$emit("request");
      this.requesting = true;
      clearBasket().then(function (response) {
        _this.$root.$emit(basket.clearBasket.SUCCESS, response);

        _this.$emit("success", response);
      }).catch(function (error) {
        _this.$root.$emit(basket.clearBasket.FAILURE, error);

        _this.$emit("failure", error);
      }).finally(function () {
        _this.$root.$emit(basket.clearBasket.RESPONSE);

        _this.$emit("response");

        _this.requesting = false;
      });
    }
  }
};

/* script */
var __vue_script__$b = script$a;
/* template */

var __vue_render__$a = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('button', {
    staticClass: "btn delete-all-order-lines",
    on: {
      "click": _vm.deleteAllOrderLines
    }
  }, [_vm._t("default", [_vm._v("\n    Clear basket\n  ")])], 2);
};

var __vue_staticRenderFns__$a = [];
/* style */

var __vue_inject_styles__$b = undefined;
/* scoped */

var __vue_scope_id__$b = "data-v-60c7103a";
/* module identifier */

var __vue_module_identifier__$b = undefined;
/* functional template */

var __vue_is_functional_template__$b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, undefined, undefined, undefined);

var script$b = {
  name: "DeleteOrderLine",
  props: {
    orderLineId: {
      type: String,
      required: true
    },
    productId: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      requesting: false
    };
  },
  computed: {
    classes: function classes() {
      var result = [];

      if (this.requesting) {
        result.push("delete-order-line--requesting");
      }

      return result;
    }
  },
  methods: {
    deleteOrderLine: function deleteOrderLine() {
      var _this = this;

      if (!this.requesting) {
        var payload = {
          orderLineId: this.orderLineId
        };
        this.$root.$emit(basket.removeFromBasket.REQUEST, payload);
        this.$emit("request");
        this.requesting = true;
        removeItem(this.orderLineId).then(function (response) {
          _this.$root.$emit(basket.removeFromBasket.SUCCESS, response);

          _this.$emit("success", response);

          _this.$gtag.onRemoveFromBasket([_this.productId]);
        }).catch(function (error) {
          _this.$root.$emit(basket.removeFromBasket.FAILURE, error);

          _this.$emit("failure", error);
        }).finally(function () {
          _this.$root.$emit(basket.clearBasket.RESPONSE);

          _this.$emit("response");

          _this.requesting = false;
        });
      }
    }
  }
};

/* script */
var __vue_script__$c = script$b;
/* template */

var __vue_render__$b = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('button', _vm._g({
    staticClass: "delete-order-line",
    class: _vm.classes,
    attrs: {
      "aria-label": "Delete order line"
    },
    on: {
      "click": _vm.deleteOrderLine
    }
  }, _vm.$listeners), [_vm.requesting ? [_vm._t("loading")] : [_vm._t("delete-label", [_vm._v("\n      Remove from basket\n    ")])]], 2);
};

var __vue_staticRenderFns__$b = [];
/* style */

var __vue_inject_styles__$c = undefined;
/* scoped */

var __vue_scope_id__$c = "data-v-8c1b334a";
/* module identifier */

var __vue_module_identifier__$c = undefined;
/* functional template */

var __vue_is_functional_template__$c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$c = {
  name: "ErrorBoundary",
  props: {
    propagate: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Something went wrong!"
    },
    message: {
      type: String,
      default: "Please try again later."
    }
  },
  data: function data() {
    return {
      err: null,
      vm: null,
      info: null
    };
  },
  computed: {
    hasError: function hasError() {
      return this.err !== null;
    },
    errorMessage: function errorMessage() {
      return this.hasError ? this.err.message : null;
    },
    details: function details() {
      var _this$vm, _this$vm2;

      return {
        message: this.errorMessage,
        hasError: this.hasError,
        info: this.info,
        error: this.err,
        props: (_this$vm = this.vm) === null || _this$vm === void 0 ? void 0 : _this$vm._props,
        computed: (_this$vm2 = this.vm) === null || _this$vm2 === void 0 ? void 0 : _this$vm2._data
      };
    }
  },
  errorCaptured: function errorCaptured(err, vm, info) {
    this.err = err;
    this.vm = vm;
    this.info = info;
    this.$emit("error", err);
    return this.propagate;
  }
};

/* script */
var __vue_script__$d = script$c;
/* template */

var __vue_render__$c = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.hasError,
      expression: "hasError"
    }]
  }, [_vm._t("error", [_c('h1', {
    staticClass: "error-boundry__error-title"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "error-boundry__error-message"
  }, [_vm._v("\n        " + _vm._s(_vm.message) + "\n      ")])], {
    "details": _vm.details
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.hasError,
      expression: "!hasError"
    }]
  }, [_vm._t("default")], 2)]);
};

var __vue_staticRenderFns__$c = [];
/* style */

var __vue_inject_styles__$d = undefined;
/* scoped */

var __vue_scope_id__$d = undefined;
/* module identifier */

var __vue_module_identifier__$d = undefined;
/* functional template */

var __vue_is_functional_template__$d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$d, __vue_script__$d, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, undefined, undefined, undefined);

/* script */
var __vue_script__$e = script$3;
/* template */

var __vue_render__$d = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.internalValue,
      expression: "internalValue"
    }],
    staticClass: "base-quantity",
    attrs: {
      "type": "number",
      "min": _vm.min,
      "max": _vm.stockOrMax,
      "step": _vm.step,
      "disabled": _vm.readOnly,
      "aria-label": "Base quantity"
    },
    domProps: {
      "value": _vm.internalValue
    },
    on: {
      "blur": _vm.onLostFocus,
      "focus": _vm.onFocus,
      "input": function input($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.internalValue = $event.target.value;
      }
    }
  });
};

var __vue_staticRenderFns__$d = [];
/* style */

var __vue_inject_styles__$e = undefined;
/* scoped */

var __vue_scope_id__$e = "data-v-408f7572";
/* module identifier */

var __vue_module_identifier__$e = undefined;
/* functional template */

var __vue_is_functional_template__$e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$e, __vue_script__$e, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, undefined, undefined, undefined);

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var script$d = {
  name: "OrderLineQuantity",
  components: {
    BaseQuantity: __vue_component__$e
  },
  props: {
    orderLineId: {
      type: String,
      required: true
    },
    productId: {
      type: Number,
      required: true
    },
    stackSize: {
      type: Number,
      default: null
    },
    initValue: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      default: 1,
      validator: function validator(val) {
        return val >= 0;
      }
    },
    max: {
      type: Number,
      default: null
    },
    step: {
      type: Number,
      default: 1,
      validator: function validator(val) {
        return val > 0;
      }
    },
    stock: {
      type: Number,
      default: null
    },
    inputClass: {
      type: String,
      default: "form-control"
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      mutable: 1,
      cachedVal: null,
      eventSource: false,
      editing: false
    };
  },
  computed: {
    classes: function classes() {
      var result = [];

      if (this.eventSource) {
        result.push("order-line-quantity--optimistic");
      }

      return result;
    },
    payload: function payload() {
      return {
        orderLineId: this.orderLineId,
        quantity: this.mutable
      };
    },
    props: function props() {
      return _objectSpread$1({}, this.$props, {
        readOnly: !!this.stackSize || this.readOnly
      });
    }
  },
  watch: {
    editing: function editing(val) {
      var message = val === true ? basket.setBasketItemQuantity.START : basket.setBasketItemQuantity.STOP;
      this.$root.$emit(message, this.payload);
    },
    initValue: {
      immediate: false,
      handler: function handler(val) {
        this.mutable = val;
      }
    }
  },
  created: function created() {
    var _this = this;

    this.mutable = this.initValue;
    this.cachedVal = this.mutable;
    this.$root.$on(basket.addToBasket.REQUEST, this.incrementQuantity);
    this.$root.$on(basket.addToBasket.RESPONSE, function () {
      _this.eventSource = false;
    });
  },
  methods: {
    incrementQuantity: function incrementQuantity(val) {
      if (val.id === this.productId && !this.stackSize) {
        this.eventSource = true;
        this.cachedVal = this.mutable;
        this.mutable += val.quantity;
      }
    },
    onInput: function onInput(val) {
      if (!this.eventSource) {
        this.mutable = Number(val);
        this.editing = true;
        this.$root.$emit(basket.setBasketItemQuantity.UPDATE, this.payload);
        this.debouncedSetQuantity();
      }
    },
    debouncedSetQuantity: debounce(function debouncedSetQuantity() {
      this.setQuantity();
    }, 1000),
    setQuantity: function setQuantity$1() {
      var _this2 = this;

      this.editing = false;
      this.$root.$emit(basket.setBasketItemQuantity.REQUEST, this.payload);

      setQuantity(this.orderLineId, this.mutable).then(function (response) {
        _this2.$root.$emit(basket.setBasketItemQuantity.SUCCESS, response);

        _this2.$emit("success", response);
      }).catch(function (error) {
        _this2.mutable = _this2.cachedVal;

        _this2.$root.$emit(basket.setBasketItemQuantity.FAILURE, error);

        _this2.$emit("failure", error);
      }).finally(function () {
        _this2.cachedVal = _this2.mutable;

        _this2.$root.$emit(basket.setBasketItemQuantity.RESPONSE);

        _this2.$emit("response");
      });
    }
  }
};

/* script */
var __vue_script__$f = script$d;
/* template */

var __vue_render__$e = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "order-line-quantity",
    class: _vm.classes
  }, [_c('BaseQuantity', _vm._b({
    class: _vm.inputClass,
    attrs: {
      "value": _vm.mutable
    },
    on: {
      "input": _vm.onInput
    }
  }, 'BaseQuantity', _vm.props, false))], 1);
};

var __vue_staticRenderFns__$e = [];
/* style */

var __vue_inject_styles__$f = undefined;
/* scoped */

var __vue_scope_id__$f = undefined;
/* module identifier */

var __vue_module_identifier__$f = undefined;
/* functional template */

var __vue_is_functional_template__$f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$f, __vue_script__$f, __vue_scope_id__$f, __vue_is_functional_template__$f, __vue_module_identifier__$f, false, undefined, undefined, undefined);

var max$2 = Math.max;
var min$4 = Math.min;
var floor$3 = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
_fixReWks('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = _anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = _regexpExecAbstract(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = _advanceStringIndex(S, _toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max$2(min$4(_toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = _toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor$3(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});

function renderPrice(price, currency, locale) {
  var config = {
    style: "currency",
    currency: currency
  };
  var number = new Intl.NumberFormat(locale, config);
  return number.format(price || 0);
}
function createAlias(text) {
  var result;

  if (text.length > 0) {
    result = text; // Convert string to title case

    result = result.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }); // Remove all whitespace and non-alphanumeric characters

    result = result.replace(/[^0-9a-z]/gi, ""); // Convert first character to lower case

    result = result.charAt(0).toLowerCase() + result.slice(1);
  }

  return result;
}

//
var script$e = {
  name: "OrderTotals",
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    currency: {
      type: String,
      default: "GBP"
    },
    locale: {
      type: String,
      default: "en-GB"
    }
  },
  methods: {
    renderPrice: function renderPrice$1(val) {
      return renderPrice(val, this.currency, this.locale);
    }
  }
};

/* script */
var __vue_script__$g = script$e;
/* template */

var __vue_render__$f = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "order-totals"
  }, [_c('div', {
    staticClass: "order-totals__content"
  }, [_c('table', {
    staticClass: "order-totals__table"
  }, _vm._l(_vm.value, function (total) {
    return _c('tr', {
      key: total.text
    }, [_c('th', [_vm._v(_vm._s(total.text))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.renderPrice(total.price)))])]);
  }), 0)])]);
};

var __vue_staticRenderFns__$f = [];
/* style */

var __vue_inject_styles__$g = undefined;
/* scoped */

var __vue_scope_id__$g = "data-v-9879ba64";
/* module identifier */

var __vue_module_identifier__$g = undefined;
/* functional template */

var __vue_is_functional_template__$g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f,
  staticRenderFns: __vue_staticRenderFns__$f
}, __vue_inject_styles__$g, __vue_script__$g, __vue_scope_id__$g, __vue_is_functional_template__$g, __vue_module_identifier__$g, false, undefined, undefined, undefined);

//
var script$f = {
  name: "PricingBandsTable",
  props: {
    bands: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    currency: {
      type: String,
      default: "GBP"
    },
    locale: {
      type: String,
      default: "en-GB"
    },
    isTier: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    renderQuantity: function renderQuantity(band) {
      var result;
      var upper = band.upper,
          lower = band.lower;

      if (upper < 0) {
        result = "".concat(lower, "+");
      } else if (lower === upper) {
        result = "".concat(lower);
      } else {
        result = "".concat(lower, " - ").concat(upper);
      }

      return result;
    },
    renderPrice: function renderPrice$1(band) {
      return renderPrice(band.price, this.currency, this.locale);
    }
  }
};

/* script */
var __vue_script__$h = script$f;
/* template */

var __vue_render__$g = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('table', {
    staticClass: "table pricing-bands-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "pricing-bands-table__heading"
  }, [_vm.isTier ? [_vm._v("\n          Tier limit\n        ")] : [_vm._v("\n          Volume\n        ")]], 2), _vm._v(" "), _c('th', {
    staticClass: "pricing-bands-table__heading"
  }, [_vm._v("\n        Price Exc. VAT\n      ")])])]), _vm._v(" "), _c('tbody', _vm._l(_vm.bands, function (band, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v("\n        " + _vm._s(_vm.renderQuantity(band)) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n        " + _vm._s(_vm.renderPrice(band)) + "\n      ")])]);
  }), 0)]);
};

var __vue_staticRenderFns__$g = [];
/* style */

var __vue_inject_styles__$h = undefined;
/* scoped */

var __vue_scope_id__$h = "data-v-606811ff";
/* module identifier */

var __vue_module_identifier__$h = undefined;
/* functional template */

var __vue_is_functional_template__$h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g,
  staticRenderFns: __vue_staticRenderFns__$g
}, __vue_inject_styles__$h, __vue_script__$h, __vue_scope_id__$h, __vue_is_functional_template__$h, __vue_module_identifier__$h, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
var script$g = {
  name: "SaveAsWishlist",
  methods: {
    saveAsWishlist: function saveAsWishlist() {}
  }
};

/* script */
var __vue_script__$i = script$g;
/* template */

var __vue_render__$h = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('form', {
    staticClass: "save-as-wishlist",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.saveAsWishlist($event);
      }
    }
  }, [_c('button', [_vm._t("default", [_vm._v("\n      Save as wishlist\n    ")])], 2)]);
};

var __vue_staticRenderFns__$h = [];
/* style */

var __vue_inject_styles__$i = undefined;
/* scoped */

var __vue_scope_id__$i = "data-v-00129581";
/* module identifier */

var __vue_module_identifier__$i = undefined;
/* functional template */

var __vue_is_functional_template__$i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$h,
  staticRenderFns: __vue_staticRenderFns__$h
}, __vue_inject_styles__$i, __vue_script__$i, __vue_scope_id__$i, __vue_is_functional_template__$i, __vue_module_identifier__$i, false, undefined, undefined, undefined);

/* script */
var __vue_script__$j = script$2;
/* template */

/* style */

var __vue_inject_styles__$j = undefined;
/* scoped */

var __vue_scope_id__$j = "data-v-0351fafe";
/* module identifier */

var __vue_module_identifier__$j = undefined;
/* functional template */

var __vue_is_functional_template__$j = undefined;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$j = /*#__PURE__*/normalizeComponent({}, __vue_inject_styles__$j, __vue_script__$j, __vue_scope_id__$j, __vue_is_functional_template__$j, __vue_module_identifier__$j, false, undefined, undefined, undefined);

/* script */
var __vue_script__$k = script$1;
/* template */

var __vue_render__$i = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('form', {
    staticClass: "apply-voucher",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.applyVoucher($event);
      }
    }
  }, [_vm.internalAppliedCodes && _vm.internalAppliedCodes.length ? _c('div', {
    staticClass: "apply-voucher__applied"
  }, [_c('span', {
    staticClass: "apply-voucher__applied-heading"
  }, [_vm._v(_vm._s(_vm.appliedHeading))]), _vm._v(" "), _c('ul', {
    staticClass: "applied-voucher__list"
  }, _vm._l(_vm.internalAppliedCodes, function (code) {
    return _c('li', {
      key: code,
      staticClass: "apply-voucher__item"
    }, [_vm._v("\n        " + _vm._s(code) + "\n        "), _vm.canRemoveVoucher ? _c('div', {
      staticClass: "apply-voucher__remove-code",
      attrs: {
        "title": "Remove voucher code"
      },
      on: {
        "click": function click($event) {
          return _vm.removeVoucher(code);
        }
      }
    }, [_vm._t("remove-voucher-icon", [_vm._v("\n            x\n          ")])], 2) : _vm._e()]);
  }), 0), _vm._v(" "), _vm.errorRemoving ? _c('div', {
    staticClass: "apply-voucher__error-removing"
  }, [_vm._v("\n      Unable to remove the voucher code.\n    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "apply-voucher__input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.voucherCode,
      expression: "voucherCode"
    }],
    staticClass: "apply-voucher__input",
    class: _vm.inputClass,
    attrs: {
      "placeholder": _vm.placeholder,
      "aria-label": "Enter your voucher code here"
    },
    domProps: {
      "value": _vm.voucherCode
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.voucherCode = $event.target.value;
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "for": "submit-button"
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "apply-voucher__button",
    class: _vm.btnClass,
    attrs: {
      "id": "submit-button"
    }
  }, [_vm.submitting ? _vm._t("submitting", [_vm._v("\n        Applying...\n      ")]) : _vm.submitted && !_vm.error ? _vm._t("submitted", [_vm._v("\n        Applied!\n      ")]) : _vm.error ? _vm._t("error", [_vm._v("\n        Error applying\n      ")]) : _vm._t("default", [_vm._v("\n        Apply\n      ")])], 2)])]);
};

var __vue_staticRenderFns__$i = [];
/* style */

var __vue_inject_styles__$k = undefined;
/* scoped */

var __vue_scope_id__$k = "data-v-7f115c12";
/* module identifier */

var __vue_module_identifier__$k = undefined;
/* functional template */

var __vue_is_functional_template__$k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$i,
  staticRenderFns: __vue_staticRenderFns__$i
}, __vue_inject_styles__$k, __vue_script__$k, __vue_scope_id__$k, __vue_is_functional_template__$k, __vue_module_identifier__$k, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$h = {
  name: "SimpleBasketOrderLinesList",
  props: {
    noDelete: {
      type: Boolean,
      default: false
    }
  }
};

/* script */
var __vue_script__$l = script$h;
/* template */

var __vue_render__$j = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "order-lines-list"
  }, [_c('div', {
    staticClass: "order-lines-list__content"
  }, [_c('table', {
    staticClass: "order-lines-list__table"
  }, [_c('thead', [_c('tr', {
    staticClass: "order-lines-list__headings"
  }, [_c('th', {
    staticClass: "order-line-list__heading order-line__name"
  }, [_vm._v("\n            Product\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "order-line-list__heading order-line__quantity"
  }, [_vm._v("\n            Quantity\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "order-line-list__heading order-line__price"
  }, [_vm._v("\n            Price\n          ")]), _vm._v(" "), !_vm.noDelete ? _c('th', {
    staticClass: "order-line-list__heading order-line__remove"
  }) : _vm._e()])]), _vm._v(" "), _c('tbody', {
    staticClass: "order-lines-list__list"
  }, [_vm._t("default")], 2)])])]);
};

var __vue_staticRenderFns__$j = [];
/* style */

var __vue_inject_styles__$l = undefined;
/* scoped */

var __vue_scope_id__$l = "data-v-c15b1464";
/* module identifier */

var __vue_module_identifier__$l = undefined;
/* functional template */

var __vue_is_functional_template__$l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$j,
  staticRenderFns: __vue_staticRenderFns__$j
}, __vue_inject_styles__$l, __vue_script__$l, __vue_scope_id__$l, __vue_is_functional_template__$l, __vue_module_identifier__$l, false, undefined, undefined, undefined);

// https://github.com/tc39/Array.prototype.includes

var $includes = _arrayIncludes(true);

_export(_export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

_addToUnscopables('includes');

// 7.2.8 IsRegExp(argument)


var MATCH = _wks('match');
var _isRegexp = function (it) {
  var isRegExp;
  return _isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : _cof(it) == 'RegExp');
};

// helper for String#{startsWith, endsWith, includes}



var _stringContext = function (that, searchString, NAME) {
  if (_isRegexp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(_defined(that));
};

var MATCH$1 = _wks('match');
var _failsIsRegexp = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH$1] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};

var INCLUDES = 'includes';

_export(_export.P + _export.F * _failsIsRegexp(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~_stringContext(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

/* script */
var __vue_script__$m = script$d;
/* template */

var __vue_render__$k = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "order-line-quantity",
    class: _vm.classes
  }, [_c('BaseQuantity', _vm._b({
    class: _vm.inputClass,
    attrs: {
      "value": _vm.mutable
    },
    on: {
      "input": _vm.onInput
    }
  }, 'BaseQuantity', _vm.props, false))], 1);
};

var __vue_staticRenderFns__$k = [];
/* style */

var __vue_inject_styles__$m = undefined;
/* scoped */

var __vue_scope_id__$m = undefined;
/* module identifier */

var __vue_module_identifier__$m = undefined;
/* functional template */

var __vue_is_functional_template__$m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$k,
  staticRenderFns: __vue_staticRenderFns__$k
}, __vue_inject_styles__$m, __vue_script__$m, __vue_scope_id__$m, __vue_is_functional_template__$m, __vue_module_identifier__$m, false, undefined, undefined, undefined);

/* script */
var __vue_script__$n = script$b;
/* template */

var __vue_render__$l = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('button', _vm._g({
    staticClass: "delete-order-line",
    class: _vm.classes,
    attrs: {
      "aria-label": "Delete order line"
    },
    on: {
      "click": _vm.deleteOrderLine
    }
  }, _vm.$listeners), [_vm.requesting ? [_vm._t("loading")] : [_vm._t("delete-label", [_vm._v("\n      Remove from basket\n    ")])]], 2);
};

var __vue_staticRenderFns__$l = [];
/* style */

var __vue_inject_styles__$n = undefined;
/* scoped */

var __vue_scope_id__$n = "data-v-8c1b334a";
/* module identifier */

var __vue_module_identifier__$n = undefined;
/* functional template */

var __vue_is_functional_template__$n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$l,
  staticRenderFns: __vue_staticRenderFns__$l
}, __vue_inject_styles__$n, __vue_script__$n, __vue_scope_id__$n, __vue_is_functional_template__$n, __vue_module_identifier__$n, false, undefined, undefined, undefined);

//
var script$i = {
  name: "AlternativePerson",
  props: {
    value: {
      type: Object,
      default: function _default() {}
    },
    contactType: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      default: null
    },

    /**
     * Person details based on the logged in users account
     */
    accountPerson: {
      type: Object,
      default: null
    },

    /**
     * Text for the check box to pull person details from the users account
     */
    useAccountDetailsText: {
      type: String,
      default: "Use details from your account"
    },

    /**
     * If true then we will always show the person details (no toggle)
     */
    alwaysShow: {
      type: Boolean,
      default: false
    },

    /**
     * Should the telephone field be mandatory
     */
    telephoneMandatory: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      person: this.blankPerson(),
      showForm: false,
      useAccountDetails: false,
      // If this is true then we will ignore some processing the next time the person
      // object is changed
      ignoreNextPersonWatch: false
    };
  },
  computed: {
    internalButtonText: function internalButtonText() {
      return "".concat(this.buttonText, " ").concat(this.showForm ? "-" : "+");
    },
    hasAccountDetails: function hasAccountDetails() {
      return !!this.accountPerson;
    }
  },
  watch: {
    person: {
      deep: true,
      handler: function handler(val) {
        var _this = this;

        this.$emit("input", val);

        if (this.ignoreNextPersonWatch) {
          this.$nextTick(function () {
            _this.ignoreNextPersonWatch = false;
          });
        } else {
          this.useAccountDetails = false;
          this.person.id = null;
          this.person.isAccount = false;
        }
      }
    },
    value: {
      deep: true,
      immediate: true,
      handler: function handler(val) {
        if (val) {
          this.person = val;
        }
      }
    },

    /**
     * If the use account details checkbox is ticked then we will lock the form and
     * populate it with person details from the logged in user account
     * @param {boolean} val The value of the use account details checkbox
     */
    useAccountDetails: function useAccountDetails(val) {
      if (val) {
        this.ignoreNextPersonWatch = true;
        this.person = cloneDeep(this.accountPerson);
        this.person.isAccount = true;
      }
    },

    /**
     * When the always show property is toggled, emit the toggle event
     */
    alwaysShow: {
      immediate: true,
      handler: function handler(val) {
        if (val) {
          this.$emit("toggle", true);
        } else {
          this.$emit("toggle", this.showForm);
        }
      }
    }
  },
  methods: {
    toggleForm: function toggleForm() {
      this.showForm = !this.showForm;
      this.$emit("toggle", this.showForm);
    },
    blankPerson: function blankPerson() {
      return {
        title: null,
        firstName: null,
        surname: null,
        email: null,
        telephone: null
      };
    }
  }
};

/* script */
var __vue_script__$o = script$i;
/* template */

var __vue_render__$m = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "alternative-person"
  }, [!_vm.alwaysShow ? _c('button', {
    staticClass: "alternative-person__form-toggle",
    on: {
      "click": _vm.toggleForm
    }
  }, [_vm._v("\n    " + _vm._s(_vm.internalButtonText) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm.showForm || _vm.alwaysShow ? [_c('div', {
    staticClass: "alternative-person__container"
  }, [_c('div', {
    staticClass: "alternative-person__form"
  }, [_vm.hasAccountDetails ? _c('div', {
    staticClass: "alternative-person__use-account-details"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.useAccountDetails,
      expression: "useAccountDetails"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.useAccountDetails) ? _vm._i(_vm.useAccountDetails, null) > -1 : _vm.useAccountDetails
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.useAccountDetails,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && (_vm.useAccountDetails = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.useAccountDetails = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.useAccountDetails = $$c;
        }
      }
    }
  }), _vm._v("\n            " + _vm._s(_vm.useAccountDetailsText) + "\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Title")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.person.title,
      callback: function callback($$v) {
        _vm.$set(_vm.person, "title", $$v);
      },
      expression: "person.title"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("First name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.person.firstName,
      callback: function callback($$v) {
        _vm.$set(_vm.person, "firstName", $$v);
      },
      expression: "person.firstName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Last name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.person.surname,
      callback: function callback($$v) {
        _vm.$set(_vm.person, "surname", $$v);
      },
      expression: "person.surname"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Email address")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "email"
    },
    model: {
      value: _vm.person.email,
      callback: function callback($$v) {
        _vm.$set(_vm.person, "email", $$v);
      },
      expression: "person.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Telephone" + _vm._s(_vm.telephoneMandatory ? "*" : ""))]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "tel"
    },
    model: {
      value: _vm.person.telephone,
      callback: function callback($$v) {
        _vm.$set(_vm.person, "telephone", $$v);
      },
      expression: "person.telephone"
    }
  })], 1)])]), _vm._v(" "), _vm.$slots.altPersonInfo ? _c('div', {
    staticClass: "alternative-person__info"
  }, [_vm._t("altPersonInfo")], 2) : _vm._e()]), _vm._v(" "), _vm.$slots.validation ? _c('div', {
    staticClass: "alternative-person__validation"
  }, [_vm._t("validation")], 2) : _vm._e(), _vm._v(" "), _vm.$slots.footer ? _c('div', {
    staticClass: "alternative-person__footer"
  }, [_vm._t("footer")], 2) : _vm._e()] : _vm._e()], 2);
};

var __vue_staticRenderFns__$m = [];
/* style */

var __vue_inject_styles__$o = undefined;
/* scoped */

var __vue_scope_id__$o = "data-v-d534ee24";
/* module identifier */

var __vue_module_identifier__$o = undefined;
/* functional template */

var __vue_is_functional_template__$o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$m,
  staticRenderFns: __vue_staticRenderFns__$m
}, __vue_inject_styles__$o, __vue_script__$o, __vue_scope_id__$o, __vue_is_functional_template__$o, __vue_module_identifier__$o, false, undefined, undefined, undefined);

var script$j = {
  name: "SimpleBasketOrderLine",
  components: {
    OrderLineQuantity: __vue_component__$m,
    DeleteOrderLine: __vue_component__$n,
    DeliveryPerson: __vue_component__$o,
    VSelect: VSelect
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      default: "GBP"
    },
    locale: {
      type: String,
      default: "en-GB"
    },
    btnClass: {
      type: String,
      default: "btn"
    },
    inputClass: {
      type: String,
      default: "form-control"
    },
    lockQuantity: {
      type: Boolean,
      default: false
    },
    noDelete: {
      type: Boolean,
      default: false
    },
    showDeliveryAddress: {
      type: Boolean,
      default: false
    },
    isSplittable: {
      type: Boolean,
      default: true
    },
    lockDeliveryAddress: {
      type: Boolean,
      default: false
    },
    allowSelectDeliveryPerson: {
      type: Boolean,
      default: false
    },
    accountPerson: {
      type: Object,
      default: null
    },
    allowMultiDeliveryAddress: {
      type: Boolean,
      default: false
    },
    showAddressForCarriage: {
      type: Boolean,
      default: false
    },
    nextProductId: {
      type: Number,
      default: null
    },
    prevProductId: {
      type: Number,
      default: null
    },
    defaultSopAddress: {
      type: Object,
      default: null
    },
    sopAddresses: {
      type: Array,
      default: null
    },
    blacklistedAddressIds: {
      type: Array,
      default: null
    },
    enableUpdateSpinner: {
      type: Boolean,
      default: true
    },
    showVoucherQuantity: {
      type: Boolean,
      default: true
    },
    setAddressOnAdd: {
      type: Boolean,
      default: true
    },
    deliveryAddressMsg: {
      type: String,
      default: "Delivery address:"
    },
    deliverToMsg: {
      type: String,
      default: "Deliver to:"
    }
  },
  data: function data() {
    return {
      deleting: false,
      deleted: false,
      updating: false,
      showPersonEditor: false,
      deliveryPersonValMessage: null,
      deliveryPerson: {}
    };
  },
  computed: {
    classes: function classes() {
      var result = [];

      if (this.deleting) {
        result.push("order-line--deleting");
      }

      if (this.deleted) {
        result.push("order-line--deleted");
      }

      if (this.isCarriage) {
        result.push("order-line--carriage");
      }

      if (this.isVoucher) {
        result.push("order-line--voucher");
      }

      if (this.productGroupStart) {
        result.push("order-line--group-start");
      }

      if (this.productGroupEnd) {
        result.push("order-line--group-end");
      }

      if (this.canAddNewAddress) {
        result.push("order-line--add-address");
      }

      if (this.canSelectAddress) {
        result.push("order-line--has-address");
      }

      return result;
    },
    isCarriage: function isCarriage() {
      return this.value.carriage;
    },
    isVoucher: function isVoucher() {
      return this.value.addedByVoucher;
    },
    showQuantity: function showQuantity() {
      var result = !this.isCarriage;

      if (!this.showVoucherQuantity) {
        result = result && !this.isVoucher;
      }

      return result;
    },
    quantity: function quantity() {
      var result = 0;

      if (this.value) {
        var parsed = parseInt(this.value.quantity, 10);

        if (parsed >= 0) {
          result = parsed;
        }
      }

      return result;
    },
    price: function price() {
      var price = 0;

      if (this.value.priceExcVat) {
        price = this.value.priceExcVat;
      }

      return renderPrice(price, this.currency, this.locale);
    },
    addressId: function addressId() {
      var _this$value;

      return (_this$value = this.value) === null || _this$value === void 0 ? void 0 : _this$value.deliveryAddressId;
    },
    orgId: function orgId() {
      var _this$value2;

      return (_this$value2 = this.value) === null || _this$value2 === void 0 ? void 0 : _this$value2.deliveryOrgId;
    },
    orderLineId: function orderLineId() {
      var _this$value3;

      return (_this$value3 = this.value) === null || _this$value3 === void 0 ? void 0 : _this$value3.id;
    },
    hasDeliveryAddress: function hasDeliveryAddress() {
      return !!(this.addressId && this.orgId);
    },
    hasDeliveryPerson: function hasDeliveryPerson() {
      var _this$value4;

      return !!((_this$value4 = this.value) !== null && _this$value4 !== void 0 && _this$value4.deliveryPersonId);
    },
    productGroupEnd: function productGroupEnd() {
      return this.nextProductId !== this.value.productId;
    },
    productGroupStart: function productGroupStart() {
      return this.prevProductId !== this.value.productId;
    },

    /**
     * Addresses are locked if the user has told us to lock them or the line
     * is a carriage line
     */
    addressIsLocked: function addressIsLocked() {
      return this.lockDeliveryAddress || this.value.carriage;
    },

    /**
     * Can we add or edit a delivery person
     */
    canEditDeliveryPerson: function canEditDeliveryPerson() {
      return this.allowSelectDeliveryPerson && this.hasDeliveryAddress && !this.addressIsLocked && !this.showPersonEditor;
    },

    /**
     * Only alow a new address to be added if this is the last item in a group
     */
    canAddNewAddress: function canAddNewAddress() {
      var _this$selectedSopAddr, _this$formattedSopAdd;

      return this.allowMultiDeliveryAddress && ((_this$selectedSopAddr = this.selectedSopAddress) === null || _this$selectedSopAddr === void 0 ? void 0 : _this$selectedSopAddr.id) && this.productGroupEnd && !this.addressIsLocked && this.isSplittable && ((_this$formattedSopAdd = this.formattedSopAddresses) === null || _this$formattedSopAdd === void 0 ? void 0 : _this$formattedSopAdd.length) > 1 && !this.showPersonEditor;
    },

    /**
     * Whether or not we should show the not splittable message
     */
    showNotSplittableMsg: function showNotSplittableMsg() {
      var _this$formattedSopAdd2;

      return this.productGroupEnd && !this.addressIsLocked && (!this.isSplittable || ((_this$formattedSopAdd2 = this.formattedSopAddresses) === null || _this$formattedSopAdd2 === void 0 ? void 0 : _this$formattedSopAdd2.length) <= 1) && !this.showPersonEditor;
    },

    /**
     * Whether we can select delivery addresses
     */
    canSelectAddress: function canSelectAddress() {
      var carriage = this.value.carriage;
      var result = this.showDeliveryAddress && this.value.stockProduct && !carriage;

      if (carriage && this.showAddressForCarriage) {
        // This is a carriage line but we want to force showing addresses for carriage
        result = true;
      }

      return result;
    },

    /**
     * Only show the product name for the first product group line
     * if we are showing delivery addresses
     */
    showProductName: function showProductName() {
      return this.productGroupStart || !this.showDeliveryAddress;
    },

    /**
     * A list of formatted addresses to use in the drop down
     */
    formattedSopAddresses: function formattedSopAddresses() {
      var _this$sopAddresses,
          _this = this;

      var blacklistedIds = this.blacklistedAddressIds || [];
      var addresses = ((_this$sopAddresses = this.sopAddresses) === null || _this$sopAddresses === void 0 ? void 0 : _this$sopAddresses.filter(function (address) {
        // we only want addresses that are not the currently selected or are
        // not black listed (selected in another order line)
        var isValid = address.addressId === _this.value.deliveryAddressId;

        if (!isValid) {
          isValid = !blacklistedIds.includes(address.addressId);
        }

        return isValid;
      }).map(function (address) {
        var formattedAddress = null;

        if (address.addressType === "NEW") {
          formattedAddress = {
            id: "NEW",
            orgId: null,
            label: address.orgName
          };
        } else {
          var label = address.orgName;
          var postcode = address.postcode || "No postcode";

          if (label) {
            label = "".concat(label, " - ").concat(address.line1 || address.line2 || address.line3, " (").concat(postcode, ")");
          } else {
            label = "".concat(address.line1 || address.line2 || address.line3 || "No name", " - (").concat(postcode, ")");
          }

          formattedAddress = {
            id: address.addressId,
            orgId: address.orgId,
            label: label
          };
        }

        return formattedAddress;
      })) || [];
      return addresses;
    },

    /**
     * The currently selected delivery Address
     */
    selectedSopAddress: function selectedSopAddress() {
      var _this$formattedSopAdd3,
          _this2 = this;

      return ((_this$formattedSopAdd3 = this.formattedSopAddresses) === null || _this$formattedSopAdd3 === void 0 ? void 0 : _this$formattedSopAdd3.find(function (address) {
        return address.id === _this2.value.deliveryAddressId;
      })) || {};
    },

    /**
     * Add new Delivery destination button default text
     */
    addNewAddressDefaultMsg: function addNewAddressDefaultMsg() {
      return "Add new Delivery destination";
    },

    /**
     * Not splittable message default text
     */
    notSplittableDefaultMsg: function notSplittableDefaultMsg() {
      return "You need to increase the quantity for this product before you can add more delivery destinations or add a new delivery address";
    },

    /**
     * Message shown on the delivery person button
     */
    deliveryPersonMsg: function deliveryPersonMsg() {
      var msg = null;

      if (this.hasDeliveryPerson) {
        msg = "Edit Delivery Person";
      } else {
        msg = "Add Delivery Person";
      }

      return msg;
    },

    /**
     * Whether the update spinner is showing
     */
    showUpdateSpinner: function showUpdateSpinner() {
      return this.updating && this.enableUpdateSpinner;
    }
  },
  methods: {
    onDeleteRequest: function onDeleteRequest() {
      this.deleting = true;
    },

    /**
     * A new delivery address has been selected
     * @param {object} val The newly selected delivery address
     */
    onSelectDeliveryAddress: function onSelectDeliveryAddress(val) {
      if (val) {
        if (val.id === "NEW") {
          // Add a new address and select it
          this.$root.$emit(basket.orderLineDeliveryAddress.ADDNEW, {
            orderLineId: this.value.id,
            productId: this.value.productId
          });
        } else {
          // Select the new address
          var payload = {
            addressId: val.id,
            orgId: val.orgId,
            orgName: val.name,
            addNew: false
          };
          this.saveLineDeliveryAddress(payload);
        }
      }
    },

    /**
     * Add a new delivery address
     */
    onAddDeliveryAddress: function onAddDeliveryAddress() {
      var _this3 = this;

      // Find the next free address that is not the currently selected address ID, or select a
      // blank address if we are not defaultling when adding
      var freeAddress = this.setAddressOnAdd ? this.formattedSopAddresses.find(function (address) {
        return address.id !== _this3.selectedSopAddress.id;
      }) : {};

      if (freeAddress) {
        // We will add a clone of the current order line and default it to using the
        // default SOP address
        var payload = {
          addressId: freeAddress.id,
          orgId: freeAddress.orgId,
          orgName: freeAddress.label,
          addNew: true
        };
        this.$root.$emit(basket.orderLineDeliveryAddress.SPLIT, payload);
        this.saveLineDeliveryAddress(payload);
      }
    },

    /**
     * Add or edit the person associated with this delivery line
     */
    onEditDeliveryPerson: function onEditDeliveryPerson() {
      var _this4 = this;

      this.clearDeliveryPerson();

      if (this.hasDeliveryPerson) {
        this.updating = true;
        loadOrderLineDeliveryPerson(this.value.deliveryPersonId).then(function (result) {
          if (result !== null && result !== void 0 && result.data) {
            _this4.deliveryPerson = result.data;
            _this4.showPersonEditor = true;
          }
        }).catch(function () {
          console.log("Unable to load delivery person");
        }).finally(function () {
          _this4.updating = false;
        });
      } else {
        this.showPersonEditor = true;
      }
    },

    /**
     * Remove the delivery person from the order line
     */
    onRemoveDeliveryPerson: function onRemoveDeliveryPerson() {
      var _this5 = this;

      // Create payload for events
      var localPayload = {
        orderLineId: this.value.id,
        personId: null,
        personName: null
      };
      this.updating = true;
      this.$root.$emit(basket.orderLineDeliveryPerson.REQUEST, localPayload);
      removeLineDeliveryPerson(this.value.id).then(function (result) {
        if (result !== null && result !== void 0 && result.data) {
          _this5.$root.$emit(basket.orderLineDeliveryPerson.SUCCESS, localPayload);

          _this5.showPersonEditor = false;
        } else {
          _this5.$root.$emit(basket.orderLineDeliveryPerson.FAILURE, localPayload);
        }
      }).catch(function (err) {
        _this5.$root.$emit(basket.orderLineDeliveryPerson.FAILURE, err);
      }).finally(function () {
        _this5.updating = false;
      });
    },

    /**
     * Save and close the person editor
     */
    onSaveDeliveryPerson: function onSaveDeliveryPerson() {
      var _this6 = this;

      // Create the person data to save
      var localPayload = this.deliveryPerson || {};
      localPayload.orderLineId = this.value.id;
      localPayload.deliveryOrgId = this.value.deliveryOrgId;

      if (this.validateDeliveryPerson()) {
        this.$root.$emit(basket.orderLineDeliveryPerson.REQUEST, localPayload);
        this.updating = true;
        updateLineDeliveryPerson(localPayload).then(function (result) {
          if (result !== null && result !== void 0 && result.data) {
            // The result will contain the updated or newly added person ID
            localPayload.personId = result.data.personId;
            localPayload.personName = result.data.personName;

            _this6.$root.$emit(basket.orderLineDeliveryPerson.SUCCESS, localPayload);

            _this6.showPersonEditor = false;
          } else {
            _this6.$root.$emit(basket.orderLineDeliveryPerson.FAILURE, localPayload);
          }
        }).catch(function (err) {
          _this6.$root.$emit(basket.orderLineDeliveryPerson.FAILURE, err);
        }).finally(function () {
          _this6.updating = false;
        });
      }
    },

    /**
     * Update the details of an order lines devliery address could be the current line or
     * a new line
     * @param {object} payload Delivery address details to save
     */
    saveLineDeliveryAddress: function saveLineDeliveryAddress(payload) {
      var _this7 = this;

      var localPayload = payload; // Pass up the current order line so that we have something to clone

      localPayload.orderLineId = this.value.id;
      this.$root.$emit(basket.orderLineDeliveryAddress.REQUEST, localPayload);
      this.updating = true;
      updateLineDeliveryAddress(localPayload).then(function (result) {
        if (result !== null && result !== void 0 && result.data) {
          // The result will contain the updated or newly added order line ID
          localPayload.newOrderLineId = result.data.lineId;
          localPayload.donorLineId = result.data.donorLineId;
          localPayload.addressId = result.data.addressId;
          localPayload.orgId = result.data.orgId;
          localPayload.addresses = result.data.addresses;

          _this7.$root.$emit(basket.orderLineDeliveryAddress.SUCCESS, localPayload);
        } else {
          _this7.$root.$emit(basket.orderLineDeliveryAddress.FAILURE, localPayload);
        }
      }).catch(function (err) {
        _this7.$root.$emit(basket.orderLineDeliveryAddress.FAILURE, err);
      }).finally(function () {
        _this7.$root.$emit(basket.orderLineDeliveryAddress.RESPONSE);

        _this7.updating = false;
      });
    },

    /**
     * Validate the delivery person
     */
    validateDeliveryPerson: function validateDeliveryPerson() {
      var person = this.deliveryPerson;
      var isValid = person && person.firstName && person.surname && person.email;
      this.deliveryPersonValMessage = null;

      if (!isValid) {
        this.deliveryPersonValMessage = "The delivery person needs a first name, last name and an email address.";
      }

      return isValid;
    },

    /**
     * Clear the delivery person data
     */
    clearDeliveryPerson: function clearDeliveryPerson() {
      this.deliveryPersonValMessage = null;
      this.deliveryPerson = {
        title: null,
        firstName: null,
        surname: null,
        email: null,
        telephone: null
      };
    }
  }
};

/* script */
var __vue_script__$p = script$j;
/* template */

var __vue_render__$n = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('tr', {
    staticClass: "order-line",
    class: _vm.classes
  }, [_c('td', {
    staticClass: "order-line__data order-line__name"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showUpdateSpinner,
      expression: "showUpdateSpinner"
    }],
    staticClass: "order-line__updating"
  }, [_c('font-awesome-icon', {
    attrs: {
      "spin": "",
      "icon": ['fas', 'spinner']
    }
  })], 1), _vm._v(" "), _vm.showProductName ? _vm._t("default", [_vm._v("\n      " + _vm._s(_vm.value.productDisplayName) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.canSelectAddress ? _c('div', {
    staticClass: "order-line__delivery-address",
    class: {
      'order-line__delivery-address--spacing': _vm.showProductName
    }
  }, [!_vm.addressIsLocked ? _c('div', {
    staticClass: "order-line__selected-address"
  }, [_c('VSelect', {
    attrs: {
      "value": _vm.selectedSopAddress,
      "options": _vm.formattedSopAddresses,
      "clearable": false,
      "filterable": false,
      "searchable": false,
      "disabled": _vm.showPersonEditor,
      "placholder": "Select a delivery address"
    },
    on: {
      "input": _vm.onSelectDeliveryAddress
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(item) {
        return [_c('span', {
          class: {
            'order-line__add-new-address': item.id === 'NEW'
          }
        }, [_vm._v("\n              " + _vm._s(item.label) + "\n            ")])];
      }
    }], null, false, 1442199039)
  }), _vm._v(" "), !_vm.hasDeliveryAddress ? _c('div', {
    staticClass: "order-line__validation"
  }, [_vm._t("noDeliveryAddress", [_vm._v("\n            Please select a delivery address\n          ")])], 2) : _vm._e(), _vm._v(" "), _vm.showPersonEditor ? _c('DeliveryPerson', {
    staticClass: "order-line__delivery-person-editor",
    attrs: {
      "account-person": _vm.accountPerson,
      "contact-type": "delivery",
      "always-show": ""
    },
    scopedSlots: _vm._u([{
      key: "validation",
      fn: function fn() {
        return [_vm.deliveryPersonValMessage ? _c('div', {
          staticClass: "order-line__delivery-person-validation"
        }, [_vm._v("\n              " + _vm._s(_vm.deliveryPersonValMessage) + "\n            ")]) : _vm._e()];
      },
      proxy: true
    }, {
      key: "altPersonInfo",
      fn: function fn() {
        return [_vm._t("deliveryPersonInfo")];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function fn() {
        return [_c('button', {
          staticClass: "order-line__save-delivery-person btn btn-primary",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.onSaveDeliveryPerson
          }
        }, [_vm._v("\n              Save\n            ")]), _vm._v(" "), _c('button', {
          staticClass: "order-line__cancel-delivery-person btn btn-primary",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              _vm.showPersonEditor = false;
            }
          }
        }, [_vm._v("\n              Cancel\n            ")]), _vm._v(" "), _c('button', {
          staticClass: "order-line__remove-delivery-person btn btn-primary",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.onRemoveDeliveryPerson
          }
        }, [_vm._v("\n              Remove\n            ")])];
      },
      proxy: true
    }], null, true),
    model: {
      value: _vm.deliveryPerson,
      callback: function callback($$v) {
        _vm.deliveryPerson = $$v;
      },
      expression: "deliveryPerson"
    }
  }) : _vm.hasDeliveryPerson ? _c('div', {
    staticClass: "order-line__delivery-person-display"
  }, [_c('span', [_vm._v(_vm._s(_vm.deliverToMsg) + " ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.value.deliveryPersonName))])]) : _vm._e()], 1) : _vm.hasDeliveryAddress ? _c('div', {
    staticClass: "order-line__selected-address order-line__selected-address--readonly"
  }, [_c('span', [_vm._v(_vm._s(_vm.deliveryAddressMsg) + " ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.value.deliveryOrgName))]), _vm._v(" "), _vm.hasDeliveryPerson ? _c('span', [_vm._v(_vm._s(_vm.deliverToMsg) + " ")]) : _vm._e(), _vm._v(" "), _vm.hasDeliveryPerson ? _c('span', [_vm._v(_vm._s(_vm.value.deliveryPersonName))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order-line__add-address-options-desktop"
  }, [_vm.canEditDeliveryPerson ? _c('button', {
    staticClass: "order-line__delivery-person btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onEditDeliveryPerson
    }
  }, [_vm._v("\n          " + _vm._s(_vm.deliveryPersonMsg) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm.canAddNewAddress ? _c('button', {
    staticClass: "order-line__new-address btn btn-primary",
    attrs: {
      "type": "button",
      "aria-label": "Add new Delivery destination"
    },
    on: {
      "click": _vm.onAddDeliveryAddress
    }
  }, [_vm._t("newDeliverryDestination", [_vm._v("\n            " + _vm._s(_vm.addNewAddressDefaultMsg) + "\n          ")])], 2) : _vm.showNotSplittableMsg ? _c('div', {
    staticClass: "order-line__not-splittable"
  }, [_vm._t("notSplittable", [_vm._v("\n            " + _vm._s(_vm.notSplittableDefaultMsg) + "\n          ")])], 2) : _vm._e()])]) : _vm._e()], 2), _vm._v(" "), _c('td', {
    staticClass: "order-line__data order-line__quantity"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showUpdateSpinner,
      expression: "showUpdateSpinner"
    }],
    staticClass: "order-line__updating"
  }), _vm._v(" "), _vm.showQuantity ? _c('label', {
    staticClass: "order-line__mobile-header"
  }, [_vm._v("Quantity")]) : _vm._e(), _vm._v(" "), _vm.showQuantity ? _c('OrderLineQuantity', {
    attrs: {
      "init-value": _vm.quantity,
      "order-line-id": _vm.value.id,
      "product-id": _vm.value.productId,
      "stack-size": _vm.value.stackSize,
      "read-only": _vm.lockQuantity,
      "input-class": _vm.inputClass
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('td', {
    staticClass: "order-line__data order-line__price"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showUpdateSpinner,
      expression: "showUpdateSpinner"
    }],
    staticClass: "order-line__updating"
  }), _vm._v(" "), _c('label', {
    staticClass: "order-line__mobile-header"
  }, [_vm._v("Price")]), _vm._v(" "), _vm._t("price", [_vm._v("\n      " + _vm._s(_vm.price) + "\n    ")])], 2), _vm._v(" "), !_vm.noDelete && !_vm.isCarriage ? _c('td', {
    staticClass: "order-line__data order-line__remove"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showUpdateSpinner,
      expression: "showUpdateSpinner"
    }],
    staticClass: "order-line__updating"
  }), _vm._v(" "), _c('delete-order-line', {
    class: _vm.btnClass,
    attrs: {
      "order-line-id": _vm.value.id,
      "product-id": _vm.value.productId
    },
    on: {
      "request": function request($event) {
        _vm.updating = true;
      },
      "success": function success($event) {
        _vm.deleted = true;
      },
      "failure": function failure($event) {
        _vm.updating = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "delete-label",
      fn: function fn() {
        return [_vm._t("delete-label")];
      },
      proxy: true
    }, {
      key: "loading",
      fn: function fn() {
        return [_vm._t("loading")];
      },
      proxy: true
    }], null, true)
  })], 1) : _vm._e(), _vm._v(" "), _vm.canSelectAddress ? _c('td', {
    staticClass: "order-line__add-address-options-mobile"
  }, [_vm.canEditDeliveryPerson ? _c('button', {
    staticClass: "order-line__delivery-person btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onEditDeliveryPerson
    }
  }, [_vm._v("\n      " + _vm._s(_vm.deliveryPersonMsg) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.canAddNewAddress ? _c('button', {
    staticClass: "order-line__new-address btn btn-primary",
    attrs: {
      "type": "button",
      "aria-label": "Add new Delivery destination"
    },
    on: {
      "click": _vm.onAddDeliveryAddress
    }
  }, [_vm._t("newDeliverryDestination", [_vm._v("\n        " + _vm._s(_vm.addNewAddressDefaultMsg) + "\n      ")])], 2) : _vm.showNotSplittableMsg ? _c('div', {
    staticClass: "order-line__not-splittable"
  }, [_vm._t("notSplittable", [_vm._v("\n        " + _vm._s(_vm.notSplittableDefaultMsg) + "\n      ")])], 2) : _vm._e()]) : _vm._e()]);
};

var __vue_staticRenderFns__$n = [];
/* style */

var __vue_inject_styles__$p = undefined;
/* scoped */

var __vue_scope_id__$p = "data-v-9cdd73e0";
/* module identifier */

var __vue_module_identifier__$p = undefined;
/* functional template */

var __vue_is_functional_template__$p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$n,
  staticRenderFns: __vue_staticRenderFns__$n
}, __vue_inject_styles__$p, __vue_script__$p, __vue_scope_id__$p, __vue_is_functional_template__$p, __vue_module_identifier__$p, false, undefined, undefined, undefined);

/* script */
var __vue_script__$q = script$a;
/* template */

var __vue_render__$o = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('button', {
    staticClass: "btn delete-all-order-lines",
    on: {
      "click": _vm.deleteAllOrderLines
    }
  }, [_vm._t("default", [_vm._v("\n    Clear basket\n  ")])], 2);
};

var __vue_staticRenderFns__$o = [];
/* style */

var __vue_inject_styles__$q = undefined;
/* scoped */

var __vue_scope_id__$q = "data-v-60c7103a";
/* module identifier */

var __vue_module_identifier__$q = undefined;
/* functional template */

var __vue_is_functional_template__$q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$o,
  staticRenderFns: __vue_staticRenderFns__$o
}, __vue_inject_styles__$q, __vue_script__$q, __vue_scope_id__$q, __vue_is_functional_template__$q, __vue_module_identifier__$q, false, undefined, undefined, undefined);

/* script */
var __vue_script__$r = script$e;
/* template */

var __vue_render__$p = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "order-totals"
  }, [_c('div', {
    staticClass: "order-totals__content"
  }, [_c('table', {
    staticClass: "order-totals__table"
  }, _vm._l(_vm.value, function (total) {
    return _c('tr', {
      key: total.text
    }, [_c('th', [_vm._v(_vm._s(total.text))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.renderPrice(total.price)))])]);
  }), 0)])]);
};

var __vue_staticRenderFns__$p = [];
/* style */

var __vue_inject_styles__$r = undefined;
/* scoped */

var __vue_scope_id__$r = "data-v-9879ba64";
/* module identifier */

var __vue_module_identifier__$r = undefined;
/* functional template */

var __vue_is_functional_template__$r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$p,
  staticRenderFns: __vue_staticRenderFns__$p
}, __vue_inject_styles__$r, __vue_script__$r, __vue_scope_id__$r, __vue_is_functional_template__$r, __vue_module_identifier__$r, false, undefined, undefined, undefined);

/* script */
var __vue_script__$s = script$6;
/* template */

var __vue_render__$q = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('b-modal', {
    staticClass: "order-line-address",
    attrs: {
      "id": "order-line-address",
      "title": "Add new Delivery Address",
      "ok-only": !_vm.canAddAddress,
      "ok-title": _vm.okTitle,
      "ok-variant": "primary"
    },
    on: {
      "shown": _vm.onShown,
      "hidden": _vm.onHidden,
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.onSave($event);
      }
    }
  }, [_vm.loading ? _c('div', {
    staticClass: "order-line-address__loading"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.canAddAddress || !_vm.loaded ? _c('div', {
    staticClass: "order-line-address__details"
  }, [_vm.canSearchForAddress ? _c('UberSearch', {
    staticClass: "order-line-address__search",
    attrs: {
      "show-validation": _vm.showValidation,
      "user-type": _vm.config.userType
    },
    model: {
      value: _vm.address,
      callback: function callback($$v) {
        _vm.address = $$v;
      },
      expression: "address"
    }
  }) : _c('label', {
    staticClass: "order-line-address__manual"
  }, [_vm._v("\n      Please enter the address details below\n    ")]), _vm._v(" "), _c('AddressDisplay', {
    staticClass: "address-selector__current",
    attrs: {
      "disabled": !_vm.canAddManualAddress,
      "show-validation": _vm.showValidation,
      "countries": _vm.config.countries
    },
    on: {
      "addressChanged": _vm.onManualAddressChanged
    },
    model: {
      value: _vm.address,
      callback: function callback($$v) {
        _vm.address = $$v;
      },
      expression: "address"
    }
  })], 1) : _c('div', {
    staticClass: "order-line-address__details"
  }, [_vm._t("cannotAddAddresses", [_c('p', [_vm._v("\n        Your account can only add certain addresses to your delivery address list.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        All of the addresses that you can add are already in your list.\n      ")])])], 2)]);
};

var __vue_staticRenderFns__$q = [];
/* style */

var __vue_inject_styles__$s = undefined;
/* scoped */

var __vue_scope_id__$s = undefined;
/* module identifier */

var __vue_module_identifier__$s = undefined;
/* functional template */

var __vue_is_functional_template__$s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$q,
  staticRenderFns: __vue_staticRenderFns__$q
}, __vue_inject_styles__$s, __vue_script__$s, __vue_scope_id__$s, __vue_is_functional_template__$s, __vue_module_identifier__$s, false, undefined, undefined, undefined);

//
var script$k = {
  name: "SimpleBasket",
  components: {
    OrderTotals: __vue_component__$r,
    DeleteAllOrderLines: __vue_component__$q,
    SimpleBasketOrderLine: __vue_component__$p,
    SimpleBasketOrderLinesList: __vue_component__$l,
    ApplyVoucher: __vue_component__$k,
    BaseBasket: __vue_component__$j,
    BasketOrderLineAddress: __vue_component__$s
  },
  props: {
    enableVouchers: {
      type: Boolean,
      default: false
    },
    enableClear: {
      type: Boolean,
      default: false
    },
    inputClass: {
      type: String,
      default: "form-control"
    },
    btnClass: {
      type: String,
      default: "btn"
    },
    checkoutUrl: {
      type: String,
      default: null
    },
    currency: {
      type: String,
      default: "GBP"
    },
    locale: {
      type: String,
      default: "en-GB"
    },
    showDeliveryAddress: {
      type: Boolean,
      default: false
    },
    lockDeliveryAddress: {
      type: Boolean,
      default: false
    },
    showAddressForCarriage: {
      type: Boolean,
      default: false
    },
    setAddressOnAdd: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      localAllowDeliveryAddresses: false
    };
  },
  methods: {
    /**
     * Allow delivery addresses to be added for each line
     */
    onAddDeliveryAddresses: function onAddDeliveryAddresses(defaultSopAddress) {
      var _this = this;

      if (this.setAddressOnAdd) {
        var _ref = defaultSopAddress || {},
            orgId = _ref.orgId,
            addressId = _ref.addressId;

        if (orgId && addressId) {
          setDefaultLineDeliveryAddress(orgId, addressId).then(function () {
            _this.$root.$emit(basket.refreshBasket.REQUEST);
          }).catch(function () {
            console.error("Unable to set default addresses");
          }).finally(function () {
            _this.localAllowDeliveryAddresses = true;
          });
        }
      } else {
        this.localAllowDeliveryAddresses = true;
      }
    }
  }
};

/* script */
var __vue_script__$t = script$k;
/* template */

var __vue_render__$r = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "simple-basket"
  }, [_c('BaseBasket', {
    attrs: {
      "show-carriage": ""
    },
    on: {
      "checkDefaultSopAddress": _vm.onAddDeliveryAddresses
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(ref) {
        var orderLines = ref.orderLines;
        var allowSelectDeliveryAddress = ref.allowSelectDeliveryAddress;
        var allowMultiDeliveryAddress = ref.allowMultiDeliveryAddress;
        var allowSelectDeliveryPerson = ref.allowSelectDeliveryPerson;
        var accountPerson = ref.accountPerson;
        var hasDeliveryAddresses = ref.hasDeliveryAddresses;
        var voucherCodes = ref.voucherCodes;
        var totals = ref.totals;
        var refreshData = ref.refreshData;
        var expectingNewLine = ref.expectingNewLine;
        var initialLoading = ref.initialLoading;
        var messages = ref.messages;
        var clearMessages = ref.clearMessages;
        var defaultSopAddress = ref.defaultSopAddress;
        var sopAddresses = ref.sopAddresses;
        var productAddresses = ref.productAddresses;
        var splittableProducts = ref.splittableProducts;
        var missingDeliveryAddresses = ref.missingDeliveryAddresses;
        return [!initialLoading ? [_c('AlertViewer', {
          attrs: {
            "namespace": "basket"
          }
        }), _vm._v(" "), allowSelectDeliveryAddress && !_vm.localAllowDeliveryAddresses && !hasDeliveryAddresses ? _c('button', {
          staticClass: "btn",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.onAddDeliveryAddresses(defaultSopAddress);
            }
          }
        }, [_vm._v("\n        Allow item delivery addresses\n      ")]) : _vm._e(), _vm._v(" "), orderLines && orderLines.length > 0 ? [_c('SimpleBasketOrderLinesList', [_vm._l(orderLines, function (orderLine, index) {
          return _c('SimpleBasketOrderLine', {
            key: orderLine.id,
            attrs: {
              "next-product-id": index < orderLines.length - 1 ? orderLines[index + 1].productId : 0,
              "prev-product-id": index > 0 ? orderLines[index - 1].productId : 0,
              "input-class": _vm.inputClass,
              "btn-class": _vm.btnClass,
              "currency": _vm.currency,
              "locale": _vm.locale,
              "show-delivery-address": _vm.localAllowDeliveryAddresses || hasDeliveryAddresses,
              "show-address-for-carriage": _vm.showAddressForCarriage,
              "allow-multi-delivery-address": allowMultiDeliveryAddress,
              "allow-select-delivery-person": allowSelectDeliveryPerson,
              "account-person": accountPerson,
              "is-splittable": splittableProducts[orderLines[index].productId],
              "lock-delivery-address": _vm.lockDeliveryAddress,
              "default-sop-address": defaultSopAddress,
              "sop-addresses": sopAddresses,
              "blacklisted-address-ids": productAddresses[orderLines[index].productId],
              "set-address-on-add": _vm.setAddressOnAdd
            },
            on: {
              "update": function update($event) {
                return refreshData();
              }
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function fn() {
                return [_vm._t("default")];
              },
              proxy: true
            }, {
              key: "deliveryPersonInfo",
              fn: function fn() {
                return [_vm._t("deliveryPersonInfo", null, {
                  "orderLine": orderLine
                })];
              },
              proxy: true
            }, {
              key: "loading",
              fn: function fn() {
                return [_vm._t("loading")];
              },
              proxy: true
            }], null, true),
            model: {
              value: orderLines[index],
              callback: function callback($$v) {
                _vm.$set(orderLines, index, $$v);
              },
              expression: "orderLines[index]"
            }
          });
        }), _vm._v(" "), expectingNewLine ? _c('tr', {
          staticClass: "simple-basket__loading"
        }, [_c('td', {
          attrs: {
            "colspan": "100%"
          }
        }, [_vm._t("new-line", [_vm._v("\n                LOADING...\n              ")])], 2)]) : _vm._e()], 2), _vm._v(" "), _c('div', {
          staticClass: "simple-basket__summary"
        }, [_c('div', {
          staticClass: "simple-basket__pricing"
        }, [_c('OrderTotals', {
          attrs: {
            "value": totals,
            "currency": _vm.currency,
            "locale": _vm.locale
          }
        }), _vm._v(" "), _vm.enableVouchers ? _c('ApplyVoucher', {
          attrs: {
            "applied-voucher-codes": voucherCodes,
            "input-class": _vm.inputClass,
            "btn-class": _vm.btnClass
          },
          on: {
            "update": function update($event) {
              return refreshData();
            }
          }
        }) : _vm._e()], 1), _vm._v(" "), _vm.enableClear ? _c('div', {
          staticClass: "simple-basket__clear"
        }, [_c('DeleteAllOrderLines', {
          class: _vm.btnClass,
          on: {
            "update": function update($event) {
              return refreshData();
            }
          },
          scopedSlots: _vm._u([{
            key: "loading",
            fn: function fn() {
              return [_vm._t("loading")];
            },
            proxy: true
          }], null, true)
        })], 1) : _vm._e()]), _vm._v(" "), _vm._t("submit", [_vm.checkoutUrl ? _c('a', {
          staticClass: "btn btn-lg",
          style: {
            pointerEvents: missingDeliveryAddresses ? 'none' : 'auto'
          },
          attrs: {
            "href": _vm.checkoutUrl,
            "disabled": missingDeliveryAddresses
          }
        }, [_vm._v("\n            Check out\n          ")]) : _vm._e()]), _vm._v(" "), _c('BasketOrderLineAddress', {
          attrs: {
            "order-lines": orderLines,
            "sop-addresses": sopAddresses
          }
        })] : [_c('div', {
          staticClass: "simple-basket__empty"
        }, [_vm._t("empty", [_vm._v("\n            Your basket is currently empty.\n          ")])], 2)]] : [_vm._t("loading", [_vm._v("\n        Loading...\n      ")])]];
      }
    }], null, true)
  })], 1);
};

var __vue_staticRenderFns__$r = [];
/* style */

var __vue_inject_styles__$t = undefined;
/* scoped */

var __vue_scope_id__$t = "data-v-c51d1586";
/* module identifier */

var __vue_module_identifier__$t = undefined;
/* functional template */

var __vue_is_functional_template__$t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$r,
  staticRenderFns: __vue_staticRenderFns__$r
}, __vue_inject_styles__$t, __vue_script__$t, __vue_scope_id__$t, __vue_is_functional_template__$t, __vue_module_identifier__$t, false, undefined, undefined, undefined);

/* script */
var __vue_script__$u = script$j;
/* template */

var __vue_render__$s = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('tr', {
    staticClass: "order-line",
    class: _vm.classes
  }, [_c('td', {
    staticClass: "order-line__data order-line__name"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showUpdateSpinner,
      expression: "showUpdateSpinner"
    }],
    staticClass: "order-line__updating"
  }, [_c('font-awesome-icon', {
    attrs: {
      "spin": "",
      "icon": ['fas', 'spinner']
    }
  })], 1), _vm._v(" "), _vm.showProductName ? _vm._t("default", [_vm._v("\n      " + _vm._s(_vm.value.productDisplayName) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.canSelectAddress ? _c('div', {
    staticClass: "order-line__delivery-address",
    class: {
      'order-line__delivery-address--spacing': _vm.showProductName
    }
  }, [!_vm.addressIsLocked ? _c('div', {
    staticClass: "order-line__selected-address"
  }, [_c('VSelect', {
    attrs: {
      "value": _vm.selectedSopAddress,
      "options": _vm.formattedSopAddresses,
      "clearable": false,
      "filterable": false,
      "searchable": false,
      "disabled": _vm.showPersonEditor,
      "placholder": "Select a delivery address"
    },
    on: {
      "input": _vm.onSelectDeliveryAddress
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(item) {
        return [_c('span', {
          class: {
            'order-line__add-new-address': item.id === 'NEW'
          }
        }, [_vm._v("\n              " + _vm._s(item.label) + "\n            ")])];
      }
    }], null, false, 1442199039)
  }), _vm._v(" "), !_vm.hasDeliveryAddress ? _c('div', {
    staticClass: "order-line__validation"
  }, [_vm._t("noDeliveryAddress", [_vm._v("\n            Please select a delivery address\n          ")])], 2) : _vm._e(), _vm._v(" "), _vm.showPersonEditor ? _c('DeliveryPerson', {
    staticClass: "order-line__delivery-person-editor",
    attrs: {
      "account-person": _vm.accountPerson,
      "contact-type": "delivery",
      "always-show": ""
    },
    scopedSlots: _vm._u([{
      key: "validation",
      fn: function fn() {
        return [_vm.deliveryPersonValMessage ? _c('div', {
          staticClass: "order-line__delivery-person-validation"
        }, [_vm._v("\n              " + _vm._s(_vm.deliveryPersonValMessage) + "\n            ")]) : _vm._e()];
      },
      proxy: true
    }, {
      key: "altPersonInfo",
      fn: function fn() {
        return [_vm._t("deliveryPersonInfo")];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function fn() {
        return [_c('button', {
          staticClass: "order-line__save-delivery-person btn btn-primary",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.onSaveDeliveryPerson
          }
        }, [_vm._v("\n              Save\n            ")]), _vm._v(" "), _c('button', {
          staticClass: "order-line__cancel-delivery-person btn btn-primary",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              _vm.showPersonEditor = false;
            }
          }
        }, [_vm._v("\n              Cancel\n            ")]), _vm._v(" "), _c('button', {
          staticClass: "order-line__remove-delivery-person btn btn-primary",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.onRemoveDeliveryPerson
          }
        }, [_vm._v("\n              Remove\n            ")])];
      },
      proxy: true
    }], null, true),
    model: {
      value: _vm.deliveryPerson,
      callback: function callback($$v) {
        _vm.deliveryPerson = $$v;
      },
      expression: "deliveryPerson"
    }
  }) : _vm.hasDeliveryPerson ? _c('div', {
    staticClass: "order-line__delivery-person-display"
  }, [_c('span', [_vm._v(_vm._s(_vm.deliverToMsg) + " ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.value.deliveryPersonName))])]) : _vm._e()], 1) : _vm.hasDeliveryAddress ? _c('div', {
    staticClass: "order-line__selected-address order-line__selected-address--readonly"
  }, [_c('span', [_vm._v(_vm._s(_vm.deliveryAddressMsg) + " ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.value.deliveryOrgName))]), _vm._v(" "), _vm.hasDeliveryPerson ? _c('span', [_vm._v(_vm._s(_vm.deliverToMsg) + " ")]) : _vm._e(), _vm._v(" "), _vm.hasDeliveryPerson ? _c('span', [_vm._v(_vm._s(_vm.value.deliveryPersonName))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order-line__add-address-options-desktop"
  }, [_vm.canEditDeliveryPerson ? _c('button', {
    staticClass: "order-line__delivery-person btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onEditDeliveryPerson
    }
  }, [_vm._v("\n          " + _vm._s(_vm.deliveryPersonMsg) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm.canAddNewAddress ? _c('button', {
    staticClass: "order-line__new-address btn btn-primary",
    attrs: {
      "type": "button",
      "aria-label": "Add new Delivery destination"
    },
    on: {
      "click": _vm.onAddDeliveryAddress
    }
  }, [_vm._t("newDeliverryDestination", [_vm._v("\n            " + _vm._s(_vm.addNewAddressDefaultMsg) + "\n          ")])], 2) : _vm.showNotSplittableMsg ? _c('div', {
    staticClass: "order-line__not-splittable"
  }, [_vm._t("notSplittable", [_vm._v("\n            " + _vm._s(_vm.notSplittableDefaultMsg) + "\n          ")])], 2) : _vm._e()])]) : _vm._e()], 2), _vm._v(" "), _c('td', {
    staticClass: "order-line__data order-line__quantity"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showUpdateSpinner,
      expression: "showUpdateSpinner"
    }],
    staticClass: "order-line__updating"
  }), _vm._v(" "), _vm.showQuantity ? _c('label', {
    staticClass: "order-line__mobile-header"
  }, [_vm._v("Quantity")]) : _vm._e(), _vm._v(" "), _vm.showQuantity ? _c('OrderLineQuantity', {
    attrs: {
      "init-value": _vm.quantity,
      "order-line-id": _vm.value.id,
      "product-id": _vm.value.productId,
      "stack-size": _vm.value.stackSize,
      "read-only": _vm.lockQuantity,
      "input-class": _vm.inputClass
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('td', {
    staticClass: "order-line__data order-line__price"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showUpdateSpinner,
      expression: "showUpdateSpinner"
    }],
    staticClass: "order-line__updating"
  }), _vm._v(" "), _c('label', {
    staticClass: "order-line__mobile-header"
  }, [_vm._v("Price")]), _vm._v(" "), _vm._t("price", [_vm._v("\n      " + _vm._s(_vm.price) + "\n    ")])], 2), _vm._v(" "), !_vm.noDelete && !_vm.isCarriage ? _c('td', {
    staticClass: "order-line__data order-line__remove"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showUpdateSpinner,
      expression: "showUpdateSpinner"
    }],
    staticClass: "order-line__updating"
  }), _vm._v(" "), _c('delete-order-line', {
    class: _vm.btnClass,
    attrs: {
      "order-line-id": _vm.value.id,
      "product-id": _vm.value.productId
    },
    on: {
      "request": function request($event) {
        _vm.updating = true;
      },
      "success": function success($event) {
        _vm.deleted = true;
      },
      "failure": function failure($event) {
        _vm.updating = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "delete-label",
      fn: function fn() {
        return [_vm._t("delete-label")];
      },
      proxy: true
    }, {
      key: "loading",
      fn: function fn() {
        return [_vm._t("loading")];
      },
      proxy: true
    }], null, true)
  })], 1) : _vm._e(), _vm._v(" "), _vm.canSelectAddress ? _c('td', {
    staticClass: "order-line__add-address-options-mobile"
  }, [_vm.canEditDeliveryPerson ? _c('button', {
    staticClass: "order-line__delivery-person btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onEditDeliveryPerson
    }
  }, [_vm._v("\n      " + _vm._s(_vm.deliveryPersonMsg) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.canAddNewAddress ? _c('button', {
    staticClass: "order-line__new-address btn btn-primary",
    attrs: {
      "type": "button",
      "aria-label": "Add new Delivery destination"
    },
    on: {
      "click": _vm.onAddDeliveryAddress
    }
  }, [_vm._t("newDeliverryDestination", [_vm._v("\n        " + _vm._s(_vm.addNewAddressDefaultMsg) + "\n      ")])], 2) : _vm.showNotSplittableMsg ? _c('div', {
    staticClass: "order-line__not-splittable"
  }, [_vm._t("notSplittable", [_vm._v("\n        " + _vm._s(_vm.notSplittableDefaultMsg) + "\n      ")])], 2) : _vm._e()]) : _vm._e()]);
};

var __vue_staticRenderFns__$s = [];
/* style */

var __vue_inject_styles__$u = undefined;
/* scoped */

var __vue_scope_id__$u = "data-v-9cdd73e0";
/* module identifier */

var __vue_module_identifier__$u = undefined;
/* functional template */

var __vue_is_functional_template__$u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$s,
  staticRenderFns: __vue_staticRenderFns__$s
}, __vue_inject_styles__$u, __vue_script__$u, __vue_scope_id__$u, __vue_is_functional_template__$u, __vue_module_identifier__$u, false, undefined, undefined, undefined);

/* script */
var __vue_script__$v = script$h;
/* template */

var __vue_render__$t = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "order-lines-list"
  }, [_c('div', {
    staticClass: "order-lines-list__content"
  }, [_c('table', {
    staticClass: "order-lines-list__table"
  }, [_c('thead', [_c('tr', {
    staticClass: "order-lines-list__headings"
  }, [_c('th', {
    staticClass: "order-line-list__heading order-line__name"
  }, [_vm._v("\n            Product\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "order-line-list__heading order-line__quantity"
  }, [_vm._v("\n            Quantity\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "order-line-list__heading order-line__price"
  }, [_vm._v("\n            Price\n          ")]), _vm._v(" "), !_vm.noDelete ? _c('th', {
    staticClass: "order-line-list__heading order-line__remove"
  }) : _vm._e()])]), _vm._v(" "), _c('tbody', {
    staticClass: "order-lines-list__list"
  }, [_vm._t("default")], 2)])])]);
};

var __vue_staticRenderFns__$t = [];
/* style */

var __vue_inject_styles__$v = undefined;
/* scoped */

var __vue_scope_id__$v = "data-v-c15b1464";
/* module identifier */

var __vue_module_identifier__$v = undefined;
/* functional template */

var __vue_is_functional_template__$v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$t,
  staticRenderFns: __vue_staticRenderFns__$t
}, __vue_inject_styles__$v, __vue_script__$v, __vue_scope_id__$v, __vue_is_functional_template__$v, __vue_module_identifier__$v, false, undefined, undefined, undefined);

var _strictMethod = function (method, arg) {
  return !!method && _fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};

var $sort = [].sort;
var test = [1, 2, 3];

_export(_export.P + _export.F * (_fails(function () {
  // IE8-
  test.sort(undefined);
}) || !_fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !_strictMethod($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(_toObject(this))
      : $sort.call(_toObject(this), _aFunction(comparefn));
  }
});

function _arrayWithoutHoles(arr) {
  if (isArray$1(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var _createProperty$1 = function (object, index, value) {
  if (index in object) _objectDp$1.f(object, index, _propertyDesc$1(0, value));
  else object[index] = value;
};

_export$1(_export$1.S + _export$1.F * !_iterDetect(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = _toObject$1(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = core_getIteratorMethod(O);
    var length, result, step, iterator;
    if (mapping) mapfn = _ctx$1(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && _isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        _createProperty$1(result, index, mapping ? _iterCall(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = _toLength$1(O.length);
      for (result = new C(length); length > index; index++) {
        _createProperty$1(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

var from_1 = _core$1.Array.from;

var from_1$1 = from_1;

function _iterableToArray(iter) {
  if (isIterable$1(Object(iter)) || Object.prototype.toString.call(iter) === "[object Arguments]") return from_1$1(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

var MILLISECONDS_IN_MINUTE = 60000;

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
var getTimezoneOffsetInMilliseconds = function getTimezoneOffsetInMilliseconds (dirtyDate) {
  var date = new Date(dirtyDate.getTime());
  var baseTimezoneOffset = date.getTimezoneOffset();
  date.setSeconds(0, 0);
  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE;

  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset
};

/**
 * @category Common Helpers
 * @summary Is the given argument an instance of Date?
 *
 * @description
 * Is the given argument an instance of Date?
 *
 * @param {*} argument - the argument to check
 * @returns {Boolean} the given argument is an instance of Date
 *
 * @example
 * // Is 'mayonnaise' a Date?
 * var result = isDate('mayonnaise')
 * //=> false
 */
function isDate (argument) {
  return argument instanceof Date
}

var is_date = isDate;

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE$1 = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;

var parseTokenDateTimeDelimeter = /[T ]/;
var parseTokenPlainTime = /:/;

// year tokens
var parseTokenYY = /^(\d{2})$/;
var parseTokensYYY = [
  /^([+-]\d{2})$/, // 0 additional digits
  /^([+-]\d{3})$/, // 1 additional digit
  /^([+-]\d{4})$/ // 2 additional digits
];

var parseTokenYYYY = /^(\d{4})/;
var parseTokensYYYYY = [
  /^([+-]\d{4})/, // 0 additional digits
  /^([+-]\d{5})/, // 1 additional digit
  /^([+-]\d{6})/ // 2 additional digits
];

// date tokens
var parseTokenMM = /^-(\d{2})$/;
var parseTokenDDD = /^-?(\d{3})$/;
var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/;
var parseTokenWww = /^-?W(\d{2})$/;
var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/;

// time tokens
var parseTokenHH = /^(\d{2}([.,]\d*)?)$/;
var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/;
var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/;

// timezone tokens
var parseTokenTimezone = /([Z+-].*)$/;
var parseTokenTimezoneZ = /^(Z)$/;
var parseTokenTimezoneHH = /^([+-])(\d{2})$/;
var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/;

/**
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If all above fails, the function passes the given argument to Date constructor.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {Object} [options] - the object with options
 * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parse('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Parse string '+02014101',
 * // if the additional number of digits in the extended year format is 1:
 * var result = parse('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function parse (argument, dirtyOptions) {
  if (is_date(argument)) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (typeof argument !== 'string') {
    return new Date(argument)
  }

  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits;
  if (additionalDigits == null) {
    additionalDigits = DEFAULT_ADDITIONAL_DIGITS;
  } else {
    additionalDigits = Number(additionalDigits);
  }

  var dateStrings = splitDateString(argument);

  var parseYearResult = parseYear(dateStrings.date, additionalDigits);
  var year = parseYearResult.year;
  var restDateString = parseYearResult.restDateString;

  var date = parseDate(restDateString, year);

  if (date) {
    var timestamp = date.getTime();
    var time = 0;
    var offset;

    if (dateStrings.time) {
      time = parseTime(dateStrings.time);
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone) * MILLISECONDS_IN_MINUTE$1;
    } else {
      var fullTime = timestamp + time;
      var fullTimeDate = new Date(fullTime);

      offset = getTimezoneOffsetInMilliseconds(fullTimeDate);

      // Adjust time when it's coming from DST
      var fullTimeDateNextDay = new Date(fullTime);
      fullTimeDateNextDay.setDate(fullTimeDate.getDate() + 1);
      var offsetDiff =
        getTimezoneOffsetInMilliseconds(fullTimeDateNextDay) -
        getTimezoneOffsetInMilliseconds(fullTimeDate);
      if (offsetDiff > 0) {
        offset += offsetDiff;
      }
    }

    return new Date(timestamp + time + offset)
  } else {
    return new Date(argument)
  }
}

function splitDateString (dateString) {
  var dateStrings = {};
  var array = dateString.split(parseTokenDateTimeDelimeter);
  var timeString;

  if (parseTokenPlainTime.test(array[0])) {
    dateStrings.date = null;
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
  }

  if (timeString) {
    var token = parseTokenTimezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings
}

function parseYear (dateString, additionalDigits) {
  var parseTokenYYY = parseTokensYYY[additionalDigits];
  var parseTokenYYYYY = parseTokensYYYYY[additionalDigits];

  var token;

  // YYYY or ±YYYYY
  token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString);
  if (token) {
    var yearString = token[1];
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    }
  }

  // YY or ±YYY
  token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString);
  if (token) {
    var centuryString = token[1];
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null
  }
}

function parseDate (dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token;
  var date;
  var month;
  var week;

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0);
    date.setUTCFullYear(year);
    return date
  }

  // YYYY-MM
  token = parseTokenMM.exec(dateString);
  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;
    date.setUTCFullYear(year, month);
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = parseTokenDDD.exec(dateString);
  if (token) {
    date = new Date(0);
    var dayOfYear = parseInt(token[1], 10);
    date.setUTCFullYear(year, 0, dayOfYear);
    return date
  }

  // YYYY-MM-DD or YYYYMMDD
  token = parseTokenMMDD.exec(dateString);
  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;
    var day = parseInt(token[2], 10);
    date.setUTCFullYear(year, month, day);
    return date
  }

  // YYYY-Www or YYYYWww
  token = parseTokenWww.exec(dateString);
  if (token) {
    week = parseInt(token[1], 10) - 1;
    return dayOfISOYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = parseTokenWwwD.exec(dateString);
  if (token) {
    week = parseInt(token[1], 10) - 1;
    var dayOfWeek = parseInt(token[2], 10) - 1;
    return dayOfISOYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime (timeString) {
  var token;
  var hours;
  var minutes;

  // hh
  token = parseTokenHH.exec(timeString);
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'));
    return (hours % 24) * MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = parseTokenHHMM.exec(timeString);
  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseFloat(token[2].replace(',', '.'));
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE$1
  }

  // hh:mm:ss or hhmmss
  token = parseTokenHHMMSS.exec(timeString);
  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseInt(token[2], 10);
    var seconds = parseFloat(token[3].replace(',', '.'));
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE$1 +
      seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function parseTimezone (timezoneString) {
  var token;
  var absoluteOffset;

  // Z
  token = parseTokenTimezoneZ.exec(timezoneString);
  if (token) {
    return 0
  }

  // ±hh
  token = parseTokenTimezoneHH.exec(timezoneString);
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60;
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  // ±hh:mm or ±hhmm
  token = parseTokenTimezoneHHMM.exec(timezoneString);
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10);
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  return 0
}

function dayOfISOYear (isoYear, week, day) {
  week = week || 0;
  day = day || 0;
  var date = new Date(0);
  date.setUTCFullYear(isoYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date
}

var parse_1 = parse;

/**
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added
 * @returns {Date} the new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * var result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays (dirtyDate, dirtyAmount) {
  var date = parse_1(dirtyDate);
  var amount = Number(dirtyAmount);
  date.setDate(date.getDate() + amount);
  return date
}

var add_days = addDays;

/**
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added
 * @returns {Date} the new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds (dirtyDate, dirtyAmount) {
  var timestamp = parse_1(dirtyDate).getTime();
  var amount = Number(dirtyAmount);
  return new Date(timestamp + amount)
}

var add_milliseconds = addMilliseconds;

var MILLISECONDS_IN_HOUR$1 = 3600000;

/**
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added
 * @returns {Date} the new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */
function addHours (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount);
  return add_milliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR$1)
}

var add_hours = addHours;

/**
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0;

  var date = parse_1(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date
}

var start_of_week = startOfWeek;

/**
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek (dirtyDate) {
  return start_of_week(dirtyDate, {weekStartsOn: 1})
}

var start_of_iso_week = startOfISOWeek;

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * var result = getISOYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOYear (dirtyDate) {
  var date = parse_1(dirtyDate);
  var year = date.getFullYear();

  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = start_of_iso_week(fourthOfJanuaryOfNextYear);

  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = start_of_iso_week(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}

var get_iso_year = getISOYear;

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * var result = startOfISOYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOYear (dirtyDate) {
  var year = get_iso_year(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = start_of_iso_week(fourthOfJanuary);
  return date
}

var start_of_iso_year = startOfISOYear;

/**
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay (dirtyDate) {
  var date = parse_1(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date
}

var start_of_day = startOfDay;

var MILLISECONDS_IN_MINUTE$2 = 60000;
var MILLISECONDS_IN_DAY = 86400000;

/**
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 */
function differenceInCalendarDays (dirtyDateLeft, dirtyDateRight) {
  var startOfDayLeft = start_of_day(dirtyDateLeft);
  var startOfDayRight = start_of_day(dirtyDateRight);

  var timestampLeft = startOfDayLeft.getTime() -
    startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$2;
  var timestampRight = startOfDayRight.getTime() -
    startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$2;

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
}

var difference_in_calendar_days = differenceInCalendarDays;

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} isoYear - the ISO week-numbering year of the new date
 * @returns {Date} the new date with the ISO week-numbering year setted
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * var result = setISOYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */
function setISOYear (dirtyDate, dirtyISOYear) {
  var date = parse_1(dirtyDate);
  var isoYear = Number(dirtyISOYear);
  var diff = difference_in_calendar_days(date, start_of_iso_year(date));
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(isoYear, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  date = start_of_iso_year(fourthOfJanuary);
  date.setDate(date.getDate() + diff);
  return date
}

var set_iso_year = setISOYear;

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be added
 * @returns {Date} the new date with the ISO week-numbering years added
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * var result = addISOYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jun 26 2015 00:00:00
 */
function addISOYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount);
  return set_iso_year(dirtyDate, get_iso_year(dirtyDate) + amount)
}

var add_iso_years = addISOYears;

var MILLISECONDS_IN_MINUTE$3 = 60000;

/**
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added
 * @returns {Date} the new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */
function addMinutes (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount);
  return add_milliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE$3)
}

var add_minutes = addMinutes;

/**
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * var result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth (dirtyDate) {
  var date = parse_1(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate()
}

var get_days_in_month = getDaysInMonth;

/**
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added
 * @returns {Date} the new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * var result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths (dirtyDate, dirtyAmount) {
  var date = parse_1(dirtyDate);
  var amount = Number(dirtyAmount);
  var desiredMonth = date.getMonth() + amount;
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = get_days_in_month(dateWithDesiredMonth);
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()));
  return date
}

var add_months = addMonths;

/**
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be added
 * @returns {Date} the new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * var result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */
function addQuarters (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount);
  var months = amount * 3;
  return add_months(dirtyDate, months)
}

var add_quarters = addQuarters;

/**
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be added
 * @returns {Date} the new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * var result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */
function addSeconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount);
  return add_milliseconds(dirtyDate, amount * 1000)
}

var add_seconds = addSeconds;

/**
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added
 * @returns {Date} the new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * var result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount);
  var days = amount * 7;
  return add_days(dirtyDate, days)
}

var add_weeks = addWeeks;

/**
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added
 * @returns {Date} the new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * var result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount);
  return add_months(dirtyDate, amount * 12)
}

var add_years = addYears;

/**
 * @category Range Helpers
 * @summary Is the given date range overlapping with another date range?
 *
 * @description
 * Is the given date range overlapping with another date range?
 *
 * @param {Date|String|Number} initialRangeStartDate - the start of the initial range
 * @param {Date|String|Number} initialRangeEndDate - the end of the initial range
 * @param {Date|String|Number} comparedRangeStartDate - the start of the range to compare it with
 * @param {Date|String|Number} comparedRangeEndDate - the end of the range to compare it with
 * @returns {Boolean} whether the date ranges are overlapping
 * @throws {Error} startDate of a date range cannot be after its endDate
 *
 * @example
 * // For overlapping date ranges:
 * areRangesOverlapping(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 17), new Date(2014, 0, 21)
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping date ranges:
 * areRangesOverlapping(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 21), new Date(2014, 0, 22)
 * )
 * //=> false
 */
function areRangesOverlapping (dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
  var initialStartTime = parse_1(dirtyInitialRangeStartDate).getTime();
  var initialEndTime = parse_1(dirtyInitialRangeEndDate).getTime();
  var comparedStartTime = parse_1(dirtyComparedRangeStartDate).getTime();
  var comparedEndTime = parse_1(dirtyComparedRangeEndDate).getTime();

  if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  return initialStartTime < comparedEndTime && comparedStartTime < initialEndTime
}

var are_ranges_overlapping = areRangesOverlapping;

/**
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date[]|String[]|Number[]} datesArray - the array to search
 * @returns {Number} an index of the date closest to the given date
 * @throws {TypeError} the second argument must be an instance of Array
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * var dateToCompare = new Date(2015, 8, 6)
 * var datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * var result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */
function closestIndexTo (dirtyDateToCompare, dirtyDatesArray) {
  if (!(dirtyDatesArray instanceof Array)) {
    throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array')
  }

  var dateToCompare = parse_1(dirtyDateToCompare);
  var timeToCompare = dateToCompare.getTime();

  var result;
  var minDistance;

  dirtyDatesArray.forEach(function (dirtyDate, index) {
    var currentDate = parse_1(dirtyDate);
    var distance = Math.abs(timeToCompare - currentDate.getTime());
    if (result === undefined || distance < minDistance) {
      result = index;
      minDistance = distance;
    }
  });

  return result
}

var closest_index_to = closestIndexTo;

/**
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date[]|String[]|Number[]} datesArray - the array to search
 * @returns {Date} the date from the array closest to the given date
 * @throws {TypeError} the second argument must be an instance of Array
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * var dateToCompare = new Date(2015, 8, 6)
 * var result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */
function closestTo (dirtyDateToCompare, dirtyDatesArray) {
  if (!(dirtyDatesArray instanceof Array)) {
    throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array')
  }

  var dateToCompare = parse_1(dirtyDateToCompare);
  var timeToCompare = dateToCompare.getTime();

  var result;
  var minDistance;

  dirtyDatesArray.forEach(function (dirtyDate) {
    var currentDate = parse_1(dirtyDate);
    var distance = Math.abs(timeToCompare - currentDate.getTime());
    if (result === undefined || distance < minDistance) {
      result = currentDate;
      minDistance = distance;
    }
  });

  return result
}

var closest_to = closestTo;

/**
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * var result = compareAsc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */
function compareAsc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse_1(dirtyDateLeft);
  var timeLeft = dateLeft.getTime();
  var dateRight = parse_1(dirtyDateRight);
  var timeRight = dateRight.getTime();

  if (timeLeft < timeRight) {
    return -1
  } else if (timeLeft > timeRight) {
    return 1
  } else {
    return 0
  }
}

var compare_asc = compareAsc;

/**
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * var result = compareDesc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */
function compareDesc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse_1(dirtyDateLeft);
  var timeLeft = dateLeft.getTime();
  var dateRight = parse_1(dirtyDateRight);
  var timeRight = dateRight.getTime();

  if (timeLeft > timeRight) {
    return -1
  } else if (timeLeft < timeRight) {
    return 1
  } else {
    return 0
  }
}

var compare_desc = compareDesc;

var MILLISECONDS_IN_MINUTE$4 = 60000;
var MILLISECONDS_IN_WEEK = 604800000;

/**
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO weeks
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * var result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */
function differenceInCalendarISOWeeks (dirtyDateLeft, dirtyDateRight) {
  var startOfISOWeekLeft = start_of_iso_week(dirtyDateLeft);
  var startOfISOWeekRight = start_of_iso_week(dirtyDateRight);

  var timestampLeft = startOfISOWeekLeft.getTime() -
    startOfISOWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$4;
  var timestampRight = startOfISOWeekRight.getTime() -
    startOfISOWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$4;

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
}

var difference_in_calendar_iso_weeks = differenceInCalendarISOWeeks;

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO week-numbering years
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * var result = differenceInCalendarISOYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */
function differenceInCalendarISOYears (dirtyDateLeft, dirtyDateRight) {
  return get_iso_year(dirtyDateLeft) - get_iso_year(dirtyDateRight)
}

var difference_in_calendar_iso_years = differenceInCalendarISOYears;

/**
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse_1(dirtyDateLeft);
  var dateRight = parse_1(dirtyDateRight);

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();

  return yearDiff * 12 + monthDiff
}

var difference_in_calendar_months = differenceInCalendarMonths;

/**
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * var result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */
function getQuarter (dirtyDate) {
  var date = parse_1(dirtyDate);
  var quarter = Math.floor(date.getMonth() / 3) + 1;
  return quarter
}

var get_quarter = getQuarter;

/**
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * var result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */
function differenceInCalendarQuarters (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse_1(dirtyDateLeft);
  var dateRight = parse_1(dirtyDateRight);

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var quarterDiff = get_quarter(dateLeft) - get_quarter(dateRight);

  return yearDiff * 4 + quarterDiff
}

var difference_in_calendar_quarters = differenceInCalendarQuarters;

var MILLISECONDS_IN_MINUTE$5 = 60000;
var MILLISECONDS_IN_WEEK$1 = 604800000;

/**
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   {weekStartsOn: 1}
 * )
 * //=> 2
 */
function differenceInCalendarWeeks (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  var startOfWeekLeft = start_of_week(dirtyDateLeft, dirtyOptions);
  var startOfWeekRight = start_of_week(dirtyDateRight, dirtyOptions);

  var timestampLeft = startOfWeekLeft.getTime() -
    startOfWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$5;
  var timestampRight = startOfWeekRight.getTime() -
    startOfWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$5;

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK$1)
}

var difference_in_calendar_weeks = differenceInCalendarWeeks;

/**
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInCalendarYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse_1(dirtyDateLeft);
  var dateRight = parse_1(dirtyDateRight);

  return dateLeft.getFullYear() - dateRight.getFullYear()
}

var difference_in_calendar_years = differenceInCalendarYears;

/**
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full days
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 */
function differenceInDays (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse_1(dirtyDateLeft);
  var dateRight = parse_1(dirtyDateRight);

  var sign = compare_asc(dateLeft, dateRight);
  var difference = Math.abs(difference_in_calendar_days(dateLeft, dateRight));
  dateLeft.setDate(dateLeft.getDate() - sign * difference);

  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastDayNotFull = compare_asc(dateLeft, dateRight) === -sign;
  return sign * (difference - isLastDayNotFull)
}

var difference_in_days = differenceInDays;

/**
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * var result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */
function differenceInMilliseconds (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse_1(dirtyDateLeft);
  var dateRight = parse_1(dirtyDateRight);
  return dateLeft.getTime() - dateRight.getTime()
}

var difference_in_milliseconds = differenceInMilliseconds;

var MILLISECONDS_IN_HOUR$2 = 3600000;

/**
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * var result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */
function differenceInHours (dirtyDateLeft, dirtyDateRight) {
  var diff = difference_in_milliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_HOUR$2;
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

var difference_in_hours = differenceInHours;

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be subtracted
 * @returns {Date} the new date with the ISO week-numbering years subtracted
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * var result = subISOYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */
function subISOYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount);
  return add_iso_years(dirtyDate, -amount)
}

var sub_iso_years = subISOYears;

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full ISO week-numbering years
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * var result = differenceInISOYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */
function differenceInISOYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse_1(dirtyDateLeft);
  var dateRight = parse_1(dirtyDateRight);

  var sign = compare_asc(dateLeft, dateRight);
  var difference = Math.abs(difference_in_calendar_iso_years(dateLeft, dateRight));
  dateLeft = sub_iso_years(dateLeft, sign * difference);

  // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
  // if last calendar ISO year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastISOYearNotFull = compare_asc(dateLeft, dateRight) === -sign;
  return sign * (difference - isLastISOYearNotFull)
}

var difference_in_iso_years = differenceInISOYears;

var MILLISECONDS_IN_MINUTE$6 = 60000;

/**
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the number of minutes between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * var result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 */
function differenceInMinutes (dirtyDateLeft, dirtyDateRight) {
  var diff = difference_in_milliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE$6;
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

var difference_in_minutes = differenceInMinutes;

/**
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 7
 */
function differenceInMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse_1(dirtyDateLeft);
  var dateRight = parse_1(dirtyDateRight);

  var sign = compare_asc(dateLeft, dateRight);
  var difference = Math.abs(difference_in_calendar_months(dateLeft, dateRight));
  dateLeft.setMonth(dateLeft.getMonth() - sign * difference);

  // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastMonthNotFull = compare_asc(dateLeft, dateRight) === -sign;
  return sign * (difference - isLastMonthNotFull)
}

var difference_in_months = differenceInMonths;

/**
 * @category Quarter Helpers
 * @summary Get the number of full quarters between the given dates.
 *
 * @description
 * Get the number of full quarters between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full quarters
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * var result = differenceInQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInQuarters (dirtyDateLeft, dirtyDateRight) {
  var diff = difference_in_months(dirtyDateLeft, dirtyDateRight) / 3;
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

var difference_in_quarters = differenceInQuarters;

/**
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * var result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */
function differenceInSeconds (dirtyDateLeft, dirtyDateRight) {
  var diff = difference_in_milliseconds(dirtyDateLeft, dirtyDateRight) / 1000;
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

var difference_in_seconds = differenceInSeconds;

/**
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full weeks
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 2
 */
function differenceInWeeks (dirtyDateLeft, dirtyDateRight) {
  var diff = difference_in_days(dirtyDateLeft, dirtyDateRight) / 7;
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

var difference_in_weeks = differenceInWeeks;

/**
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 1
 */
function differenceInYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse_1(dirtyDateLeft);
  var dateRight = parse_1(dirtyDateRight);

  var sign = compare_asc(dateLeft, dateRight);
  var difference = Math.abs(difference_in_calendar_years(dateLeft, dateRight));
  dateLeft.setFullYear(dateLeft.getFullYear() - sign * difference);

  // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastYearNotFull = compare_asc(dateLeft, dateRight) === -sign;
  return sign * (difference - isLastYearNotFull)
}

var difference_in_years = differenceInYears;

function buildDistanceInWordsLocale () {
  var distanceInWordsLocale = {
    lessThanXSeconds: {
      one: 'less than a second',
      other: 'less than {{count}} seconds'
    },

    xSeconds: {
      one: '1 second',
      other: '{{count}} seconds'
    },

    halfAMinute: 'half a minute',

    lessThanXMinutes: {
      one: 'less than a minute',
      other: 'less than {{count}} minutes'
    },

    xMinutes: {
      one: '1 minute',
      other: '{{count}} minutes'
    },

    aboutXHours: {
      one: 'about 1 hour',
      other: 'about {{count}} hours'
    },

    xHours: {
      one: '1 hour',
      other: '{{count}} hours'
    },

    xDays: {
      one: '1 day',
      other: '{{count}} days'
    },

    aboutXMonths: {
      one: 'about 1 month',
      other: 'about {{count}} months'
    },

    xMonths: {
      one: '1 month',
      other: '{{count}} months'
    },

    aboutXYears: {
      one: 'about 1 year',
      other: 'about {{count}} years'
    },

    xYears: {
      one: '1 year',
      other: '{{count}} years'
    },

    overXYears: {
      one: 'over 1 year',
      other: 'over {{count}} years'
    },

    almostXYears: {
      one: 'almost 1 year',
      other: 'almost {{count}} years'
    }
  };

  function localize (token, count, options) {
    options = options || {};

    var result;
    if (typeof distanceInWordsLocale[token] === 'string') {
      result = distanceInWordsLocale[token];
    } else if (count === 1) {
      result = distanceInWordsLocale[token].one;
    } else {
      result = distanceInWordsLocale[token].other.replace('{{count}}', count);
    }

    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'in ' + result
      } else {
        return result + ' ago'
      }
    }

    return result
  }

  return {
    localize: localize
  }
}

var build_distance_in_words_locale = buildDistanceInWordsLocale;

var commonFormatterKeys = [
  'M', 'MM', 'Q', 'D', 'DD', 'DDD', 'DDDD', 'd',
  'E', 'W', 'WW', 'YY', 'YYYY', 'GG', 'GGGG',
  'H', 'HH', 'h', 'hh', 'm', 'mm',
  's', 'ss', 'S', 'SS', 'SSS',
  'Z', 'ZZ', 'X', 'x'
];

function buildFormattingTokensRegExp (formatters) {
  var formatterKeys = [];
  for (var key in formatters) {
    if (formatters.hasOwnProperty(key)) {
      formatterKeys.push(key);
    }
  }

  var formattingTokens = commonFormatterKeys
    .concat(formatterKeys)
    .sort()
    .reverse();
  var formattingTokensRegExp = new RegExp(
    '(\\[[^\\[]*\\])|(\\\\)?' + '(' + formattingTokens.join('|') + '|.)', 'g'
  );

  return formattingTokensRegExp
}

var build_formatting_tokens_reg_exp = buildFormattingTokensRegExp;

function buildFormatLocale () {
  // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.
  var months3char = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var weekdays2char = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
  var weekdays3char = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var weekdaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var meridiemUppercase = ['AM', 'PM'];
  var meridiemLowercase = ['am', 'pm'];
  var meridiemFull = ['a.m.', 'p.m.'];

  var formatters = {
    // Month: Jan, Feb, ..., Dec
    'MMM': function (date) {
      return months3char[date.getMonth()]
    },

    // Month: January, February, ..., December
    'MMMM': function (date) {
      return monthsFull[date.getMonth()]
    },

    // Day of week: Su, Mo, ..., Sa
    'dd': function (date) {
      return weekdays2char[date.getDay()]
    },

    // Day of week: Sun, Mon, ..., Sat
    'ddd': function (date) {
      return weekdays3char[date.getDay()]
    },

    // Day of week: Sunday, Monday, ..., Saturday
    'dddd': function (date) {
      return weekdaysFull[date.getDay()]
    },

    // AM, PM
    'A': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemUppercase[1] : meridiemUppercase[0]
    },

    // am, pm
    'a': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemLowercase[1] : meridiemLowercase[0]
    },

    // a.m., p.m.
    'aa': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemFull[1] : meridiemFull[0]
    }
  };

  // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
  var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W'];
  ordinalFormatters.forEach(function (formatterToken) {
    formatters[formatterToken + 'o'] = function (date, formatters) {
      return ordinal(formatters[formatterToken](date))
    };
  });

  return {
    formatters: formatters,
    formattingTokensRegExp: build_formatting_tokens_reg_exp(formatters)
  }
}

function ordinal (number) {
  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st'
      case 2:
        return number + 'nd'
      case 3:
        return number + 'rd'
    }
  }
  return number + 'th'
}

var build_format_locale = buildFormatLocale;

/**
 * @category Locales
 * @summary English locale.
 */
var en = {
  distanceInWords: build_distance_in_words_locale(),
  format: build_format_locale()
};

var MINUTES_IN_DAY = 1440;
var MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var MINUTES_IN_MONTH = 43200;
var MINUTES_IN_TWO_MONTHS = 86400;

/**
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date|String|Number} date - the other date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = distanceInWords(
 *   new Date(2014, 6, 2),
 *   new Date(2015, 0, 1)
 * )
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * var result = distanceInWords(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = distanceInWords(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWords(
 *   new Date(2016, 7, 1),
 *   new Date(2015, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function distanceInWords (dirtyDateToCompare, dirtyDate, dirtyOptions) {
  var options = dirtyOptions || {};

  var comparison = compare_desc(dirtyDateToCompare, dirtyDate);

  var locale = options.locale;
  var localize = en.distanceInWords.localize;
  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
    localize = locale.distanceInWords.localize;
  }

  var localizeOptions = {
    addSuffix: Boolean(options.addSuffix),
    comparison: comparison
  };

  var dateLeft, dateRight;
  if (comparison > 0) {
    dateLeft = parse_1(dirtyDateToCompare);
    dateRight = parse_1(dirtyDate);
  } else {
    dateLeft = parse_1(dirtyDate);
    dateRight = parse_1(dirtyDateToCompare);
  }

  var seconds = difference_in_seconds(dateRight, dateLeft);
  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset();
  var minutes = Math.round(seconds / 60) - offset;
  var months;

  // 0 up to 2 mins
  if (minutes < 2) {
    if (options.includeSeconds) {
      if (seconds < 5) {
        return localize('lessThanXSeconds', 5, localizeOptions)
      } else if (seconds < 10) {
        return localize('lessThanXSeconds', 10, localizeOptions)
      } else if (seconds < 20) {
        return localize('lessThanXSeconds', 20, localizeOptions)
      } else if (seconds < 40) {
        return localize('halfAMinute', null, localizeOptions)
      } else if (seconds < 60) {
        return localize('lessThanXMinutes', 1, localizeOptions)
      } else {
        return localize('xMinutes', 1, localizeOptions)
      }
    } else {
      if (minutes === 0) {
        return localize('lessThanXMinutes', 1, localizeOptions)
      } else {
        return localize('xMinutes', minutes, localizeOptions)
      }
    }

  // 2 mins up to 0.75 hrs
  } else if (minutes < 45) {
    return localize('xMinutes', minutes, localizeOptions)

  // 0.75 hrs up to 1.5 hrs
  } else if (minutes < 90) {
    return localize('aboutXHours', 1, localizeOptions)

  // 1.5 hrs up to 24 hrs
  } else if (minutes < MINUTES_IN_DAY) {
    var hours = Math.round(minutes / 60);
    return localize('aboutXHours', hours, localizeOptions)

  // 1 day up to 1.75 days
  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
    return localize('xDays', 1, localizeOptions)

  // 1.75 days up to 30 days
  } else if (minutes < MINUTES_IN_MONTH) {
    var days = Math.round(minutes / MINUTES_IN_DAY);
    return localize('xDays', days, localizeOptions)

  // 1 month up to 2 months
  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
    months = Math.round(minutes / MINUTES_IN_MONTH);
    return localize('aboutXMonths', months, localizeOptions)
  }

  months = difference_in_months(dateRight, dateLeft);

  // 2 months up to 12 months
  if (months < 12) {
    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
    return localize('xMonths', nearestMonth, localizeOptions)

  // 1 year up to max Date
  } else {
    var monthsSinceStartOfYear = months % 12;
    var years = Math.floor(months / 12);

    // N years up to 1 years 3 months
    if (monthsSinceStartOfYear < 3) {
      return localize('aboutXYears', years, localizeOptions)

    // N years 3 months up to N years 9 months
    } else if (monthsSinceStartOfYear < 9) {
      return localize('overXYears', years, localizeOptions)

    // N years 9 months up to N year 12 months
    } else {
      return localize('almostXYears', years + 1, localizeOptions)
    }
  }
}

var distance_in_words = distanceInWords;

var MINUTES_IN_DAY$1 = 1440;
var MINUTES_IN_MONTH$1 = 43200;
var MINUTES_IN_YEAR = 525600;

/**
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `distanceInWords`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date|String|Number} date - the other date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {'s'|'m'|'h'|'d'|'M'|'Y'} [options.unit] - if specified, will force a unit
 * @param {'floor'|'ceil'|'round'} [options.partialMethod='floor'] - which way to round partial units
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = distanceInWordsStrict(
 *   new Date(2014, 6, 2),
 *   new Date(2015, 0, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * var result = distanceInWordsStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = distanceInWordsStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * var result = distanceInWordsStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {unit: 'm'}
 * )
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 28 January 2015, in months, rounded up?
 * var result = distanceInWordsStrict(
 *   new Date(2015, 0, 28),
 *   new Date(2015, 0, 1),
 *   {unit: 'M', partialMethod: 'ceil'}
 * )
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWordsStrict(
 *   new Date(2016, 7, 1),
 *   new Date(2015, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */
function distanceInWordsStrict (dirtyDateToCompare, dirtyDate, dirtyOptions) {
  var options = dirtyOptions || {};

  var comparison = compare_desc(dirtyDateToCompare, dirtyDate);

  var locale = options.locale;
  var localize = en.distanceInWords.localize;
  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
    localize = locale.distanceInWords.localize;
  }

  var localizeOptions = {
    addSuffix: Boolean(options.addSuffix),
    comparison: comparison
  };

  var dateLeft, dateRight;
  if (comparison > 0) {
    dateLeft = parse_1(dirtyDateToCompare);
    dateRight = parse_1(dirtyDate);
  } else {
    dateLeft = parse_1(dirtyDate);
    dateRight = parse_1(dirtyDateToCompare);
  }

  var unit;
  var mathPartial = Math[options.partialMethod ? String(options.partialMethod) : 'floor'];
  var seconds = difference_in_seconds(dateRight, dateLeft);
  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset();
  var minutes = mathPartial(seconds / 60) - offset;
  var hours, days, months, years;

  if (options.unit) {
    unit = String(options.unit);
  } else {
    if (minutes < 1) {
      unit = 's';
    } else if (minutes < 60) {
      unit = 'm';
    } else if (minutes < MINUTES_IN_DAY$1) {
      unit = 'h';
    } else if (minutes < MINUTES_IN_MONTH$1) {
      unit = 'd';
    } else if (minutes < MINUTES_IN_YEAR) {
      unit = 'M';
    } else {
      unit = 'Y';
    }
  }

  // 0 up to 60 seconds
  if (unit === 's') {
    return localize('xSeconds', seconds, localizeOptions)

  // 1 up to 60 mins
  } else if (unit === 'm') {
    return localize('xMinutes', minutes, localizeOptions)

  // 1 up to 24 hours
  } else if (unit === 'h') {
    hours = mathPartial(minutes / 60);
    return localize('xHours', hours, localizeOptions)

  // 1 up to 30 days
  } else if (unit === 'd') {
    days = mathPartial(minutes / MINUTES_IN_DAY$1);
    return localize('xDays', days, localizeOptions)

  // 1 up to 12 months
  } else if (unit === 'M') {
    months = mathPartial(minutes / MINUTES_IN_MONTH$1);
    return localize('xMonths', months, localizeOptions)

  // 1 year up to max Date
  } else if (unit === 'Y') {
    years = mathPartial(minutes / MINUTES_IN_YEAR);
    return localize('xYears', years, localizeOptions)
  }

  throw new Error('Unknown unit: ' + unit)
}

var distance_in_words_strict = distanceInWordsStrict;

/**
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @param {Date|String|Number} date - the given date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result specifies if the second date is earlier or later than the first
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * var result = distanceInWordsToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * var result = distanceInWordsToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * var result = distanceInWordsToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWordsToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function distanceInWordsToNow (dirtyDate, dirtyOptions) {
  return distance_in_words(Date.now(), dirtyDate, dirtyOptions)
}

var distance_in_words_to_now = distanceInWordsToNow;

/**
 * @category Day Helpers
 * @summary Return the array of dates within the specified range.
 *
 * @description
 * Return the array of dates within the specified range.
 *
 * @param {Date|String|Number} startDate - the first date
 * @param {Date|String|Number} endDate - the last date
 * @param {Number} [step=1] - the step between each day
 * @returns {Date[]} the array with starts of days from the day of startDate to the day of endDate
 * @throws {Error} startDate cannot be after endDate
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * var result = eachDay(
 *   new Date(2014, 9, 6),
 *   new Date(2014, 9, 10)
 * )
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */
function eachDay (dirtyStartDate, dirtyEndDate, dirtyStep) {
  var startDate = parse_1(dirtyStartDate);
  var endDate = parse_1(dirtyEndDate);
  var step = dirtyStep !== undefined ? dirtyStep : 1;

  var endTime = endDate.getTime();

  if (startDate.getTime() > endTime) {
    throw new Error('The first date cannot be after the second date')
  }

  var dates = [];

  var currentDate = startDate;
  currentDate.setHours(0, 0, 0, 0);

  while (currentDate.getTime() <= endTime) {
    dates.push(parse_1(currentDate));
    currentDate.setDate(currentDate.getDate() + step);
  }

  return dates
}

var each_day = eachDay;

/**
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay (dirtyDate) {
  var date = parse_1(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date
}

var end_of_day = endOfDay;

/**
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an hour
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * var result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */
function endOfHour (dirtyDate) {
  var date = parse_1(dirtyDate);
  date.setMinutes(59, 59, 999);
  return date
}

var end_of_hour = endOfHour;

/**
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0;

  var date = parse_1(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);

  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date
}

var end_of_week = endOfWeek;

/**
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * var result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfISOWeek (dirtyDate) {
  return end_of_week(dirtyDate, {weekStartsOn: 1})
}

var end_of_iso_week = endOfISOWeek;

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * var result = endOfISOYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */
function endOfISOYear (dirtyDate) {
  var year = get_iso_year(dirtyDate);
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var date = start_of_iso_week(fourthOfJanuaryOfNextYear);
  date.setMilliseconds(date.getMilliseconds() - 1);
  return date
}

var end_of_iso_year = endOfISOYear;

/**
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a minute
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * var result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */
function endOfMinute (dirtyDate) {
  var date = parse_1(dirtyDate);
  date.setSeconds(59, 999);
  return date
}

var end_of_minute = endOfMinute;

/**
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth (dirtyDate) {
  var date = parse_1(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date
}

var end_of_month = endOfMonth;

/**
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a quarter
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * var result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfQuarter (dirtyDate) {
  var date = parse_1(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3 + 3;
  date.setMonth(month, 0);
  date.setHours(23, 59, 59, 999);
  return date
}

var end_of_quarter = endOfQuarter;

/**
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a second
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * var result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */
function endOfSecond (dirtyDate) {
  var date = parse_1(dirtyDate);
  date.setMilliseconds(999);
  return date
}

var end_of_second = endOfSecond;

/**
 * @category Day Helpers
 * @summary Return the end of today.
 *
 * @description
 * Return the end of today.
 *
 * @returns {Date} the end of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */
function endOfToday () {
  return end_of_day(new Date())
}

var end_of_today = endOfToday;

/**
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 *
 * @description
 * Return the end of tomorrow.
 *
 * @returns {Date} the end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */
function endOfTomorrow () {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth();
  var day = now.getDate();

  var date = new Date(0);
  date.setFullYear(year, month, day + 1);
  date.setHours(23, 59, 59, 999);
  return date
}

var end_of_tomorrow = endOfTomorrow;

/**
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */
function endOfYear (dirtyDate) {
  var date = parse_1(dirtyDate);
  var year = date.getFullYear();
  date.setFullYear(year + 1, 0, 0);
  date.setHours(23, 59, 59, 999);
  return date
}

var end_of_year = endOfYear;

/**
 * @category Day Helpers
 * @summary Return the end of yesterday.
 *
 * @description
 * Return the end of yesterday.
 *
 * @returns {Date} the end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */
function endOfYesterday () {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth();
  var day = now.getDate();

  var date = new Date(0);
  date.setFullYear(year, month, day - 1);
  date.setHours(23, 59, 59, 999);
  return date
}

var end_of_yesterday = endOfYesterday;

/**
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear (dirtyDate) {
  var cleanDate = parse_1(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date
}

var start_of_year = startOfYear;

/**
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * var result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear (dirtyDate) {
  var date = parse_1(dirtyDate);
  var diff = difference_in_calendar_days(date, start_of_year(date));
  var dayOfYear = diff + 1;
  return dayOfYear
}

var get_day_of_year = getDayOfYear;

var MILLISECONDS_IN_WEEK$2 = 604800000;

/**
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * var result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek (dirtyDate) {
  var date = parse_1(dirtyDate);
  var diff = start_of_iso_week(date).getTime() - start_of_iso_year(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK$2) + 1
}

var get_iso_week = getISOWeek;

/**
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {Date} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} argument must be an instance of Date
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid (dirtyDate) {
  if (is_date(dirtyDate)) {
    return !isNaN(dirtyDate)
  } else {
    throw new TypeError(toString.call(dirtyDate) + ' is not an instance of Date')
  }
}

var is_valid = isValid;

/**
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format.
 *
 * Accepted tokens:
 * | Unit                    | Token | Result examples                  |
 * |-------------------------|-------|----------------------------------|
 * | Month                   | M     | 1, 2, ..., 12                    |
 * |                         | Mo    | 1st, 2nd, ..., 12th              |
 * |                         | MM    | 01, 02, ..., 12                  |
 * |                         | MMM   | Jan, Feb, ..., Dec               |
 * |                         | MMMM  | January, February, ..., December |
 * | Quarter                 | Q     | 1, 2, 3, 4                       |
 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
 * | Day of month            | D     | 1, 2, ..., 31                    |
 * |                         | Do    | 1st, 2nd, ..., 31st              |
 * |                         | DD    | 01, 02, ..., 31                  |
 * | Day of year             | DDD   | 1, 2, ..., 366                   |
 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
 * |                         | DDDD  | 001, 002, ..., 366               |
 * | Day of week             | d     | 0, 1, ..., 6                     |
 * |                         | do    | 0th, 1st, ..., 6th               |
 * |                         | dd    | Su, Mo, ..., Sa                  |
 * |                         | ddd   | Sun, Mon, ..., Sat               |
 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
 * | ISO week                | W     | 1, 2, ..., 53                    |
 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
 * |                         | WW    | 01, 02, ..., 53                  |
 * | Year                    | YY    | 00, 01, ..., 99                  |
 * |                         | YYYY  | 1900, 1901, ..., 2099            |
 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
 * |                         | GGGG  | 1900, 1901, ..., 2099            |
 * | AM/PM                   | A     | AM, PM                           |
 * |                         | a     | am, pm                           |
 * |                         | aa    | a.m., p.m.                       |
 * | Hour                    | H     | 0, 1, ... 23                     |
 * |                         | HH    | 00, 01, ... 23                   |
 * |                         | h     | 1, 2, ..., 12                    |
 * |                         | hh    | 01, 02, ..., 12                  |
 * | Minute                  | m     | 0, 1, ..., 59                    |
 * |                         | mm    | 00, 01, ..., 59                  |
 * | Second                  | s     | 0, 1, ..., 59                    |
 * |                         | ss    | 00, 01, ..., 59                  |
 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
 * | Millisecond             | SSS   | 000, 001, ..., 999               |
 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
 * |                         | ZZ    | -0100, +0000, ..., +1200         |
 * | Seconds timestamp       | X     | 512969520                        |
 * | Milliseconds timestamp  | x     | 512969520900                     |
 *
 * The characters wrapped in square brackets are escaped.
 *
 * The result may vary by locale.
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} [format='YYYY-MM-DDTHH:mm:ss.SSSZ'] - the string of tokens
 * @param {Object} [options] - the object with options
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the formatted date string
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(
 *   new Date(2014, 1, 11),
 *   'MM/DD/YYYY'
 * )
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * var eoLocale = require('date-fns/locale/eo')
 * var result = format(
 *   new Date(2014, 6, 2),
 *   'Do [de] MMMM YYYY',
 *   {locale: eoLocale}
 * )
 * //=> '2-a de julio 2014'
 */
function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = dirtyFormatStr ? String(dirtyFormatStr) : 'YYYY-MM-DDTHH:mm:ss.SSSZ';
  var options = dirtyOptions || {};

  var locale = options.locale;
  var localeFormatters = en.format.formatters;
  var formattingTokensRegExp = en.format.formattingTokensRegExp;
  if (locale && locale.format && locale.format.formatters) {
    localeFormatters = locale.format.formatters;

    if (locale.format.formattingTokensRegExp) {
      formattingTokensRegExp = locale.format.formattingTokensRegExp;
    }
  }

  var date = parse_1(dirtyDate);

  if (!is_valid(date)) {
    return 'Invalid Date'
  }

  var formatFn = buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp);

  return formatFn(date)
}

var formatters = {
  // Month: 1, 2, ..., 12
  'M': function (date) {
    return date.getMonth() + 1
  },

  // Month: 01, 02, ..., 12
  'MM': function (date) {
    return addLeadingZeros(date.getMonth() + 1, 2)
  },

  // Quarter: 1, 2, 3, 4
  'Q': function (date) {
    return Math.ceil((date.getMonth() + 1) / 3)
  },

  // Day of month: 1, 2, ..., 31
  'D': function (date) {
    return date.getDate()
  },

  // Day of month: 01, 02, ..., 31
  'DD': function (date) {
    return addLeadingZeros(date.getDate(), 2)
  },

  // Day of year: 1, 2, ..., 366
  'DDD': function (date) {
    return get_day_of_year(date)
  },

  // Day of year: 001, 002, ..., 366
  'DDDD': function (date) {
    return addLeadingZeros(get_day_of_year(date), 3)
  },

  // Day of week: 0, 1, ..., 6
  'd': function (date) {
    return date.getDay()
  },

  // Day of ISO week: 1, 2, ..., 7
  'E': function (date) {
    return date.getDay() || 7
  },

  // ISO week: 1, 2, ..., 53
  'W': function (date) {
    return get_iso_week(date)
  },

  // ISO week: 01, 02, ..., 53
  'WW': function (date) {
    return addLeadingZeros(get_iso_week(date), 2)
  },

  // Year: 00, 01, ..., 99
  'YY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4).substr(2)
  },

  // Year: 1900, 1901, ..., 2099
  'YYYY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4)
  },

  // ISO week-numbering year: 00, 01, ..., 99
  'GG': function (date) {
    return String(get_iso_year(date)).substr(2)
  },

  // ISO week-numbering year: 1900, 1901, ..., 2099
  'GGGG': function (date) {
    return get_iso_year(date)
  },

  // Hour: 0, 1, ... 23
  'H': function (date) {
    return date.getHours()
  },

  // Hour: 00, 01, ..., 23
  'HH': function (date) {
    return addLeadingZeros(date.getHours(), 2)
  },

  // Hour: 1, 2, ..., 12
  'h': function (date) {
    var hours = date.getHours();
    if (hours === 0) {
      return 12
    } else if (hours > 12) {
      return hours % 12
    } else {
      return hours
    }
  },

  // Hour: 01, 02, ..., 12
  'hh': function (date) {
    return addLeadingZeros(formatters['h'](date), 2)
  },

  // Minute: 0, 1, ..., 59
  'm': function (date) {
    return date.getMinutes()
  },

  // Minute: 00, 01, ..., 59
  'mm': function (date) {
    return addLeadingZeros(date.getMinutes(), 2)
  },

  // Second: 0, 1, ..., 59
  's': function (date) {
    return date.getSeconds()
  },

  // Second: 00, 01, ..., 59
  'ss': function (date) {
    return addLeadingZeros(date.getSeconds(), 2)
  },

  // 1/10 of second: 0, 1, ..., 9
  'S': function (date) {
    return Math.floor(date.getMilliseconds() / 100)
  },

  // 1/100 of second: 00, 01, ..., 99
  'SS': function (date) {
    return addLeadingZeros(Math.floor(date.getMilliseconds() / 10), 2)
  },

  // Millisecond: 000, 001, ..., 999
  'SSS': function (date) {
    return addLeadingZeros(date.getMilliseconds(), 3)
  },

  // Timezone: -01:00, +00:00, ... +12:00
  'Z': function (date) {
    return formatTimezone(date.getTimezoneOffset(), ':')
  },

  // Timezone: -0100, +0000, ... +1200
  'ZZ': function (date) {
    return formatTimezone(date.getTimezoneOffset())
  },

  // Seconds timestamp: 512969520
  'X': function (date) {
    return Math.floor(date.getTime() / 1000)
  },

  // Milliseconds timestamp: 512969520900
  'x': function (date) {
    return date.getTime()
  }
};

function buildFormatFn (formatStr, localeFormatters, formattingTokensRegExp) {
  var array = formatStr.match(formattingTokensRegExp);
  var length = array.length;

  var i;
  var formatter;
  for (i = 0; i < length; i++) {
    formatter = localeFormatters[array[i]] || formatters[array[i]];
    if (formatter) {
      array[i] = formatter;
    } else {
      array[i] = removeFormattingTokens(array[i]);
    }
  }

  return function (date) {
    var output = '';
    for (var i = 0; i < length; i++) {
      if (array[i] instanceof Function) {
        output += array[i](date, formatters);
      } else {
        output += array[i];
      }
    }
    return output
  }
}

function removeFormattingTokens (input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|]$/g, '')
  }
  return input.replace(/\\/g, '')
}

function formatTimezone (offset, delimeter) {
  delimeter = delimeter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
}

function addLeadingZeros (number, targetLength) {
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return output
}

var format_1 = format;

/**
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * var result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */
function getDate (dirtyDate) {
  var date = parse_1(dirtyDate);
  var dayOfMonth = date.getDate();
  return dayOfMonth
}

var get_date = getDate;

/**
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of week
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * var result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay (dirtyDate) {
  var date = parse_1(dirtyDate);
  var day = date.getDay();
  return day
}

var get_day = getDay;

/**
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the leap year
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * var result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */
function isLeapYear (dirtyDate) {
  var date = parse_1(dirtyDate);
  var year = date.getFullYear();
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0
}

var is_leap_year = isLeapYear;

/**
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * var result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */
function getDaysInYear (dirtyDate) {
  return is_leap_year(dirtyDate) ? 366 : 365
}

var get_days_in_year = getDaysInYear;

/**
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * var result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */
function getHours (dirtyDate) {
  var date = parse_1(dirtyDate);
  var hours = date.getHours();
  return hours
}

var get_hours = getHours;

/**
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * var result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */
function getISODay (dirtyDate) {
  var date = parse_1(dirtyDate);
  var day = date.getDay();

  if (day === 0) {
    day = 7;
  }

  return day
}

var get_iso_day = getISODay;

var MILLISECONDS_IN_WEEK$3 = 604800000;

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of ISO weeks in a year
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * var result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */
function getISOWeeksInYear (dirtyDate) {
  var thisYear = start_of_iso_year(dirtyDate);
  var nextYear = start_of_iso_year(add_weeks(thisYear, 60));
  var diff = nextYear.valueOf() - thisYear.valueOf();
  // Round the number of weeks to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK$3)
}

var get_iso_weeks_in_year = getISOWeeksInYear;

/**
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * var result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */
function getMilliseconds (dirtyDate) {
  var date = parse_1(dirtyDate);
  var milliseconds = date.getMilliseconds();
  return milliseconds
}

var get_milliseconds = getMilliseconds;

/**
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * var result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */
function getMinutes (dirtyDate) {
  var date = parse_1(dirtyDate);
  var minutes = date.getMinutes();
  return minutes
}

var get_minutes = getMinutes;

/**
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the month
 *
 * @example
 * // Which month is 29 February 2012?
 * var result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */
function getMonth (dirtyDate) {
  var date = parse_1(dirtyDate);
  var month = date.getMonth();
  return month
}

var get_month = getMonth;

var MILLISECONDS_IN_DAY$1 = 24 * 60 * 60 * 1000;

/**
 * @category Range Helpers
 * @summary Get the number of days that overlap in two date ranges
 *
 * @description
 * Get the number of days that overlap in two date ranges
 *
 * @param {Date|String|Number} initialRangeStartDate - the start of the initial range
 * @param {Date|String|Number} initialRangeEndDate - the end of the initial range
 * @param {Date|String|Number} comparedRangeStartDate - the start of the range to compare it with
 * @param {Date|String|Number} comparedRangeEndDate - the end of the range to compare it with
 * @returns {Number} the number of days that overlap in two date ranges
 * @throws {Error} startDate of a date range cannot be after its endDate
 *
 * @example
 * // For overlapping date ranges adds 1 for each started overlapping day:
 * getOverlappingDaysInRanges(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 17), new Date(2014, 0, 21)
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping date ranges returns 0:
 * getOverlappingDaysInRanges(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 21), new Date(2014, 0, 22)
 * )
 * //=> 0
 */
function getOverlappingDaysInRanges (dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
  var initialStartTime = parse_1(dirtyInitialRangeStartDate).getTime();
  var initialEndTime = parse_1(dirtyInitialRangeEndDate).getTime();
  var comparedStartTime = parse_1(dirtyComparedRangeStartDate).getTime();
  var comparedEndTime = parse_1(dirtyComparedRangeEndDate).getTime();

  if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  var isOverlapping = initialStartTime < comparedEndTime && comparedStartTime < initialEndTime;

  if (!isOverlapping) {
    return 0
  }

  var overlapStartDate = comparedStartTime < initialStartTime
    ? initialStartTime
    : comparedStartTime;

  var overlapEndDate = comparedEndTime > initialEndTime
    ? initialEndTime
    : comparedEndTime;

  var differenceInMs = overlapEndDate - overlapStartDate;

  return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY$1)
}

var get_overlapping_days_in_ranges = getOverlappingDaysInRanges;

/**
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * var result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */
function getSeconds (dirtyDate) {
  var date = parse_1(dirtyDate);
  var seconds = date.getSeconds();
  return seconds
}

var get_seconds = getSeconds;

/**
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * var result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */
function getTime (dirtyDate) {
  var date = parse_1(dirtyDate);
  var timestamp = date.getTime();
  return timestamp
}

var get_time = getTime;

/**
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the year
 *
 * @example
 * // Which year is 2 July 2014?
 * var result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */
function getYear (dirtyDate) {
  var date = parse_1(dirtyDate);
  var year = date.getFullYear();
  return year
}

var get_year = getYear;

/**
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|String|Number} date - the date that should be after the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter (dirtyDate, dirtyDateToCompare) {
  var date = parse_1(dirtyDate);
  var dateToCompare = parse_1(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime()
}

var is_after = isAfter;

/**
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|String|Number} date - the date that should be before the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore (dirtyDate, dirtyDateToCompare) {
  var date = parse_1(dirtyDate);
  var dateToCompare = parse_1(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime()
}

var is_before = isBefore;

/**
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0)
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual (dirtyLeftDate, dirtyRightDate) {
  var dateLeft = parse_1(dirtyLeftDate);
  var dateRight = parse_1(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime()
}

var is_equal = isEqual;

/**
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is the first day of a month
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * var result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */
function isFirstDayOfMonth (dirtyDate) {
  return parse_1(dirtyDate).getDate() === 1
}

var is_first_day_of_month = isFirstDayOfMonth;

/**
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * var result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */
function isFriday (dirtyDate) {
  return parse_1(dirtyDate).getDay() === 5
}

var is_friday = isFriday;

/**
 * @category Common Helpers
 * @summary Is the given date in the future?
 *
 * @description
 * Is the given date in the future?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * var result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */
function isFuture (dirtyDate) {
  return parse_1(dirtyDate).getTime() > new Date().getTime()
}

var is_future = isFuture;

/**
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * var result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */
function isLastDayOfMonth (dirtyDate) {
  var date = parse_1(dirtyDate);
  return end_of_day(date).getTime() === end_of_month(date).getTime()
}

var is_last_day_of_month = isLastDayOfMonth;

/**
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Monday
 *
 * @example
 * // Is 22 September 2014 Monday?
 * var result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */
function isMonday (dirtyDate) {
  return parse_1(dirtyDate).getDay() === 1
}

var is_monday = isMonday;

/**
 * @category Common Helpers
 * @summary Is the given date in the past?
 *
 * @description
 * Is the given date in the past?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * var result = isPast(new Date(2014, 6, 2))
 * //=> true
 */
function isPast (dirtyDate) {
  return parse_1(dirtyDate).getTime() < new Date().getTime()
}

var is_past = isPast;

/**
 * @category Day Helpers
 * @summary Are the given dates in the same day?
 *
 * @description
 * Are the given dates in the same day?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 18, 0)
 * )
 * //=> true
 */
function isSameDay (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfDay = start_of_day(dirtyDateLeft);
  var dateRightStartOfDay = start_of_day(dirtyDateRight);

  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime()
}

var is_same_day = isSameDay;

/**
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * var result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */
function startOfHour (dirtyDate) {
  var date = parse_1(dirtyDate);
  date.setMinutes(0, 0, 0);
  return date
}

var start_of_hour = startOfHour;

/**
 * @category Hour Helpers
 * @summary Are the given dates in the same hour?
 *
 * @description
 * Are the given dates in the same hour?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same hour
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * var result = isSameHour(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 6, 30)
 * )
 * //=> true
 */
function isSameHour (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfHour = start_of_hour(dirtyDateLeft);
  var dateRightStartOfHour = start_of_hour(dirtyDateRight);

  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime()
}

var is_same_hour = isSameHour;

/**
 * @category Week Helpers
 * @summary Are the given dates in the same week?
 *
 * @description
 * Are the given dates in the same week?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the dates are in the same week
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(
 *   new Date(2014, 7, 31),
 *   new Date(2014, 8, 4)
 * )
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(
 *   new Date(2014, 7, 31),
 *   new Date(2014, 8, 4),
 *   {weekStartsOn: 1}
 * )
 * //=> false
 */
function isSameWeek (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  var dateLeftStartOfWeek = start_of_week(dirtyDateLeft, dirtyOptions);
  var dateRightStartOfWeek = start_of_week(dirtyDateRight, dirtyOptions);

  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime()
}

var is_same_week = isSameWeek;

/**
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week?
 *
 * @description
 * Are the given dates in the same ISO week?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * var result = isSameISOWeek(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 8, 7)
 * )
 * //=> true
 */
function isSameISOWeek (dirtyDateLeft, dirtyDateRight) {
  return is_same_week(dirtyDateLeft, dirtyDateRight, {weekStartsOn: 1})
}

var is_same_iso_week = isSameISOWeek;

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week-numbering year
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * var result = isSameISOYear(
 *   new Date(2003, 11, 29),
 *   new Date(2005, 0, 2)
 * )
 * //=> true
 */
function isSameISOYear (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfYear = start_of_iso_year(dirtyDateLeft);
  var dateRightStartOfYear = start_of_iso_year(dirtyDateRight);

  return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime()
}

var is_same_iso_year = isSameISOYear;

/**
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * var result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */
function startOfMinute (dirtyDate) {
  var date = parse_1(dirtyDate);
  date.setSeconds(0, 0);
  return date
}

var start_of_minute = startOfMinute;

/**
 * @category Minute Helpers
 * @summary Are the given dates in the same minute?
 *
 * @description
 * Are the given dates in the same minute?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same minute
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15
 * // in the same minute?
 * var result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 */
function isSameMinute (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfMinute = start_of_minute(dirtyDateLeft);
  var dateRightStartOfMinute = start_of_minute(dirtyDateRight);

  return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime()
}

var is_same_minute = isSameMinute;

/**
 * @category Month Helpers
 * @summary Are the given dates in the same month?
 *
 * @description
 * Are the given dates in the same month?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameMonth (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse_1(dirtyDateLeft);
  var dateRight = parse_1(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() &&
    dateLeft.getMonth() === dateRight.getMonth()
}

var is_same_month = isSameMonth;

/**
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * var result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */
function startOfQuarter (dirtyDate) {
  var date = parse_1(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3;
  date.setMonth(month, 1);
  date.setHours(0, 0, 0, 0);
  return date
}

var start_of_quarter = startOfQuarter;

/**
 * @category Quarter Helpers
 * @summary Are the given dates in the same year quarter?
 *
 * @description
 * Are the given dates in the same year quarter?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * var result = isSameQuarter(
 *   new Date(2014, 0, 1),
 *   new Date(2014, 2, 8)
 * )
 * //=> true
 */
function isSameQuarter (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfQuarter = start_of_quarter(dirtyDateLeft);
  var dateRightStartOfQuarter = start_of_quarter(dirtyDateRight);

  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime()
}

var is_same_quarter = isSameQuarter;

/**
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a second
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * var result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */
function startOfSecond (dirtyDate) {
  var date = parse_1(dirtyDate);
  date.setMilliseconds(0);
  return date
}

var start_of_second = startOfSecond;

/**
 * @category Second Helpers
 * @summary Are the given dates in the same second?
 *
 * @description
 * Are the given dates in the same second?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same second
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500
 * // in the same second?
 * var result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 */
function isSameSecond (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfSecond = start_of_second(dirtyDateLeft);
  var dateRightStartOfSecond = start_of_second(dirtyDateRight);

  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime()
}

var is_same_second = isSameSecond;

/**
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * var result = isSameYear(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameYear (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse_1(dirtyDateLeft);
  var dateRight = parse_1(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear()
}

var is_same_year = isSameYear;

/**
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * var result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */
function isSaturday (dirtyDate) {
  return parse_1(dirtyDate).getDay() === 6
}

var is_saturday = isSaturday;

/**
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * var result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */
function isSunday (dirtyDate) {
  return parse_1(dirtyDate).getDay() === 0
}

var is_sunday = isSunday;

/**
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * var result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */
function isThisHour (dirtyDate) {
  return is_same_hour(new Date(), dirtyDate)
}

var is_this_hour = isThisHour;

/**
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this ISO week
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * var result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */
function isThisISOWeek (dirtyDate) {
  return is_same_iso_week(new Date(), dirtyDate)
}

var is_this_iso_week = isThisISOWeek;

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Is the given date in the same ISO week-numbering year as the current date?
 *
 * @description
 * Is the given date in the same ISO week-numbering year as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this ISO week-numbering year
 *
 * @example
 * // If today is 25 September 2014,
 * // is 30 December 2013 in this ISO week-numbering year?
 * var result = isThisISOYear(new Date(2013, 11, 30))
 * //=> true
 */
function isThisISOYear (dirtyDate) {
  return is_same_iso_year(new Date(), dirtyDate)
}

var is_this_iso_year = isThisISOYear;

/**
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * var result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */
function isThisMinute (dirtyDate) {
  return is_same_minute(new Date(), dirtyDate)
}

var is_this_minute = isThisMinute;

/**
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * var result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */
function isThisMonth (dirtyDate) {
  return is_same_month(new Date(), dirtyDate)
}

var is_this_month = isThisMonth;

/**
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * var result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */
function isThisQuarter (dirtyDate) {
  return is_same_quarter(new Date(), dirtyDate)
}

var is_this_quarter = isThisQuarter;

/**
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this second
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * var result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */
function isThisSecond (dirtyDate) {
  return is_same_second(new Date(), dirtyDate)
}

var is_this_second = isThisSecond;

/**
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21), {weekStartsOn: 1})
 * //=> false
 */
function isThisWeek (dirtyDate, dirtyOptions) {
  return is_same_week(new Date(), dirtyDate, dirtyOptions)
}

var is_this_week = isThisWeek;

/**
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * var result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */
function isThisYear (dirtyDate) {
  return is_same_year(new Date(), dirtyDate)
}

var is_this_year = isThisYear;

/**
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Thursday
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * var result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */
function isThursday (dirtyDate) {
  return parse_1(dirtyDate).getDay() === 4
}

var is_thursday = isThursday;

/**
 * @category Day Helpers
 * @summary Is the given date today?
 *
 * @description
 * Is the given date today?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * var result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */
function isToday (dirtyDate) {
  return start_of_day(dirtyDate).getTime() === start_of_day(new Date()).getTime()
}

var is_today = isToday;

/**
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 *
 * @description
 * Is the given date tomorrow?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is tomorrow
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * var result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */
function isTomorrow (dirtyDate) {
  var tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return start_of_day(dirtyDate).getTime() === start_of_day(tomorrow).getTime()
}

var is_tomorrow = isTomorrow;

/**
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Tuesday
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * var result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */
function isTuesday (dirtyDate) {
  return parse_1(dirtyDate).getDay() === 2
}

var is_tuesday = isTuesday;

/**
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Wednesday
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * var result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */
function isWednesday (dirtyDate) {
  return parse_1(dirtyDate).getDay() === 3
}

var is_wednesday = isWednesday;

/**
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * var result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */
function isWeekend (dirtyDate) {
  var date = parse_1(dirtyDate);
  var day = date.getDay();
  return day === 0 || day === 6
}

var is_weekend = isWeekend;

/**
 * @category Range Helpers
 * @summary Is the given date within the range?
 *
 * @description
 * Is the given date within the range?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Date|String|Number} startDate - the start of range
 * @param {Date|String|Number} endDate - the end of range
 * @returns {Boolean} the date is within the range
 * @throws {Error} startDate cannot be after endDate
 *
 * @example
 * // For the date within the range:
 * isWithinRange(
 *   new Date(2014, 0, 3), new Date(2014, 0, 1), new Date(2014, 0, 7)
 * )
 * //=> true
 *
 * @example
 * // For the date outside of the range:
 * isWithinRange(
 *   new Date(2014, 0, 10), new Date(2014, 0, 1), new Date(2014, 0, 7)
 * )
 * //=> false
 */
function isWithinRange (dirtyDate, dirtyStartDate, dirtyEndDate) {
  var time = parse_1(dirtyDate).getTime();
  var startTime = parse_1(dirtyStartDate).getTime();
  var endTime = parse_1(dirtyEndDate).getTime();

  if (startTime > endTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  return time >= startTime && time <= endTime
}

var is_within_range = isWithinRange;

/**
 * @category Day Helpers
 * @summary Is the given date yesterday?
 *
 * @description
 * Is the given date yesterday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * var result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */
function isYesterday (dirtyDate) {
  var yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  return start_of_day(dirtyDate).getTime() === start_of_day(yesterday).getTime()
}

var is_yesterday = isYesterday;

/**
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the last day of a week
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0;

  var date = parse_1(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);

  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() + diff);
  return date
}

var last_day_of_week = lastDayOfWeek;

/**
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of an ISO week
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * var result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfISOWeek (dirtyDate) {
  return last_day_of_week(dirtyDate, {weekStartsOn: 1})
}

var last_day_of_iso_week = lastDayOfISOWeek;

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * var result = lastDayOfISOYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */
function lastDayOfISOYear (dirtyDate) {
  var year = get_iso_year(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year + 1, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = start_of_iso_week(fourthOfJanuary);
  date.setDate(date.getDate() - 1);
  return date
}

var last_day_of_iso_year = lastDayOfISOYear;

/**
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * var result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfMonth (dirtyDate) {
  var date = parse_1(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(0, 0, 0, 0);
  return date
}

var last_day_of_month = lastDayOfMonth;

/**
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a quarter
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * var result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfQuarter (dirtyDate) {
  var date = parse_1(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3 + 3;
  date.setMonth(month, 0);
  date.setHours(0, 0, 0, 0);
  return date
}

var last_day_of_quarter = lastDayOfQuarter;

/**
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a year
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * var result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */
function lastDayOfYear (dirtyDate) {
  var date = parse_1(dirtyDate);
  var year = date.getFullYear();
  date.setFullYear(year + 1, 0, 0);
  date.setHours(0, 0, 0, 0);
  return date
}

var last_day_of_year = lastDayOfYear;

/**
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @param {...(Date|String|Number)} dates - the dates to compare
 * @returns {Date} the latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * var result = max(
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * )
 * //=> Sun Jul 02 1995 00:00:00
 */
function max$3 () {
  var dirtyDates = Array.prototype.slice.call(arguments);
  var dates = dirtyDates.map(function (dirtyDate) {
    return parse_1(dirtyDate)
  });
  var latestTimestamp = Math.max.apply(null, dates);
  return new Date(latestTimestamp)
}

var max_1 = max$3;

/**
 * @category Common Helpers
 * @summary Return the earliest of the given dates.
 *
 * @description
 * Return the earliest of the given dates.
 *
 * @param {...(Date|String|Number)} dates - the dates to compare
 * @returns {Date} the earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * var result = min(
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * )
 * //=> Wed Feb 11 1987 00:00:00
 */
function min$5 () {
  var dirtyDates = Array.prototype.slice.call(arguments);
  var dates = dirtyDates.map(function (dirtyDate) {
    return parse_1(dirtyDate)
  });
  var earliestTimestamp = Math.min.apply(null, dates);
  return new Date(earliestTimestamp)
}

var min_1 = min$5;

/**
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfMonth - the day of the month of the new date
 * @returns {Date} the new date with the day of the month setted
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * var result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */
function setDate (dirtyDate, dirtyDayOfMonth) {
  var date = parse_1(dirtyDate);
  var dayOfMonth = Number(dirtyDayOfMonth);
  date.setDate(dayOfMonth);
  return date
}

var set_date = setDate;

/**
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} day - the day of the week of the new date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the new date with the day of the week setted
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * var result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If week starts with Monday, set Sunday to 1 September 2014:
 * var result = setDay(new Date(2014, 8, 1), 0, {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 00:00:00
 */
function setDay (dirtyDate, dirtyDay, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0;
  var date = parse_1(dirtyDate);
  var day = Number(dirtyDay);
  var currentDay = date.getDay();

  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;

  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  return add_days(date, diff)
}

var set_day = setDay;

/**
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfYear - the day of the year of the new date
 * @returns {Date} the new date with the day of the year setted
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * var result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */
function setDayOfYear (dirtyDate, dirtyDayOfYear) {
  var date = parse_1(dirtyDate);
  var dayOfYear = Number(dirtyDayOfYear);
  date.setMonth(0);
  date.setDate(dayOfYear);
  return date
}

var set_day_of_year = setDayOfYear;

/**
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours setted
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */
function setHours (dirtyDate, dirtyHours) {
  var date = parse_1(dirtyDate);
  var hours = Number(dirtyHours);
  date.setHours(hours);
  return date
}

var set_hours = setHours;

/**
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} day - the day of the ISO week of the new date
 * @returns {Date} the new date with the day of the ISO week setted
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * var result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */
function setISODay (dirtyDate, dirtyDay) {
  var date = parse_1(dirtyDate);
  var day = Number(dirtyDay);
  var currentDay = get_iso_day(date);
  var diff = day - currentDay;
  return add_days(date, diff)
}

var set_iso_day = setISODay;

/**
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} isoWeek - the ISO week of the new date
 * @returns {Date} the new date with the ISO week setted
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * var result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */
function setISOWeek (dirtyDate, dirtyISOWeek) {
  var date = parse_1(dirtyDate);
  var isoWeek = Number(dirtyISOWeek);
  var diff = get_iso_week(date) - isoWeek;
  date.setDate(date.getDate() - diff * 7);
  return date
}

var set_iso_week = setISOWeek;

/**
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} milliseconds - the milliseconds of the new date
 * @returns {Date} the new date with the milliseconds setted
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * var result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */
function setMilliseconds (dirtyDate, dirtyMilliseconds) {
  var date = parse_1(dirtyDate);
  var milliseconds = Number(dirtyMilliseconds);
  date.setMilliseconds(milliseconds);
  return date
}

var set_milliseconds = setMilliseconds;

/**
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes setted
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */
function setMinutes (dirtyDate, dirtyMinutes) {
  var date = parse_1(dirtyDate);
  var minutes = Number(dirtyMinutes);
  date.setMinutes(minutes);
  return date
}

var set_minutes = setMinutes;

/**
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month setted
 *
 * @example
 * // Set February to 1 September 2014:
 * var result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth (dirtyDate, dirtyMonth) {
  var date = parse_1(dirtyDate);
  var month = Number(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();

  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = get_days_in_month(dateWithDesiredMonth);
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(month, Math.min(day, daysInMonth));
  return date
}

var set_month = setMonth;

/**
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter setted
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * var result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */
function setQuarter (dirtyDate, dirtyQuarter) {
  var date = parse_1(dirtyDate);
  var quarter = Number(dirtyQuarter);
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
  var diff = quarter - oldQuarter;
  return set_month(date, date.getMonth() + diff * 3)
}

var set_quarter = setQuarter;

/**
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds setted
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * var result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */
function setSeconds (dirtyDate, dirtySeconds) {
  var date = parse_1(dirtyDate);
  var seconds = Number(dirtySeconds);
  date.setSeconds(seconds);
  return date
}

var set_seconds = setSeconds;

/**
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year setted
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * var result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear (dirtyDate, dirtyYear) {
  var date = parse_1(dirtyDate);
  var year = Number(dirtyYear);
  date.setFullYear(year);
  return date
}

var set_year = setYear;

/**
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth (dirtyDate) {
  var date = parse_1(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date
}

var start_of_month = startOfMonth;

/**
 * @category Day Helpers
 * @summary Return the start of today.
 *
 * @description
 * Return the start of today.
 *
 * @returns {Date} the start of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */
function startOfToday () {
  return start_of_day(new Date())
}

var start_of_today = startOfToday;

/**
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns {Date} the start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */
function startOfTomorrow () {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth();
  var day = now.getDate();

  var date = new Date(0);
  date.setFullYear(year, month, day + 1);
  date.setHours(0, 0, 0, 0);
  return date
}

var start_of_tomorrow = startOfTomorrow;

/**
 * @category Day Helpers
 * @summary Return the start of yesterday.
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns {Date} the start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */
function startOfYesterday () {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth();
  var day = now.getDate();

  var date = new Date(0);
  date.setFullYear(year, month, day - 1);
  date.setHours(0, 0, 0, 0);
  return date
}

var start_of_yesterday = startOfYesterday;

/**
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted
 * @returns {Date} the new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * var result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount);
  return add_days(dirtyDate, -amount)
}

var sub_days = subDays;

/**
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be subtracted
 * @returns {Date} the new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * var result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */
function subHours (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount);
  return add_hours(dirtyDate, -amount)
}

var sub_hours = subHours;

/**
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted
 * @returns {Date} the new date with the milliseconds subtracted
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount);
  return add_milliseconds(dirtyDate, -amount)
}

var sub_milliseconds = subMilliseconds;

/**
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be subtracted
 * @returns {Date} the new date with the mintues subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */
function subMinutes (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount);
  return add_minutes(dirtyDate, -amount)
}

var sub_minutes = subMinutes;

/**
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted
 * @returns {Date} the new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * var result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount);
  return add_months(dirtyDate, -amount)
}

var sub_months = subMonths;

/**
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be subtracted
 * @returns {Date} the new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * var result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */
function subQuarters (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount);
  return add_quarters(dirtyDate, -amount)
}

var sub_quarters = subQuarters;

/**
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be subtracted
 * @returns {Date} the new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * var result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */
function subSeconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount);
  return add_seconds(dirtyDate, -amount)
}

var sub_seconds = subSeconds;

/**
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted
 * @returns {Date} the new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * var result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */
function subWeeks (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount);
  return add_weeks(dirtyDate, -amount)
}

var sub_weeks = subWeeks;

/**
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted
 * @returns {Date} the new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * var result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */
function subYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount);
  return add_years(dirtyDate, -amount)
}

var sub_years = subYears;

var dateFns = {
  addDays: add_days,
  addHours: add_hours,
  addISOYears: add_iso_years,
  addMilliseconds: add_milliseconds,
  addMinutes: add_minutes,
  addMonths: add_months,
  addQuarters: add_quarters,
  addSeconds: add_seconds,
  addWeeks: add_weeks,
  addYears: add_years,
  areRangesOverlapping: are_ranges_overlapping,
  closestIndexTo: closest_index_to,
  closestTo: closest_to,
  compareAsc: compare_asc,
  compareDesc: compare_desc,
  differenceInCalendarDays: difference_in_calendar_days,
  differenceInCalendarISOWeeks: difference_in_calendar_iso_weeks,
  differenceInCalendarISOYears: difference_in_calendar_iso_years,
  differenceInCalendarMonths: difference_in_calendar_months,
  differenceInCalendarQuarters: difference_in_calendar_quarters,
  differenceInCalendarWeeks: difference_in_calendar_weeks,
  differenceInCalendarYears: difference_in_calendar_years,
  differenceInDays: difference_in_days,
  differenceInHours: difference_in_hours,
  differenceInISOYears: difference_in_iso_years,
  differenceInMilliseconds: difference_in_milliseconds,
  differenceInMinutes: difference_in_minutes,
  differenceInMonths: difference_in_months,
  differenceInQuarters: difference_in_quarters,
  differenceInSeconds: difference_in_seconds,
  differenceInWeeks: difference_in_weeks,
  differenceInYears: difference_in_years,
  distanceInWords: distance_in_words,
  distanceInWordsStrict: distance_in_words_strict,
  distanceInWordsToNow: distance_in_words_to_now,
  eachDay: each_day,
  endOfDay: end_of_day,
  endOfHour: end_of_hour,
  endOfISOWeek: end_of_iso_week,
  endOfISOYear: end_of_iso_year,
  endOfMinute: end_of_minute,
  endOfMonth: end_of_month,
  endOfQuarter: end_of_quarter,
  endOfSecond: end_of_second,
  endOfToday: end_of_today,
  endOfTomorrow: end_of_tomorrow,
  endOfWeek: end_of_week,
  endOfYear: end_of_year,
  endOfYesterday: end_of_yesterday,
  format: format_1,
  getDate: get_date,
  getDay: get_day,
  getDayOfYear: get_day_of_year,
  getDaysInMonth: get_days_in_month,
  getDaysInYear: get_days_in_year,
  getHours: get_hours,
  getISODay: get_iso_day,
  getISOWeek: get_iso_week,
  getISOWeeksInYear: get_iso_weeks_in_year,
  getISOYear: get_iso_year,
  getMilliseconds: get_milliseconds,
  getMinutes: get_minutes,
  getMonth: get_month,
  getOverlappingDaysInRanges: get_overlapping_days_in_ranges,
  getQuarter: get_quarter,
  getSeconds: get_seconds,
  getTime: get_time,
  getYear: get_year,
  isAfter: is_after,
  isBefore: is_before,
  isDate: is_date,
  isEqual: is_equal,
  isFirstDayOfMonth: is_first_day_of_month,
  isFriday: is_friday,
  isFuture: is_future,
  isLastDayOfMonth: is_last_day_of_month,
  isLeapYear: is_leap_year,
  isMonday: is_monday,
  isPast: is_past,
  isSameDay: is_same_day,
  isSameHour: is_same_hour,
  isSameISOWeek: is_same_iso_week,
  isSameISOYear: is_same_iso_year,
  isSameMinute: is_same_minute,
  isSameMonth: is_same_month,
  isSameQuarter: is_same_quarter,
  isSameSecond: is_same_second,
  isSameWeek: is_same_week,
  isSameYear: is_same_year,
  isSaturday: is_saturday,
  isSunday: is_sunday,
  isThisHour: is_this_hour,
  isThisISOWeek: is_this_iso_week,
  isThisISOYear: is_this_iso_year,
  isThisMinute: is_this_minute,
  isThisMonth: is_this_month,
  isThisQuarter: is_this_quarter,
  isThisSecond: is_this_second,
  isThisWeek: is_this_week,
  isThisYear: is_this_year,
  isThursday: is_thursday,
  isToday: is_today,
  isTomorrow: is_tomorrow,
  isTuesday: is_tuesday,
  isValid: is_valid,
  isWednesday: is_wednesday,
  isWeekend: is_weekend,
  isWithinRange: is_within_range,
  isYesterday: is_yesterday,
  lastDayOfISOWeek: last_day_of_iso_week,
  lastDayOfISOYear: last_day_of_iso_year,
  lastDayOfMonth: last_day_of_month,
  lastDayOfQuarter: last_day_of_quarter,
  lastDayOfWeek: last_day_of_week,
  lastDayOfYear: last_day_of_year,
  max: max_1,
  min: min_1,
  parse: parse_1,
  setDate: set_date,
  setDay: set_day,
  setDayOfYear: set_day_of_year,
  setHours: set_hours,
  setISODay: set_iso_day,
  setISOWeek: set_iso_week,
  setISOYear: set_iso_year,
  setMilliseconds: set_milliseconds,
  setMinutes: set_minutes,
  setMonth: set_month,
  setQuarter: set_quarter,
  setSeconds: set_seconds,
  setYear: set_year,
  startOfDay: start_of_day,
  startOfHour: start_of_hour,
  startOfISOWeek: start_of_iso_week,
  startOfISOYear: start_of_iso_year,
  startOfMinute: start_of_minute,
  startOfMonth: start_of_month,
  startOfQuarter: start_of_quarter,
  startOfSecond: start_of_second,
  startOfToday: start_of_today,
  startOfTomorrow: start_of_tomorrow,
  startOfWeek: start_of_week,
  startOfYear: start_of_year,
  startOfYesterday: start_of_yesterday,
  subDays: sub_days,
  subHours: sub_hours,
  subISOYears: sub_iso_years,
  subMilliseconds: sub_milliseconds,
  subMinutes: sub_minutes,
  subMonths: sub_months,
  subQuarters: sub_quarters,
  subSeconds: sub_seconds,
  subWeeks: sub_weeks,
  subYears: sub_years
};
var dateFns_50 = dateFns.format;
var dateFns_145 = dateFns.subDays;
var dateFns_150 = dateFns.subMonths;
var dateFns_154 = dateFns.subYears;

var instance$1 = new HttpService("umbraco/api/OrdersApi");
/* eslint-disable arrow-body-style */

/* eslint-disable object-shorthand */

/**
 * Get the order history for the current logged in user
 */

var loadOrderHistory = function loadOrderHistory() {
  return instance$1.get("LoadOrderHistory");
};
/**
 * Get order header data
 * @param {string} orderId The order header id
 */

var getOrderHeader = function getOrderHeader(orderId) {
  return instance$1.get("LoadOrderRefundSummary?orderHeaderId=".concat(orderId));
};
/**
 * Get the order line summary data
 * @param {string} orderId The order header id
 * @param {string} creditOrderId The order header id
 * @param {string} creditOrderLineId The order line id
 */

var getRefundOrderLine = function getRefundOrderLine(orderId, creditOrderId, creditOrderLineId) {
  return instance$1.get("LoadOrderLineRefundSummary?orderId=".concat(orderId, "&creditOrderId=").concat(creditOrderId, "&creditOrderLineId=").concat(creditOrderLineId));
};
/**
 * Post submit order refund data
 * @param {string} orderHeader The order header
 */

var submitRefund = function submitRefund(orderHeader) {
  return instance$1.post("SubmitRefund", orderHeader);
};
/**
 * Post cancel refund order line
 * @param {string} creditOrderId The order header id
 * @param {string} creditOrderLineId The order line id
 */

var cancelRefundOrderLine = function cancelRefundOrderLine(creditOrderId, creditOrderLineId) {
  return instance$1.post("CancelRefundOrderLine?creditOrderId=".concat(creditOrderId, "&creditOrderLineId=").concat(creditOrderLineId));
};

//
var script$l = {
  name: "OrderRefundsModal",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    getOrderHeader: getOrderHeader,
    CustomModal: CustomModal
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      orderHeader: null,
      cancelling: false,
      submitting: false,
      loading: false
    };
  },
  watch: {
    show: {
      immediate: true,
      handler: function handler(val) {
        var _this = this;

        if (val) {
          this.cancelling = false;
          this.submitting = false;
          this.loading = true;
          this.orderHeader = null;
          getOrderHeader(this.orderId).then(function (result) {
            if (result && result.data) {
              _this.orderHeader = result.data;
            }
          }).catch(function (error) {
            console.log("an error occured when loading modal data");
            throw error;
          }).finally(function () {
            _this.loading = false;
          });
        }
      }
    }
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this2 = this;

      if (!this.submitting) {
        this.submitting = true;
        submitRefund(this.orderHeader).then(function (result) {
          if (result && result.data) {
            _this2.$emit("refreshPage");
          }
        }).catch(function (error) {
          console.log("error saving the refund request");
          throw error;
        }).finally(function () {
          _this2.submitting = false;
        });
      }
    },
    onCancel: function onCancel() {
      if (!this.cancelling && !this.submitting) {
        this.cancelling = true;
        this.$emit("close");
        this.cancelling = false;
      }
    },
    onClose: function onClose() {
      this.orderHeader = null;
      this.$emit("close");
    },
    onRefundShow: function onRefundShow(item) {
      item.reasonInvalid = false;
      item.showDetails = true;
    },
    onRefundAccept: function onRefundAccept(item) {
      if (item.refundReasonId) {
        item.reasonInvalid = false;
        item.showDetails = false;
        item.refundRequested = true;
      } else {
        item.reasonInvalid = true;
      }
    },
    onRefundClose: function onRefundClose(item) {
      item.showDetails = false;
    },
    onRefundCancel: function onRefundCancel(item) {
      item.refundRequested = false;
      item.showDetails = false;
      item.refundReasonId = null;
      item.refundDetails = "";
    }
  }
};

/* script */
var __vue_script__$w = script$l;
/* template */

var __vue_render__$u = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "order-refund-modal"
  }, [_c('CustomModal', {
    attrs: {
      "show": _vm.show
    },
    on: {
      "close": _vm.onClose
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_c('h1', {
          staticClass: "custom-modal__heading"
        }, [_vm._v("\n        Request Refund\n      ")])];
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "order-refund-modal__body"
  }, [_vm.loading ? [_c('div', {
    staticClass: "order-refund-modal__loading-container"
  }, [_c('div', {
    staticClass: "order-refund-modal__loading-content"
  }, [_c('h5', [_vm._v("Loading")]), _vm._v(" "), _c('font-awesome-icon', {
    staticClass: "icon",
    attrs: {
      "icon": "spinner",
      "size": "lg",
      "spin": ""
    }
  })], 1)])] : [_vm.orderHeader && _vm.orderHeader.orderLines && _vm.orderHeader.orderLines.length > 0 ? [_c('ul', {
    staticClass: "order-refund-modal__order-line-lists"
  }, _vm._l(_vm.orderHeader.orderLines, function (item, index) {
    return _c('li', {
      key: index,
      staticClass: "order-refund-modal__order-line"
    }, [_c('div', {
      staticClass: "order-refund-modal__summary"
    }, [_c('div', {
      staticClass: "order-refund-modal__name"
    }, [_vm._v("\n                  " + _vm._s(item.productName) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "order-refund-modal__edit",
      on: {
        "click": function click($event) {
          return _vm.onRefundShow(item);
        }
      }
    }, [_c('div', [item.refundRequested ? [_vm._v("\n                      View Refund\n                    ")] : [_vm._v("\n                      Request Refund\n                    ")]], 2)])]), _vm._v(" "), item.showDetails ? _c('div', {
      staticClass: "order-refund-modal__form"
    }, [_c('b-form-group', [_c('b-select', {
      model: {
        value: item.refundReasonId,
        callback: function callback($$v) {
          _vm.$set(item, "refundReasonId", $$v);
        },
        expression: "item.refundReasonId"
      }
    }, _vm._l(_vm.orderHeader.refundReasons, function (reason) {
      return _c('option', {
        key: reason.value,
        attrs: {
          "disabled": item.refundRequested
        },
        domProps: {
          "value": reason.value
        }
      }, [_vm._v("\n                      " + _vm._s(reason.text) + "\n                    ")]);
    }), 0), _vm._v(" "), item.reasonInvalid ? _c('span', {
      staticClass: "validation-error"
    }, [_vm._v("Please select a refund reason")]) : _vm._e()], 1), _vm._v(" "), _c('b-form-group', [_c('b-form-textarea', {
      attrs: {
        "placeholder": "Notes...",
        "disabled": item.refundRequested,
        "rows": "5",
        "max-rows": "8"
      },
      model: {
        value: item.refundDetails,
        callback: function callback($$v) {
          _vm.$set(item, "refundDetails", $$v);
        },
        expression: "item.refundDetails"
      }
    })], 1), _vm._v(" "), _c('b-form-group', [!item.refundRequested ? [!item.refundRequested ? _c('button', {
      staticClass: "btn btn-accent-8 btn-sm btn-rounded",
      on: {
        "click": function click($event) {
          return _vm.onRefundAccept(item);
        }
      }
    }, [_vm._v("\n                      Accept\n                    ")]) : _vm._e()] : [_c('button', {
      staticClass: "btn btn-accent-8 btn-sm btn-rounded",
      on: {
        "click": function click($event) {
          return _vm.onRefundClose(item);
        }
      }
    }, [_vm._v("\n                      Close\n                    ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-accent-3 btn-sm btn-rounded order-refund-modal__cancelItem",
      on: {
        "click": function click($event) {
          return _vm.onRefundCancel(item);
        }
      }
    }, [_vm._v("\n                      Cancel Refund\n                    ")])]], 2)], 1) : _vm._e()]);
  }), 0)] : [_c('p', [_vm._v("No products found!")])], _vm._v(" "), _c('div', {
    staticClass: "order-refund-modal__action-buttons"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": _vm.loading || _vm.submitting
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm.cancelling ? [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })] : [_vm._v("\n              Cancel\n            ")]], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-accent-1",
    attrs: {
      "disabled": _vm.loading || _vm.cancelling
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm.submitting ? [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })] : [_vm._v("\n              Submit\n            ")]], 2)])]], 2)])], 1);
};

var __vue_staticRenderFns__$u = [];
/* style */

var __vue_inject_styles__$w = undefined;
/* scoped */

var __vue_scope_id__$w = "data-v-11b71345";
/* module identifier */

var __vue_module_identifier__$w = undefined;
/* functional template */

var __vue_is_functional_template__$w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$u,
  staticRenderFns: __vue_staticRenderFns__$u
}, __vue_inject_styles__$w, __vue_script__$w, __vue_scope_id__$w, __vue_is_functional_template__$w, __vue_module_identifier__$w, false, undefined, undefined, undefined);

//
var script$m = {
  name: "OrderLineRefundModal",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    getRefundOrderLine: getRefundOrderLine,
    CustomModal: CustomModal
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: String,
      default: null
    },
    creditOrderId: {
      type: String,
      default: null
    },
    creditOrderLineId: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      orderLine: null,
      cancelling: false,
      submitting: false,
      loading: false
    };
  },
  watch: {
    show: {
      immediate: true,
      handler: function handler(val) {
        var _this = this;

        if (val) {
          this.cancelling = false;
          this.submitting = false;
          this.loading = true;
          this.orderLine = null;
          getRefundOrderLine(this.orderId, this.creditOrderId, this.creditOrderLineId).then(function (result) {
            if (result && result.data) {
              _this.orderLine = result.data;
            }
          }).catch(function (error) {
            console.log("an error occured when loading modal data");
            throw error;
          }).finally(function () {
            _this.loading = false;
          });
        }
      }
    }
  },
  methods: {
    onRefundCancel: function onRefundCancel() {
      var _this2 = this;

      if (!this.submitting) {
        this.submitting = true;
        cancelRefundOrderLine(this.creditOrderId, this.creditOrderLineId).then(function (result) {
          if (result && result.data) {
            _this2.$emit("refreshPage");
          }
        }).catch(function (error) {
          console.log("error cancelling the refund request");
          throw error;
        }).finally(function () {
          _this2.submitting = false;
        });
      }
    },
    onClose: function onClose() {
      this.orderLine = null;
      this.$emit("close");
    }
  }
};

/* script */
var __vue_script__$x = script$m;
/* template */

var __vue_render__$v = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "order-line-refund-modal"
  }, [_c('CustomModal', {
    attrs: {
      "show": _vm.show
    },
    on: {
      "close": _vm.onClose
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_c('h1', {
          staticClass: "custom-modal__heading"
        }, [_vm._v("\n        View Refund\n      ")])];
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "order-line-refund-modal__body"
  }, [_vm.loading ? [_c('div', {
    staticClass: "order-line-refund-modal__loading-container"
  }, [_c('div', {
    staticClass: "order-line-refund-modal__loading-content"
  }, [_c('h5', [_vm._v("Loading")]), _vm._v(" "), _c('font-awesome-icon', {
    staticClass: "icon",
    attrs: {
      "icon": "spinner",
      "size": "lg",
      "spin": ""
    }
  })], 1)])] : [_vm.orderLine ? [_c('div', {
    staticClass: "order-line-refund-modal__summary"
  }, [_c('div', {
    staticClass: "order-line-refund-modal__name"
  }, [_vm._v("\n              " + _vm._s(_vm.orderLine.productName) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "order-line-refund-modal__status"
  }, [_vm._v("\n              Pending Refund\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "order-line-refund-modal__form"
  }, [_c('b-form-group', [_c('b-form-input', {
    attrs: {
      "type": "text",
      "disabled": true
    },
    model: {
      value: _vm.orderLine.refundReason,
      callback: function callback($$v) {
        _vm.$set(_vm.orderLine, "refundReason", $$v);
      },
      expression: "orderLine.refundReason"
    }
  })], 1), _vm._v(" "), _c('b-form-group', [_c('b-form-textarea', {
    attrs: {
      "disabled": true,
      "rows": "5",
      "max-rows": "8"
    },
    model: {
      value: _vm.orderLine.refundDetails,
      callback: function callback($$v) {
        _vm.$set(_vm.orderLine, "refundDetails", $$v);
      },
      expression: "orderLine.refundDetails"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    staticClass: "order-line-refund-modal__actions"
  }, [_c('button', {
    staticClass: "btn btn-accent-8 btn-sm btn-rounded order-line-refund-modal__close",
    attrs: {
      "disabled": _vm.cancelling
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm.cancelling ? [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })] : [_vm._v("\n                  Close\n                ")]], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-accent-8 btn-sm btn-rounded order-line-refund-modal__cancel",
    attrs: {
      "disabled": _vm.loading || _vm.submitting
    },
    on: {
      "click": _vm.onRefundCancel
    }
  }, [_vm.loading || _vm.submitting ? [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })] : [_vm._v("\n                  Cancel Request\n                ")]], 2)])], 1)] : [_c('p', [_vm._v("No product found!")])]]], 2)])], 1);
};

var __vue_staticRenderFns__$v = [];
/* style */

var __vue_inject_styles__$x = undefined;
/* scoped */

var __vue_scope_id__$x = "data-v-0e5b30f2";
/* module identifier */

var __vue_module_identifier__$x = undefined;
/* functional template */

var __vue_is_functional_template__$x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$v,
  staticRenderFns: __vue_staticRenderFns__$v
}, __vue_inject_styles__$x, __vue_script__$x, __vue_scope_id__$x, __vue_is_functional_template__$x, __vue_module_identifier__$x, false, undefined, undefined, undefined);

//
var script$n = {
  name: "OrderTable",
  components: {
    OrderRefundsModal: __vue_component__$w,
    OrderLineRefundModal: __vue_component__$x
  },
  props: {
    orders: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      fields: [{
        key: "orderNumber",
        label: "#"
      }, {
        key: "dateOrdered",
        label: "Date Ordered",
        formatter: this.formatDate
      }, {
        key: "orderedBy",
        label: "Purchased by"
      }, {
        key: "orgName",
        label: "Organisation"
      }, {
        key: "purchaseOrderNo",
        label: "PO"
      }, {
        key: "itemsInOrder",
        label: "Items in Order",
        formatter: this.formatItems
      }, {
        key: "totalCost",
        label: "Total Cost",
        formatter: this.formatPrice
      }, {
        key: "details",
        label: ""
      }],
      showOrderRefundsModal: false,
      showOrderLineRefundModal: false,
      orderId: null,
      orderLineId: null,
      creditOrderId: null,
      creditOrderLineId: null
    };
  },
  methods: {
    formatDate: function formatDate(input) {
      return dateFns_50(new Date(input), "dd/MM/yyyy");
    },
    formatItems: function formatItems(input) {
      var result = "";

      if (input && input.length > 0) {
        result += "".concat(input.length, " item").concat(input.length !== 1 ? "s" : "", ": ");
        result += input.map(function (x) {
          return x.productName;
        }).join(", ");
      }

      if (result.length > 45) {
        result = "".concat(result.substring(0, 45), "...");
      }

      return result;
    },
    formatPrice: function formatPrice(input) {
      return renderPrice(input, "gbp", "en-gb");
    },
    onRefundClick: function onRefundClick(id) {
      this.orderId = id;
      this.showOrderRefundsModal = true;
    },
    onRefundLineClick: function onRefundLineClick(orderId, creditOrderId, creditOrderLineId) {
      this.orderId = orderId;
      this.creditOrderId = creditOrderId;
      this.creditOrderLineId = creditOrderLineId;
      this.showOrderLineRefundModal = true;
    },
    refreshPage: function refreshPage() {
      this.showOrderRefundsModal = false;
      this.showOrderLineRefundModal = false;
      this.$emit("refreshPage");
    }
  }
};

/* script */
var __vue_script__$y = script$n;
/* template */

var __vue_render__$w = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "orders-table"
  }, [_c('b-table', {
    staticClass: "custom-table",
    attrs: {
      "borderless": "",
      "responsive": "",
      "fields": _vm.fields,
      "items": _vm.orders
    },
    scopedSlots: _vm._u([{
      key: "cell(details)",
      fn: function fn(row) {
        return [_c('div', {
          staticClass: "orders-table__actions"
        }, [_c('button', {
          staticClass: "btn btn-sm btn-accent-1 btnOrderView",
          on: {
            "click": row.toggleDetails
          }
        }, [_vm._v("\n          " + _vm._s(row.detailsShowing ? 'Hide' : 'View') + "\n        ")]), _vm._v(" "), row.item.showRefundOption ? _c('button', {
          staticClass: "btn btn-sm btn-accent-1 btnOrderRefund",
          on: {
            "click": function click($event) {
              return _vm.onRefundClick(row.item.orderHeaderId);
            }
          }
        }, [_vm._v("\n          " + _vm._s('Refund') + "\n        ")]) : _vm._e()])];
      }
    }, {
      key: "row-details",
      fn: function fn(row) {
        return [_c('div', {
          staticClass: "orders-table__card"
        }, [_c('div', {
          staticClass: "orders-table__card-header"
        }, [_vm._v("\n          Products\n        ")]), _vm._v(" "), _vm._l(row.item.itemsInOrder, function (item, index) {
          return _c('div', {
            key: index,
            staticClass: "orders-table__card-line"
          }, [_c('div', {
            staticClass: "row no-padding"
          }, [_c('div', {
            staticClass: "col-lg-7 col-8 no-padding"
          }, [_vm._v("\n              " + _vm._s(item.productName) + "\n            ")]), _vm._v(" "), _c('div', {
            staticClass: "col-lg-2 col-2 no-padding"
          }, [_vm._v("\n              x" + _vm._s(item.quantity) + "\n            ")]), _vm._v(" "), _c('div', {
            staticClass: "col-lg-1 col-2 no-padding"
          }, [_vm._v("\n              " + _vm._s(_vm.formatPrice(item.lineValue)) + "\n            ")]), _vm._v(" "), _c('div', {
            staticClass: "col-lg-2 col-12 no-padding"
          }, [item.statusId == 'ACT' ? _c('button', {
            staticClass: "btn btn-sm btn-accent-2 orderlineStatus btnOrderLineRefund",
            on: {
              "click": function click($event) {
                return _vm.onRefundLineClick(row.item.orderHeaderId, item.creditOrderId, item.creditOrderLineId);
              }
            }
          }, [_vm._v("\n                " + _vm._s(item.statusText) + "\n              ")]) : _vm._e(), _vm._v(" "), item.statusId == 'SUB' ? _c('span', {
            staticClass: "orderlineStatus"
          }, [_vm._v(_vm._s(item.statusText))]) : _vm._e()])])]);
        })], 2)];
      }
    }])
  }), _vm._v(" "), _c('OrderRefundsModal', {
    attrs: {
      "show": _vm.showOrderRefundsModal,
      "order-id": _vm.orderId
    },
    on: {
      "close": function close($event) {
        _vm.showOrderRefundsModal = false;
      },
      "refreshPage": _vm.refreshPage
    }
  }), _vm._v(" "), _c('OrderLineRefundModal', {
    attrs: {
      "show": _vm.showOrderLineRefundModal,
      "order-id": _vm.orderId,
      "credit-order-id": _vm.creditOrderId,
      "credit-order-line-id": _vm.creditOrderLineId
    },
    on: {
      "close": function close($event) {
        _vm.showOrderLineRefundModal = false;
      },
      "refreshPage": _vm.refreshPage
    }
  })], 1);
};

var __vue_staticRenderFns__$w = [];
/* style */

var __vue_inject_styles__$y = undefined;
/* scoped */

var __vue_scope_id__$y = undefined;
/* module identifier */

var __vue_module_identifier__$y = undefined;
/* functional template */

var __vue_is_functional_template__$y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$w,
  staticRenderFns: __vue_staticRenderFns__$w
}, __vue_inject_styles__$y, __vue_script__$y, __vue_scope_id__$y, __vue_is_functional_template__$y, __vue_module_identifier__$y, false, undefined, undefined, undefined);

var script$o = {
  name: "OrderItemProduct",
  components: {
    OrderLineRefundModal: __vue_component__$x
  },
  props: {
    orderHeaderId: {
      type: String,
      required: true
    },
    creditOrderId: {
      type: String,
      default: null
    },
    creditOrderLineId: {
      type: String,
      default: null
    },
    statusId: {
      type: String,
      default: null
    },
    statusText: {
      type: String,
      default: null
    },
    name: {
      type: String,
      required: true
    },
    cost: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      showOrderLineRefundModal: false
    };
  },
  methods: {
    formatPrice: function formatPrice(price) {
      return renderPrice(price, "gbp", "en-gb");
    },
    onRefundLineClick: function onRefundLineClick() {
      this.showOrderLineRefundModal = true;
    },
    refreshPage: function refreshPage() {
      this.showOrderLineRefundModal = false;
      this.$emit("refreshPage");
    }
  }
};

var __vue_script__$z = script$o;
/* template */

var __vue_render__$x = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "order-item-product"
  }, [_c('div', {
    staticClass: "order-item-product__name"
  }, [_vm._v("\n    " + _vm._s(_vm.name) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "order-item-product__cost"
  }, [_vm._v("\n    Cost: " + _vm._s(_vm.formatPrice(_vm.cost)) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "order-item-product__status"
  }, [_vm.statusId == 'ACT' ? _c('button', {
    staticClass: "btn btn-xs btn-accent-8 order-item-product__refund",
    on: {
      "click": _vm.onRefundLineClick
    }
  }, [_vm._v("\n      " + _vm._s(_vm.statusText) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.statusId == 'SUB' ? _c('span', {
    staticClass: "order-item-product__status"
  }, [_vm._v("\n      " + _vm._s(_vm.statusText) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('OrderLineRefundModal', {
    attrs: {
      "show": _vm.showOrderLineRefundModal,
      "order-id": _vm.orderHeaderId,
      "credit-order-id": _vm.creditOrderId,
      "credit-order-line-id": _vm.creditOrderLineId
    },
    on: {
      "close": function close($event) {
        _vm.showOrderLineRefundModal = false;
      },
      "refreshPage": _vm.refreshPage
    }
  })], 1);
};

var __vue_staticRenderFns__$x = [];
/* style */

var __vue_inject_styles__$z = undefined;
/* scoped */

var __vue_scope_id__$z = "data-v-5ffcd585";
/* module identifier */

var __vue_module_identifier__$z = undefined;
/* functional template */

var __vue_is_functional_template__$z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$x,
  staticRenderFns: __vue_staticRenderFns__$x
}, __vue_inject_styles__$z, __vue_script__$z, __vue_scope_id__$z, __vue_is_functional_template__$z, __vue_module_identifier__$z, false, undefined, undefined, undefined);

//
var script$p = {
  name: "OrderItem",
  components: {
    OrderItemProduct: __vue_component__$z,
    OrderRefundsModal: __vue_component__$w
  },
  props: {
    order: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      showOrderRefundsModal: false
    };
  },
  methods: {
    formatDate: function formatDate(input) {
      return dateFns_50(new Date(input), "dd/MM/yyyy");
    },
    formatPrice: function formatPrice(input) {
      return renderPrice(input, "gbp", "en-gb");
    },
    onRefundClick: function onRefundClick() {
      this.showOrderRefundsModal = true;
    },
    refreshPage: function refreshPage() {
      this.showOrderRefundsModal = false;
      this.$emit("refreshPage");
    }
  }
};

/* script */
var __vue_script__$A = script$p;
/* template */

var __vue_render__$y = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "order-item"
  }, [_c('div', {
    staticClass: "row no-padding"
  }, [_c('div', {
    staticClass: "col-md-4 no-padding order-item__summary"
  }, [_c('div', {
    staticClass: "order-item__heading"
  }, [_vm._v("\n        #" + _vm._s(_vm.order.orderNumber) + " Ordered " + _vm._s(_vm.formatDate(_vm.order.dateOrdered)) + "\n        "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "order-item__heading-organisation"
  }, [_vm._v(_vm._s(_vm.order.orgName))])]), _vm._v(" "), _c('div', {
    staticClass: "order-item__details"
  }, [_c('div', {
    staticClass: "order-item__col"
  }, [_vm.order.orderedBy ? _c('div', {
    staticClass: "order-item__sub-heading"
  }, [_vm._v("\n            Ordered by: " + _vm._s(_vm.order.orderedBy) + "\n          ")]) : _vm._e(), _vm._v(" "), _vm.order.purchaseOrderNo ? _c('div', {
    staticClass: "order-item__sub-heading"
  }, [_vm._v("\n            PO: " + _vm._s(_vm.order.purchaseOrderNo) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order-item__cost"
  }, [_vm._v("\n            Total cost: " + _vm._s(_vm.formatPrice(_vm.order.totalCost)) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "order-item__col"
  }, [_vm.order.showRefundOption ? _c('button', {
    staticClass: "btn btn-sm btn-accent-1 order-item__refund",
    on: {
      "click": function click($event) {
        return _vm.onRefundClick(_vm.order.orderHeaderId);
      }
    }
  }, [_vm._v("\n            Refund\n          ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 no-padding"
  }, [_c('div', {
    staticClass: "order-item__items"
  }, [_c('div', {
    staticClass: "order-item__heading"
  }, [_vm._v("\n          Items In Order\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "order-item__items-list"
  }, [_c('div', {
    staticClass: "row no-padding"
  }, _vm._l(_vm.order.itemsInOrder, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-md-6 no-padding"
    }, [_c('order-item-product', {
      attrs: {
        "name": item.productName,
        "cost": item.lineValue,
        "status-id": item.statusId,
        "status-text": item.statusText,
        "credit-order-line-id": item.creditOrderLineId,
        "credit-order-id": item.creditOrderId,
        "order-header-id": _vm.order.orderHeaderId
      },
      on: {
        "refreshPage": _vm.refreshPage
      }
    })], 1);
  }), 0)])])])]), _vm._v(" "), _c('OrderRefundsModal', {
    attrs: {
      "show": _vm.showOrderRefundsModal,
      "order-id": _vm.order.orderHeaderId
    },
    on: {
      "close": function close($event) {
        _vm.showOrderRefundsModal = false;
      },
      "refreshPage": _vm.refreshPage
    }
  })], 1);
};

var __vue_staticRenderFns__$y = [];
/* style */

var __vue_inject_styles__$A = undefined;
/* scoped */

var __vue_scope_id__$A = undefined;
/* module identifier */

var __vue_module_identifier__$A = undefined;
/* functional template */

var __vue_is_functional_template__$A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$y,
  staticRenderFns: __vue_staticRenderFns__$y
}, __vue_inject_styles__$A, __vue_script__$A, __vue_scope_id__$A, __vue_is_functional_template__$A, __vue_module_identifier__$A, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
var script$q = {
  name: "DownloadCsv",
  props: {
    label: {
      type: String,
      default: "Download"
    },
    fileName: {
      type: String,
      default: "csv-download"
    },
    inputData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    blacklistKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tableId: {
      type: String,
      default: ""
    },
    formatKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
      /*
        [
          { key: "totalCost", type: "currency" },
          { key: "orderedOn", type: "date" }
        ]
      */

    },
    delimiter: {
      type: String,
      default: ","
    }
  },
  computed: {
    exportDataFromTable: function exportDataFromTable() {
      return this.tableId !== "";
    },
    hasData: function hasData() {
      return !(document.getElementById(this.tableId) == null && this.inputData.length === 0);
    }
  },
  methods: {
    exportHandler: function exportHandler() {
      if (this.exportDataFromTable) {
        this.exportTableToCsv(this.tableId, this.delimiter);
      } else {
        this.exportDataToCsv(this.inputData, this.getWhiteListKeys(), this.delimiter);
      }
    },
    exportTableToCsv: function exportTableToCsv(tableId) {
      var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ",";
      // select rows from tableId
      var rows = document.querySelectorAll("table#".concat(tableId, " tr"));
      var csv = [];

      for (var i = 0; i < rows.length; i += 1) {
        var row = [];
        var cols = rows[i].querySelectorAll("td, th");

        for (var j = 0; j < cols.length; j += 1) {
          var value = cols[j].innerText; // clean innertext to remove multiple spaces and jumpline (break csv)

          var data = value.replace(/(\r\n|\n|\r)/gm, "").replace(/(\s\s)/gm, " "); // escape double-quote with double-double-quote

          data = data.replace(/"/g, "".concat(null, "\"\"")); // push escaped string

          row.push("\"".concat(data, "\""));
        }

        csv.push(row.join(delimiter));
      }

      var csvStr = csv.join("\n");
      this.exportCsv(csvStr);
    },
    exportDataToCsv: function exportDataToCsv(data, keys) {
      var csvStr = this.convertDataToCsv(data, keys);
      this.exportCsv(csvStr);
    },
    exportCsv: function exportCsv(csvStr) {
      var filename = "".concat(this.fileName, ".csv");
      var universalBOM = "\uFEFF";
      var forceEncodedCsvString = "".concat(universalBOM).concat(csvStr);
      var link = document.createElement("a");
      link.style.display = "none";
      link.setAttribute("target", "_blank");
      link.setAttribute("href", "data:text/csv;charset=utf-16,".concat(encodeURIComponent(forceEncodedCsvString)));
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    convertDataToCsv: function convertDataToCsv(arr, columns) {
      var _this = this;

      var delimiter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ",";
      var cols = columns.map(function (col) {
        return _this.camel2Title(col);
      });
      return [cols.join(delimiter)].concat(_toConsumableArray(arr.map(function (obj) {
        return columns.reduce(function (acc, key) {
          var value = obj[key];
          var formattedValue;

          var _ref = _this.formatKeys.find(function (format) {
            return format.key === key;
          }) || {},
              type = _ref.type;

          switch (type) {
            case "currency":
              formattedValue = _this.formatCurrency(value);
              break;

            case "date":
              formattedValue = _this.formatDate(value);
              break;

            default:
              formattedValue = value ? "".concat(value) : "";
          }

          return "".concat(acc).concat(!acc.length ? "" : delimiter, "\"").concat(!formattedValue ? "" : formattedValue, "\"");
        }, "");
      }))).join("\n");
    },
    camel2Title: function camel2Title(camelCase) {
      return camelCase.replace(/([A-Z])/g, function (match) {
        return " ".concat(match);
      }).replace(/^./, function (match) {
        return match.toUpperCase();
      });
    },
    formatCurrency: function formatCurrency(str) {
      try {
        var formatter = new Intl.NumberFormat("en-UK", {
          style: "currency",
          currency: "GBP",
          minimumFractionDigits: 2
        });
        return formatter.format(str);
      } catch (ex) {
        console.warn("Couldn't convert ".concat(str, " to a currency. Info: ").concat(ex));
        return str;
      }
    },
    formatDate: function formatDate(str) {
      try {
        var date = new Date(str);
        var dateTimeFormat = new Intl.DateTimeFormat("en", {
          year: "numeric",
          month: "short",
          day: "2-digit"
        });

        var _dateTimeFormat$forma = dateTimeFormat.formatToParts(date),
            _dateTimeFormat$forma2 = _slicedToArray(_dateTimeFormat$forma, 5),
            month = _dateTimeFormat$forma2[0].value,
            day = _dateTimeFormat$forma2[2].value,
            year = _dateTimeFormat$forma2[4].value;

        return "".concat(day, "-").concat(month, "-").concat(year);
      } catch (ex) {
        console.warn("Couldn\"t format ".concat(str, " to date. Info: ").concat(ex));
        return str;
      }
    },
    getWhiteListKeys: function getWhiteListKeys() {
      var _this2 = this;

      if (this.inputData.length <= 0) {
        return [];
      }

      var index = this.inputData.length - 1;
      return Object.keys(this.inputData[index]).filter(function (key) {
        return !_this2.blacklistKeys.includes(key);
      });
    }
  }
};

/* script */
var __vue_script__$B = script$q;
/* template */

var __vue_render__$z = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.hasData ? _c('div', {
    staticClass: "btn btn-primary cta-download",
    on: {
      "click": _vm.exportHandler
    }
  }, [_vm._v("\n  " + _vm._s(_vm.label) + "\n")]) : _vm._e();
};

var __vue_staticRenderFns__$z = [];
/* style */

var __vue_inject_styles__$B = undefined;
/* scoped */

var __vue_scope_id__$B = "data-v-43b59423";
/* module identifier */

var __vue_module_identifier__$B = undefined;
/* functional template */

var __vue_is_functional_template__$B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$z,
  staticRenderFns: __vue_staticRenderFns__$z
}, __vue_inject_styles__$B, __vue_script__$B, __vue_scope_id__$B, __vue_is_functional_template__$B, __vue_module_identifier__$B, false, undefined, undefined, undefined);

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var script$r = {
  name: "OrderHistory",
  components: {
    OrderTable: __vue_component__$y,
    OrderItem: __vue_component__$A,
    DownloadCsv: __vue_component__$B
  },
  data: function data() {
    return {
      orders: [],
      selectedTime: null,
      selectedOrganisation: null,
      loading: false,
      filterOptions: ["all-products", "consultancy", "resources", "subscription", "training"],
      timeOptions: [{
        value: null,
        text: "Please select a time frame"
      }, {
        value: "month",
        text: "Last 30 Days"
      }, {
        value: "six-months",
        text: "Last 6 Months"
      }, {
        value: "year",
        text: "Last Year"
      }, {
        value: "all",
        text: "All Orders"
      }]
    };
  },
  computed: {
    filteredOrders: function filteredOrders() {
      var _this = this;

      var result = null;

      switch (this.selectedTime) {
        case "month":
          {
            result = this.orders.filter(function (o) {
              return new Date(o.dateOrdered) >= new Date(dateFns_145(Date.now(), 30));
            });
            break;
          }

        case "six-months":
          {
            result = this.orders.filter(function (o) {
              return new Date(o.dateOrdered) >= new Date(dateFns_150(Date.now(), 6));
            });
            break;
          }

        case "year":
          {
            result = this.orders.filter(function (o) {
              return new Date(o.dateOrdered) >= new Date(dateFns_154(Date.now(), 1));
            });
            break;
          }

        case "all":
        default:
          result = this.orders;
          break;
      }

      var mutableResult = _toConsumableArray(result);

      mutableResult.sort(function (a, b) {
        return new Date(b.dateOrdered) - new Date(a.dateOrdered);
      });

      if (this.selectedOrganisation) {
        mutableResult = result.filter(function (product) {
          return product.orgName === _this.selectedOrganisation;
        });
      } // console.log( mutableResult );
      // console.log( JSON.stringify( mutableResult ) );


      return mutableResult;
    },
    orgOptions: function orgOptions() {
      var opts = [{
        value: null,
        text: "Please select an organisation"
      }];
      var orgs = this.orders.map(function (order) {
        return {
          value: order.orgName,
          text: order.orgName
        };
      });
      var combined = [].concat(opts, _toConsumableArray(orgs));
      return this.removeDuplicatesFromArray(combined, "value");
    },
    csv: function csv() {
      var csv = {
        orders: {
          blacklistKeys: [],
          data: [],
          formatKeys: []
        }
      };

      if (this.filteredOrders == null || this.filteredOrders.length < 0) {
        return csv;
      }

      var rows = this.filteredOrders.map(function (order) {
        var itemsInOrder = order.itemsInOrder;
        return itemsInOrder.map(function (item) {
          var csvItem = {};
          delete Object.assign(csvItem, item, {
            pricePerItem: item.lineValue
          }).lineValue;
          return _objectSpread$2({}, order, {}, csvItem);
        });
      }).reduce(function (acc, curr) {
        return acc.concat(curr);
      }, []);
      csv.orders.data = rows;
      csv.orders.blacklistKeys = ["orderHeaderId", "showRefundOption", "orderLineId", "creditOrderId", "itemsInOrder", "productId", "creditOrderLineId", "statusText", "statusId"];
      csv.orders.formatKeys = [{
        key: "dateOrdered",
        type: "date"
      }, {
        key: "totalCost",
        type: "currency"
      }, {
        key: "pricePerItem",
        type: "currency"
      }]; // console.log( csv );

      return csv;
    }
  },
  mounted: function mounted() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var _this2 = this;

      this.loading = true;
      loadOrderHistory().then(function (result) {
        if (result && result.data) {
          _this2.orders = result.data;
        }
      }).catch(function (error) {
        console.log("error occured when loading order history", error);
        throw error;
      }).finally(function () {
        _this2.loading = false;
      });
    },
    removeDuplicatesFromArray: function removeDuplicatesFromArray(array, key) {
      var lookup = {};
      var result = [];
      array.forEach(function (element) {
        if (!lookup[element[key]]) {
          lookup[element[key]] = true;
          result.push(element);
        }
      });
      return result;
    },
    camel2title: function camel2title(camelCase) {
      return camelCase.replace(/([A-Z])/g, function (match) {
        return " ".concat(match);
      }).replace(/^./, function (match) {
        return match.toUpperCase();
      });
    },
    isDate: function isDate(dateStr) {
      return !Number.isNaN(new Date(dateStr).getDate());
    }
  }
};

/* script */
var __vue_script__$C = script$r;
/* template */

var __vue_render__$A = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "order-history"
  }, [_c('div', {
    staticClass: "container d-flex justify-content-between"
  }, [_c('h2', {
    staticClass: "order-history__heading"
  }, [_vm._v("\n      Order History\n    ")]), _vm._v(" "), _c('download-csv', {
    attrs: {
      "label": "Download",
      "file-name": "Order History",
      "format-keys": _vm.csv.orders.formatKeys,
      "blacklist-keys": _vm.csv.orders.blacklistKeys,
      "input-data": _vm.csv.orders.data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "order-history__container"
  }, [_vm.loading ? _c('div', {
    staticClass: "order-history__loading-container"
  }, [_c('div', {
    staticClass: "order-history__loading-content"
  }, [_c('h6', [_vm._v("Loading order history")]), _vm._v(" "), _c('font-awesome-icon', {
    staticClass: "icon",
    attrs: {
      "icon": "spinner",
      "size": "lg",
      "spin": ""
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order-history__filter"
  }, [_c('span', {
    staticClass: "order-history__filter-header"
  }, [_vm._v("Filters:")]), _vm._v(" "), _c('div', {
    staticClass: "order-history__filter-item"
  }, [_c('b-form-select', {
    staticClass: "order-history__filter-time",
    attrs: {
      "options": _vm.timeOptions
    },
    model: {
      value: _vm.selectedTime,
      callback: function callback($$v) {
        _vm.selectedTime = $$v;
      },
      expression: "selectedTime"
    }
  }), _vm._v(" "), _c('b-form-select', {
    staticClass: "order-history__filter-org",
    attrs: {
      "options": _vm.orgOptions
    },
    model: {
      value: _vm.selectedOrganisation,
      callback: function callback($$v) {
        _vm.selectedOrganisation = $$v;
      },
      expression: "selectedOrganisation"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "order-history__filter_cta"
  }, [_c('button', {
    staticClass: "btn btn-sm refresh-btn",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.fetchData
    }
  }, [_c('font-awesome-icon', {
    staticClass: "align-right icon",
    attrs: {
      "icon": "sync-alt"
    }
  }), _vm._v("\n          Refresh\n        ")], 1)])]), _vm._v(" "), _vm.filteredOrders && _vm.filteredOrders.length > 0 ? [_c('order-table', {
    staticClass: "order-history__table",
    attrs: {
      "orders": _vm.filteredOrders
    },
    on: {
      "refreshPage": _vm.fetchData
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "order-history__cards"
  }, _vm._l(_vm.filteredOrders, function (item, index) {
    return _c('order-item', {
      key: index,
      attrs: {
        "order": item
      }
    });
  }), 1)] : [_vm._m(0)]], 2)]);
};

var __vue_staticRenderFns__$A = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "order-history__empty"
  }, [_c('p', [_vm._v("No orders found.")])]);
}];
/* style */

var __vue_inject_styles__$C = undefined;
/* scoped */

var __vue_scope_id__$C = "data-v-c95ec090";
/* module identifier */

var __vue_module_identifier__$C = undefined;
/* functional template */

var __vue_is_functional_template__$C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$A,
  staticRenderFns: __vue_staticRenderFns__$A
}, __vue_inject_styles__$C, __vue_script__$C, __vue_scope_id__$C, __vue_is_functional_template__$C, __vue_module_identifier__$C, false, undefined, undefined, undefined);

/* script */
var __vue_script__$D = script$p;
/* template */

var __vue_render__$B = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "order-item"
  }, [_c('div', {
    staticClass: "row no-padding"
  }, [_c('div', {
    staticClass: "col-md-4 no-padding order-item__summary"
  }, [_c('div', {
    staticClass: "order-item__heading"
  }, [_vm._v("\n        #" + _vm._s(_vm.order.orderNumber) + " Ordered " + _vm._s(_vm.formatDate(_vm.order.dateOrdered)) + "\n        "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "order-item__heading-organisation"
  }, [_vm._v(_vm._s(_vm.order.orgName))])]), _vm._v(" "), _c('div', {
    staticClass: "order-item__details"
  }, [_c('div', {
    staticClass: "order-item__col"
  }, [_vm.order.orderedBy ? _c('div', {
    staticClass: "order-item__sub-heading"
  }, [_vm._v("\n            Ordered by: " + _vm._s(_vm.order.orderedBy) + "\n          ")]) : _vm._e(), _vm._v(" "), _vm.order.purchaseOrderNo ? _c('div', {
    staticClass: "order-item__sub-heading"
  }, [_vm._v("\n            PO: " + _vm._s(_vm.order.purchaseOrderNo) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order-item__cost"
  }, [_vm._v("\n            Total cost: " + _vm._s(_vm.formatPrice(_vm.order.totalCost)) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "order-item__col"
  }, [_vm.order.showRefundOption ? _c('button', {
    staticClass: "btn btn-sm btn-accent-1 order-item__refund",
    on: {
      "click": function click($event) {
        return _vm.onRefundClick(_vm.order.orderHeaderId);
      }
    }
  }, [_vm._v("\n            Refund\n          ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 no-padding"
  }, [_c('div', {
    staticClass: "order-item__items"
  }, [_c('div', {
    staticClass: "order-item__heading"
  }, [_vm._v("\n          Items In Order\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "order-item__items-list"
  }, [_c('div', {
    staticClass: "row no-padding"
  }, _vm._l(_vm.order.itemsInOrder, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-md-6 no-padding"
    }, [_c('order-item-product', {
      attrs: {
        "name": item.productName,
        "cost": item.lineValue,
        "status-id": item.statusId,
        "status-text": item.statusText,
        "credit-order-line-id": item.creditOrderLineId,
        "credit-order-id": item.creditOrderId,
        "order-header-id": _vm.order.orderHeaderId
      },
      on: {
        "refreshPage": _vm.refreshPage
      }
    })], 1);
  }), 0)])])])]), _vm._v(" "), _c('OrderRefundsModal', {
    attrs: {
      "show": _vm.showOrderRefundsModal,
      "order-id": _vm.order.orderHeaderId
    },
    on: {
      "close": function close($event) {
        _vm.showOrderRefundsModal = false;
      },
      "refreshPage": _vm.refreshPage
    }
  })], 1);
};

var __vue_staticRenderFns__$B = [];
/* style */

var __vue_inject_styles__$D = undefined;
/* scoped */

var __vue_scope_id__$D = undefined;
/* module identifier */

var __vue_module_identifier__$D = undefined;
/* functional template */

var __vue_is_functional_template__$D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$B,
  staticRenderFns: __vue_staticRenderFns__$B
}, __vue_inject_styles__$D, __vue_script__$D, __vue_scope_id__$D, __vue_is_functional_template__$D, __vue_module_identifier__$D, false, undefined, undefined, undefined);

var __vue_script__$E = script$o;
/* template */

var __vue_render__$C = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "order-item-product"
  }, [_c('div', {
    staticClass: "order-item-product__name"
  }, [_vm._v("\n    " + _vm._s(_vm.name) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "order-item-product__cost"
  }, [_vm._v("\n    Cost: " + _vm._s(_vm.formatPrice(_vm.cost)) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "order-item-product__status"
  }, [_vm.statusId == 'ACT' ? _c('button', {
    staticClass: "btn btn-xs btn-accent-8 order-item-product__refund",
    on: {
      "click": _vm.onRefundLineClick
    }
  }, [_vm._v("\n      " + _vm._s(_vm.statusText) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.statusId == 'SUB' ? _c('span', {
    staticClass: "order-item-product__status"
  }, [_vm._v("\n      " + _vm._s(_vm.statusText) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('OrderLineRefundModal', {
    attrs: {
      "show": _vm.showOrderLineRefundModal,
      "order-id": _vm.orderHeaderId,
      "credit-order-id": _vm.creditOrderId,
      "credit-order-line-id": _vm.creditOrderLineId
    },
    on: {
      "close": function close($event) {
        _vm.showOrderLineRefundModal = false;
      },
      "refreshPage": _vm.refreshPage
    }
  })], 1);
};

var __vue_staticRenderFns__$C = [];
/* style */

var __vue_inject_styles__$E = undefined;
/* scoped */

var __vue_scope_id__$E = "data-v-5ffcd585";
/* module identifier */

var __vue_module_identifier__$E = undefined;
/* functional template */

var __vue_is_functional_template__$E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$C,
  staticRenderFns: __vue_staticRenderFns__$C
}, __vue_inject_styles__$E, __vue_script__$E, __vue_scope_id__$E, __vue_is_functional_template__$E, __vue_module_identifier__$E, false, undefined, undefined, undefined);

/* script */
var __vue_script__$F = script$m;
/* template */

var __vue_render__$D = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "order-line-refund-modal"
  }, [_c('CustomModal', {
    attrs: {
      "show": _vm.show
    },
    on: {
      "close": _vm.onClose
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_c('h1', {
          staticClass: "custom-modal__heading"
        }, [_vm._v("\n        View Refund\n      ")])];
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "order-line-refund-modal__body"
  }, [_vm.loading ? [_c('div', {
    staticClass: "order-line-refund-modal__loading-container"
  }, [_c('div', {
    staticClass: "order-line-refund-modal__loading-content"
  }, [_c('h5', [_vm._v("Loading")]), _vm._v(" "), _c('font-awesome-icon', {
    staticClass: "icon",
    attrs: {
      "icon": "spinner",
      "size": "lg",
      "spin": ""
    }
  })], 1)])] : [_vm.orderLine ? [_c('div', {
    staticClass: "order-line-refund-modal__summary"
  }, [_c('div', {
    staticClass: "order-line-refund-modal__name"
  }, [_vm._v("\n              " + _vm._s(_vm.orderLine.productName) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "order-line-refund-modal__status"
  }, [_vm._v("\n              Pending Refund\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "order-line-refund-modal__form"
  }, [_c('b-form-group', [_c('b-form-input', {
    attrs: {
      "type": "text",
      "disabled": true
    },
    model: {
      value: _vm.orderLine.refundReason,
      callback: function callback($$v) {
        _vm.$set(_vm.orderLine, "refundReason", $$v);
      },
      expression: "orderLine.refundReason"
    }
  })], 1), _vm._v(" "), _c('b-form-group', [_c('b-form-textarea', {
    attrs: {
      "disabled": true,
      "rows": "5",
      "max-rows": "8"
    },
    model: {
      value: _vm.orderLine.refundDetails,
      callback: function callback($$v) {
        _vm.$set(_vm.orderLine, "refundDetails", $$v);
      },
      expression: "orderLine.refundDetails"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    staticClass: "order-line-refund-modal__actions"
  }, [_c('button', {
    staticClass: "btn btn-accent-8 btn-sm btn-rounded order-line-refund-modal__close",
    attrs: {
      "disabled": _vm.cancelling
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm.cancelling ? [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })] : [_vm._v("\n                  Close\n                ")]], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-accent-8 btn-sm btn-rounded order-line-refund-modal__cancel",
    attrs: {
      "disabled": _vm.loading || _vm.submitting
    },
    on: {
      "click": _vm.onRefundCancel
    }
  }, [_vm.loading || _vm.submitting ? [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })] : [_vm._v("\n                  Cancel Request\n                ")]], 2)])], 1)] : [_c('p', [_vm._v("No product found!")])]]], 2)])], 1);
};

var __vue_staticRenderFns__$D = [];
/* style */

var __vue_inject_styles__$F = undefined;
/* scoped */

var __vue_scope_id__$F = "data-v-0e5b30f2";
/* module identifier */

var __vue_module_identifier__$F = undefined;
/* functional template */

var __vue_is_functional_template__$F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$D,
  staticRenderFns: __vue_staticRenderFns__$D
}, __vue_inject_styles__$F, __vue_script__$F, __vue_scope_id__$F, __vue_is_functional_template__$F, __vue_module_identifier__$F, false, undefined, undefined, undefined);

/* script */
var __vue_script__$G = script$l;
/* template */

var __vue_render__$E = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "order-refund-modal"
  }, [_c('CustomModal', {
    attrs: {
      "show": _vm.show
    },
    on: {
      "close": _vm.onClose
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_c('h1', {
          staticClass: "custom-modal__heading"
        }, [_vm._v("\n        Request Refund\n      ")])];
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "order-refund-modal__body"
  }, [_vm.loading ? [_c('div', {
    staticClass: "order-refund-modal__loading-container"
  }, [_c('div', {
    staticClass: "order-refund-modal__loading-content"
  }, [_c('h5', [_vm._v("Loading")]), _vm._v(" "), _c('font-awesome-icon', {
    staticClass: "icon",
    attrs: {
      "icon": "spinner",
      "size": "lg",
      "spin": ""
    }
  })], 1)])] : [_vm.orderHeader && _vm.orderHeader.orderLines && _vm.orderHeader.orderLines.length > 0 ? [_c('ul', {
    staticClass: "order-refund-modal__order-line-lists"
  }, _vm._l(_vm.orderHeader.orderLines, function (item, index) {
    return _c('li', {
      key: index,
      staticClass: "order-refund-modal__order-line"
    }, [_c('div', {
      staticClass: "order-refund-modal__summary"
    }, [_c('div', {
      staticClass: "order-refund-modal__name"
    }, [_vm._v("\n                  " + _vm._s(item.productName) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "order-refund-modal__edit",
      on: {
        "click": function click($event) {
          return _vm.onRefundShow(item);
        }
      }
    }, [_c('div', [item.refundRequested ? [_vm._v("\n                      View Refund\n                    ")] : [_vm._v("\n                      Request Refund\n                    ")]], 2)])]), _vm._v(" "), item.showDetails ? _c('div', {
      staticClass: "order-refund-modal__form"
    }, [_c('b-form-group', [_c('b-select', {
      model: {
        value: item.refundReasonId,
        callback: function callback($$v) {
          _vm.$set(item, "refundReasonId", $$v);
        },
        expression: "item.refundReasonId"
      }
    }, _vm._l(_vm.orderHeader.refundReasons, function (reason) {
      return _c('option', {
        key: reason.value,
        attrs: {
          "disabled": item.refundRequested
        },
        domProps: {
          "value": reason.value
        }
      }, [_vm._v("\n                      " + _vm._s(reason.text) + "\n                    ")]);
    }), 0), _vm._v(" "), item.reasonInvalid ? _c('span', {
      staticClass: "validation-error"
    }, [_vm._v("Please select a refund reason")]) : _vm._e()], 1), _vm._v(" "), _c('b-form-group', [_c('b-form-textarea', {
      attrs: {
        "placeholder": "Notes...",
        "disabled": item.refundRequested,
        "rows": "5",
        "max-rows": "8"
      },
      model: {
        value: item.refundDetails,
        callback: function callback($$v) {
          _vm.$set(item, "refundDetails", $$v);
        },
        expression: "item.refundDetails"
      }
    })], 1), _vm._v(" "), _c('b-form-group', [!item.refundRequested ? [!item.refundRequested ? _c('button', {
      staticClass: "btn btn-accent-8 btn-sm btn-rounded",
      on: {
        "click": function click($event) {
          return _vm.onRefundAccept(item);
        }
      }
    }, [_vm._v("\n                      Accept\n                    ")]) : _vm._e()] : [_c('button', {
      staticClass: "btn btn-accent-8 btn-sm btn-rounded",
      on: {
        "click": function click($event) {
          return _vm.onRefundClose(item);
        }
      }
    }, [_vm._v("\n                      Close\n                    ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-accent-3 btn-sm btn-rounded order-refund-modal__cancelItem",
      on: {
        "click": function click($event) {
          return _vm.onRefundCancel(item);
        }
      }
    }, [_vm._v("\n                      Cancel Refund\n                    ")])]], 2)], 1) : _vm._e()]);
  }), 0)] : [_c('p', [_vm._v("No products found!")])], _vm._v(" "), _c('div', {
    staticClass: "order-refund-modal__action-buttons"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": _vm.loading || _vm.submitting
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm.cancelling ? [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })] : [_vm._v("\n              Cancel\n            ")]], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-accent-1",
    attrs: {
      "disabled": _vm.loading || _vm.cancelling
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm.submitting ? [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })] : [_vm._v("\n              Submit\n            ")]], 2)])]], 2)])], 1);
};

var __vue_staticRenderFns__$E = [];
/* style */

var __vue_inject_styles__$G = undefined;
/* scoped */

var __vue_scope_id__$G = "data-v-11b71345";
/* module identifier */

var __vue_module_identifier__$G = undefined;
/* functional template */

var __vue_is_functional_template__$G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$E,
  staticRenderFns: __vue_staticRenderFns__$E
}, __vue_inject_styles__$G, __vue_script__$G, __vue_scope_id__$G, __vue_is_functional_template__$G, __vue_module_identifier__$G, false, undefined, undefined, undefined);

/* script */
var __vue_script__$H = script$n;
/* template */

var __vue_render__$F = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "orders-table"
  }, [_c('b-table', {
    staticClass: "custom-table",
    attrs: {
      "borderless": "",
      "responsive": "",
      "fields": _vm.fields,
      "items": _vm.orders
    },
    scopedSlots: _vm._u([{
      key: "cell(details)",
      fn: function fn(row) {
        return [_c('div', {
          staticClass: "orders-table__actions"
        }, [_c('button', {
          staticClass: "btn btn-sm btn-accent-1 btnOrderView",
          on: {
            "click": row.toggleDetails
          }
        }, [_vm._v("\n          " + _vm._s(row.detailsShowing ? 'Hide' : 'View') + "\n        ")]), _vm._v(" "), row.item.showRefundOption ? _c('button', {
          staticClass: "btn btn-sm btn-accent-1 btnOrderRefund",
          on: {
            "click": function click($event) {
              return _vm.onRefundClick(row.item.orderHeaderId);
            }
          }
        }, [_vm._v("\n          " + _vm._s('Refund') + "\n        ")]) : _vm._e()])];
      }
    }, {
      key: "row-details",
      fn: function fn(row) {
        return [_c('div', {
          staticClass: "orders-table__card"
        }, [_c('div', {
          staticClass: "orders-table__card-header"
        }, [_vm._v("\n          Products\n        ")]), _vm._v(" "), _vm._l(row.item.itemsInOrder, function (item, index) {
          return _c('div', {
            key: index,
            staticClass: "orders-table__card-line"
          }, [_c('div', {
            staticClass: "row no-padding"
          }, [_c('div', {
            staticClass: "col-lg-7 col-8 no-padding"
          }, [_vm._v("\n              " + _vm._s(item.productName) + "\n            ")]), _vm._v(" "), _c('div', {
            staticClass: "col-lg-2 col-2 no-padding"
          }, [_vm._v("\n              x" + _vm._s(item.quantity) + "\n            ")]), _vm._v(" "), _c('div', {
            staticClass: "col-lg-1 col-2 no-padding"
          }, [_vm._v("\n              " + _vm._s(_vm.formatPrice(item.lineValue)) + "\n            ")]), _vm._v(" "), _c('div', {
            staticClass: "col-lg-2 col-12 no-padding"
          }, [item.statusId == 'ACT' ? _c('button', {
            staticClass: "btn btn-sm btn-accent-2 orderlineStatus btnOrderLineRefund",
            on: {
              "click": function click($event) {
                return _vm.onRefundLineClick(row.item.orderHeaderId, item.creditOrderId, item.creditOrderLineId);
              }
            }
          }, [_vm._v("\n                " + _vm._s(item.statusText) + "\n              ")]) : _vm._e(), _vm._v(" "), item.statusId == 'SUB' ? _c('span', {
            staticClass: "orderlineStatus"
          }, [_vm._v(_vm._s(item.statusText))]) : _vm._e()])])]);
        })], 2)];
      }
    }])
  }), _vm._v(" "), _c('OrderRefundsModal', {
    attrs: {
      "show": _vm.showOrderRefundsModal,
      "order-id": _vm.orderId
    },
    on: {
      "close": function close($event) {
        _vm.showOrderRefundsModal = false;
      },
      "refreshPage": _vm.refreshPage
    }
  }), _vm._v(" "), _c('OrderLineRefundModal', {
    attrs: {
      "show": _vm.showOrderLineRefundModal,
      "order-id": _vm.orderId,
      "credit-order-id": _vm.creditOrderId,
      "credit-order-line-id": _vm.creditOrderLineId
    },
    on: {
      "close": function close($event) {
        _vm.showOrderLineRefundModal = false;
      },
      "refreshPage": _vm.refreshPage
    }
  })], 1);
};

var __vue_staticRenderFns__$F = [];
/* style */

var __vue_inject_styles__$H = undefined;
/* scoped */

var __vue_scope_id__$H = undefined;
/* module identifier */

var __vue_module_identifier__$H = undefined;
/* functional template */

var __vue_is_functional_template__$H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$F,
  staticRenderFns: __vue_staticRenderFns__$F
}, __vue_inject_styles__$H, __vue_script__$H, __vue_scope_id__$H, __vue_is_functional_template__$H, __vue_module_identifier__$H, false, undefined, undefined, undefined);

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * @typedef {object} StepState a single point in the checkout
 * @property {string} id the unique id of the step
 * @property {string} name the name of the step
 * @property {string} title the title of the step
 * @property {string} alias the unique name of the step
 * @property {string} status the current reported state of the step
 * @property {boolean} isLoaded true if the step has finished loading
 * @property {boolean} isValid true if the step has not reported being invalid
 * @property {boolean} isSealed true if the step has been marked complete when sealed === true
 * @property {boolean} stateless if true, the various states are unnecessary
 * @property {string} status name of the current state
 */

var script$s = {
  name: "BaseCheckoutStep",
  props: {
    alias: {
      type: String,
      default: null
    },
    hideNext: {
      type: Boolean,
      default: false
    },
    hidePrevious: {
      type: Boolean,
      default: false
    },
    hideUnloaded: {
      type: Boolean,
      default: false
    },
    loaded: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: null
    },
    sealed: {
      type: Boolean,
      default: false
    },
    stateless: {
      type: Boolean,
      default: false
    },
    valid: {
      type: Boolean,
      default: false
    }
  },
  inject: {
    checkout: {
      default: function _default() {
        throw new Error("A step must be within a <checkout>");
      }
    }
  },
  data: function data() {
    return {
      intlValid: false,
      intlSealed: false,
      intlLoaded: false,
      intlAlias: null,
      intlProgressName: null,
      intlId: null,
      intlSealTrigger: false
    };
  },
  computed: {
    status: function status() {
      var result;

      if (!this.isLoaded) {
        result = "loading";
      } else if (!this.isValid) {
        result = "invalid";
      } else if (this.isSealed) {
        result = "sealed";
      } else {
        result = "valid";
      }

      return result;
    },
    isLoaded: function isLoaded() {
      return this.intlId && (this.intlLoaded || this.stateless);
    },
    isValid: function isValid() {
      return this.stateless || this.intlValid;
    },
    isSealed: function isSealed() {
      var result = this.intlSealed;
      return result;
    },
    _isStep: function _isStep() {
      return true;
    },
    isCurrent: function isCurrent() {
      return this.checkout.isCurrent(this.intlId);
    },
    isLastStep: function isLastStep() {
      return this.checkout.isLastStep;
    },
    isSubmitted: function isSubmitted() {
      return this.checkout.isSubmitted;
    },
    _title: function _title() {
      return this.title ? this.title : this.name;
    },
    canGoToNextStep: function canGoToNextStep() {
      return this.checkout.canGoToNextStep;
    },
    canGoToPreviousStep: function canGoToPreviousStep() {
      return this.checkout.canGoToPreviousStep;
    },
    functionality: function functionality() {
      return _objectSpread$3({}, this.state, {
        setLoaded: this.setLoaded,
        setValid: this.setValid,
        setSealed: this.setSealed,
        goToNextStep: this.goToNextStep,
        goToPreviousStep: this.goToPreviousStep
      });
    },
    state: function state() {
      return {
        id: this.intlId,
        name: this.name,
        title: this._title,
        alias: this.intlAlias,
        isLoaded: this.isLoaded,
        isValid: this.isValid,
        isSealed: this.isSealed,
        isCurrent: this.isCurrent,
        stateless: this.stateless,
        canGoToNextStep: this.canGoToNextStep,
        canGoToPreviousStep: this.canGoToPreviousStep,
        status: this.status,
        isLastStep: this.isLastStep
      };
    }
  },
  watch: {
    status: {
      handler: function handler(val) {
        this.$emit("change", val);
      }
    },
    loaded: {
      immediate: true,
      handler: function handler(val) {
        this.intlLoaded = val;
      }
    },
    valid: {
      immediate: true,
      handler: function handler(val) {
        this.intlValid = val;
      }
    },
    sealed: {
      immediate: true,
      handler: function handler(val) {
        if (val !== this.intlSealed) {
          this.intlSealed = val;
        }
      }
    },
    isLoaded: function isLoaded() {
      this.announce();
    },
    isValid: function isValid() {
      this.announce();
    },
    isSealed: function isSealed() {
      this.announce();
    },
    isCurrent: function isCurrent(val) {
      if (val === true) {
        this.$emit("currentStep", this.intlAlias);
      }
    },
    isSubmitted: function isSubmitted(val) {
      if (val === true) {
        this.$emit("submitted", this.checkout.orderReference);
      }
    }
  },
  created: function created() {
    var baseAlias = this.alias ? this.alias : this.name;
    this.intlAlias = createAlias(baseAlias);
    console.assert(this.intlAlias, "createAlias error");
    this.intlId = "".concat(this.intlAlias, "-").concat(Math.floor(Math.random() * (9999 - 1000) + 1000));
    this.announce();
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      if (!_this.checkout.hasError && !document.getElementById(_this.intlId)) {
        console.warn("Step '".concat(_this.intlId, "' has not had it's 'intlId' ") + "registered in it's 'template'!");
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.checkout.removeStep(this.intlId);
  },
  methods: {
    // #region [rgba(221, 216, 196, 0.1)] structure
    announce: function announce() {
      this.checkout.registerStep(this.intlId, this.state);
      this.$emit("announce", this.intlId, this.state);
    },
    // #endregion structure
    // #region [rgba(254, 95, 85, 0.1)] state
    setLoaded: function setLoaded() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.intlLoaded = val;
    },
    setValid: function setValid(val) {
      this.intlValid = val;
    },
    setSealed: function setSealed(val) {
      this.intlSealed = val;
    },
    goToNextStep: function goToNextStep() {
      this.checkout.goToNextStep();
    },
    goToPreviousStep: function goToPreviousStep() {
      this.checkout.goToPreviousStep();
    } // #endregion state
    // #region [rgba(112, 193, 179, 0.1)] functionality
    // #endregion functionality

  }
};

/* script */
var __vue_script__$I = script$s;
/* template */

var __vue_render__$G = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div');
};

var __vue_staticRenderFns__$G = [];
/* style */

var __vue_inject_styles__$I = undefined;
/* scoped */

var __vue_scope_id__$I = undefined;
/* module identifier */

var __vue_module_identifier__$I = undefined;
/* functional template */

var __vue_is_functional_template__$I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$G,
  staticRenderFns: __vue_staticRenderFns__$G
}, __vue_inject_styles__$I, __vue_script__$I, __vue_scope_id__$I, __vue_is_functional_template__$I, __vue_module_identifier__$I, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$t = {
  name: "Basket",
  data: function data() {
    return {
      loaded: false
    };
  },
  watch: {
    loaded: function loaded() {
      this.$emit("loaded");
    }
  },
  created: function created() {
    var _this = this;

    window.setTimeout(function () {
      _this.loaded = true;
    }, 2000);
  },
  methods: {
    onClick: function onClick() {
      this.$emit("error");
    }
  }
};

/* script */
var __vue_script__$J = script$t;
/* template */

var __vue_render__$H = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "basket"
  }, [!_vm.loaded ? _c('span', [_vm._v("\n    Loading...\n  ")]) : _c('span', [_vm._v("\n    Your basket items are being listed here.\n\n    "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "debug",
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v("\n      Empty my basket (This will break things!)\n    ")])])]);
};

var __vue_staticRenderFns__$H = [];
/* style */

var __vue_inject_styles__$J = undefined;
/* scoped */

var __vue_scope_id__$J = undefined;
/* module identifier */

var __vue_module_identifier__$J = undefined;
/* functional template */

var __vue_is_functional_template__$J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$H,
  staticRenderFns: __vue_staticRenderFns__$H
}, __vue_inject_styles__$J, __vue_script__$J, __vue_scope_id__$J, __vue_is_functional_template__$J, __vue_module_identifier__$J, false, undefined, undefined, undefined);

var $at$1 = _stringAt$1(true);

// 21.1.3.27 String.prototype[@@iterator]()
_iterDefine(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at$1(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

// call something on iterator step with safe closing on error

var _iterCall$1 = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(_anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) _anObject(ret.call(iterator));
    throw e;
  }
};

// check on default Array iterator

var ITERATOR$7 = _wks('iterator');
var ArrayProto$2 = Array.prototype;

var _isArrayIter$1 = function (it) {
  return it !== undefined && (_iterators.Array === it || ArrayProto$2[ITERATOR$7] === it);
};

var ITERATOR$8 = _wks('iterator');

var core_getIteratorMethod$1 = _core.getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR$8]
    || it['@@iterator']
    || _iterators[_classof$1(it)];
};

var ITERATOR$9 = _wks('iterator');
var SAFE_CLOSING$1 = false;

try {
  var riter$1 = [7][ITERATOR$9]();
  riter$1['return'] = function () { SAFE_CLOSING$1 = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter$1, function () { throw 2; });
} catch (e) { /* empty */ }

var _iterDetect$1 = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING$1) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR$9]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR$9] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

_export(_export.S + _export.F * !_iterDetect$1(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = _toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = core_getIteratorMethod$1(O);
    var length, result, step, iterator;
    if (mapping) mapfn = _ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && _isArrayIter$1(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        _createProperty(result, index, mapping ? _iterCall$1(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = _toLength(O.length);
      for (result = new C(length); length > index; index++) {
        _createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

var iterator = _wksExt.f('iterator');

var iterator$1 = iterator;

_wksDefine('asyncIterator');

_wksDefine('observable');

var symbol = _core$1.Symbol;

var symbol$1 = symbol;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof symbol$1 === "function" && typeof iterator$1 === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof symbol$1 === "function" && obj.constructor === symbol$1 && obj !== symbol$1.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

// 21.2.5.3 get RegExp.prototype.flags()
if (_descriptors && /./g.flags != 'g') _objectDp.f(RegExp.prototype, 'flags', {
  configurable: true,
  get: _flags
});

var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  _redefine(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (_fails(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = _anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !_descriptors && R instanceof RegExp ? _flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}

function diff(original, updated) {
  if (!updated || Object.prototype.toString.call(updated) !== "[object Object]") {
    return original;
  }

  if (!original || Object.prototype.toString.call(original) !== "[object Object]") {
    return updated;
  }

  var diffs = {};
  Object.keys(original).forEach(function (key) {
    if (original[key] !== updated[key]) {
      if (Array.isArray(original[key])) {
        if (original[key].toString() !== updated[key].toString()) {
          diffs[key] = updated[key];
        }
      } else if (_typeof(original[key]) === "object") {
        var oResult = diff(original[key], updated[key]);

        if (oResult && Object.keys(oResult).length > 0) {
          diffs[key] = oResult;
        }
      } else {
        diffs[key] = updated[key];
      }
    }
  });
  return diffs;
}

var instance$2 = new HttpService("umbraco/api/Checkout/");
var getSubmittedOrderReference = function getSubmittedOrderReference() {
  return instance$2.get("GetSubmittedOrderReference");
};

/**
 * @typedef {object} Step a single point in the checkout
 * @property {string} id the unique id of the step
 * @property {string} name the name of the step
 * @property {string} title the title of the step
 * @property {string} alias the unique name of the step
 * @property {string} status the current reported state of the step
 * @property {boolean} isLoaded true if the step has finished loading
 * @property {boolean} isValid true if the step has not reported being invalid
 * @property {boolean} isSealed true if the step has been marked complete when sealed === true
 * @property {boolean} stateless if true, the various states are unnecessary
 * @property {string} status name of the current state
 */

var script$u = {
  name: "Checkout",
  components: {
    AlertViewer: AlertViewer
  },
  model: {
    prop: "currentStepAlias",
    event: "changeStep"
  },
  props: {
    currentStepAlias: {
      type: String,
      default: null
    },
    hasError: {
      type: Boolean,
      default: false
    },
    submitted: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      steps: [],
      stepOrder: null,
      currentStepId: null,
      observer: null,
      targetId: null,
      isLoading: true,
      cachedAlias: null,
      orderReference: null
    };
  },
  provide: function provide() {
    return {
      checkout: this
    };
  },
  computed: {
    functionality: function functionality() {
      var result = {
        registerStep: this.registerStep,
        removeStep: this.removeStep,
        steps: this.steps,
        hasSteps: this.hasSteps,
        canGoToPreviousStep: this.canGoToPreviousStep,
        canGoToNextStep: this.canGoToNextStep,
        goToPreviousStep: this.goToPreviousStep,
        goToNextStep: this.goToNextStep,
        goToStep: this.goToStep,
        currentStepIndex: this.currentStepIndex,
        currentStep: this.currentStep,
        isCurrent: this.isCurrent,
        isInPast: this.isInPast,
        hasError: this.hasError,
        isSubmitted: this.isSubmitted,
        orderReference: this.orderReference,
        setOrderReference: this.setOrderReference
      };
      return result;
    },
    stepCount: function stepCount() {
      var result = this.steps.length;
      return result;
    },
    hasSteps: function hasSteps() {
      var result = this.stepCount > 0;
      return result;
    },
    isLastStep: function isLastStep() {
      var result = false;

      if (this.currentStepId) {
        console.assert(this.currentStepIndex !== null, "currentStepIndex should not be null", {
          currentStepId: this.currentStepId
        });
        result = !(this.currentStepIndex < this.stepCount - 1);
      }

      return result;
    },
    canGoToPreviousStep: function canGoToPreviousStep() {
      var result = false;

      if (this.previousStepId !== null) {
        result = this.validateDestination(this.previousStepId);
      }

      return result;
    },
    previousStepId: function previousStepId() {
      if (this.currentStepIndex === null || this.currentStepIndex <= 0) {
        return null;
      }

      var index = this.currentStepIndex - 1;
      var result = this.steps[index].id;
      console.assert(result !== null, "computed > previousStepId: this.steps[".concat(index, "].id should not be null"));
      return result;
    },
    canGoToNextStep: function canGoToNextStep() {
      var result = false;

      if (this.nextStepId !== null) {
        result = this.validateDestination(this.nextStepId);
      }

      return result;
    },
    nextStepId: function nextStepId() {
      if (this.currentStepId === null || this.isLastStep) {
        return null;
      }

      var result = this.steps[this.currentStepIndex + 1].id;
      console.assert(result !== null, "nextStepId: this.steps[".concat(this.currentStepIndex + 1, "].id should not be null"));
      return result;
    },
    currentStepIndex: function currentStepIndex() {
      if (!this.hasSteps || !this.currentStepId) return -1;
      var result = this.stepIndexes[this.currentStepId];
      console.assert(result >= 0, "computed > currentStepIndex: did not find a step with an ID of ".concat(this.currentStepId), this.stepIds);
      return result;
    },
    currentStep: function currentStep() {
      if (!this.hasSteps || !this.currentStepId) return null;
      console.assert(this.currentStepIndex >= 0, "computed > currentStep: this.currentStepIndex should not be null", this.stepIds);
      var result = this.steps[this.currentStepIndex];
      console.assert(result, "computed > currentStep: this.steps[".concat(this.currentStepId, "] should not be null"), this.stepIds);
      return result;
    },
    firstInvalidIndex: function firstInvalidIndex() {
      var result = -1;

      if (this.hasSteps) {
        result = this.steps.findIndex(function (step) {
          return !step.isValid;
        });
      }

      return result;
    },
    firstUnloadedIndex: function firstUnloadedIndex() {
      var result = this.steps.findIndex(function (step) {
        return !step.isLoaded;
      });
      return result;
    },
    sealingPoint: function sealingPoint() {
      if (!this.hasSteps) return -1;
      var result = this.steps.map(function (step) {
        return step.isSealed;
      }).lastIndexOf(true);
      return result;
    },
    idAliasMap: function idAliasMap() {
      var _this = this;

      var result = {};
      this.stepIds.forEach(function (id, index) {
        result[id] = _this.stepAliases[index];
      });
      return result;
    },
    aliasIdMap: function aliasIdMap() {
      var _this2 = this;

      var result = {};
      this.stepAliases.forEach(function (alias, index) {
        result[alias] = _this2.stepIds[index];
      });
      return result;
    },
    stepIndexes: function stepIndexes() {
      var result = {};
      this.stepIds.forEach(function (id, index) {
        result[id] = index;
      });
      return result;
    },
    stepIds: function stepIds() {
      return this.steps.map(function (step) {
        return step.id;
      });
    },
    stepAliases: function stepAliases() {
      return this.steps.map(function (step) {
        return step.alias;
      });
    },
    stepLoadedStates: function stepLoadedStates() {
      return this.steps.map(function (step) {
        return step.isLoaded;
      });
    },
    stepsValidity: function stepsValidity() {
      var result = [];

      if (this.hasSteps) {
        this.steps.forEach(function (step) {
          var state = null;

          if (step.isLoaded) {
            state = step.isValid || step.stateless;
          }

          result.push(state);
        });
        console.assert(result, "should not be undefined");
      }

      return result;
    },
    isSubmitted: function isSubmitted() {
      var result = false;

      if (this.orderReference) {
        result = true;
      }

      return result;
    }
  },
  watch: {
    currentStepAlias: {
      immediate: true,
      handler: function () {
        var _handler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(newAlias) {
          var debug, id, success;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  // console.groupCollapsed( "watch > currentStepAlias" );
                  debug = {
                    hasSteps: this.hasSteps,
                    newAlias: newAlias,
                    cachedAlias: this.cachedAlias,
                    result: this.hasSteps && newAlias !== this.cachedAlias
                  };

                  if (!(this.hasSteps && newAlias !== this.cachedAlias)) {
                    _context.next = 14;
                    break;
                  }

                  _context.next = 5;
                  return this.aliasIdMap[newAlias];

                case 5:
                  _context.t0 = _context.sent;

                  if (_context.t0) {
                    _context.next = 8;
                    break;
                  }

                  _context.t0 = null;

                case 8:
                  id = _context.t0;

                  if (!id) {
                    _context.next = 14;
                    break;
                  }

                  _context.next = 12;
                  return this.goToStep(id);

                case 12:
                  success = _context.sent;

                  if (!success && this.cachedAlias !== null) {
                    console.warn("Could not go to", newAlias);
                    this.$emit("changeStep", this.cachedAlias);
                  }

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function handler(_x) {
          return _handler.apply(this, arguments);
        }

        return handler;
      }()
    },
    isLoading: function isLoading(val) {
      this.$emit("loading", val);
    },
    stepsValidity: function stepsValidity(states) {
      if (this.hasSteps) {
        if (this.isLoading) {
          var targetId = null;

          if (this.currentStepAlias !== null) {
            targetId = this.aliasIdMap[this.currentStepAlias];
          } else {
            targetId = this.steps[0].id;
          }

          var targetIndex = this.stepIndexes[targetId];

          if (this.sealingPoint >= targetIndex) {
            targetIndex = this.sealingPoint + 1;
          }

          var wait = false;
          states.forEach(function (state, index) {
            if (index > targetIndex) {
              return;
            }

            if (state === null || wait) {
              wait = true;
              return;
            }

            if (state === false) {
              targetIndex = index;
            }
          });

          if (!wait) {
            this.goToStep(this.stepIds[targetIndex]);
          }
        }
      }
    },
    currentStepId: function currentStepId(id) {
      // console.groupCollapsed( "watch > currentStepId" );
      // console.log( "watch > currentStepId:", { newId: id, oldId, hasSteps: this.hasSteps } );
      if (id && this.hasSteps) {
        var alias = this.idAliasMap[id];
        console.assert(alias, "watch > currentStepId: there should be a step & alias associated with id:".concat(id), this.stepIds);
        this.cachedAlias = alias;
        this.$emit("changeStep", alias);
      } // console.groupEnd();

    },
    currentStepIndex: function currentStepIndex(index) {
      this.$gtag.onCheckoutStep(index + 1);
    },
    stepCount: {
      handler: function handler() {
        if (!this.hasError && this.currentStepAlias === null && this.hasSteps) {
          if (this.currentStep === null) {
            this.goToStep(this.steps[0].id);
          }
        }
      }
    }
  },
  created: function created() {
    return this.checkSubmitted();
  },
  mounted: function mounted() {
    this.observer = new MutationObserver(this.observerHandler);
    this.observer.observe(this.$el, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["id"]
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.observer.disconnect();
  },
  methods: {
    // #region [rgba(221, 216, 196, 0.1)] structure
    observerHandler: function observerHandler() {
      this.orderSteps();
    },
    orderSteps: function orderSteps() {
      var _this3 = this;

      if (this.hasSteps) {
        // Gets comma deliminated list of step ids
        var selector = this.steps.map(function (step) {
          return "#".concat(step.id);
        }).join(", ");

        if (selector) {
          // Gets ordered list of ids based on dom hierarchy
          var stepOrder = Array.from(this.$el.querySelectorAll(selector)).map(function (el) {
            return el.id;
          }); // Creates new steps array from the old one
          // based on the order of stepsOrder

          this.steps = stepOrder.map(function (id) {
            return _this3.steps.find(function (step) {
              return step.id === id;
            });
          });
        }
      }
    },
    getStepIndex: function getStepIndex(id) {
      console.assert(id, "methods > getStepIndex: was given no id");
      var result = this.stepIndexes[id] || -1;
      return result;
    },
    getStep: function getStep(id) {
      console.assert(id, "methods > getStep: was given no id");
      var result = this.steps.find(function (step) {
        return step.id === id;
      });
      return result;
    },
    removeStep: function removeStep(id) {
      console.assert(id, "methods > removeStep: was given no id");
      var index = this.stepIndexes[id]; // this.getStepIndex( id );

      if (index > -1) {
        this.$delete(this.steps, index);
      }
    },
    registerStep: function registerStep(id, step) {
      var _this4 = this;

      var index = this.stepIndexes[id];
      var original = this.steps[index];
      var difference = diff(original, step);
      var alias = "";

      if (original && original.alias) {
        // eslint-disable-next-line prefer-destructuring
        alias = original.alias;
      } else if (step && step.alias) {
        // eslint-disable-next-line prefer-destructuring
        alias = step.alias;
      }

      if (index > -1) {
        if (Object.keys(difference).length > 0 && difference.constructor === Object) {
          var payload = {
            alias: alias,
            difference: difference
          };
          new Promise(function (resolve, reject) {
            if (_this4.$listeners.beforeUpdateStep) {
              _this4.$listeners.beforeUpdateStep(payload, resolve, reject);
            } else {
              resolve();
            }
          }).then(function () {
            _this4.$set(_this4.steps, index, step);
          }).catch(function (error) {
            throw new Error(error);
          });
        }
      } else {
        this.steps.push(step);
      }
    },
    // #endregion structure
    // #region [rgba(254, 95, 85, 0.1)] state
    validateDestination: function validateDestination(targetId) {
      var enableLogging = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var result = true;

      if (targetId !== null) {
        var targetIndex = this.stepIndexes[targetId];
        var states = this.stepsValidity; // Check that target step isn't sealed

        if (this.sealingPoint < 0 || targetIndex > this.sealingPoint) {
          var index = 0;

          while (index <= targetIndex && result) {
            // check status of previous step
            if (index > 0) {
              result = result && states[index - 1] === true;

              if (!result && enableLogging) {
                var _this$steps$index;

                console.error("A previous step is invalid", (_this$steps$index = this.steps[index]) === null || _this$steps$index === void 0 ? void 0 : _this$steps$index.alias, this.steps[index]);
              }
            } // If index is the target index, and the previous
            // steps are all good, then the destination is valid...
            // ...unless the checkout is still loading, then
            // the step has to have loaded ( can't be null )


            if (result && index === targetIndex) {
              result = !(states[index] === null && this.isLoading);

              if (!result && enableLogging) {
                var _this$steps$index2;

                console.error("Checkout is still loading", (_this$steps$index2 = this.steps[index]) === null || _this$steps$index2 === void 0 ? void 0 : _this$steps$index2.alias, this.steps[index]);
              }
            }

            index += 1;
          }
        } else {
          if (enableLogging) {
            var _this$steps$targetInd;

            console.error("Step behind sealing point", (_this$steps$targetInd = this.steps[targetIndex]) === null || _this$steps$targetInd === void 0 ? void 0 : _this$steps$targetInd.alias, this.steps[targetIndex]);
          }

          result = false;
        }
      } else if (enableLogging) {
        console.error("Target ID was not specified.");
      }

      return result;
    },
    isCurrent: function isCurrent(id) {
      return id === this.currentStepId;
    },
    checkSubmitted: function checkSubmitted() {
      var _this5 = this;

      return getSubmittedOrderReference().then(function (response) {
        _this5.orderReference = response.data;
      });
    },
    setOrderReference: function setOrderReference(ref) {
      this.orderReference = ref;
    },
    // #endregion state
    // #region [rgba(36, 123, 160,0.1)] navigation
    goToStep: function () {
      var _goToStep = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
        var caller, result, isValid;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                caller = "methods > goToStep( ".concat(id, " ):");
                result = false;

                if (this.hasError) {
                  _context2.next = 23;
                  break;
                }

                console.assert(id, "".concat(caller, " id should not be null"));
                _context2.prev = 4;
                _context2.next = 7;
                return this.validateDestination(id, true);

              case 7:
                isValid = _context2.sent;

                if (!isValid) {
                  _context2.next = 15;
                  break;
                }

                _context2.next = 11;
                return this.beforeChangeStep(id);

              case 11:
                this.currentStepId = id;
                this.isLoading = false;
                _context2.next = 16;
                break;

              case 15:
                console.error("Not able to validate destination.");

              case 16:
                _context2.next = 21;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](4);
                throw new Error(_context2.t0);

              case 21:
                _context2.next = 24;
                break;

              case 23:
                console.error("Has error, cannot proceed.");

              case 24:
                return _context2.abrupt("return", result);

              case 25:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 18]]);
      }));

      function goToStep(_x2) {
        return _goToStep.apply(this, arguments);
      }

      return goToStep;
    }(),
    goToNextStep: function goToNextStep() {
      return this.goToStep(this.nextStepId);
    },
    goToPreviousStep: function goToPreviousStep() {
      return this.goToStep(this.previousStepId);
    },
    // #endregion navigation
    // #region [rgba(112, 193, 179, 0.1)] functionality
    beforeChangeStep: function beforeChangeStep(id) {
      var _this6 = this;

      return new Promise(function (resolve, reject) {
        if (_this6.$listeners.beforeChangeStep) {
          _this6.$listeners.beforeChangeStep(_this6.idAliasMap[id], resolve, reject);
        } else {
          resolve();
        }
      });
    } // #endregion functionality

  }
};

/* script */
var __vue_script__$K = script$u;
/* template */

var __vue_render__$I = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('alert-viewer', {
    attrs: {
      "namespace": "checkout"
    }
  }), _vm._v(" "), _vm._t("default", null, {
    "checkout": _vm.functionality
  })], 2);
};

var __vue_staticRenderFns__$I = [];
/* style */

var __vue_inject_styles__$K = undefined;
/* scoped */

var __vue_scope_id__$K = undefined;
/* module identifier */

var __vue_module_identifier__$K = undefined;
/* functional template */

var __vue_is_functional_template__$K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$I,
  staticRenderFns: __vue_staticRenderFns__$I
}, __vue_inject_styles__$K, __vue_script__$K, __vue_scope_id__$K, __vue_is_functional_template__$K, __vue_module_identifier__$K, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$v = {
  name: "CheckoutProgress",
  inject: {
    checkout: {
      default: function _default() {
        throw new Error("Checkout progress must be within a <checkout>");
      }
    }
  },
  computed: {
    sealingPoint: function sealingPoint() {
      var _this$checkout$steps$, _this$checkout$steps;

      return (_this$checkout$steps$ = (_this$checkout$steps = this.checkout.steps) === null || _this$checkout$steps === void 0 ? void 0 : _this$checkout$steps.findIndex(function (x) {
        return x.isSealed;
      })) !== null && _this$checkout$steps$ !== void 0 ? _this$checkout$steps$ : -1;
    }
  },
  methods: {
    getStepClasses: function getStepClasses(step, index) {
      // const caller = "CheckoutProgress::methods::getStepClasses:";
      var current = this.checkout.isCurrent(step.id) ? "current" : null;
      var past = this.checkout.currentStepIndex > index ? "past" : null;
      var disabled = index <= this.sealingPoint ? "disabled" : null;
      var result = [step.status, current, past, disabled].filter(function (i) {
        return i !== null;
      }).map(function (state) {
        return "checkout-progress__item--".concat(state);
      });
      return result;
    },
    onClick: function onClick(step) {
      this.$emit("click", step);
    }
  }
};

var __vue_script__$L = script$v;
/* template */

var __vue_render__$J = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "checkout-progress"
  }, [_c('ol', {
    staticClass: "checkout-progress__list"
  }, _vm._l(_vm.checkout.steps, function (step, index) {
    return _c('li', {
      key: step.id,
      staticClass: "checkout-progress__item",
      class: _vm.getStepClasses(step, index)
    }, [_vm._t("default", [_c('span', {
      staticClass: "checkout-progress__btn"
    }, [_vm._v("\n          " + _vm._s(step.name) + "\n        ")])], {
      "step": step,
      "index": index
    })], 2);
  }), 0)]);
};

var __vue_staticRenderFns__$J = [];
/* style */

var __vue_inject_styles__$L = undefined;
/* scoped */

var __vue_scope_id__$L = "data-v-0a6f082a";
/* module identifier */

var __vue_module_identifier__$L = undefined;
/* functional template */

var __vue_is_functional_template__$L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$J,
  staticRenderFns: __vue_staticRenderFns__$J
}, __vue_inject_styles__$L, __vue_script__$L, __vue_scope_id__$L, __vue_is_functional_template__$L, __vue_module_identifier__$L, false, undefined, undefined, undefined);

/* script */
var __vue_script__$M = script$s;
/* template */

var __vue_render__$K = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div');
};

var __vue_staticRenderFns__$K = [];
/* style */

var __vue_inject_styles__$M = undefined;
/* scoped */

var __vue_scope_id__$M = undefined;
/* module identifier */

var __vue_module_identifier__$M = undefined;
/* functional template */

var __vue_is_functional_template__$M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$K,
  staticRenderFns: __vue_staticRenderFns__$K
}, __vue_inject_styles__$M, __vue_script__$M, __vue_scope_id__$M, __vue_is_functional_template__$M, __vue_module_identifier__$M, false, undefined, undefined, undefined);

//
var script$w = {
  name: "StackedStep",
  extends: __vue_component__$M,
  computed: {
    classes: function classes() {
      var loadState = this.isLoaded ? "loaded" : "loading";
      var validState = this.isValid ? "valid" : "invalid";
      var completedState = this.isCompleted ? "complete" : "incomplete";
      return ["stacked-step--".concat(loadState), "stacked-step--".concat(validState), "stacked-step--".concat(completedState)];
    }
  }
};

var __vue_script__$N = script$w;
/* template */

var __vue_render__$L = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "step stacked-step",
    class: _vm.classes,
    attrs: {
      "id": _vm.intlId,
      "name": _vm.$options.name,
      "data-category": _vm.$options.category
    }
  }, [_c('div', {
    staticClass: "step__header stacked-step__header"
  }, [_c('div', {
    staticClass: "step__icon stacked-step__icon"
  }, [_vm._t("icon", [_vm._v("\n        icon\n      ")])], 2), _vm._v(" "), _c('h2', {
    staticClass: "step__heading stacked-step__heading"
  }, [_vm._v("\n      " + _vm._s(_vm.name) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "step__status stacked-step__status"
  }, [_vm._t("status", [_vm._v("\n        status\n      ")], {
    "step": _vm.functionality
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "step__body stacked-step__body"
  }, [_c('div', {
    staticClass: "json"
  }, [_vm._v("\n      " + _vm._s(_vm.functionality) + "\n    ")]), _vm._v(" "), _vm._t("default", [_c('ul', [_c('li', [_vm._v("isStep: " + _vm._s(_vm._isStep))]), _vm._v(" "), _c('li', [_vm._v("id: " + _vm._s(_vm.intlId))]), _vm._v(" "), _c('li', [_vm._v("alias: " + _vm._s(_vm.intlAlias))]), _vm._v(" "), _c('li', [_vm._v("isVisible: " + _vm._s(_vm.isCurrent))])])], {
    "step": _vm.functionality
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "step__footer stacked-step__footer"
  }, [_vm._t("footer", [_vm.isCurrent ? _c('button', {
    staticClass: "step__continue stacked-step__continue debug",
    on: {
      "click": function click($event) {
        return _vm.step.goToNextStep();
      }
    }
  }, [_vm._v("\n        Continue\n      ")]) : _vm._e()], {
    "step": _vm.functionality
  })], 2)]);
};

var __vue_staticRenderFns__$L = [];
/* style */

var __vue_inject_styles__$N = undefined;
/* scoped */

var __vue_scope_id__$N = "data-v-1e98f815";
/* module identifier */

var __vue_module_identifier__$N = undefined;
/* functional template */

var __vue_is_functional_template__$N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$L,
  staticRenderFns: __vue_staticRenderFns__$L
}, __vue_inject_styles__$N, __vue_script__$N, __vue_scope_id__$N, __vue_is_functional_template__$N, __vue_module_identifier__$N, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$x = {
  name: "StepStatus",
  props: {
    step: {
      type: Object,
      required: true
    }
  }
};

/* script */
var __vue_script__$O = script$x;
/* template */

var __vue_render__$M = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "step-status",
    attrs: {
      "title": _vm.step.status
    }
  }, [_vm.step.status === 'loading' ? [_vm._v("\n    🔵\n  ")] : _vm._e(), _vm._v(" "), _vm.step.status === 'invalid' ? [_vm._v("\n    ❗❗\n  ")] : _vm._e(), _vm._v(" "), _vm.step.status === 'completed' ? [_vm._v("\n    ✔\n  ")] : _vm._e()], 2);
};

var __vue_staticRenderFns__$M = [];
/* style */

var __vue_inject_styles__$O = undefined;
/* scoped */

var __vue_scope_id__$O = "data-v-0b3566a8";
/* module identifier */

var __vue_module_identifier__$O = undefined;
/* functional template */

var __vue_is_functional_template__$O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$M,
  staticRenderFns: __vue_staticRenderFns__$M
}, __vue_inject_styles__$O, __vue_script__$O, __vue_scope_id__$O, __vue_is_functional_template__$O, __vue_module_identifier__$O, false, undefined, undefined, undefined);

//
var script$y = {
  name: "TabbedStep",
  extends: __vue_component__$M,
  mixins: [StyleMixin],
  props: {
    heading: {
      type: String,
      default: undefined
    },
    noHeader: {
      type: Boolean,
      default: false
    },
    noFooter: {
      type: Boolean,
      default: false
    },
    hideBackToHome: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes: function classes() {
      var current = this.checkout.isCurrent(this.intlId) ? "current" : null;
      var result = [this.status, current].filter(function (i) {
        return i !== null;
      }).map(function (state) {
        return "tabbed-step--".concat(state);
      });
      return result;
    }
  },
  methods: {
    GetButtonClasses: function GetButtonClasses(name) {
      var result = "step__footer-button tabbed-step__footer-button";
      result = "".concat(result, " step__").concat(name, " tabbed-step__").concat(name);

      if (this.buttonClass) {
        result += " ".concat(this.buttonClass);
      }

      return result;
    }
  }
};

var __vue_script__$P = script$y;
/* template */

var __vue_render__$N = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isCurrent,
      expression: "isCurrent"
    }],
    staticClass: "step tabbed-step",
    class: _vm.classes,
    attrs: {
      "id": _vm.intlId,
      "name": _vm.$options.name,
      "data-category": _vm.$options.category
    }
  }, [!_vm.noHeader ? _c('div', {
    staticClass: "step__header tabbed-step__header"
  }, [_c('h2', {
    staticClass: "step__heading tabbed-step__heading"
  }, [_vm._v("\n      " + _vm._s(_vm.heading || _vm.name) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step__body tabbed-step__body"
  }, [!_vm.isLoaded ? _vm._t("loading", [_c('h3', [_vm._v("Step Loading")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isLoaded || !_vm.hideUnloaded,
      expression: "isLoaded || !hideUnloaded"
    }]
  }, [_vm._t("default", [_c('ul', [_c('li', [_vm._v("isStep: " + _vm._s(_vm._isStep))]), _vm._v(" "), _c('li', [_vm._v("id: " + _vm._s(_vm.intlId))]), _vm._v(" "), _c('li', [_vm._v("alias: " + _vm._s(_vm.intlAlias))]), _vm._v(" "), _c('li', [_vm._v("isVisible: " + _vm._s(_vm.isCurrent))])])], {
    "step": _vm.functionality
  })], 2)], 2), _vm._v(" "), !_vm.noFooter && _vm.isLoaded ? _c('div', {
    staticClass: "step__footer tabbed-step__footer"
  }, [_vm._t("footer", [!_vm.hidePrevious && _vm.canGoToPreviousStep ? _c('button', {
    class: _vm.GetButtonClasses('previous'),
    on: {
      "click": function click($event) {
        return _vm.goToPreviousStep();
      }
    }
  }, [_vm._v("\n        Back\n      ")]) : _vm._e(), _vm._v(" "), !_vm.hideNext && !_vm.state.isLastStep ? _c('button', {
    class: _vm.GetButtonClasses('continue'),
    attrs: {
      "disabled": !_vm.canGoToNextStep
    },
    on: {
      "click": function click($event) {
        return _vm.goToNextStep();
      }
    }
  }, [_vm._v("\n        Continue\n      ")]) : _vm._e(), _vm._v(" "), _vm.state.isLastStep && !_vm.hideBackToHome ? _c('a', {
    staticClass: "step__continue step__back-to-home",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("\n        Back to home\n      ")]) : _vm._e()], {
    "step": _vm.functionality
  })], 2) : _vm._e()]);
};

var __vue_staticRenderFns__$N = [];
/* style */

var __vue_inject_styles__$P = undefined;
/* scoped */

var __vue_scope_id__$P = "data-v-2e0f2b40";
/* module identifier */

var __vue_module_identifier__$P = undefined;
/* functional template */

var __vue_is_functional_template__$P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$N,
  staticRenderFns: __vue_staticRenderFns__$N
}, __vue_inject_styles__$P, __vue_script__$P, __vue_scope_id__$P, __vue_is_functional_template__$P, __vue_module_identifier__$P, false, undefined, undefined, undefined);

/* script */
var __vue_script__$Q = script$5;
/* template */

var __vue_render__$O = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "address-display"
  }, [_c('div', {
    staticClass: "address-display__field"
  }, [_c('label', [_vm._v("Organisation name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": _vm.disabled ? null : 'Organisation name',
      "type": "text",
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.address.orgName,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "orgName", $$v);
      },
      expression: "address.orgName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "address-display__field"
  }, [_c('label', [_vm._v("Address line 1")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": _vm.disabled ? null : 'Address line 1',
      "type": "text",
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.address.line1,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "line1", $$v);
      },
      expression: "address.line1"
    }
  }), _vm._v(" "), _vm.isValidated && !_vm.address.line1 ? _c('div', {
    staticClass: "validation-message"
  }, [_vm._v("\n      Please enter your address.\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "address-display__field"
  }, [_c('label', [_vm._v("Address line 2")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": _vm.disabled ? null : 'Address line 2',
      "type": "text",
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.address.line2,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "line2", $$v);
      },
      expression: "address.line2"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "address-display__field"
  }, [_c('label', [_vm._v("Address line 3")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": _vm.disabled ? null : 'Address line 3',
      "type": "text",
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.address.line3,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "line3", $$v);
      },
      expression: "address.line3"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "address-display__field"
  }, [_c('label', [_vm._v("Town")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": _vm.disabled ? null : 'Town',
      "type": "text",
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.address.town,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "town", $$v);
      },
      expression: "address.town"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "address-display__field"
  }, [_c('label', [_vm._v("Region")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": _vm.disabled ? null : 'County',
      "type": "text",
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.address.region,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "region", $$v);
      },
      expression: "address.region"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "address-display__field"
  }, [_c('label', [_vm._v("Postcode")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": _vm.disabled ? null : 'Postcode',
      "type": "text",
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.address.postcode,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "postcode", $$v);
      },
      expression: "address.postcode"
    }
  }), _vm._v(" "), _vm.isValidated && !_vm.address.postcode ? _c('div', {
    staticClass: "validation-message"
  }, [_vm._v("\n      Please enter your postcode.\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "address-display__field"
  }, [_c('label', [_vm._v("Country")]), _vm._v(" "), _c('b-form-select', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.address.countryId,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "countryId", $$v);
      },
      expression: "address.countryId"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null,
      "selected": ""
    }
  }, [_vm._v("\n        Please select\n      ")]), _vm._v(" "), _vm._l(_vm.countries, function (country, index) {
    return _c('b-form-select-option', {
      key: index,
      attrs: {
        "value": country.countryId
      }
    }, [_vm._v("\n        " + _vm._s(country.countryName) + "\n      ")]);
  })], 2), _vm._v(" "), _vm.isValidated && !_vm.countrySelected ? _c('div', {
    staticClass: "validation-message"
  }, [_vm._v("\n      Please select your country.\n    ")]) : _vm._e()], 1)]);
};

var __vue_staticRenderFns__$O = [];
/* style */

var __vue_inject_styles__$Q = undefined;
/* scoped */

var __vue_scope_id__$Q = "data-v-89621622";
/* module identifier */

var __vue_module_identifier__$Q = undefined;
/* functional template */

var __vue_is_functional_template__$Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$O,
  staticRenderFns: __vue_staticRenderFns__$O
}, __vue_inject_styles__$Q, __vue_script__$Q, __vue_scope_id__$Q, __vue_is_functional_template__$Q, __vue_module_identifier__$Q, false, undefined, undefined, undefined);

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var script$z = {
  name: "AddressList",
  props: {
    /**
     * The selected address
     */
    value: {
      type: Object,
      default: function _default() {}
    },

    /**
     * The type of address to list (I or D)
     */
    addressTypeId: {
      type: String,
      default: null
    },

    /**
     * List of addresses to pick from
     */
    addressList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /**
     * Set to true to indicate addresses are being loaded
     */
    loading: {
      type: Boolean,
      default: false
    },

    /**
     * Turns on or off the free text search
     */
    enableFilter: {
      type: Boolean,
      default: false
    },

    /**
     * The placeholder to use for the filter text box
     */
    filterPlaceholder: {
      type: String,
      default: "Filter address list..."
    }
  },
  data: function data() {
    return {
      selectedAddress: {},
      addressFilter: ""
    };
  },
  computed: {
    /**
     * List heading
     */
    heading: function heading() {
      var _this$addressTypeId;

      return ((_this$addressTypeId = this.addressTypeId) === null || _this$addressTypeId === void 0 ? void 0 : _this$addressTypeId.toUpperCase()) === "D" ? "Delivery Addresses" : "Billing Addresses";
    },

    /**
     * List info text
     */
    info: function info() {
      var _this$addressTypeId2;

      return ((_this$addressTypeId2 = this.addressTypeId) === null || _this$addressTypeId2 === void 0 ? void 0 : _this$addressTypeId2.toUpperCase()) === "D" ? "You have the following delivery addresses associated with your account:" : "You have the following billing addresses associated with your account:";
    },

    /**
     * Take the raw address list and process it so we can use it
     * more efficiently
     */
    processedAddresses: function processedAddresses() {
      var _this$addressList;

      var result = null;

      if (((_this$addressList = this.addressList) === null || _this$addressList === void 0 ? void 0 : _this$addressList.length) > 0) {
        result = this.addressList.map(function (address) {
          var filterString = "";

          if (address) {
            var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9;

            // Build a filter string for this address
            filterString = (_ref = (_ref2 = filterString + address.orgName) !== null && _ref2 !== void 0 ? _ref2 : address.organisation) !== null && _ref !== void 0 ? _ref : "";
            filterString = (_ref3 = filterString + address.line1) !== null && _ref3 !== void 0 ? _ref3 : "";
            filterString = (_ref4 = filterString + address.line2) !== null && _ref4 !== void 0 ? _ref4 : "";
            filterString = (_ref5 = filterString + address.line3) !== null && _ref5 !== void 0 ? _ref5 : "";
            filterString = (_ref6 = filterString + address.town) !== null && _ref6 !== void 0 ? _ref6 : "";
            filterString = (_ref7 = filterString + address.region) !== null && _ref7 !== void 0 ? _ref7 : "";
            filterString = (_ref8 = filterString + address.postcode) !== null && _ref8 !== void 0 ? _ref8 : "";
            filterString = (_ref9 = filterString + address.country) !== null && _ref9 !== void 0 ? _ref9 : "";
          }

          return _objectSpread$4({
            __filterString: filterString.toLowerCase()
          }, address);
        });
      }

      return result;
    },

    /**
     * Filter the addresses
     */
    filteredAddresses: function filteredAddresses() {
      var _this$addressFilter, _this$selectedAddress, _this$processedAddres;

      var filter = (_this$addressFilter = this.addressFilter) === null || _this$addressFilter === void 0 ? void 0 : _this$addressFilter.toLowerCase();
      var selAddId = (_this$selectedAddress = this.selectedAddress) === null || _this$selectedAddress === void 0 ? void 0 : _this$selectedAddress.addressId;
      var result = filter === "" ? this.processedAddresses : (_this$processedAddres = this.processedAddresses) === null || _this$processedAddres === void 0 ? void 0 : _this$processedAddres.filter(function (address) {
        return address.__filterString.includes(filter) || address.addressId === selAddId;
      });
      return result || [];
    }
  },
  watch: {
    /**
     * Value has been changed so create a copy for internal use
     */
    value: {
      deep: true,
      immediate: true,
      handler: function handler(val) {
        if (!isEqual$1(val, this.selectedAddress)) {
          if (val) {
            this.selectedAddress = cloneDeep(val);
          } else {
            this.selectedAddress = {};
          }
        }
      }
    },

    /**
     * The selected address has changed so pass it to the parent component
     */
    selectedAddress: {
      deep: true,
      handler: function handler() {
        this.$emit("input", this.selectedAddress);
      }
    }
  },
  methods: {
    /**
     * Select an address at the specific index
     *
     * @param {Number} index The index of the address to select
     */
    onSelectAddress: function onSelectAddress(index) {
      var _this$addressList2;

      if ((((_this$addressList2 = this.addressList) === null || _this$addressList2 === void 0 ? void 0 : _this$addressList2.length) || 0) > index) {
        this.selectedAddress = this.addressList[index] || {};
        this.$emit("addressSelected");
      }
    },

    /**
     * Format an address so that only the parts of the address that exist are returned
     */
    formatAddress: function formatAddress(address) {
      var formattedAddress = "";

      if (address) {
        if (address.line1) {
          formattedAddress += address.line1;
        }

        formattedAddress = this.addAddressLine(formattedAddress, address.line2);
        formattedAddress = this.addAddressLine(formattedAddress, address.line3);
        formattedAddress = this.addAddressLine(formattedAddress, address.town);
        formattedAddress = this.addAddressLine(formattedAddress, address.region);
        formattedAddress = this.addAddressLine(formattedAddress, address.postcode);
        formattedAddress = this.addAddressLine(formattedAddress, address.country);
      }

      return formattedAddress;
    },

    /**
     * Add a line to the address string and add a newline character if needed
     */
    addAddressLine: function addAddressLine(addressString, addressLine) {
      var result = addressString;

      if (addressString && addressLine) {
        result += "<br>";
      }

      if (addressLine) {
        result += addressLine;
      }

      return result;
    }
  }
};

/* script */
var __vue_script__$R = script$z;
/* template */

var __vue_render__$P = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "address-list"
  }, [_c('div', {
    staticClass: "address-list__heading"
  }, [_vm._v("\n    " + _vm._s(_vm.heading) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "address-list__info"
  }, [_vm._v("\n    " + _vm._s(_vm.info) + "\n  ")]), _vm._v(" "), _vm.loading ? _c('div', {
    staticClass: "address-list__spinner"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1) : _c('div', {
    staticClass: "address-list__container"
  }, [_vm.enableFilter ? _c('div', {
    staticClass: "address-list__filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.addressFilter,
      expression: "addressFilter"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.filterPlaceholder,
      "type": "text"
    },
    domProps: {
      "value": _vm.addressFilter
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.addressFilter = $event.target.value;
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "address-list__list"
  }, _vm._l(_vm.filteredAddresses, function (address, index) {
    return _c('div', {
      key: index,
      staticClass: "address-list__address",
      class: _vm.selectedAddress.addressId === address.addressId ? 'address-list__address--selected' : null
    }, [_c('div', {
      staticClass: "address-list__detail"
    }, [address.orgName ? _c('div', {
      staticClass: "address-list__org-name"
    }, [_vm._v("\n            " + _vm._s(address.orgName) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "address-list__address-lines",
      domProps: {
        "innerHTML": _vm._s(_vm.formatAddress(address))
      }
    })]), _vm._v(" "), _vm.selectedAddress.addressId === address.addressId ? _c('div', {
      staticClass: "address-list__select address-list__select--selected"
    }, [_vm._v("\n          You are using this address\n        ")]) : _c('a', {
      staticClass: "address-list__select",
      attrs: {
        "href": "javascript:;",
        "type": "button",
        "variant": "accent-1"
      },
      on: {
        "click": function click($event) {
          return _vm.onSelectAddress(index);
        }
      }
    }, [_vm._v("\n          Use this address\n        ")])]);
  }), 0)])]);
};

var __vue_staticRenderFns__$P = [];
/* style */

var __vue_inject_styles__$R = undefined;
/* scoped */

var __vue_scope_id__$R = "data-v-3da0cd00";
/* module identifier */

var __vue_module_identifier__$R = undefined;
/* functional template */

var __vue_is_functional_template__$R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$P,
  staticRenderFns: __vue_staticRenderFns__$P
}, __vue_inject_styles__$R, __vue_script__$R, __vue_scope_id__$R, __vue_is_functional_template__$R, __vue_module_identifier__$R, false, undefined, undefined, undefined);

/* script */
var __vue_script__$S = script$z;
/* template */

var __vue_render__$Q = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "address-list"
  }, [_c('div', {
    staticClass: "address-list__heading"
  }, [_vm._v("\n    " + _vm._s(_vm.heading) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "address-list__info"
  }, [_vm._v("\n    " + _vm._s(_vm.info) + "\n  ")]), _vm._v(" "), _vm.loading ? _c('div', {
    staticClass: "address-list__spinner"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1) : _c('div', {
    staticClass: "address-list__container"
  }, [_vm.enableFilter ? _c('div', {
    staticClass: "address-list__filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.addressFilter,
      expression: "addressFilter"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.filterPlaceholder,
      "type": "text"
    },
    domProps: {
      "value": _vm.addressFilter
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.addressFilter = $event.target.value;
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "address-list__list"
  }, _vm._l(_vm.filteredAddresses, function (address, index) {
    return _c('div', {
      key: index,
      staticClass: "address-list__address",
      class: _vm.selectedAddress.addressId === address.addressId ? 'address-list__address--selected' : null
    }, [_c('div', {
      staticClass: "address-list__detail"
    }, [address.orgName ? _c('div', {
      staticClass: "address-list__org-name"
    }, [_vm._v("\n            " + _vm._s(address.orgName) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "address-list__address-lines",
      domProps: {
        "innerHTML": _vm._s(_vm.formatAddress(address))
      }
    })]), _vm._v(" "), _vm.selectedAddress.addressId === address.addressId ? _c('div', {
      staticClass: "address-list__select address-list__select--selected"
    }, [_vm._v("\n          You are using this address\n        ")]) : _c('a', {
      staticClass: "address-list__select",
      attrs: {
        "href": "javascript:;",
        "type": "button",
        "variant": "accent-1"
      },
      on: {
        "click": function click($event) {
          return _vm.onSelectAddress(index);
        }
      }
    }, [_vm._v("\n          Use this address\n        ")])]);
  }), 0)])]);
};

var __vue_staticRenderFns__$Q = [];
/* style */

var __vue_inject_styles__$S = undefined;
/* scoped */

var __vue_scope_id__$S = "data-v-3da0cd00";
/* module identifier */

var __vue_module_identifier__$S = undefined;
/* functional template */

var __vue_is_functional_template__$S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Q,
  staticRenderFns: __vue_staticRenderFns__$Q
}, __vue_inject_styles__$S, __vue_script__$S, __vue_scope_id__$S, __vue_is_functional_template__$S, __vue_module_identifier__$S, false, undefined, undefined, undefined);

var script$A = {
  name: "AddressSelector",
  components: {
    UberSearch: UberSearch,
    AddressDisplay: __vue_component__$5,
    AddressList: __vue_component__$S
  },
  props: {
    /**
     * The selected address
     */
    value: {
      type: Object,
      default: function _default() {}
    },

    /**
     * Type of address to select (I for Invoice, D for Delivery)
     */
    addressTypeId: {
      type: String,
      default: "I"
    },

    /**
     * Whether the selector is disabled or not
     */
    disabled: {
      type: Boolean,
      default: false
    },

    /**
     * The user type for the logged in web account, contains various settings
     */
    userType: {
      type: Object,
      default: function _default() {}
    },

    /**
     * List of countries for manual address entry
     */
    countries: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /**
     * A list of related addresses the user can choose from if their user type is restricted to
     * only allow addresses related to their web account org
     */
    relatedAddresses: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /**
     * Org ID for web account
     * Used for searching for default addresses
     */
    webAccountOrgId: {
      type: String,
      default: null
    },

    /**
     * When this is flipped to true it is a signal that it is safe to load
     * the address selector
     */
    loadNow: {
      type: Boolean,
      default: false
    },

    /**
     * When the address list is first loaded we will try and preselect an
     * address with this ID if it is in the list, otherwise we will preselect
     * the web accounts default org address
     */
    initialAddressId: {
      type: String,
      default: null
    },

    /**
     * A blacklist of address IDs that cannot be selected or added
     */
    addressIdBlacklist: {
      type: Array,
      default: null
    },

    /**
     * Turns on or off the free text search
     */
    enableFilter: {
      type: Boolean,
      default: false
    },

    /**
     * The placeholder to use for the filter text box
     */
    filterPlaceholder: {
      type: String,
      default: "Filter address list..."
    }
  },
  data: function data() {
    return {
      address: {},
      tmpAddress: {},
      addressList: [],
      addNew: false,
      showValidation: false,
      saving: false,
      loading: false
    };
  },
  computed: {
    /**
     * Dynamic classes based on component state
     */
    classes: function classes() {
      var classes = [];

      if (this.addNew) {
        classes.push("address-selector--add-new");
      }

      if (this.disabled) {
        classes.push("address-selector--disabled");
      }

      return classes;
    },

    /**
     * True if we have information to add an address
     */
    canAddAddress: function canAddAddress() {
      return !!(!this.addRelatedAddress && (this.canAddManualAddress || this.canSearchForAddress));
    },

    /**
     * All new addresses get added with this org type
     */
    orgTypeId: function orgTypeId() {
      var _this$userType;

      return (_this$userType = this.userType) === null || _this$userType === void 0 ? void 0 : _this$userType.defaultOrgTypeId;
    },

    /**
     * Whether we are set up to only allow related addresses to be added
     */
    addRelatedAddress: function addRelatedAddress() {
      var _this$relatedAddresse;

      return !!(((_this$relatedAddresse = this.relatedAddresses) === null || _this$relatedAddresse === void 0 ? void 0 : _this$relatedAddresse.length) > 0);
    },

    /**
     * Whether we can search for existing addresses
     */
    canSearchForAddress: function canSearchForAddress() {
      var _this$userType2, _this$userType3;

      return !!((_this$userType2 = this.userType) !== null && _this$userType2 !== void 0 && _this$userType2.allowOrgSearch || (_this$userType3 = this.userType) !== null && _this$userType3 !== void 0 && _this$userType3.allowExternalOrgSearch && this.orgTypeId);
    },

    /**
     * Whether we can add a manual address
     */
    canAddManualAddress: function canAddManualAddress() {
      var _this$addressTypeId, _this$userType4, _this$userType5, _this$userType7;

      var addressTypeId = (_this$addressTypeId = this.addressTypeId) === null || _this$addressTypeId === void 0 ? void 0 : _this$addressTypeId.toUpperCase();
      var allowManualAdditionOfAddress = addressTypeId === "I" ? (_this$userType4 = this.userType) === null || _this$userType4 === void 0 ? void 0 : _this$userType4.allowManualAdditionOfInvoiceAddress : (_this$userType5 = this.userType) === null || _this$userType5 === void 0 ? void 0 : _this$userType5.allowManualAdditionOfDeliveryAddress;

      if (allowManualAdditionOfAddress === null || allowManualAdditionOfAddress === undefined) {
        var _this$userType6;

        // No value set specifically for invoice or delivery address so fall back to the
        // old property that covered both
        allowManualAdditionOfAddress = (_this$userType6 = this.userType) === null || _this$userType6 === void 0 ? void 0 : _this$userType6.allowManualAdditionOfAddress;
      }

      return !!(!this.disabled && this.orgTypeId && ((_this$userType7 = this.userType) !== null && _this$userType7 !== void 0 && _this$userType7.allowManualOrgEntry || allowManualAdditionOfAddress));
    },

    /**
     * If we have an initial address ID then create a version of the address black list
     * without that address ID in it
     */
    blacklistIdsWithoutInitialId: function blacklistIdsWithoutInitialId() {
      var _this = this;

      var result = cloneDeep(this.addressIdBlacklist);

      if (this.addressIdBlacklist && this.initialAddressId) {
        result = result.filter(function (id) {
          return id !== _this.initialAddressId;
        });
      }

      return result;
    }
  },
  watch: {
    /**
     * Value has been changed so create a copy for internal use
     */
    value: {
      deep: true,
      immediate: true,
      handler: function handler(val) {
        if (!isEqual$1(val, this.address)) {
          this.address = cloneDeep(val);
        }
      }
    },

    /**
     * The address has changed so pass it to the parent component
     */
    address: {
      deep: true,
      handler: function handler() {
        this.$emit("input", this.address);
      }
    },

    /**
     * The address type has been changed so refresh and reset the address list
     */
    addressTypeId: function addressTypeId() {
      this.load();
    },

    /**
     * When load now is toggled to true, load the address selector data
     * This is so we can soontrol when it loads from the parent component
     */
    loadNow: function loadNow(val) {
      if (val) {
        this.load(this.initialAddressId);
      }
    }
  },
  methods: {
    /**
     * Load a list of existing addressses
     *
     * @param {GUID} selectAddressId If supplied then this address will be automatcially selected
     * @param {GUID} includeSopAddressId If this is provided then make sure an address with this
     * SOP Address ID is returned and not removed as a duplicate
     */
    load: function load(selectAddressId, includeSopAddressId) {
      var _this2 = this;

      if (this.addRelatedAddress) {
        // The user is only allowed to select related addresses so simply
        // give them a list of releated addresses to select from
        this.addressList = cloneDeep(this.relatedAddresses);

        if (this.initialAddressId) {
          this.selectAddressById(this.initialAddressId);
        } else {
          this.selectDefaultAddress();
        }

        this.moveSelectedAddressToTop();
      } else if (this.addressTypeId) {
        // We are using SOP Addresses so load them from the server
        this.loading = true;
        AddressResource.getSopAddresses(null, null, this.addressTypeId, includeSopAddressId, this.blacklistIdsWithoutInitialId).then(function (response) {
          _this2.addressList = response.data;
        }).catch(function () {
          _this2.addressList = [];
        }).finally(function () {
          _this2.loading = false;

          if (selectAddressId) {
            // Select the address with the matching ID if it exists
            _this2.selectAddressById(selectAddressId);
          } else {
            // Select the default address
            _this2.selectDefaultAddress();
          }

          _this2.moveSelectedAddressToTop();

          _this2.$emit("loaded");
        });
      }
    },

    /**
     * Try and select an address by SOP Address ID or Org Address ID
     *
     * @param {GUID} addressId The address ID to select
     */
    selectAddressById: function selectAddressById(addressId) {
      var _this$addressList;

      if (addressId && ((_this$addressList = this.addressList) === null || _this$addressList === void 0 ? void 0 : _this$addressList.length) > 0) {
        // Select the address with the matching ID if it exists
        this.address = this.addressList.find(function (address) {
          return address.sopAddressId === addressId;
        }) || null;

        if (!this.address) {
          // No address by SOP Address ID was found, so try Org Address ID
          this.address = this.addressList.find(function (address) {
            return address.addressId === addressId;
          }) || null;
        }
      }

      if (!this.address) {
        this.address = {};
      }
    },

    /**
     * Try and select the default address
     */
    selectDefaultAddress: function selectDefaultAddress() {
      var _this$addressList2;

      if (((_this$addressList2 = this.addressList) === null || _this$addressList2 === void 0 ? void 0 : _this$addressList2.length) > 0) {
        // Find the address tagged as default
        this.address = this.addressList.find(function (address) {
          return address.isDefault;
        }) || null;

        if (!this.address) {
          var _this$webAccountOrgId;

          // No address found, so find one that matches the web account
          // org ID
          var webAccountOrgId = (_this$webAccountOrgId = this.webAccountOrgId) === null || _this$webAccountOrgId === void 0 ? void 0 : _this$webAccountOrgId.toUpperCase();
          this.address = this.addressList.find(function (address) {
            var _address$orgId;

            var addressOrgId = (_address$orgId = address.orgId) === null || _address$orgId === void 0 ? void 0 : _address$orgId.toUpperCase();
            return addressOrgId === webAccountOrgId;
          }) || null;
        }

        if (!this.address) {
          // Still no address found, so just pick the first one
          var _this$addressList3 = _slicedToArray(this.addressList, 1);

          this.address = _this$addressList3[0];
        }
      }

      if (!this.address) {
        this.address = {};
      }
    },

    /**
     * Move the selected address to the top of the list
     */
    moveSelectedAddressToTop: function moveSelectedAddressToTop() {
      var _this$address, _this$addressList4;

      if ((_this$address = this.address) !== null && _this$address !== void 0 && _this$address.addressId && ((_this$addressList4 = this.addressList) === null || _this$addressList4 === void 0 ? void 0 : _this$addressList4.length) > 0) {
        // Find the index of the selected address in the list
        var addressId = this.address.addressId;
        var addressIndex = this.addressList.findIndex(function (address) {
          return address.addressId === addressId;
        });

        if (addressIndex >= 0) {
          // Remove the selected address form the list and re-add it to the front
          this.addressList.splice(addressIndex, 1);
          this.addressList = [this.address].concat(_toConsumableArray(this.addressList));
        }
      }
    },

    /**
     * Switch to adding a new address
     */
    onAddNew: function onAddNew() {
      // Store a reference to what is currently selected then clear
      // the current selection
      this.tmpAddress = this.address;
      this.address = {};
      this.showValidation = false;
      this.addNew = true;
      this.$emit("addNew");
    },

    /**
     * Cancel adding an address
     */
    onCancelAdd: function onCancelAdd() {
      // Restore the previously selected address
      this.address = this.tmpAddress;
      this.showValidation = false;
      this.addNew = false;
      this.$emit("cancelAdd");
    },

    /**
     * The user has edited the address. We need to blank out ID values so that it will
     * force a new address to be saved
     */
    onManualAddressChanged: function onManualAddressChanged() {
      var _this$address2;

      if ((_this$address2 = this.address) !== null && _this$address2 !== void 0 && _this$address2.orgId) {
        this.address.orgId = null;
        this.address.addressId = null;
        this.address.sopAddressId = null;
      }
    },

    /**
     * When a new address is selected from the list, make sure we are not in "Add New" mode
     */
    onAddressSelected: function onAddressSelected() {
      this.showValidation = false;
      this.addNew = false;
      this.$emit("selected");
    },

    /**
     * A related address has been selected
     *
     * @param {object} selectedAddress the new releated address to use
     */
    onRelatedAddressSelected: function onRelatedAddressSelected(selectedAddress) {
      if (!isEqual$1(this.address, selectedAddress)) {
        if (selectedAddress) {
          this.address = cloneDeep(selectedAddress);
        } else {
          this.address = {};
        }
      }
    },

    /**
     * Save the new address
     */
    onSave: function onSave() {
      var _this3 = this;

      if (!this.saving && this.validate()) {
        this.prepareAddressForSaving();
        this.saving = true;
        AddressResource.saveSopAddress(this.address).then(function (response) {
          if (response.data) {
            _this3.load(response.data, response.data);

            _this3.addNew = false;

            _this3.$emit("saved");
          }
        }).catch(function () {// Not much to do;
        }).finally(function () {
          _this3.saving = false; // Move the newly added address to top top of the list

          _this3.moveSelectedAddressToTop();
        });
      }
    },

    /**
     * Validate the address we have
     */
    validate: function validate() {
      this.showValidation = true;
      return this.address.line1 && this.address.countryId && Number(this.address.countryId) !== 0 && this.address.postcode;
    },

    /**
     * Set additional properties on the address before it is saved
     */
    prepareAddressForSaving: function prepareAddressForSaving() {
      if (this.address) {
        // Set the type of address (I or D)
        this.address.addressType = this.addressTypeId;

        if (!this.address.orgId) {
          // If we have no OrgId then we will create a new org, so we need
          // to supply an organisation type
          this.address.orgTypeId = this.orgTypeId;
        }

        if (!this.address.orgName) {
          // If org name is does not exist, then make sure it is set
          // to an empty string
          this.address.orgName = "";
        }
      }
    }
  }
};

/* script */
var __vue_script__$T = script$A;
/* template */

var __vue_render__$R = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "address-selector",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "address-selector__details"
  }, [_vm.addNew && !_vm.disabled ? [_vm.canSearchForAddress ? _c('uber-search', {
    staticClass: "address-selector__search",
    attrs: {
      "show-validation": _vm.showValidation,
      "user-type": _vm.userType
    },
    model: {
      value: _vm.address,
      callback: function callback($$v) {
        _vm.address = $$v;
      },
      expression: "address"
    }
  }) : _c('label', {
    staticClass: "address-selector__manual"
  }, [_vm._v("\n        Please enter the address details below\n      ")])] : _vm._e(), _vm._v(" "), _c('address-display', {
    staticClass: "address-selector__current",
    attrs: {
      "disabled": !_vm.canAddManualAddress,
      "show-validation": _vm.showValidation,
      "countries": _vm.countries
    },
    on: {
      "addressChanged": _vm.onManualAddressChanged
    },
    model: {
      value: _vm.address,
      callback: function callback($$v) {
        _vm.address = $$v;
      },
      expression: "address"
    }
  }), _vm._v(" "), _vm.addNew && !_vm.disabled ? _c('div', {
    staticClass: "address-selector__buttons"
  }, [_c('button', {
    staticClass: "address-selector__save btn btn-primary",
    attrs: {
      "variant": "accent-1"
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm.saving ? [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })] : [_vm._v("\n          Save\n        ")]], 2), _vm._v(" "), _c('button', {
    staticClass: "address-selector__cancel btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onCancelAdd
    }
  }, [_vm._v("\n        Cancel\n      ")])]) : _vm._e()], 2), _vm._v(" "), !_vm.disabled ? _c('div', {
    staticClass: "address-selector__available"
  }, [_c('address-list', {
    staticClass: "address-selector__available-addresses",
    attrs: {
      "address-list": _vm.addressList,
      "address-type-id": _vm.addressTypeId,
      "loading": _vm.loading,
      "enable-filter": _vm.enableFilter,
      "filter-placeholder": _vm.filterPlaceholder
    },
    on: {
      "addressSelected": _vm.onAddressSelected
    },
    model: {
      value: _vm.address,
      callback: function callback($$v) {
        _vm.address = $$v;
      },
      expression: "address"
    }
  }), _vm._v(" "), _vm.canAddAddress ? _c('button', {
    staticClass: "address-selector__add-new btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onAddNew
    }
  }, [_vm._v("\n      Add new address\n    ")]) : _vm._e()], 1) : _vm._e()]);
};

var __vue_staticRenderFns__$R = [];
/* style */

var __vue_inject_styles__$T = undefined;
/* scoped */

var __vue_scope_id__$T = "data-v-64d946fa";
/* module identifier */

var __vue_module_identifier__$T = undefined;
/* functional template */

var __vue_is_functional_template__$T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$R,
  staticRenderFns: __vue_staticRenderFns__$R
}, __vue_inject_styles__$T, __vue_script__$T, __vue_scope_id__$T, __vue_is_functional_template__$T, __vue_module_identifier__$T, false, undefined, undefined, undefined);

/* script */
var __vue_script__$U = script$i;
/* template */

var __vue_render__$S = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "alternative-person"
  }, [!_vm.alwaysShow ? _c('button', {
    staticClass: "alternative-person__form-toggle",
    on: {
      "click": _vm.toggleForm
    }
  }, [_vm._v("\n    " + _vm._s(_vm.internalButtonText) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm.showForm || _vm.alwaysShow ? [_c('div', {
    staticClass: "alternative-person__container"
  }, [_c('div', {
    staticClass: "alternative-person__form"
  }, [_vm.hasAccountDetails ? _c('div', {
    staticClass: "alternative-person__use-account-details"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.useAccountDetails,
      expression: "useAccountDetails"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.useAccountDetails) ? _vm._i(_vm.useAccountDetails, null) > -1 : _vm.useAccountDetails
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.useAccountDetails,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && (_vm.useAccountDetails = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.useAccountDetails = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.useAccountDetails = $$c;
        }
      }
    }
  }), _vm._v("\n            " + _vm._s(_vm.useAccountDetailsText) + "\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Title")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.person.title,
      callback: function callback($$v) {
        _vm.$set(_vm.person, "title", $$v);
      },
      expression: "person.title"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("First name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.person.firstName,
      callback: function callback($$v) {
        _vm.$set(_vm.person, "firstName", $$v);
      },
      expression: "person.firstName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Last name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.person.surname,
      callback: function callback($$v) {
        _vm.$set(_vm.person, "surname", $$v);
      },
      expression: "person.surname"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Email address")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "email"
    },
    model: {
      value: _vm.person.email,
      callback: function callback($$v) {
        _vm.$set(_vm.person, "email", $$v);
      },
      expression: "person.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Telephone" + _vm._s(_vm.telephoneMandatory ? "*" : ""))]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "tel"
    },
    model: {
      value: _vm.person.telephone,
      callback: function callback($$v) {
        _vm.$set(_vm.person, "telephone", $$v);
      },
      expression: "person.telephone"
    }
  })], 1)])]), _vm._v(" "), _vm.$slots.altPersonInfo ? _c('div', {
    staticClass: "alternative-person__info"
  }, [_vm._t("altPersonInfo")], 2) : _vm._e()]), _vm._v(" "), _vm.$slots.validation ? _c('div', {
    staticClass: "alternative-person__validation"
  }, [_vm._t("validation")], 2) : _vm._e(), _vm._v(" "), _vm.$slots.footer ? _c('div', {
    staticClass: "alternative-person__footer"
  }, [_vm._t("footer")], 2) : _vm._e()] : _vm._e()], 2);
};

var __vue_staticRenderFns__$S = [];
/* style */

var __vue_inject_styles__$U = undefined;
/* scoped */

var __vue_scope_id__$U = "data-v-d534ee24";
/* module identifier */

var __vue_module_identifier__$U = undefined;
/* functional template */

var __vue_is_functional_template__$U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$S,
  staticRenderFns: __vue_staticRenderFns__$S
}, __vue_inject_styles__$U, __vue_script__$U, __vue_scope_id__$U, __vue_is_functional_template__$U, __vue_module_identifier__$U, false, undefined, undefined, undefined);

var script$B = {
  name: "Postage",
  props: {
    /**
     * The selected carriage
     */
    value: {
      type: Number,
      default: null
    },

    /**
     * List of carriage options to choose from
     */
    carriageItems: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /**
     * The post code we are posting to
     */
    postcode: {
      type: String,
      default: null
    },

    /**
     * Currency for carriage
     */
    currency: {
      type: String,
      default: "GBP"
    },

    /**
     * Locale for carriage
     */
    locale: {
      type: String,
      default: "en-GB"
    }
  },
  data: function data() {
    return {
      selectedCarriageId: null
    };
  },
  computed: {
    /**
     * Postage info text
     */
    info: function info() {
      return this.postcode ? "You have the following delivery options to ".concat(this.postcode, ":") : "You have the following delivery options:";
    }
  },
  watch: {
    /**
     * Value has been changed so create a copy for internal use
     */
    value: {
      deep: true,
      immediate: true,
      handler: function handler(val) {
        if (val !== this.selectedCarriageId) {
          this.selectedCarriageId = val;
        }
      }
    },

    /**
     * The carriage has changed so pass it to the parent component
     */
    selectedCarriageId: {
      deep: true,
      handler: function handler() {
        this.$emit("input", this.selectedCarriageId);
      }
    }
  },
  methods: {
    /**
     * Expose the "renderPrice" method so that is can be used in the template
     *
     * @param {decimal} price The price to format
     * @param {string} currency The currencty to use
     * @param {string} locale The locale to use
     */
    formatPrice: function formatPrice(price, currency, locale) {
      return renderPrice(price || 0, currency, locale);
    }
  }
};

/* script */
var __vue_script__$V = script$B;
/* template */

var __vue_render__$T = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "carriage"
  }, [_c('div', {
    staticClass: "carriage__info"
  }, [_vm._v("\n    " + _vm._s(_vm.info) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "carriage__items"
  }, _vm._l(_vm.carriageItems, function (carriage, index) {
    return _c('label', {
      key: index,
      staticClass: "carriage__item"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.selectedCarriageId,
        expression: "selectedCarriageId"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": carriage.id,
        "checked": _vm._q(_vm.selectedCarriageId, carriage.id)
      },
      on: {
        "change": function change($event) {
          _vm.selectedCarriageId = carriage.id;
        }
      }
    }), _vm._v("\n      (" + _vm._s(_vm.formatPrice(carriage.priceIncVat, _vm.currency, _vm.locale)) + ") \n      " + _vm._s(carriage.description) + "\n    ")]);
  }), 0)]);
};

var __vue_staticRenderFns__$T = [];
/* style */

var __vue_inject_styles__$V = undefined;
/* scoped */

var __vue_scope_id__$V = "data-v-42dac0ae";
/* module identifier */

var __vue_module_identifier__$V = undefined;
/* functional template */

var __vue_is_functional_template__$V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$T,
  staticRenderFns: __vue_staticRenderFns__$T
}, __vue_inject_styles__$V, __vue_script__$V, __vue_scope_id__$V, __vue_is_functional_template__$V, __vue_module_identifier__$V, false, undefined, undefined, undefined);

var fieldMixin = {
  props: {
    id: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    shouldFocus: {
      type: Boolean,
      default: false
    },
    showValidation: {
      type: Boolean,
      default: false
    },
    preValues: {
      type: Object,
      default: function _default() {}
    },
    mandatory: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes: function classes() {
      var result = [];

      if (this.showValidation && this.mandatory && !this.value) {
        result.push("field--invalid");
      }

      return result;
    }
  }
};

//
var script$C = {
  name: "TextboxField",
  mixins: [fieldMixin],
  data: function data() {
    return {
      mutable: ""
    };
  },
  computed: {
    inputType: function inputType() {
      var result = "text";

      if (this.dataType === "INTEGER") {
        result = "number";
      }

      return result;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(val) {
        this.mutable = val;
      }
    },
    mutable: {
      handler: function handler(val) {
        this.$emit("input", val);
      }
    }
  },
  mounted: function mounted() {
    if (this.shouldFocus) {
      this.$refs.focus.focus();
    }
  }
};

/* script */
var __vue_script__$W = script$C;
/* template */

var __vue_render__$U = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "field--string",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "field__" + _vm.fieldId
    }
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n      "), _vm.mandatory ? _c('span', {
    staticClass: "mandatory-marker"
  }, [_vm._v("\n        *\n      ")]) : _vm._e()]), _vm._v(" "), _vm.inputType === 'checkbox' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.mutable,
      expression: "mutable"
    }],
    ref: "focus",
    staticClass: "form-control",
    attrs: {
      "id": "field__" + _vm.fieldId,
      "data-hj-suppress": "",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.mutable) ? _vm._i(_vm.mutable, null) > -1 : _vm.mutable
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.mutable,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && (_vm.mutable = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.mutable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.mutable = $$c;
        }
      }
    }
  }) : _vm.inputType === 'radio' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.mutable,
      expression: "mutable"
    }],
    ref: "focus",
    staticClass: "form-control",
    attrs: {
      "id": "field__" + _vm.fieldId,
      "data-hj-suppress": "",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.mutable, null)
    },
    on: {
      "change": function change($event) {
        _vm.mutable = null;
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.mutable,
      expression: "mutable"
    }],
    ref: "focus",
    staticClass: "form-control",
    attrs: {
      "id": "field__" + _vm.fieldId,
      "data-hj-suppress": "",
      "type": _vm.inputType
    },
    domProps: {
      "value": _vm.mutable
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.mutable = $event.target.value;
      }
    }
  })])]);
};

var __vue_staticRenderFns__$U = [];
/* style */

var __vue_inject_styles__$W = undefined;
/* scoped */

var __vue_scope_id__$W = "data-v-58000b72";
/* module identifier */

var __vue_module_identifier__$W = undefined;
/* functional template */

var __vue_is_functional_template__$W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$U,
  staticRenderFns: __vue_staticRenderFns__$U
}, __vue_inject_styles__$W, __vue_script__$W, __vue_scope_id__$W, __vue_is_functional_template__$W, __vue_module_identifier__$W, false, undefined, undefined, undefined);

//
var script$D = {
  name: "TextareaField",
  mixins: [fieldMixin],
  data: function data() {
    return {
      mutable: ""
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(val) {
        this.mutable = val;
      }
    },
    mutable: {
      handler: function handler(val) {
        this.$emit("input", val);
      }
    }
  },
  mounted: function mounted() {
    if (this.shouldFocus) {
      this.$refs.focus.focus();
    }
  }
};

/* script */
var __vue_script__$X = script$D;
/* template */

var __vue_render__$V = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "field--string",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "field__" + _vm.fieldId
    }
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n      "), _vm.mandatory ? _c('span', {
    staticClass: "mandatory-marker"
  }, [_vm._v("\n        *\n      ")]) : _vm._e()]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.mutable,
      expression: "mutable"
    }],
    ref: "focus",
    staticClass: "form-control",
    attrs: {
      "id": "field__" + _vm.fieldId,
      "data-hj-suppress": ""
    },
    domProps: {
      "value": _vm.mutable
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.mutable = $event.target.value;
      }
    }
  })])]);
};

var __vue_staticRenderFns__$V = [];
/* style */

var __vue_inject_styles__$X = undefined;
/* scoped */

var __vue_scope_id__$X = "data-v-bf8fc892";
/* module identifier */

var __vue_module_identifier__$X = undefined;
/* functional template */

var __vue_is_functional_template__$X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$V,
  staticRenderFns: __vue_staticRenderFns__$V
}, __vue_inject_styles__$X, __vue_script__$X, __vue_scope_id__$X, __vue_is_functional_template__$X, __vue_module_identifier__$X, false, undefined, undefined, undefined);

// 7.3.20 SpeciesConstructor(O, defaultConstructor)


var SPECIES$4 = _wks('species');
var _speciesConstructor$1 = function (O, D) {
  var C = _anObject(O).constructor;
  var S;
  return C === undefined || (S = _anObject(C)[SPECIES$4]) == undefined ? D : _aFunction(S);
};

var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX$1 = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !_fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
_fixReWks('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!_isRegexp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = _regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX$1];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX$1] === match.index) separatorCopy[LAST_INDEX$1]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = _anObject(regexp);
      var S = String(this);
      var C = _speciesConstructor$1(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return _regexpExecAbstract(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = _regexpExecAbstract(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(_toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = _advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});

var isEnum$1 = _objectPie.f;
var _objectToArray = function (isEntries) {
  return function (it) {
    var O = _toIobject(it);
    var keys = _objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!_descriptors || isEnum$1.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

// https://github.com/tc39/proposal-object-values-entries

var $entries = _objectToArray(true);

_export(_export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});

var script$E = {
  name: "CheckboxListField",
  mixins: [fieldMixin],
  data: function data() {
    return {
      mutable: "",
      checkboxValues: {}
    };
  },
  computed: {
    options: function options() {
      var _this = this;

      var result = [];

      if (this.lookupValues != null) {
        Object.keys(this.lookupValues).forEach(function (x) {
          result.push({
            value: x,
            label: _this.lookupValues[x]
          });
        });
      }

      return result;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(val) {
        this.mutable = val;
      }
    },
    checkboxValues: {
      deep: true,
      handler: function handler(val) {
        var wanted = [];
        Object.entries(val).forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              key = _ref2[0],
              value = _ref2[1];

          if (value) {
            wanted.push(key);
          }
        });
        this.mutable = wanted.join(",");
      }
    },
    mutable: {
      immediate: true,
      handler: function handler(val) {
        var _this2 = this;

        if (val) {
          var split = val.split(",");
          split.forEach(function (x) {
            _this2.$set(_this2.checkboxValues, x, true);
          });
        }

        this.$emit("input", val);
      }
    }
  },
  mounted: function mounted() {
    if (this.shouldFocus && typeof this.$refs.focus.focus === "function") {
      this.$refs.focus.focus();
    }
  }
};

/* script */
var __vue_script__$Y = script$E;
/* template */

var __vue_render__$W = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "field--checkbox-list",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "field__" + _vm.fieldId
    }
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n      "), _vm.mandatory ? _c('span', {
    staticClass: "mandatory-marker"
  }, [_vm._v("\n        *\n      ")]) : _vm._e()]), _vm._v(" "), _vm._l(_vm.options, function (option) {
    return _c('div', {
      key: option.value
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.checkboxValues[option.value],
        expression: "checkboxValues[option.value]"
      }],
      ref: "focus",
      refInFor: true,
      attrs: {
        "id": "field__" + _vm.fieldId + "__" + option.value,
        "type": "checkbox",
        "data-hj-suppress": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.checkboxValues[option.value]) ? _vm._i(_vm.checkboxValues[option.value], null) > -1 : _vm.checkboxValues[option.value]
      },
      on: {
        "change": function change($event) {
          var $$a = _vm.checkboxValues[option.value],
              $$el = $event.target,
              $$c = $$el.checked ? true : false;

          if (Array.isArray($$a)) {
            var $$v = null,
                $$i = _vm._i($$a, $$v);

            if ($$el.checked) {
              $$i < 0 && _vm.$set(_vm.checkboxValues, option.value, $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(_vm.checkboxValues, option.value, $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(_vm.checkboxValues, option.value, $$c);
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "field-label",
      attrs: {
        "for": "field__" + _vm.fieldId + "__" + option.value
      }
    }, [_vm._v("\n        " + _vm._s(option.label) + "\n      ")])]);
  })], 2)]);
};

var __vue_staticRenderFns__$W = [];
/* style */

var __vue_inject_styles__$Y = undefined;
/* scoped */

var __vue_scope_id__$Y = "data-v-7d589dd6";
/* module identifier */

var __vue_module_identifier__$Y = undefined;
/* functional template */

var __vue_is_functional_template__$Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$W,
  staticRenderFns: __vue_staticRenderFns__$W
}, __vue_inject_styles__$Y, __vue_script__$Y, __vue_scope_id__$Y, __vue_is_functional_template__$Y, __vue_module_identifier__$Y, false, undefined, undefined, undefined);

var script$F = {
  name: "DropdownField",
  components: {
    VSelect: VSelect
  },
  mixins: [fieldMixin],
  data: function data() {
    return {
      mutable: null
    };
  },
  computed: {
    multiple: function multiple() {
      var result = false;

      if (this.inputMethod === "MULTISELECT") {
        result = true;
      }

      return result;
    },
    options: function options() {
      var _this = this;

      var result = [];

      if (this.lookupValues != null) {
        Object.keys(this.lookupValues).forEach(function (x) {
          result.push({
            value: x,
            label: _this.lookupValues[x]
          });
        });
      }

      return result;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(val) {
        var ids = "".concat(val).split(",");
        var matches = this.options.filter(function (x) {
          return ids.some(function (y) {
            return y === x.value;
          });
        });

        if (matches) {
          if (this.multiple) {
            this.mutable = matches;
          } else {
            var _matches = _slicedToArray(matches, 1);

            this.mutable = _matches[0];
          }
        } else {
          this.mutable = null;
        }
      }
    },
    mutable: function mutable(val) {
      var result = "";

      if (Array.isArray(val)) {
        result = val.map(function (x) {
          return x.value;
        }).join(",");
      } else if (val) {
        result = val.value;
      }

      this.$emit("input", result);
    }
  },
  mounted: function mounted() {
    if (this.shouldFocus && typeof this.$refs.focus.focus === "function") {
      this.$refs.focus.focus();
    }
  }
};

/* script */
var __vue_script__$Z = script$F;
/* template */

var __vue_render__$X = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "field--string",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "field__" + _vm.fieldId
    }
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n      "), _vm.mandatory ? _c('span', {
    staticClass: "mandatory-marker"
  }, [_vm._v("\n        *\n      ")]) : _vm._e()]), _vm._v(" "), _c('VSelect', {
    ref: "focus",
    attrs: {
      "id": "field__" + _vm.fieldId,
      "multiple": _vm.multiple,
      "options": _vm.options,
      "data-hj-suppress": ""
    },
    model: {
      value: _vm.mutable,
      callback: function callback($$v) {
        _vm.mutable = $$v;
      },
      expression: "mutable"
    }
  })], 1)]);
};

var __vue_staticRenderFns__$X = [];
/* style */

var __vue_inject_styles__$Z = undefined;
/* scoped */

var __vue_scope_id__$Z = "data-v-db1c7962";
/* module identifier */

var __vue_module_identifier__$Z = undefined;
/* functional template */

var __vue_is_functional_template__$Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$X,
  staticRenderFns: __vue_staticRenderFns__$X
}, __vue_inject_styles__$Z, __vue_script__$Z, __vue_scope_id__$Z, __vue_is_functional_template__$Z, __vue_module_identifier__$Z, false, undefined, undefined, undefined);

//
var script$G = {
  name: "CheckboxField",
  mixins: [fieldMixin],
  data: function data() {
    return {
      mutable: ""
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(val) {
        this.mutable = val;
      }
    },
    mutable: {
      handler: function handler(val) {
        this.$emit("input", val);
      }
    }
  }
};

/* script */
var __vue_script__$_ = script$G;
/* template */

var __vue_render__$Y = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "field--string",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "field__" + _vm.fieldId
    }
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n      "), _vm.mandatory ? _c('span', {
    staticClass: "mandatory-marker"
  }, [_vm._v("\n        *\n      ")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.mutable,
      expression: "mutable"
    }],
    ref: "focus",
    staticClass: "form-control",
    attrs: {
      "id": "field__" + _vm.fieldId,
      "type": "checkbox",
      "true-value": "1",
      "false-value": "0",
      "data-hj-suppress": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.mutable) ? _vm._i(_vm.mutable, null) > -1 : _vm._q(_vm.mutable, "1")
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.mutable,
            $$el = $event.target,
            $$c = $$el.checked ? "1" : "0";

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && (_vm.mutable = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.mutable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.mutable = $$c;
        }
      }
    }
  })])]);
};

var __vue_staticRenderFns__$Y = [];
/* style */

var __vue_inject_styles__$_ = undefined;
/* scoped */

var __vue_scope_id__$_ = "data-v-07a1caa3";
/* module identifier */

var __vue_module_identifier__$_ = undefined;
/* functional template */

var __vue_is_functional_template__$_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Y,
  staticRenderFns: __vue_staticRenderFns__$Y
}, __vue_inject_styles__$_, __vue_script__$_, __vue_scope_id__$_, __vue_is_functional_template__$_, __vue_module_identifier__$_, false, undefined, undefined, undefined);

var script$H = {
  name: "CheckboxListField",
  mixins: [fieldMixin],
  data: function data() {
    return {
      mutable: "",
      checkboxValues: {}
    };
  },
  computed: {
    options: function options() {
      var _this = this;

      var result = [];

      if (this.lookupValues != null) {
        Object.keys(this.lookupValues).forEach(function (x) {
          result.push({
            value: x,
            label: _this.lookupValues[x]
          });
        });
      }

      return result;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(val) {
        this.mutable = val;
      }
    },
    checkboxValues: {
      deep: true,
      handler: function handler(val) {
        var wanted = [];
        Object.entries(val).forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              key = _ref2[0],
              value = _ref2[1];

          if (value) {
            wanted.push(key);
          }
        });
        this.mutable = wanted.join(",");
      }
    },
    mutable: {
      immediate: true,
      handler: function handler(val) {
        var _this2 = this;

        if (val) {
          var split = val.split(",");
          split.forEach(function (x) {
            _this2.$set(_this2.checkboxValues, x, true);
          });
        }

        this.$emit("input", val);
      }
    }
  },
  mounted: function mounted() {
    if (this.shouldFocus && typeof this.$refs.focus.focus === "function") {
      this.$refs.focus.focus();
    }
  }
};

/* script */
var __vue_script__$$ = script$H;
/* template */

var __vue_render__$Z = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "field--checkbox-list",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "field__" + _vm.fieldId
    }
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n      "), _vm.mandatory ? _c('span', {
    staticClass: "mandatory-marker"
  }, [_vm._v("\n        *\n      ")]) : _vm._e()]), _vm._v(" "), _vm._l(_vm.options, function (option) {
    return _c('div', {
      key: option.value
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.checkboxValues[option.value],
        expression: "checkboxValues[option.value]"
      }],
      ref: "focus",
      refInFor: true,
      attrs: {
        "id": "field__" + _vm.fieldId + "__" + option.value,
        "type": "checkbox",
        "data-hj-suppress": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.checkboxValues[option.value]) ? _vm._i(_vm.checkboxValues[option.value], null) > -1 : _vm.checkboxValues[option.value]
      },
      on: {
        "change": function change($event) {
          var $$a = _vm.checkboxValues[option.value],
              $$el = $event.target,
              $$c = $$el.checked ? true : false;

          if (Array.isArray($$a)) {
            var $$v = null,
                $$i = _vm._i($$a, $$v);

            if ($$el.checked) {
              $$i < 0 && _vm.$set(_vm.checkboxValues, option.value, $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(_vm.checkboxValues, option.value, $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(_vm.checkboxValues, option.value, $$c);
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "field-label",
      attrs: {
        "for": "field__" + _vm.fieldId + "__" + option.value
      }
    }, [_vm._v("\n        " + _vm._s(option.label) + "\n      ")])]);
  })], 2)]);
};

var __vue_staticRenderFns__$Z = [];
/* style */

var __vue_inject_styles__$$ = undefined;
/* scoped */

var __vue_scope_id__$$ = "data-v-09a165f6";
/* module identifier */

var __vue_module_identifier__$$ = undefined;
/* functional template */

var __vue_is_functional_template__$$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Z,
  staticRenderFns: __vue_staticRenderFns__$Z
}, __vue_inject_styles__$$, __vue_script__$$, __vue_scope_id__$$, __vue_is_functional_template__$$, __vue_module_identifier__$$, false, undefined, undefined, undefined);

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var script$I = {
  name: "MetadataPage",
  components: {
    TextboxField: __vue_component__$W,
    // : () => import( "@/components/checkout/Metadata/Fields/TextboxField.vue" ),
    TextareaField: __vue_component__$X,
    // : () => import( "@/components/checkout/Metadata/Fields/TextareaField.vue" ),
    CurrencyField: __vue_component__$Y,
    // : () => import( "@/components/checkout/Metadata/Fields/CurrencyField.vue" ),
    DropdownField: __vue_component__$Z,
    // : () => import( "@/components/checkout/Metadata/Fields/DropdownField.vue" ),
    CheckboxField: __vue_component__$_,
    // : () => import( "@/components/checkout/Metadata/Fields/CheckboxField.vue" ),
    CheckboxListField: __vue_component__$$ // : () => import( "@/components/checkout/Metadata/Fields/CheckboxListField.vue" ),

  },
  props: {
    id: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: "Untitled"
    },
    value: {
      type: [Object, Array],
      default: function _default() {
        return {};
      },
      validator: function validator(val) {
        if (process.env.NODE_ENV !== "production") {
          console.log("Meta value: ", val);
        }

        var result;
        var schema = ["containerId", "containerSortOrder", "dataType", "fieldId", "fieldName", "fieldSortOrder", "gridValue", "inputMethod", "label", "lookupValues", "mandatory", "showOnEcommerceSite", "productDisplayName", "value"];

        var isMetadata = function isMetadata(metadata) {
          return schema.every(function (field) {
            return Object.keys(metadata).includes(field);
          });
        };

        if (val instanceof Array && val.length) {
          result = val.every(isMetadata);
        } else {
          result = isMetadata(val);
        }

        return result;
      }
    },
    showValidation: {
      type: Boolean,
      default: false
    },

    /**
     * Message to display at top of page
     */
    message: {
      type: String,
      default: "Please provide the details below to complete your enquiry."
    }
  },
  data: function data() {
    return {
      mutable: {
        id: null,
        name: "Untitled",
        metadata: undefined
      }
    };
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler: function handler(val) {
        this.setMutable(val);
      }
    },
    mutable: {
      deep: true,
      handler: function handler(val) {
        this.$emit("user-metadata", val);
      }
    }
  },
  methods: {
    log: function log(data) {
      var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ">>> ";

      if (process.env.NODE_ENV !== "production") {
        console.log(label, data);
      }
    },
    setMutable: function setMutable(val) {
      if (!val) {
        this.mutable = {
          id: this.id,
          name: this.name,
          metadata: undefined
        };
      } else if (val instanceof Array) {
        this.mutable = {
          id: this.id,
          name: this.name,
          metadata: this.mapMetadata(val)
        };
      } else {
        this.mutable = this.mergeFieldComponentWithMetadata(val);
      }
    },
    mapMetadata: function mapMetadata(metadata) {
      var result = [];

      if (metadata && metadata instanceof Array && metadata.length) {
        result = metadata.map(this.mergeFieldComponentWithMetadata);
      }

      return result;
    },
    mergeFieldComponentWithMetadata: function mergeFieldComponentWithMetadata(field) {
      return _objectSpread$5({}, field, {
        component: this.getFieldComponent(field)
      });
    },
    getFieldComponent: function getFieldComponent(field) {
      var result = null; // eslint-disable-next-line default-case

      switch (field.inputMethod) {
        case "CURRENCY":
          {
            result = "CurrencyField";
            break;
          }

        case "CHECKBOX":
          {
            result = "CheckboxField";
            break;
          }

        case "TEXTBOX":
          {
            if (field.type === "CURRENCY") {
              result = "CurrencyField";
            } else {
              result = "TextboxField";
            }

            break;
          }

        case "TEXTBOX_LARGE":
          {
            result = "TextareaField";
            break;
          }

        case "COMBOBOX":
          {
            result = "DropdownField";
            break;
          }

        case "MULTISELECT":
          {
            result = "CheckboxListField";
            break;
          }
      }

      return result;
    }
  }
};

var __vue_script__$10 = script$I;
/* template */

var __vue_render__$_ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "metadata-page"
  }, [_c('div', {
    staticClass: "intro"
  }, [_c('h2', {
    staticClass: "metadata-page__heading"
  }, [_vm._v("\n      " + _vm._s(_vm.mutable.name || "Untitled") + "\n    ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _vm._t("validation", [_vm.showValidation ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._t("validation-message", [_vm._v("\n          One or more mandatory fields are empty.\n        ")])], 2) : _vm._e()])], 2), _vm._v(" "), _vm._l(_vm.mutable.metadata, function (field, index) {
    return _c('div', {
      key: field.fieldId,
      staticClass: "metadata-field"
    }, [field.component ? _c(field.component, _vm._b({
      key: field.fieldId,
      tag: "Component",
      attrs: {
        "should-focus": index === 0,
        "show-validation": _vm.showValidation
      },
      model: {
        value: field.value,
        callback: function callback($$v) {
          _vm.$set(field, "value", $$v);
        },
        expression: "field.value"
      }
    }, 'Component', field, false)) : _vm._e()], 1);
  })], 2);
};

var __vue_staticRenderFns__$_ = [];
/* style */

var __vue_inject_styles__$10 = undefined;
/* scoped */

var __vue_scope_id__$10 = "data-v-b38e2a78";
/* module identifier */

var __vue_module_identifier__$10 = undefined;
/* functional template */

var __vue_is_functional_template__$10 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$10 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$_,
  staticRenderFns: __vue_staticRenderFns__$_
}, __vue_inject_styles__$10, __vue_script__$10, __vue_scope_id__$10, __vue_is_functional_template__$10, __vue_module_identifier__$10, false, undefined, undefined, undefined);

/* script */
var __vue_script__$11 = script$G;
/* template */

var __vue_render__$$ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "field--string",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "field__" + _vm.fieldId
    }
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n      "), _vm.mandatory ? _c('span', {
    staticClass: "mandatory-marker"
  }, [_vm._v("\n        *\n      ")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.mutable,
      expression: "mutable"
    }],
    ref: "focus",
    staticClass: "form-control",
    attrs: {
      "id": "field__" + _vm.fieldId,
      "type": "checkbox",
      "true-value": "1",
      "false-value": "0",
      "data-hj-suppress": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.mutable) ? _vm._i(_vm.mutable, null) > -1 : _vm._q(_vm.mutable, "1")
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.mutable,
            $$el = $event.target,
            $$c = $$el.checked ? "1" : "0";

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && (_vm.mutable = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.mutable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.mutable = $$c;
        }
      }
    }
  })])]);
};

var __vue_staticRenderFns__$$ = [];
/* style */

var __vue_inject_styles__$11 = undefined;
/* scoped */

var __vue_scope_id__$11 = "data-v-07a1caa3";
/* module identifier */

var __vue_module_identifier__$11 = undefined;
/* functional template */

var __vue_is_functional_template__$11 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$11 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$$,
  staticRenderFns: __vue_staticRenderFns__$$
}, __vue_inject_styles__$11, __vue_script__$11, __vue_scope_id__$11, __vue_is_functional_template__$11, __vue_module_identifier__$11, false, undefined, undefined, undefined);

/* script */
var __vue_script__$12 = script$H;
/* template */

var __vue_render__$10 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "field--checkbox-list",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "field__" + _vm.fieldId
    }
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n      "), _vm.mandatory ? _c('span', {
    staticClass: "mandatory-marker"
  }, [_vm._v("\n        *\n      ")]) : _vm._e()]), _vm._v(" "), _vm._l(_vm.options, function (option) {
    return _c('div', {
      key: option.value
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.checkboxValues[option.value],
        expression: "checkboxValues[option.value]"
      }],
      ref: "focus",
      refInFor: true,
      attrs: {
        "id": "field__" + _vm.fieldId + "__" + option.value,
        "type": "checkbox",
        "data-hj-suppress": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.checkboxValues[option.value]) ? _vm._i(_vm.checkboxValues[option.value], null) > -1 : _vm.checkboxValues[option.value]
      },
      on: {
        "change": function change($event) {
          var $$a = _vm.checkboxValues[option.value],
              $$el = $event.target,
              $$c = $$el.checked ? true : false;

          if (Array.isArray($$a)) {
            var $$v = null,
                $$i = _vm._i($$a, $$v);

            if ($$el.checked) {
              $$i < 0 && _vm.$set(_vm.checkboxValues, option.value, $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(_vm.checkboxValues, option.value, $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(_vm.checkboxValues, option.value, $$c);
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "field-label",
      attrs: {
        "for": "field__" + _vm.fieldId + "__" + option.value
      }
    }, [_vm._v("\n        " + _vm._s(option.label) + "\n      ")])]);
  })], 2)]);
};

var __vue_staticRenderFns__$10 = [];
/* style */

var __vue_inject_styles__$12 = undefined;
/* scoped */

var __vue_scope_id__$12 = "data-v-09a165f6";
/* module identifier */

var __vue_module_identifier__$12 = undefined;
/* functional template */

var __vue_is_functional_template__$12 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$12 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$10,
  staticRenderFns: __vue_staticRenderFns__$10
}, __vue_inject_styles__$12, __vue_script__$12, __vue_scope_id__$12, __vue_is_functional_template__$12, __vue_module_identifier__$12, false, undefined, undefined, undefined);

/* script */
var __vue_script__$13 = script$E;
/* template */

var __vue_render__$11 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "field--checkbox-list",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "field__" + _vm.fieldId
    }
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n      "), _vm.mandatory ? _c('span', {
    staticClass: "mandatory-marker"
  }, [_vm._v("\n        *\n      ")]) : _vm._e()]), _vm._v(" "), _vm._l(_vm.options, function (option) {
    return _c('div', {
      key: option.value
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.checkboxValues[option.value],
        expression: "checkboxValues[option.value]"
      }],
      ref: "focus",
      refInFor: true,
      attrs: {
        "id": "field__" + _vm.fieldId + "__" + option.value,
        "type": "checkbox",
        "data-hj-suppress": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.checkboxValues[option.value]) ? _vm._i(_vm.checkboxValues[option.value], null) > -1 : _vm.checkboxValues[option.value]
      },
      on: {
        "change": function change($event) {
          var $$a = _vm.checkboxValues[option.value],
              $$el = $event.target,
              $$c = $$el.checked ? true : false;

          if (Array.isArray($$a)) {
            var $$v = null,
                $$i = _vm._i($$a, $$v);

            if ($$el.checked) {
              $$i < 0 && _vm.$set(_vm.checkboxValues, option.value, $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(_vm.checkboxValues, option.value, $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(_vm.checkboxValues, option.value, $$c);
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "field-label",
      attrs: {
        "for": "field__" + _vm.fieldId + "__" + option.value
      }
    }, [_vm._v("\n        " + _vm._s(option.label) + "\n      ")])]);
  })], 2)]);
};

var __vue_staticRenderFns__$11 = [];
/* style */

var __vue_inject_styles__$13 = undefined;
/* scoped */

var __vue_scope_id__$13 = "data-v-7d589dd6";
/* module identifier */

var __vue_module_identifier__$13 = undefined;
/* functional template */

var __vue_is_functional_template__$13 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$13 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$11,
  staticRenderFns: __vue_staticRenderFns__$11
}, __vue_inject_styles__$13, __vue_script__$13, __vue_scope_id__$13, __vue_is_functional_template__$13, __vue_module_identifier__$13, false, undefined, undefined, undefined);

/* script */
var __vue_script__$14 = script$F;
/* template */

var __vue_render__$12 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "field--string",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "field__" + _vm.fieldId
    }
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n      "), _vm.mandatory ? _c('span', {
    staticClass: "mandatory-marker"
  }, [_vm._v("\n        *\n      ")]) : _vm._e()]), _vm._v(" "), _c('VSelect', {
    ref: "focus",
    attrs: {
      "id": "field__" + _vm.fieldId,
      "multiple": _vm.multiple,
      "options": _vm.options,
      "data-hj-suppress": ""
    },
    model: {
      value: _vm.mutable,
      callback: function callback($$v) {
        _vm.mutable = $$v;
      },
      expression: "mutable"
    }
  })], 1)]);
};

var __vue_staticRenderFns__$12 = [];
/* style */

var __vue_inject_styles__$14 = undefined;
/* scoped */

var __vue_scope_id__$14 = "data-v-db1c7962";
/* module identifier */

var __vue_module_identifier__$14 = undefined;
/* functional template */

var __vue_is_functional_template__$14 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$14 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$12,
  staticRenderFns: __vue_staticRenderFns__$12
}, __vue_inject_styles__$14, __vue_script__$14, __vue_scope_id__$14, __vue_is_functional_template__$14, __vue_module_identifier__$14, false, undefined, undefined, undefined);

/* script */
var __vue_script__$15 = script$D;
/* template */

var __vue_render__$13 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "field--string",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "field__" + _vm.fieldId
    }
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n      "), _vm.mandatory ? _c('span', {
    staticClass: "mandatory-marker"
  }, [_vm._v("\n        *\n      ")]) : _vm._e()]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.mutable,
      expression: "mutable"
    }],
    ref: "focus",
    staticClass: "form-control",
    attrs: {
      "id": "field__" + _vm.fieldId,
      "data-hj-suppress": ""
    },
    domProps: {
      "value": _vm.mutable
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.mutable = $event.target.value;
      }
    }
  })])]);
};

var __vue_staticRenderFns__$13 = [];
/* style */

var __vue_inject_styles__$15 = undefined;
/* scoped */

var __vue_scope_id__$15 = "data-v-bf8fc892";
/* module identifier */

var __vue_module_identifier__$15 = undefined;
/* functional template */

var __vue_is_functional_template__$15 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$15 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$13,
  staticRenderFns: __vue_staticRenderFns__$13
}, __vue_inject_styles__$15, __vue_script__$15, __vue_scope_id__$15, __vue_is_functional_template__$15, __vue_module_identifier__$15, false, undefined, undefined, undefined);

/* script */
var __vue_script__$16 = script$C;
/* template */

var __vue_render__$14 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "field--string",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "field__" + _vm.fieldId
    }
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n      "), _vm.mandatory ? _c('span', {
    staticClass: "mandatory-marker"
  }, [_vm._v("\n        *\n      ")]) : _vm._e()]), _vm._v(" "), _vm.inputType === 'checkbox' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.mutable,
      expression: "mutable"
    }],
    ref: "focus",
    staticClass: "form-control",
    attrs: {
      "id": "field__" + _vm.fieldId,
      "data-hj-suppress": "",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.mutable) ? _vm._i(_vm.mutable, null) > -1 : _vm.mutable
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.mutable,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && (_vm.mutable = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.mutable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.mutable = $$c;
        }
      }
    }
  }) : _vm.inputType === 'radio' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.mutable,
      expression: "mutable"
    }],
    ref: "focus",
    staticClass: "form-control",
    attrs: {
      "id": "field__" + _vm.fieldId,
      "data-hj-suppress": "",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.mutable, null)
    },
    on: {
      "change": function change($event) {
        _vm.mutable = null;
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.mutable,
      expression: "mutable"
    }],
    ref: "focus",
    staticClass: "form-control",
    attrs: {
      "id": "field__" + _vm.fieldId,
      "data-hj-suppress": "",
      "type": _vm.inputType
    },
    domProps: {
      "value": _vm.mutable
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.mutable = $event.target.value;
      }
    }
  })])]);
};

var __vue_staticRenderFns__$14 = [];
/* style */

var __vue_inject_styles__$16 = undefined;
/* scoped */

var __vue_scope_id__$16 = "data-v-58000b72";
/* module identifier */

var __vue_module_identifier__$16 = undefined;
/* functional template */

var __vue_is_functional_template__$16 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$16 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$14,
  staticRenderFns: __vue_staticRenderFns__$14
}, __vue_inject_styles__$16, __vue_script__$16, __vue_scope_id__$16, __vue_is_functional_template__$16, __vue_module_identifier__$16, false, undefined, undefined, undefined);

var script$J = {
  name: "AddressCarriage",
  props: {
    /**
     * The currently selected carriage ID
     */
    value: {
      type: Object,
      default: null
    },

    /**
     * The address object
     */
    address: {
      type: Object,
      default: null
    },

    /**
     * Text to use for the please select message
     */
    pleaseSelectText: {
      type: String,
      default: "Please select carriage for this address..."
    },

    /**
     * Carriage options label
     */
    carriageLabel: {
      type: String,
      default: "The following carriage will be used when delivering to this address"
    },

    /**
     * Validation message displayed if no carriage is selected
     */
    validationError: {
      type: String,
      default: "Please select a carriage option for this line"
    },

    /**
     * Default title text for each address
     */
    addressLabel: {
      type: String,
      default: "Address:"
    },
    validate: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      carriageItem: null,
      carriageId: null
    };
  },
  computed: {
    /**
     * Main component classes
     */
    classes: function classes() {
      var classes = ["address-carriage"];

      if (this.validate && !this.isValid) {
        classes.push("address-carriage--invalid");
      }

      return classes;
    },

    /**
     * Whether the selected carriage is valid
     */
    isValid: function isValid() {
      var _this$carriageId;

      return ((_this$carriageId = this.carriageId) !== null && _this$carriageId !== void 0 ? _this$carriageId : 0) !== 0;
    },

    /**
     * The delivery address ID
     */
    deliveryAddressId: function deliveryAddressId() {
      var _this$address;

      return (_this$address = this.address) === null || _this$address === void 0 ? void 0 : _this$address.deliveryAddressId;
    },

    /**
     * The delivery organisation ID
     */
    deliveryOrgId: function deliveryOrgId() {
      var _this$address2;

      return (_this$address2 = this.address) === null || _this$address2 === void 0 ? void 0 : _this$address2.deliveryOrgId;
    },

    /**
     * List of possible carriage options
     */
    carriageOptions: function carriageOptions() {
      var _this$address3;

      var options = ((_this$address3 = this.address) === null || _this$address3 === void 0 ? void 0 : _this$address3.carriageOptions) || [];

      if (options.length > 1) {
        options = [{
          id: 0,
          active: true,
          description: this.pleaseSelectText
        }].concat(_toConsumableArray(options));
      }

      return options;
    },

    /**
     * Whether we have any carriage options
     */
    hasCarriageOptions: function hasCarriageOptions() {
      var _this$address4, _this$address4$carria;

      return ((_this$address4 = this.address) === null || _this$address4 === void 0 ? void 0 : (_this$address4$carria = _this$address4.carriageOptions) === null || _this$address4$carria === void 0 ? void 0 : _this$address4$carria.length) > 0;
    },

    /**
     * Split the address up into seperate lines
     */
    formattedAddress: function formattedAddress() {
      var _this$address5;

      var delAddress = (_this$address5 = this.address) === null || _this$address5 === void 0 ? void 0 : _this$address5.deliveryAddress;
      var formattedAddress = "";

      if (delAddress) {
        var splitAddress = delAddress.split(",");

        for (var index = 0; index < splitAddress.length; index += 1) {
          formattedAddress += splitAddress[index];

          if (index !== splitAddress.length - 1) {
            // Only add a new line character if we are NOT on the last
            // address line
            formattedAddress += "\n";
          }
        }
      }

      return formattedAddress;
    }
  },
  watch: {
    /**
     * Watch for the external carriage item to change and sync up the internal carriage item
     */
    value: {
      immediate: true,
      deep: true,
      handler: function handler(val) {
        if (!isEqual$1(val, this.carriageItem)) {
          this.carriageItem = cloneDeep(val);
        }
      }
    },

    /**
     * Watch for the internal carriage item to change
     */
    carriageItem: {
      immediate: true,
      deep: true,
      handler: function handler(val) {
        this.$emit("input", val);
      }
    },

    /**
     * When the address object is updated, check to see how many carriage items there are,
     * if there is only o then auto select it
     */
    address: {
      deep: true,
      immediate: true,
      handler: function handler(val) {
        var _val$carriageOptions;

        if ((val === null || val === void 0 ? void 0 : (_val$carriageOptions = val.carriageOptions) === null || _val$carriageOptions === void 0 ? void 0 : _val$carriageOptions.length) === 1) {
          this.carriageId = val.carriageOptions[0].id || 0;
        } else {
          this.carriageId = 0;
        }

        this.carriageItem = {
          carriageId: this.carriageId,
          addressId: val.deliveryAddressId,
          orgId: val.deliveryOrgId
        };
      }
    }
  },
  methods: {
    /**
     * When carriage is selected, update the selected carriage item
     * @param {Number} carriageId The selected carriage ID
     */
    onCarriageSelect: function onCarriageSelect(carriageId) {
      this.carriageItem = {
        carriageId: carriageId !== null && carriageId !== void 0 ? carriageId : 0,
        addressId: this.deliveryAddressId,
        orgId: this.deliveryOrgId
      };
    }
  }
};

/* script */
var __vue_script__$17 = script$J;
/* template */

var __vue_render__$15 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.hasCarriageOptions ? _c('div', {
    class: _vm.classes
  }, [_c('label', {
    staticClass: "address-carriage__address-label"
  }, [_vm._v("\n    " + _vm._s(_vm.addressLabel) + "\n  ")]), _vm._v(" "), _c('pre', {
    staticClass: "address-carriage__address"
  }, [_vm._v("    " + _vm._s(_vm.formattedAddress) + "\n  ")]), _vm._v(" "), _vm.carriageLabel ? _c('label', {
    staticClass: "address-carriage__carriage-label"
  }, [_vm._v("\n    " + _vm._s(_vm.carriageLabel) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('b-form-select', {
    staticClass: "address-carriage__carriage",
    attrs: {
      "value": _vm.carriageId,
      "options": _vm.carriageOptions,
      "value-field": "id",
      "text-field": "description"
    },
    on: {
      "input": _vm.onCarriageSelect
    }
  }), _vm._v(" "), _vm.validate && !_vm.isValid ? _c('label', {
    staticClass: "address-carriage__validate"
  }, [_vm._v("\n    " + _vm._s(_vm.validationError) + "\n  ")]) : _vm._e()], 1) : _vm._e();
};

var __vue_staticRenderFns__$15 = [];
/* style */

var __vue_inject_styles__$17 = undefined;
/* scoped */

var __vue_scope_id__$17 = "data-v-1b420ead";
/* module identifier */

var __vue_module_identifier__$17 = undefined;
/* functional template */

var __vue_is_functional_template__$17 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$17 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$15,
  staticRenderFns: __vue_staticRenderFns__$15
}, __vue_inject_styles__$17, __vue_script__$17, __vue_scope_id__$17, __vue_is_functional_template__$17, __vue_module_identifier__$17, false, undefined, undefined, undefined);

/* script */
var __vue_script__$18 = script$A;
/* template */

var __vue_render__$16 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "address-selector",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "address-selector__details"
  }, [_vm.addNew && !_vm.disabled ? [_vm.canSearchForAddress ? _c('uber-search', {
    staticClass: "address-selector__search",
    attrs: {
      "show-validation": _vm.showValidation,
      "user-type": _vm.userType
    },
    model: {
      value: _vm.address,
      callback: function callback($$v) {
        _vm.address = $$v;
      },
      expression: "address"
    }
  }) : _c('label', {
    staticClass: "address-selector__manual"
  }, [_vm._v("\n        Please enter the address details below\n      ")])] : _vm._e(), _vm._v(" "), _c('address-display', {
    staticClass: "address-selector__current",
    attrs: {
      "disabled": !_vm.canAddManualAddress,
      "show-validation": _vm.showValidation,
      "countries": _vm.countries
    },
    on: {
      "addressChanged": _vm.onManualAddressChanged
    },
    model: {
      value: _vm.address,
      callback: function callback($$v) {
        _vm.address = $$v;
      },
      expression: "address"
    }
  }), _vm._v(" "), _vm.addNew && !_vm.disabled ? _c('div', {
    staticClass: "address-selector__buttons"
  }, [_c('button', {
    staticClass: "address-selector__save btn btn-primary",
    attrs: {
      "variant": "accent-1"
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm.saving ? [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })] : [_vm._v("\n          Save\n        ")]], 2), _vm._v(" "), _c('button', {
    staticClass: "address-selector__cancel btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onCancelAdd
    }
  }, [_vm._v("\n        Cancel\n      ")])]) : _vm._e()], 2), _vm._v(" "), !_vm.disabled ? _c('div', {
    staticClass: "address-selector__available"
  }, [_c('address-list', {
    staticClass: "address-selector__available-addresses",
    attrs: {
      "address-list": _vm.addressList,
      "address-type-id": _vm.addressTypeId,
      "loading": _vm.loading,
      "enable-filter": _vm.enableFilter,
      "filter-placeholder": _vm.filterPlaceholder
    },
    on: {
      "addressSelected": _vm.onAddressSelected
    },
    model: {
      value: _vm.address,
      callback: function callback($$v) {
        _vm.address = $$v;
      },
      expression: "address"
    }
  }), _vm._v(" "), _vm.canAddAddress ? _c('button', {
    staticClass: "address-selector__add-new btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onAddNew
    }
  }, [_vm._v("\n      Add new address\n    ")]) : _vm._e()], 1) : _vm._e()]);
};

var __vue_staticRenderFns__$16 = [];
/* style */

var __vue_inject_styles__$18 = undefined;
/* scoped */

var __vue_scope_id__$18 = "data-v-64d946fa";
/* module identifier */

var __vue_module_identifier__$18 = undefined;
/* functional template */

var __vue_is_functional_template__$18 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$18 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$16,
  staticRenderFns: __vue_staticRenderFns__$16
}, __vue_inject_styles__$18, __vue_script__$18, __vue_scope_id__$18, __vue_is_functional_template__$18, __vue_module_identifier__$18, false, undefined, undefined, undefined);

/* script */
var __vue_script__$19 = script$B;
/* template */

var __vue_render__$17 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "carriage"
  }, [_c('div', {
    staticClass: "carriage__info"
  }, [_vm._v("\n    " + _vm._s(_vm.info) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "carriage__items"
  }, _vm._l(_vm.carriageItems, function (carriage, index) {
    return _c('label', {
      key: index,
      staticClass: "carriage__item"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.selectedCarriageId,
        expression: "selectedCarriageId"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": carriage.id,
        "checked": _vm._q(_vm.selectedCarriageId, carriage.id)
      },
      on: {
        "change": function change($event) {
          _vm.selectedCarriageId = carriage.id;
        }
      }
    }), _vm._v("\n      (" + _vm._s(_vm.formatPrice(carriage.priceIncVat, _vm.currency, _vm.locale)) + ") \n      " + _vm._s(carriage.description) + "\n    ")]);
  }), 0)]);
};

var __vue_staticRenderFns__$17 = [];
/* style */

var __vue_inject_styles__$19 = undefined;
/* scoped */

var __vue_scope_id__$19 = "data-v-42dac0ae";
/* module identifier */

var __vue_module_identifier__$19 = undefined;
/* functional template */

var __vue_is_functional_template__$19 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$19 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$17,
  staticRenderFns: __vue_staticRenderFns__$17
}, __vue_inject_styles__$19, __vue_script__$19, __vue_scope_id__$19, __vue_is_functional_template__$19, __vue_module_identifier__$19, false, undefined, undefined, undefined);

var instance$3 = new HttpService("umbraco/api/BasketStep/");
var validateOrder = function validateOrder() {
  return instance$3.get("ValidateOrder");
};
var validateAddresses = function validateAddresses() {
  return instance$3.get("ValidateAddresses");
};
var basketHasOrderLines = function basketHasOrderLines() {
  return instance$3.get("BasketHasOrderLines");
};
/**
 * Load data needed for the Multi Carriage step when checking out a basket
 */

var loadMultiCarriageStep = function loadMultiCarriageStep() {
  return instance$3.get("LoadMultiCarriageStep");
};
/**
 * Apply a list of multi-ship carriage items to the current basket
 * @param {Array} carriageItems array of carriage IDs and address ID
 */

var applyMultiCarriage = function applyMultiCarriage(carriageItems) {
  return instance$3.post("ApplyMultiCarriage", carriageItems);
};
/**
 * Load data needed for the Address Step when checking out a basket
 */

var loadAddressStep = function loadAddressStep() {
  return instance$3.get("LoadAddressStep");
};
/**
 * Update the basket with the supplied invoice and delivery address
 * @param {GUID} invoiceAddressId The ID of the Invoice Address
 * @param {GUID} deliveryAddressId The ID of the delivery address
 * @param {int} carriageId The ID of the carriage item to apply to the basket
 * @param {boolean} returnCarriage If true then return a list of carriage items that
 * are compatible with the order now that it has a delivery address
 * @param {boolean} allCarriageItems If true and "returnCarriage" is true then just return
 * all carriage items no matter that the delivery address
 * @param {GUID} deliveryPersonId The ID of the delivery person to use
 * @param {GUID} invociePersonId The ID of the invoice person to use
 */

var updateAddressAndCarriage = function updateAddressAndCarriage(invoiceAddressId, deliveryAddressId, carriageId, returnCarriage, allCarriageItems, deliveryPersonId, invoicePersonId) {
  return instance$3.post("UpdateAddressAndCarriage", null, {
    invoiceAddressId: invoiceAddressId,
    deliveryAddressId: deliveryAddressId,
    carriageId: carriageId,
    returnCarriage: returnCarriage,
    allCarriageItems: allCarriageItems,
    deliveryPersonId: deliveryPersonId,
    invoicePersonId: invoicePersonId
  });
};
/**
 * Blank address
*/

var blankAddress = function blankAddress() {
  return {
    addressId: null,
    sopAddressId: null,
    orgId: null,
    orgTypeId: null,
    addressType: null,
    orgName: null,
    line1: null,
    line2: null,
    line3: null,
    town: null,
    region: null,
    poastcode: null,
    countryId: null
  };
};
var savePerson = function savePerson(person) {
  return instance$3.post("SavePerson", person);
};

var script$K = {
  name: "AddressStep",
  component: {
    AlternativePerson: __vue_component__$o,
    AddressSelector: __vue_component__$18,
    Postage: __vue_component__$19
  },
  mixins: [StyleMixin],
  props: {
    /**
     * Whether this step is stateless
     */
    stateless: {
      type: Boolean,
      default: false
    },

    /**
     * Whether we can go back to the previous step
     */
    hidePrevious: {
      type: Boolean,
      default: true
    },

    /**
     * Whether ot always load all carriage items
     */
    showAllCarriageItems: {
      type: Boolean,
      default: false
    },

    /**
     * Whether we want to default to setting the delivery address to the invoice address
     */
    defaultUseInvoiceForDelivery: {
      type: Boolean,
      default: false
    },

    /**
     * Currency for carriage
     */
    currency: {
      type: String,
      default: "GBP"
    },

    /**
     * Locale for carriage
     */
    locale: {
      type: String,
      default: "en-GB"
    },

    /**
     * Error message to display on invoice page
     */
    invoiceErrorMsg: {
      type: String,
      default: "Please select an address before continuing"
    },

    /**
     * Error message to display on delivery page
     */
    deliveryErrorMsg: {
      type: String,
      default: "Please select an address before continuing"
    },

    /**
     * Error message to display on on carriage options page
     */
    carriageErrorMsg: {
      type: String,
      default: "Please select a postage option before continuing"
    },

    /**
     * Org ID for web account
     * Used for searching for default addresses
     */
    webAccountOrgId: {
      type: String,
      default: null
    },

    /**
     * Continue button caption
     */
    continueBtn: {
      type: String,
      default: "Continue"
    },

    /**
     * Back button caption
     */
    backBtn: {
      type: String,
      default: "Back"
    },

    /**
     * If this is true then we will load the step when it is mounted
     * this is useful if it is the first step or there is no Your Details step
     */
    loadOnMount: {
      type: Boolean,
      default: false
    },

    /**
     * Turns on or off the free text search for addresses
     */
    enableFilter: {
      type: Boolean,
      default: false
    },

    /**
     * The placeholder to use for the filter text box
     */
    filterPlaceholder: {
      type: String,
      default: "Filter address list..."
    },
    showAlternativePerson: {
      type: Boolean,
      default: false
    },
    billingPersonButtonText: {
      type: String,
      default: "Choose alternative billing contact"
    },
    deliveryPersonButtonText: {
      type: String,
      default: "Choose alternative delivery contact"
    },

    /**
     * Is the delivery and billing contact telephone mandatory
     */
    telephoneMandatory: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      invoiceAddress: blankAddress(),
      deliveryAddress: blankAddress(),
      carriageId: null,
      carriageItems: [],
      countries: [],
      userType: {},
      saving: false,
      currentPage: 0,
      deliveryAddressRequired: false,
      noCarriageRequired: false,
      useInvoiceForDelivery: false,
      showUseInvoiceForDelivery: true,
      showError: false,
      loaded: false,
      loadAddressSelectors: false,
      stepId: null,
      readOnlyInvoiceAddress: false,
      relatedAddresses: [],
      alwaysShowInvoicePerson: false,
      alwaysShowDeliveryPerson: false,
      invoicePersonState: false,
      deliveryPersonState: false,
      accountPerson: null,
      billingPerson: null,
      deliveryPerson: null,
      personValidationMessage: null,
      personError: null,
      INVOICE_PAGE: 0,
      DELIVERY_PAGE: 1,
      CARRIAGE_PAGE: 2
    };
  },
  computed: {
    /**
     * Whether or not we have a header to show
     */
    hasHeader: function hasHeader() {
      return this.$slots.invoiceHeader || this.$slots.deliveryHeader || this.carriageHeader;
    },

    /**
     * Page information
     */
    info: function info() {
      var infoText = null;

      if (this.currentPage === this.INVOICE_PAGE) {
        infoText = "Please confirm your Billing Address";
      } else if (this.currentPage === this.DELIVERY_PAGE) {
        infoText = "Please confirm your Delivery Address";
      } else if (this.currentPage === this.CARRIAGE_PAGE) {
        infoText = "Please select one of the following Postage Options";
      }

      return infoText;
    },

    /**
     * Page heading
     */
    heading: function heading() {
      var headingText = null;

      if (this.currentPage === this.INVOICE_PAGE) {
        headingText = "Billing Addresses";
      } else if (this.currentPage === this.DELIVERY_PAGE) {
        headingText = "Delivery Addresses";
      } else if (this.currentPage === this.CARRIAGE_PAGE) {
        headingText = "Postage Options";
      }

      return headingText;
    },

    /**
     * True if we have completeted this step
     */
    valid: function valid() {
      return this.invoiceValid && this.deliveryValid && this.carriageValid;
    },

    /**
     * The index of the last step, this is determined by whether we need a delivery
     * address or carriage or not
     */
    lastPage: function lastPage() {
      var lastPageNumber = this.INVOICE_PAGE;

      if (this.showCarriage) {
        lastPageNumber = this.CARRIAGE_PAGE;
      } else if (this.deliveryAddressRequired) {
        lastPageNumber = this.DELIVERY_PAGE;
      }

      return lastPageNumber;
    },

    /**
     * Selected Org Address ID for the delivery address
     */
    invoiceAddressId: function invoiceAddressId() {
      var _this$invoiceAddress;

      return (_this$invoiceAddress = this.invoiceAddress) === null || _this$invoiceAddress === void 0 ? void 0 : _this$invoiceAddress.addressId;
    },

    /**
     * Selected Org Address ID for the invoice address
     */
    deliveryAddressId: function deliveryAddressId() {
      var _this$deliveryAddress;

      return this.deliveryAddressRequired ? (_this$deliveryAddress = this.deliveryAddress) === null || _this$deliveryAddress === void 0 ? void 0 : _this$deliveryAddress.addressId : null;
    },

    /**
     * The selected carriage ID to save
     */
    carriageIdToSave: function carriageIdToSave() {
      return this.noCarriageRequired ? null : this.carriageId;
    },

    /**
     * Whether the invoice address is valid
     */
    invoiceValid: function invoiceValid() {
      return !!this.invoiceAddressId;
    },

    /**
     * Whether the delivery address is valid
     */
    deliveryValid: function deliveryValid() {
      return !!this.deliveryAddressId || !this.deliveryAddressRequired;
    },

    /**
     * Whether carriage is valid
     */
    carriageValid: function carriageValid() {
      var _this$carriageId, _this$carriageItems;

      var carriageId = (_this$carriageId = this.carriageId) !== null && _this$carriageId !== void 0 ? _this$carriageId : 0;
      return ((_this$carriageItems = this.carriageItems) === null || _this$carriageItems === void 0 ? void 0 : _this$carriageItems.length) > 0 && carriageId !== 0 || !this.deliveryAddressRequired || this.noCarriageRequired;
    },

    /**
     * Whether we have enough data to show the postage options
     */
    showCarriage: function showCarriage() {
      var _this$carriageItems2;

      return this.deliveryAddressRequired && !this.noCarriageRequired && this.deliveryAddressId && ((_this$carriageItems2 = this.carriageItems) === null || _this$carriageItems2 === void 0 ? void 0 : _this$carriageItems2.length) > 1;
    },

    /**
     * The delivery address post code (if any)
     */
    deliveryPostcode: function deliveryPostcode() {
      var _this$deliveryAddress2;

      return (_this$deliveryAddress2 = this.deliveryAddress) === null || _this$deliveryAddress2 === void 0 ? void 0 : _this$deliveryAddress2.postcode;
    },

    /**
     * General validation message based on the current page and
     * what is shown on the page
     */
    errorMessage: function errorMessage() {
      var msg = null;

      if (this.currentPage === this.INVOICE_PAGE) {
        msg = this.invoiceErrorMsg;
      } else if (this.currentPage === this.DELIVERY_PAGE) {
        msg = this.deliveryErrorMsg;
      } else if (this.currentPage === this.CARRIAGE_PAGE) {
        msg = this.carriageErrorMsg;
      }

      return msg;
    },

    /**
     * Inline style to apply to the "use invoice for delivery" checkbox
     * Uses "visibility" so that hiding the checkbox does not collapse the space
     * it takes up
     */
    useInvoiceForDeliveryStyle: function useInvoiceForDeliveryStyle() {
      return {
        visibility: this.showUseInvoiceForDelivery ? "visible" : "hidden"
      };
    },

    /**
     * Whether or not we can go back a page or step
     */
    canGoPrevious: function canGoPrevious() {
      return this.currentPage > 0 || !this.hidePrevious && this.checkout.canGoToPreviousStep;
    },

    /**
     * Get the fields message for person contact validation
     */
    contactMandatoryFieldMessage: function contactMandatoryFieldMessage() {
      var flds = ["first name", "last name", "email address"];

      if (this.telephoneMandatory) {
        flds.push("telephone");
      }

      return "".concat(flds.slice(0, -1).join(", "), " and ").concat(flds.slice(-1));
    }
  },
  watch: {
    /**
     * If the use invoice address for delivery address toggle is changed, update the
     * delivery address
     */
    useInvoiceForDelivery: function useInvoiceForDelivery() {
      this.setDeliveryToInvoice();
    },

    /**
     * If the delivery address is required and present, save changes and load a list
     * of carriage (postage) options
     */
    deliveryAddressId: function deliveryAddressId() {
      if (this.deliveryAddressId && this.deliveryAddressRequired && !this.noCarriageRequired) {
        this.quickSave();
      }
    }
  },
  mounted: function mounted() {
    this.useInvoiceForDelivery = this.defaultUseInvoiceForDelivery;
    this.currentPage = this.INVOICE_PAGE;

    if (this.loadOnMount) {
      this.load();
    }
  },
  inject: {
    checkout: {
      default: function _default() {
        throw new Error("A step must be within a <checkout>");
      }
    }
  },
  methods: {
    /**
     * Set up the step
     */
    load: function load() {
      var _this = this;

      loadAddressStep().then(function (response) {
        var _response$data$delive, _response$data, _response$data2, _response$data3, _response$data$noCarr, _response$data4, _response$data5, _response$data6, _response$data$always, _response$data7, _response$data$always2, _response$data8, _response$data$accoun, _response$data9;

        _this.deliveryAddressRequired = (_response$data$delive = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.deliveryAddressRequired) !== null && _response$data$delive !== void 0 ? _response$data$delive : false;
        _this.userType = (response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.userType) || {};
        _this.countries = (response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.countries) || [];
        _this.noCarriageRequired = (_response$data$noCarr = response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.noCarriageRequired) !== null && _response$data$noCarr !== void 0 ? _response$data$noCarr : false;
        _this.readOnlyInvoiceAddress = response === null || response === void 0 ? void 0 : (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.readOnlyInvoiceAddress;
        _this.relatedAddresses = (response === null || response === void 0 ? void 0 : (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.relatedAddresses) || [];
        _this.alwaysShowDeliveryPerson = (_response$data$always = response === null || response === void 0 ? void 0 : (_response$data7 = response.data) === null || _response$data7 === void 0 ? void 0 : _response$data7.alwaysShowDeliveryPerson) !== null && _response$data$always !== void 0 ? _response$data$always : false;
        _this.alwaysShowInvoicePerson = (_response$data$always2 = response === null || response === void 0 ? void 0 : (_response$data8 = response.data) === null || _response$data8 === void 0 ? void 0 : _response$data8.alwaysShowInvoicePerson) !== null && _response$data$always2 !== void 0 ? _response$data$always2 : false;
        _this.accountPerson = (_response$data$accoun = response === null || response === void 0 ? void 0 : (_response$data9 = response.data) === null || _response$data9 === void 0 ? void 0 : _response$data9.accountPerson) !== null && _response$data$accoun !== void 0 ? _response$data$accoun : {};
      }).catch(function () {
        _this.deliveryAddressRequired = false;
      }).finally(function () {
        _this.loaded = true;

        _this.$nextTick(function () {
          // Signal the address selectors that they can load their data
          _this.loadAddressSelectors = true;
        });
      });
    },

    /**
     * When the use invoice for delivery address checkbox is changed, update the delivery address
     */
    setDeliveryToInvoice: function setDeliveryToInvoice() {
      if (this.useInvoiceForDelivery && this.deliveryAddressRequired && !isEqual$1(this.deliveryAddress, this.invoiceAddress)) {
        this.deliveryAddress = cloneDeep(this.invoiceAddress);
      }
    },

    /**
     * Move to the next page in this step
     *
     * @param {object} step Reference to the step within the checkout
     */
    onNextPage: function onNextPage(step) {
      if (this.currentPage < this.lastPage) {
        if (this.validatePage()) {
          var personValid = true;

          if (this.currentPage === this.INVOICE_PAGE) {
            if (this.invoicePersonState) {
              personValid = this.validateBillingPerson();
            }
          } else if (this.currentPage === this.DELIVERY_PAGE) {
            if (this.deliveryPersonState) {
              personValid = this.validateDeliveryPerson();
            }
          }

          if (personValid) {
            this.currentPage += 1;
            this.setupPage();
          }
        }
      } else {
        this.save(step);
      }
    },

    /**
     * Move to the previous page in this step
     *
     * @param {object} step Reference to the step within the checkout
     */
    onPrevPage: function onPrevPage(step) {
      if (this.currentPage > 0) {
        this.currentPage -= 1;
      } else {
        step.goToPreviousStep();
      }
    },

    /**
     * Start on the invoice page when ever the address step is shown
     */
    onCurrentStep: function onCurrentStep() {
      this.currentPage = this.INVOICE_PAGE;

      if (!this.loadOnMount) {
        // Load the address step data
        this.load();
      }
    },

    /**
     * The step has "announced" itself to the checkout, so store
     * the ID that check out has given us
     */
    onAnnounce: function onAnnounce(val) {
      this.stepId = val;
    },

    /**
     * Raised before a delivery address is added
     */
    onBeforeDeliveryAddress: function onBeforeDeliveryAddress() {
      this.useInvoiceForDelivery = false;
      this.showUseInvoiceForDelivery = false;
    },

    /**
     * Raised after a delivery address process completes
     */
    onAfterDeliveryAddress: function onAfterDeliveryAddress() {
      this.showUseInvoiceForDelivery = true;
    },

    /**
     * Do a quick save of the basket and load a list of carriage options for
     * the user to choose from
     */
    quickSave: function quickSave() {
      var _this2 = this;

      this.saving = true;
      this.carriageItems = [];
      updateAddressAndCarriage(this.invoiceAddressId, this.deliveryAddressId, null, true, this.showAllCarriageItems).then(function (response) {
        var _this2$carriageItems;

        _this2.carriageItems = response.data;

        if (((_this2$carriageItems = _this2.carriageItems) === null || _this2$carriageItems === void 0 ? void 0 : _this2$carriageItems.length) === 1) {
          // Only one carriage item so just select it
          _this2.carriageId = _this2.carriageItems[0].id;
        }
      }).catch(function () {// Ignore errors
      }).finally(function () {
        _this2.saving = false;
      });
    },

    /**
     * Save the addresses and carriage against the basket and continue
     *
     * @param {object} step Reference to the step within the checkout
     */
    save: function () {
      var _save = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(step) {
        var deliveryPersonId, billingPersonId, updateAddress, res, saveResult;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.validatePage()) {
                  _context.next = 33;
                  break;
                }

                this.saving = true;
                deliveryPersonId = null;
                billingPersonId = null;
                updateAddress = true;
                _context.prev = 5;
                _context.next = 8;
                return this.savePersonDetails();

              case 8:
                res = _context.sent;
                console.log(res); // eslint-disable-next-line prefer-destructuring

                deliveryPersonId = res.deliveryPersonId; // eslint-disable-next-line prefer-destructuring

                billingPersonId = res.billingPersonId;
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](5);
                updateAddress = false;

              case 17:
                if (deliveryPersonId) {
                  this.deliveryPerson.id = deliveryPersonId;
                }

                if (billingPersonId) {
                  this.billingPerson.id = billingPersonId;
                }

                _context.prev = 19;

                if (!updateAddress) {
                  _context.next = 25;
                  break;
                }

                _context.next = 23;
                return updateAddressAndCarriage(this.invoiceAddressId, this.deliveryAddressId, this.carriageIdToSave, null, null, deliveryPersonId, billingPersonId);

              case 23:
                saveResult = _context.sent;

                if (saveResult.data) {
                  step.goToNextStep();
                } else {
                  this.showError = true;
                }

              case 25:
                _context.next = 30;
                break;

              case 27:
                _context.prev = 27;
                _context.t1 = _context["catch"](19);
                this.showError = true;

              case 30:
                _context.prev = 30;
                this.saving = false;
                return _context.finish(30);

              case 33:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 14], [19, 27, 30, 33]]);
      }));

      function save(_x) {
        return _save.apply(this, arguments);
      }

      return save;
    }(),
    savePersonDetails: function () {
      var _savePersonDetails = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var result, response, _response;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.personError = null;
                result = {
                  deliveryPersonId: null,
                  billingPersonId: null
                };

                if (!this.invoicePersonState) {
                  _context2.next = 21;
                  break;
                }

                if (!this.validateBillingPerson()) {
                  _context2.next = 20;
                  break;
                }

                _context2.prev = 4;

                if (!this.billingPerson.isAccount) {
                  _context2.next = 9;
                  break;
                }

                // We are using the account person, so we already have a person ID
                // and don't neext to sabe anything
                result.billingPersonId = this.billingPerson.id;
                _context2.next = 13;
                break;

              case 9:
                _context2.next = 11;
                return savePerson(this.billingPerson);

              case 11:
                response = _context2.sent;
                result.billingPersonId = response === null || response === void 0 ? void 0 : response.data;

              case 13:
                _context2.next = 18;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](4);
                this.personError = "Unable to save billing person details.";

              case 18:
                _context2.next = 21;
                break;

              case 20:
                throw new Error("Invalid billing person");

              case 21:
                if (!(this.deliveryPersonState && this.deliveryAddressRequired)) {
                  _context2.next = 40;
                  break;
                }

                if (!this.validateDeliveryPerson()) {
                  _context2.next = 39;
                  break;
                }

                _context2.prev = 23;

                if (!this.deliveryPerson.isAccount) {
                  _context2.next = 28;
                  break;
                }

                // We are using the account person, so we already have a person ID
                // and don't neext to sabe anything
                result.deliveryPersonId = this.deliveryPerson.id;
                _context2.next = 32;
                break;

              case 28:
                _context2.next = 30;
                return savePerson(this.deliveryPerson);

              case 30:
                _response = _context2.sent;
                result.deliveryPersonId = _response === null || _response === void 0 ? void 0 : _response.data;

              case 32:
                _context2.next = 37;
                break;

              case 34:
                _context2.prev = 34;
                _context2.t1 = _context2["catch"](23);
                this.personError = "Unable to save delivery person details.";

              case 37:
                _context2.next = 40;
                break;

              case 39:
                throw new Error("Invalid delivery person");

              case 40:
                console.log("Person res", result);
                return _context2.abrupt("return", result);

              case 42:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 15], [23, 34]]);
      }));

      function savePersonDetails() {
        return _savePersonDetails.apply(this, arguments);
      }

      return savePersonDetails;
    }(),
    validateBillingPerson: function validateBillingPerson() {
      var isValid = this.validatePerson(this.billingPerson);
      this.personValidationMessage = null;

      if (!isValid) {
        this.personValidationMessage = "The billing person needs a ".concat(this.contactMandatoryFieldMessage);
      }

      return isValid;
    },
    validateDeliveryPerson: function validateDeliveryPerson() {
      var isValid = this.validatePerson(this.deliveryPerson);
      this.personValidationMessage = null;

      if (!isValid) {
        this.personValidationMessage = "The delivery person needs a ".concat(this.contactMandatoryFieldMessage);
      }

      return isValid;
    },
    validatePerson: function validatePerson(person) {
      // TODO: Not sure if a person needs a title or telephone
      return person && person.firstName && person.surname && person.email && (person.telephone || !this.telephoneMandatory);
    },

    /**
     * Validate the current page before continuing
     */
    validatePage: function validatePage() {
      var isValid = false;
      this.showError = false;
      this.personValidationMessage = null;

      if (this.currentPage === this.INVOICE_PAGE) {
        isValid = this.invoiceValid;
      } else if (this.currentPage === this.DELIVERY_PAGE) {
        isValid = this.deliveryValid && this.invoiceValid;
      } else if (this.currentPage === this.CARRIAGE_PAGE) {
        isValid = this.deliveryValid && this.invoiceValid && this.carriageValid;
      }

      if (!isValid) {
        this.showError = true;
      }

      return isValid;
    },

    /**
     * Set up the current page
     */
    setupPage: function setupPage() {
      if (this.currentPage === this.DELIVERY_PAGE && this.useInvoiceForDelivery) {
        // We are showing the delivery page and we want the delivery address to match
        // the invoice address
        this.setDeliveryToInvoice();
      }
    }
  }
};

/* script */
var __vue_script__$1a = script$K;
/* template */

var __vue_render__$18 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "address-step"
  }, [_c('tabbed-step', {
    attrs: {
      "name": "Address",
      "heading": _vm.heading,
      "valid": _vm.valid,
      "loaded": _vm.loaded,
      "stateless": _vm.stateless,
      "hide-previous": _vm.hidePrevious,
      "button-class": _vm.buttonClass,
      "hide-unloaded": ""
    },
    on: {
      "currentStep": _vm.onCurrentStep
    },
    scopedSlots: _vm._u([{
      key: "loading",
      fn: function fn() {
        return [_vm._t("loading")];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function fn(ref) {
        var step = ref.step;
        return [_c('div', {
          staticClass: "address-step__footer"
        }, [_vm._t("addressFooter"), _vm._v(" "), _vm.canGoPrevious ? _c('button', {
          staticClass: "step__footer-button step__back",
          class: _vm.buttonClass,
          on: {
            "click": function click($event) {
              return _vm.onPrevPage(step);
            }
          }
        }, [_vm._v("\n          " + _vm._s(_vm.backBtn) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
          staticClass: "step__footer-button step__continue no-disabled",
          class: _vm.buttonClass,
          on: {
            "click": function click($event) {
              return _vm.onNextPage(step);
            }
          }
        }, [_vm.saving ? [_c('font-awesome-icon', {
          attrs: {
            "icon": "spinner",
            "spin": ""
          }
        })] : [_vm._v("\n            " + _vm._s(_vm.continueBtn) + "\n          ")]], 2)], 2)];
      }
    }], null, true)
  }, [_vm._v(" "), _vm.currentPage == _vm.DELIVERY_PAGE && _vm.$slots.deliveryInfo ? _c('div', {
    staticClass: "address-step__page-info address-step__page-info--delivery"
  }, [_vm._t("deliveryInfo")], 2) : _vm._e(), _vm._v(" "), _vm.currentPage == _vm.INVOICE_PAGE && _vm.$slots.invoiceInfo ? _c('div', {
    staticClass: "address-step__page-info address-step__page-info--invoice"
  }, [_vm._t("invoiceInfo")], 2) : _vm._e(), _vm._v(" "), _vm.currentPage == _vm.CARRIAGE_PAGE && _vm.$slots.carriageInfo ? _c('div', {
    staticClass: "address-step__page-info address-step__page-info--carriage"
  }, [_vm._t("carriageInfo")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "address-step__container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentPage === _vm.INVOICE_PAGE,
      expression: "currentPage === INVOICE_PAGE"
    }],
    staticClass: "address-step__invoice"
  }, [_vm.showAlternativePerson ? _c('alternative-person', {
    attrs: {
      "button-text": _vm.billingPersonButtonText,
      "always-show": _vm.alwaysShowInvoicePerson,
      "account-person": _vm.accountPerson,
      "telephone-mandatory": _vm.telephoneMandatory,
      "contact-type": "billing"
    },
    on: {
      "toggle": function toggle($event) {
        _vm.invoicePersonState = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "validation",
      fn: function fn() {
        return [_vm.personValidationMessage ? _c('p', [_vm._v("\n              " + _vm._s(_vm.personValidationMessage) + "\n            ")]) : _vm._e()];
      },
      proxy: true
    }, {
      key: "altPersonInfo",
      fn: function fn() {
        return [_vm._t("invoiceAltPersonInfo")];
      },
      proxy: true
    }], null, true),
    model: {
      value: _vm.billingPerson,
      callback: function callback($$v) {
        _vm.billingPerson = $$v;
      },
      expression: "billingPerson"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "address-step__info"
  }, [_vm._v("\n          " + _vm._s(_vm.info) + "\n        ")]), _vm._v(" "), _c('address-selector', {
    attrs: {
      "address-type-id": "I",
      "user-type": _vm.userType,
      "countries": _vm.countries,
      "related-addresses": _vm.relatedAddresses,
      "disabled": _vm.readOnlyInvoiceAddress,
      "web-account-org-id": _vm.webAccountOrgId,
      "enable-filter": _vm.enableFilter,
      "filter-placeholder": _vm.filterPlaceholder,
      "load-now": _vm.loadAddressSelectors
    },
    model: {
      value: _vm.invoiceAddress,
      callback: function callback($$v) {
        _vm.invoiceAddress = $$v;
      },
      expression: "invoiceAddress"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentPage === _vm.DELIVERY_PAGE,
      expression: "currentPage === DELIVERY_PAGE"
    }],
    staticClass: "address-step__delivery"
  }, [_vm.showAlternativePerson ? _c('alternative-person', {
    attrs: {
      "button-text": _vm.deliveryPersonButtonText,
      "always-show": _vm.alwaysShowDeliveryPerson,
      "account-person": _vm.accountPerson,
      "telephone-mandatory": _vm.telephoneMandatory,
      "contact-type": "delivery"
    },
    on: {
      "toggle": function toggle($event) {
        _vm.deliveryPersonState = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "validation",
      fn: function fn() {
        return [_vm.personValidationMessage ? _c('p', [_vm._v("\n              " + _vm._s(_vm.personValidationMessage) + "\n            ")]) : _vm._e()];
      },
      proxy: true
    }, {
      key: "altPersonInfo",
      fn: function fn() {
        return [_vm._t("deliveryAltPersonInfo")];
      },
      proxy: true
    }], null, true),
    model: {
      value: _vm.deliveryPerson,
      callback: function callback($$v) {
        _vm.deliveryPerson = $$v;
      },
      expression: "deliveryPerson"
    }
  }) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "address-step__invoice-for-delivery",
    style: _vm.useInvoiceForDeliveryStyle
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.useInvoiceForDelivery,
      expression: "useInvoiceForDelivery"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.useInvoiceForDelivery) ? _vm._i(_vm.useInvoiceForDelivery, null) > -1 : _vm.useInvoiceForDelivery
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.useInvoiceForDelivery,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && (_vm.useInvoiceForDelivery = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.useInvoiceForDelivery = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.useInvoiceForDelivery = $$c;
        }
      }
    }
  }), _vm._v("\n          Use same address as Billing address\n        ")]), _vm._v(" "), _c('address-selector', {
    attrs: {
      "address-type-id": "D",
      "user-type": _vm.userType,
      "countries": _vm.countries,
      "related-addresses": _vm.relatedAddresses,
      "web-account-org-id": _vm.webAccountOrgId,
      "load-now": _vm.loadAddressSelectors,
      "enable-filter": _vm.enableFilter,
      "filter-placeholder": _vm.filterPlaceholder
    },
    on: {
      "addNew": _vm.onBeforeDeliveryAddress,
      "cancelAdd": _vm.onAfterDeliveryAddress,
      "saved": _vm.onAfterDeliveryAddress,
      "selected": _vm.onAfterDeliveryAddress
    },
    model: {
      value: _vm.deliveryAddress,
      callback: function callback($$v) {
        _vm.deliveryAddress = $$v;
      },
      expression: "deliveryAddress"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentPage === _vm.CARRIAGE_PAGE,
      expression: "currentPage === CARRIAGE_PAGE"
    }],
    staticClass: "address-step__carriage"
  }, [_c('div', {
    staticClass: "address-step__info"
  }, [_vm._v("\n          " + _vm._s(_vm.info) + "\n        ")]), _vm._v(" "), _c('postage', {
    attrs: {
      "currency": _vm.currency,
      "locale": _vm.locale,
      "carriage-items": _vm.carriageItems,
      "postcode": _vm.deliveryPostcode
    },
    model: {
      value: _vm.carriageId,
      callback: function callback($$v) {
        _vm.carriageId = $$v;
      },
      expression: "carriageId"
    }
  })], 1), _vm._v(" "), _vm.showError ? _c('div', {
    staticClass: "address-step__error"
  }, [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")]) : _vm._e(), _vm._v(" "), _vm.personError ? _c('div', {
    staticClass: "address-step__error"
  }, [_vm._v("\n        " + _vm._s(_vm.personError) + "\n      ")]) : _vm._e()])])], 1);
};

var __vue_staticRenderFns__$18 = [];
/* style */

var __vue_inject_styles__$1a = undefined;
/* scoped */

var __vue_scope_id__$1a = "data-v-59f3c0ac";
/* module identifier */

var __vue_module_identifier__$1a = undefined;
/* functional template */

var __vue_is_functional_template__$1a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$18,
  staticRenderFns: __vue_staticRenderFns__$18
}, __vue_inject_styles__$1a, __vue_script__$1a, __vue_scope_id__$1a, __vue_is_functional_template__$1a, __vue_module_identifier__$1a, false, undefined, undefined, undefined);

var instance$4 = new HttpService("umbraco/api/Events/");
var basketStepInstance = new HttpService("umbraco/api/BasketStep/");
var validateBookings = function validateBookings() {
  return basketStepInstance.get("ValidateBookings");
};

var script$L = {
  name: "BasketStep",
  mixins: [StyleMixin],
  props: {
    sealed: {
      type: Boolean,
      default: false
    },
    stateless: {
      type: Boolean,
      default: false
    },
    searchTypeId: {
      type: String,
      default: null
    },
    currency: {
      type: String,
      default: "GBP"
    },
    locale: {
      type: String,
      default: "en-GB"
    },
    hidePrevious: {
      type: Boolean,
      default: true
    },
    validateTickInterval: {
      type: Number,
      default: 30000
    },
    ignoreEventDelegateValidation: {
      type: Boolean,
      default: false
    },
    enableValidation: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      orderValid: false,
      invalidVouchers: null,
      unmetPreRequesiteProducts: null,
      bookingValidations: null,
      addressValidations: null,
      webAccountId: null,
      hasOrderLines: false,
      loaded: false,
      interval: null,
      refreshing: false,
      submitted: false
    };
  },
  computed: {
    valid: function valid() {
      var result = true;

      if (!this.submitted) {
        var _this$bookingValidati, _this$addressValidati;

        if (!this.orderValid) {
          result = false;
        }

        if (result && !((_this$bookingValidati = this.bookingValidations) !== null && _this$bookingValidati !== void 0 && _this$bookingValidati.valid)) {
          result = false;
        }

        if (result && !((_this$addressValidati = this.addressValidations) !== null && _this$addressValidati !== void 0 && _this$addressValidati.valid)) {
          result = false;
        }

        if (result && !this.hasOrderLines) {
          result = false;
        }
      }

      return result;
    },
    validBookings: function validBookings() {
      var _this$bookingValidati2;

      var result = true;

      if (!((_this$bookingValidati2 = this.bookingValidations) !== null && _this$bookingValidati2 !== void 0 && _this$bookingValidati2.valid)) {
        result = false;
      }

      return result;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.onValidateTick();
    this.interval = window.setInterval(function () {
      _this.onValidateTick();
    }, this.validateTickInterval);
  },
  beforeDestroy: function beforeDestroy() {
    this.clearInterval();
  },
  methods: {
    onSubmitted: function onSubmitted() {
      this.submitted = true;
      this.clearInterval();
    },
    onRefreshed: function onRefreshed() {
      this.refreshing = false;
      this.onValidateTick();
    },
    onValidateTick: function onValidateTick() {
      var _this2 = this;

      if (this.enableValidation) {
        Promise.all([this.cacheWebAccountId(), this.validateBookings(), this.validateAddresses(), this.validateOrder(), this.basketHasOrderLines()]).catch(function (err) {
          _this2.orderValid = false;

          if (err.isSpiritError) {
            var alert = new NotificationModule.SwAlert(err.message, {
              namespace: "checkout",
              variant: "danger"
            });

            _this2.$notifications.add(alert);
          } else {
            throw new Error("Something went wrong whilst validating...");
          }
        }).finally(function () {
          _this2.loaded = true;
        });
      }
    },
    clearInterval: function clearInterval() {
      window.clearInterval(this.interval);
      this.interval = null;
    },
    cacheWebAccountId: function cacheWebAccountId() {
      var _this3 = this;

      return WebAccountResource.getWebAccountId().then(function (response) {
        _this3.webAccountId = response.data;
      });
    },
    basketHasOrderLines: function basketHasOrderLines$1() {
      var _this4 = this;

      return basketHasOrderLines().then(function (response) {
        _this4.hasOrderLines = response.data;
      });
    },
    validateOrder: function validateOrder$1() {
      var _this5 = this;

      return validateOrder().then(function (response) {
        _this5.orderValid = response.data.isValid;
        _this5.invalidVouchers = response.data.invalidVouchers;
        _this5.unmetPreRequesiteProducts = response.data.unmetPreRequesiteProducts;
      });
    },
    validateBookings: function validateBookings$1() {
      var _this6 = this;

      return validateBookings().then(function (response) {
        if (response && response.data) {
          if (response.data.length === 0) {
            _this6.bookingValidations = {};
          } else if (_this6.ignoreEventDelegateValidation) {
            _this6.bookingValidations = _this6.revalidateBookings(response.data);
          } else {
            _this6.bookingValidations = response.data;
          }
        }
      });
    },
    validateAddresses: function validateAddresses$1() {
      var _this7 = this;

      return validateAddresses().then(function (response) {
        _this7.addressValidations = response.data;
      });
    },
    onCurrentStep: function () {
      var _onCurrentStep = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.refreshing = true;

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onCurrentStep() {
        return _onCurrentStep.apply(this, arguments);
      }

      return onCurrentStep;
    }(),
    revalidateBookings: function revalidateBookings(bookingValidations) {
      var result = {
        bookings: [],
        valid: true
      };

      for (var i = 0; i < bookingValidations.bookings.length; i += 1) {
        var b = bookingValidations.bookings[i]; // Ignore the allDelegateDetailsProvided field

        b.allDelegateDetailsProvided = true;
        b.valid = b.allDelegateDetailsProvided && b.allReservedDelegatesProvided && b.bookingHasNotBeenAbandoned && b.bookingHasNotExpired && b.matchesOrderLineQuantity && b.notPastLastBookingDate;
        result.bookings.push(b);

        if (!b.valid) {
          result.valid = false;
        }
      }

      return result;
    }
  }
};

var __vue_script__$1b = script$L;
/* template */

var __vue_render__$19 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "basket-step"
  }, [_c('tabbed-step', {
    attrs: {
      "name": "Review Purchases",
      "heading": "Review your purchases",
      "valid": _vm.valid,
      "loaded": _vm.loaded,
      "sealed": _vm.sealed,
      "stateless": _vm.stateless,
      "button-class": _vm.buttonClass,
      "hide-previous": _vm.hidePrevious,
      "hide-unloaded": ""
    },
    on: {
      "currentStep": _vm.onCurrentStep,
      "submitted": _vm.onSubmitted
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function fn(ref) {
        var step = ref.step;
        return [_c('step-status', {
          attrs: {
            "step": step
          }
        })];
      }
    }, {
      key: "loading",
      fn: function fn() {
        return [_vm._t("loading")];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('b-alert', {
          attrs: {
            "variant": "danger",
            "show": _vm.bookingValidations && !_vm.bookingValidations.valid
          }
        }, [_c('h2', {
          staticClass: "alert-heading"
        }, [_vm._v("\n          Error:\n        ")]), _vm._v(" "), _c('p', {
          staticClass: "alert-msg"
        }, [_vm._v("\n          Please check the highlighted bookings below.\n        ")])]), _vm._v(" "), _c('b-alert', {
          attrs: {
            "variant": "danger",
            "show": _vm.addressValidations && !_vm.addressValidations.valid
          }
        }, [_c('h2', {
          staticClass: "alert-heading"
        }, [_vm._v("\n          Error:\n        ")]), _vm._v(" "), _c('p', {
          staticClass: "alert-msg"
        }, [_vm._v("\n          Please supply your address for the highlighted products below.\n        ")])]), _vm._v(" "), _c('b-alert', {
          attrs: {
            "variant": "danger",
            "show": _vm.invalidVouchers && Object.keys(_vm.invalidVouchers).length > 0
          }
        }, [_c('h2', {
          staticClass: "alert-heading"
        }, [_vm._v("\n          Error:\n        ")]), _vm._v(" "), _c('p', {
          staticClass: "alert-msg"
        }, [_vm._v("\n          The following voucher codes have expired or are not valid for this order:\n        ")]), _vm._v(" "), _c('ul', {
          staticClass: "alert-list"
        }, _vm._l(_vm.invalidVouchers, function (invalidVoucher, index) {
          return _c('li', {
            key: index,
            staticClass: "alert-item"
          }, [_vm._v("\n            " + _vm._s(invalidVoucher) + "\n          ")]);
        }), 0)]), _vm._v(" "), _c('b-alert', {
          attrs: {
            "variant": "danger",
            "show": _vm.unmetPreRequesiteProducts && _vm.unmetPreRequesiteProducts.length > 0
          }
        }, [_c('h2', {
          staticClass: "alert-heading"
        }, [_vm._v("\n          Error:\n        ")]), _vm._v(" "), _c('p', {
          staticClass: "alert-msg"
        }, [_vm._v("\n          You are not allowed to complete this basket due to the following products,\n          these products need to have either been purchased\n          in the past or included in this basket:\n        ")]), _vm._v(" "), _c('ul', {
          staticClass: "alert-list"
        }, _vm._l(_vm.unmetPreRequesiteProducts, function (product, index) {
          return _c('li', {
            key: index,
            staticClass: "alert-item"
          }, [_vm._v("\n            " + _vm._s(product) + "\n          ")]);
        }), 0)]), _vm._v(" "), _vm._t("basket", null, {
          "bookingValidations": _vm.bookingValidations,
          "addressValidations": _vm.addressValidations,
          "searchTypeId": _vm.searchTypeId,
          "refresh": _vm.refreshing,
          "currency": _vm.currency,
          "locale": _vm.locale,
          "webAccountId": _vm.webAccountId,
          "validBookings": _vm.validBookings,
          "events": {
            refreshBookings: function refreshBookings() {
              return _vm.validateBookings(true);
            },
            refreshAddresses: function refreshAddresses() {
              return _vm.validateAddresses(true);
            },
            refreshed: _vm.onRefreshed
          }
        })];
      },
      proxy: true
    }], null, true)
  })], 1);
};

var __vue_staticRenderFns__$19 = [];
/* style */

var __vue_inject_styles__$1b = undefined;
/* scoped */

var __vue_scope_id__$1b = undefined;
/* module identifier */

var __vue_module_identifier__$1b = undefined;
/* functional template */

var __vue_is_functional_template__$1b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$19,
  staticRenderFns: __vue_staticRenderFns__$19
}, __vue_inject_styles__$1b, __vue_script__$1b, __vue_scope_id__$1b, __vue_is_functional_template__$1b, __vue_module_identifier__$1b, false, undefined, undefined, undefined);

var instance$5 = new HttpService("umbraco/api/ConfirmationStep/");
var getConfirmedOrder = function getConfirmedOrder() {
  return instance$5.get("GetConfirmedOrder");
};

var instance$6 = new HttpService("umbraco/api/Gtag/");
var getBasketEventData = function getBasketEventData() {
  return instance$6.get("GetBasketEventData");
};
var getEventData = function getEventData(productData) {
  return instance$6.post("GetEventData", productData);
};

var script$M = {
  name: "ConfirmationStep",
  components: {
    StateManager: StateManager,
    StateWrapper: StateWrapper,
    SubscriptionsManager: SubscriptionsManager,
    EventsManager: EventsManager
  },
  mixins: [StyleMixin],
  props: {
    assignEvents: {
      type: Boolean,
      default: false
    },
    assignSubscriptions: {
      type: Boolean,
      default: false
    },
    hideBackToHome: {
      type: Boolean,
      default: false
    },
    backToHomeText: {
      type: String,
      default: "Back to home"
    },
    orderHistoryLink: {
      type: String,
      default: null
    },
    orderHistoryText: {
      type: String,
      default: null
    },
    webAccountOrgId: {
      type: String,
      default: null
    },
    assignEventsButtonText: {
      type: String,
      default: "Assign Events"
    },
    assignSubscriptionsButtonText: {
      type: String,
      default: "Assign Subscriptions"
    },
    hidePricingScheduleText: {
      type: Boolean,
      default: false
    },
    orderHeaderId: {
      type: String,
      default: null
    },
    subscriptionsCount: {
      type: Number,
      default: null
    },
    eventsCount: {
      type: Number,
      default: null
    },
    userType: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    heading: {
      type: String,
      default: null
    },
    hideEventInfo: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      orderReference: null,
      newOrderId: null,
      loading: false,
      currentState: "default",
      internalSubscriptionsCount: 0,
      internalEventsCount: 0,
      isCurrentStep: false
    };
  },
  computed: {
    showAssignSubscriptions: function showAssignSubscriptions() {
      return this.assignSubscriptions && this.internalSubscriptionsCount > 0;
    },
    showAssignEvents: function showAssignEvents() {
      return this.assignEvents && this.internalEventsCount > 0;
    },
    inSubStep: function inSubStep() {
      return this.currentState === "assign-events" || this.currentState === "assign-subscriptions";
    },
    stepHeading: function stepHeading() {
      var result = "Confirmation";

      if (this.currentState === "assign-events" || this.currentState === "assign-subscriptions") {
        result = null;
      }

      return result;
    },
    isPricingScheduleTextHidden: function isPricingScheduleTextHidden() {
      var result = false;
      var eventsManager = this.nested.eventsManager;

      if (eventsManager && eventsManager.props) {
        var hidePricingScheduleText = eventsManager.props.hidePricingScheduleText;
        result = hidePricingScheduleText || this.hidePricingScheduleText;
      }

      return result;
    }
  },
  watch: {
    subscriptionsCount: {
      immediate: true,
      handler: function handler(val) {
        this.internalSubscriptionsCount = val;
      }
    },
    eventsCount: {
      immediate: true,
      handler: function handler(val) {
        this.internalEventsCount = val;
      }
    }
  },
  inject: {
    checkout: {
      default: function _default() {
        throw new Error("A step must be within a <checkout>");
      }
    },
    nested: {
      default: function _default() {
        return {
          eventsManager: {
            props: {
              hidePricingScheduleText: false
            }
          }
        };
      }
    }
  },
  methods: {
    onCurrentStep: function () {
      var _onCurrentStep = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, items, eventDataResponse, eventData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loading = true;
                _context.prev = 1;
                _context.next = 4;
                return getConfirmedOrder();

              case 4:
                response = _context.sent;
                items = [];

                if (!(response && response.data)) {
                  _context.next = 18;
                  break;
                }

                if (!(response.data.sopLines && response.data.sopLines.length > 0)) {
                  _context.next = 12;
                  break;
                }

                _context.next = 10;
                return getEventData(response.data.sopLines.map(function (l) {
                  return {
                    id: l.productId,
                    price: l.itemPrice,
                    quantity: l.quantity
                  };
                }));

              case 10:
                eventDataResponse = _context.sent;

                if (eventDataResponse && eventDataResponse.data) {
                  items = eventDataResponse.data;
                }

              case 12:
                this.$root.$emit("sw::clearBasket::request");
                this.orderReference = response.data.reference;
                this.newOrderId = response.data.id;
                this.$gtag.onEvent({
                  ecommerce: null
                }); // Clear the previous ecommerce object

                if (this.$gtag.useUaAnalytics === "true") {
                  eventData = {
                    event: "ecomPurchase",
                    ecommerce: {
                      purchase: {
                        actionField: {
                          id: this.orderReference,
                          revenue: response.data.totalExcludingVat,
                          step: this.checkout.currentStepIndex + 1
                        },
                        products: items.map(this.$gtag.parseAdditionalData)
                      }
                    }
                  };
                } else {
                  eventData = {
                    event: "purchase",
                    ecommerce: {
                      transaction_id: this.orderReference,
                      value: response.data.totalExcludingVat,
                      currency: "GBP",
                      items: items.map(this.$gtag.parseAdditionalData)
                    }
                  };
                }

                this.$gtag.onEvent(eventData);

              case 18:
                _context.next = 23;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](1);
                console.log("error", _context.t0);

              case 23:
                _context.prev = 23;
                this.loading = false;
                this.isCurrentStep = true;
                return _context.finish(23);

              case 27:
                this.$emit("submit", true);

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 20, 23, 27]]);
      }));

      function onCurrentStep() {
        return _onCurrentStep.apply(this, arguments);
      }

      return onCurrentStep;
    }()
  }
};

/* script */
var __vue_script__$1c = script$M;
/* template */

var __vue_render__$1a = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "confirmation-step"
  }, [_c('tabbed-step', {
    attrs: {
      "name": _vm.stepHeading,
      "heading": _vm.heading,
      "loaded": !_vm.loading,
      "no-header": _vm.inSubStep,
      "button-class": _vm.buttonClass,
      "hide-back-to-home": "",
      "valid": "",
      "no-footer": "",
      "hide-unloaded": ""
    },
    on: {
      "currentStep": _vm.onCurrentStep
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function fn(ref) {
        var step = ref.step;
        return [_c('step-status', {
          attrs: {
            "step": step
          }
        })];
      }
    }, {
      key: "loading",
      fn: function fn() {
        return [_vm._t("loading")];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('state-manager', {
          model: {
            value: _vm.currentState,
            callback: function callback($$v) {
              _vm.currentState = $$v;
            },
            expression: "currentState"
          }
        }, [_c('state-wrapper', {
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(ref) {
              var setState = ref.setState;
              return [_c('div', {
                staticClass: "confirmation-step__content"
              }, [_c('h2', {
                staticClass: "confirmation-step__heading"
              }, [_vm._t("subHeading", [_vm._v("\n                Thank you for your order\n              ")])], 2), _vm._v(" "), _vm._t("prefix", null, {
                "orderReference": _vm.orderReference
              }), _vm._v(" "), _vm._t("confirmation", [_c('div', {
                staticClass: "alert alert-success",
                staticStyle: {
                  "margin-top": "20px"
                }
              }, [_c('div', {
                staticClass: "orderNumberHighlight"
              }, [_vm._t("confirmationText", [_vm._v("\n                    Your order has been successful, and your order number is\n                    "), _c('strong', [_vm._v(_vm._s(_vm.orderReference))]), _vm._v(".\n                  ")], {
                "orderReference": _vm.orderReference
              })], 2)])], {
                "orderReference": _vm.orderReference
              }), _vm._v(" "), _vm._t("default", null, {
                "orderReference": _vm.orderReference
              }), _vm._v(" "), _c('div', {
                staticClass: "confirmation-step__footer"
              }, [_vm.showAssignEvents ? _c('button', {
                class: _vm.style.getButtonClass('confirmation-step__assign-button'),
                on: {
                  "click": function click($event) {
                    return setState('assign-events');
                  }
                }
              }, [_vm._v("\n                " + _vm._s(_vm.assignEventsButtonText) + "\n              ")]) : _vm._e(), _vm._v(" "), _vm.showAssignSubscriptions ? _c('button', {
                class: _vm.style.getButtonClass('confirmation-step__assign-button'),
                on: {
                  "click": function click($event) {
                    return setState('assign-subscriptions');
                  }
                }
              }, [_vm._v("\n                " + _vm._s(_vm.assignSubscriptionsButtonText) + "\n              ")]) : _vm._e(), _vm._v(" "), _vm.orderHistoryText && _vm.orderHistoryLink ? _c('a', {
                class: _vm.style.getButtonClass('confirmation-step__order-history'),
                attrs: {
                  "href": _vm.orderHistoryLink
                }
              }, [_vm._v("\n                " + _vm._s(_vm.orderHistoryText) + "\n              ")]) : _vm._e(), _vm._v(" "), !_vm.hideBackToHome ? _c('a', {
                class: _vm.style.getButtonClass('confirmation-step__back'),
                attrs: {
                  "href": "/"
                }
              }, [_vm._v("\n                " + _vm._s(_vm.backToHomeText) + "\n              ")]) : _vm._e()])], 2)];
            }
          }], null, true)
        }), _vm._v(" "), _vm.isCurrentStep ? _c('state-wrapper', {
          attrs: {
            "name": "assign-events",
            "use-show": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(ref) {
              var goBack = ref.goBack;
              return [_vm._t("events-manager", [_c('events-manager', {
                attrs: {
                  "default-org-id": _vm.webAccountOrgId,
                  "hide-pricing-schedule-text": _vm.isPricingScheduleTextHidden,
                  "button-class": _vm.buttonClass,
                  "order-header-id": _vm.orderHeaderId,
                  "user-type": _vm.userType,
                  "hide-event-info": _vm.hideEventInfo
                },
                on: {
                  "count": function count(val) {
                    return _vm.internalEventsCount = val;
                  }
                }
              })]), _vm._v(" "), _c('button', {
                class: _vm.style.getButtonClass('confirmation-step__back'),
                on: {
                  "click": goBack
                }
              }, [_vm._v("\n            Back to confirmation\n          ")]), _vm._v(" "), _vm.orderHistoryText && _vm.orderHistoryLink ? _c('a', {
                class: _vm.style.getButtonClass('confirmation-step__order-history'),
                attrs: {
                  "href": _vm.orderHistoryLink
                }
              }, [_vm._v("\n            " + _vm._s(_vm.orderHistoryText) + "\n          ")]) : _vm._e(), _vm._v(" "), !_vm.hideBackToHome ? _c('a', {
                class: _vm.style.getButtonClass('confirmation-step__back'),
                attrs: {
                  "href": "/"
                }
              }, [_vm._v("\n            " + _vm._s(_vm.backToHomeText) + "\n          ")]) : _vm._e()];
            }
          }], null, true)
        }) : _vm._e(), _vm._v(" "), _vm.isCurrentStep ? _c('state-wrapper', {
          attrs: {
            "name": "assign-subscriptions",
            "use-show": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(ref) {
              var goBack = ref.goBack;
              return [_vm._t("subscription-manager", [_c('subscriptions-manager', {
                attrs: {
                  "heading": "Assign Subscriptions",
                  "button-class": _vm.buttonClass,
                  "order-header-id": _vm.orderHeaderId,
                  "new-order-id": _vm.newOrderId,
                  "user-type": _vm.userType,
                  "hide-event-info": _vm.hideEventInfo
                },
                on: {
                  "count": function count(val) {
                    return _vm.internalSubscriptionsCount = val;
                  }
                },
                scopedSlots: _vm._u([{
                  key: "loading",
                  fn: function fn() {
                    return [_vm._t("loading")];
                  },
                  proxy: true
                }], null, true)
              })]), _vm._v(" "), _c('button', {
                class: _vm.style.getButtonClass('confirmation-step__back'),
                on: {
                  "click": goBack
                }
              }, [_vm._v("\n            Back to confirmation\n          ")]), _vm._v(" "), _vm.orderHistoryText && _vm.orderHistoryLink ? _c('a', {
                class: _vm.style.getButtonClass('confirmation-step__order-history'),
                attrs: {
                  "href": _vm.orderHistoryLink
                }
              }, [_vm._v("\n            " + _vm._s(_vm.orderHistoryText) + "\n          ")]) : _vm._e(), _vm._v(" "), !_vm.hideBackToHome ? _c('a', {
                class: _vm.style.getButtonClass('confirmation-step__back'),
                attrs: {
                  "href": "/"
                }
              }, [_vm._v("\n            " + _vm._s(_vm.backToHomeText) + "\n          ")]) : _vm._e()];
            }
          }], null, true)
        }) : _vm._e()], 1)];
      },
      proxy: true
    }], null, true)
  })], 1);
};

var __vue_staticRenderFns__$1a = [];
/* style */

var __vue_inject_styles__$1c = undefined;
/* scoped */

var __vue_scope_id__$1c = "data-v-0baff4dc";
/* module identifier */

var __vue_module_identifier__$1c = undefined;
/* functional template */

var __vue_is_functional_template__$1c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1a,
  staticRenderFns: __vue_staticRenderFns__$1a
}, __vue_inject_styles__$1c, __vue_script__$1c, __vue_scope_id__$1c, __vue_is_functional_template__$1c, __vue_module_identifier__$1c, false, undefined, undefined, undefined);

// https://github.com/tc39/proposal-object-values-entries

var $values = _objectToArray(false);

_export(_export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

var instance$7 = new HttpService("umbraco/api/Basket/");
var listItemsInBasket = function listItemsInBasket() {
  return instance$7.get("ListItemsInBasket");
};
var getMetadataForBasketItems = function getMetadataForBasketItems() {
  return instance$7.get("GetMetadataForBasketItems");
};
var saveOrderLineMetadata = function saveOrderLineMetadata(orderLineId, metadata) {
  return instance$7.put("SaveOrderLineMetadata", metadata, {
    orderLineId: orderLineId
  });
};

var __vue_script__$1d = script$I;
/* template */

var __vue_render__$1b = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "metadata-page"
  }, [_c('div', {
    staticClass: "intro"
  }, [_c('h2', {
    staticClass: "metadata-page__heading"
  }, [_vm._v("\n      " + _vm._s(_vm.mutable.name || "Untitled") + "\n    ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _vm._t("validation", [_vm.showValidation ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._t("validation-message", [_vm._v("\n          One or more mandatory fields are empty.\n        ")])], 2) : _vm._e()])], 2), _vm._v(" "), _vm._l(_vm.mutable.metadata, function (field, index) {
    return _c('div', {
      key: field.fieldId,
      staticClass: "metadata-field"
    }, [field.component ? _c(field.component, _vm._b({
      key: field.fieldId,
      tag: "Component",
      attrs: {
        "should-focus": index === 0,
        "show-validation": _vm.showValidation
      },
      model: {
        value: field.value,
        callback: function callback($$v) {
          _vm.$set(field, "value", $$v);
        },
        expression: "field.value"
      }
    }, 'Component', field, false)) : _vm._e()], 1);
  })], 2);
};

var __vue_staticRenderFns__$1b = [];
/* style */

var __vue_inject_styles__$1d = undefined;
/* scoped */

var __vue_scope_id__$1d = "data-v-b38e2a78";
/* module identifier */

var __vue_module_identifier__$1d = undefined;
/* functional template */

var __vue_is_functional_template__$1d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1b,
  staticRenderFns: __vue_staticRenderFns__$1b
}, __vue_inject_styles__$1d, __vue_script__$1d, __vue_scope_id__$1d, __vue_is_functional_template__$1d, __vue_module_identifier__$1d, false, undefined, undefined, undefined);

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var script$N = {
  name: "MetadataStep",
  inject: {
    checkout: {
      default: function _default() {
        throw new Error("A step must be within a <checkout>");
      }
    }
  },
  components: {
    MetadataPage: __vue_component__$1d
  },
  mixins: [StyleMixin],
  props: {
    sealed: {
      type: Boolean,
      default: false
    },
    stateless: {
      type: Boolean,
      default: false
    },
    hidePrevious: {
      type: Boolean,
      default: true
    },
    showValidation: {
      type: Boolean,
      dafault: false
    },

    /**
     * Message to display at top of page each meta data page
     */
    metadataPageMessage: {
      type: String,
      default: "Please provide the details below to complete your enquiry."
    }
  },
  data: function data() {
    return {
      currentPage: 0,
      orderMetadataCollection: {},
      orderLines: [],
      loading: true,
      saving: false,
      valid: true,
      userMetadata: undefined,
      debouncedSaveMetadata: undefined,
      performValidation: false,
      userMetadataArc: []
    };
  },
  computed: {
    numPages: function numPages() {
      var result = 0;

      if (this.orderMetadataCollection) {
        result = Object.values(this.orderMetadataCollection).filter(function (x) {
          return x.length > 0;
        }).length;
      }

      return result;
    },
    currentPageId: function currentPageId() {
      var result = null;

      if (this.orderMetadataCollection) {
        var sortedKeys = Object.keys(this.orderMetadataCollection);
        sortedKeys.sort(function (a, b) {
          if (a.firstname < b.firstname) {
            return -1;
          }

          if (a.firstname > b.firstname) {
            return 1;
          }

          return 0;
        });
        result = sortedKeys[this.currentPage];
      }

      return result;
    },
    lastPage: function lastPage() {
      return !(this.currentPage + 1 < this.numPages);
    },
    canGoPrevious: function canGoPrevious() {
      return this.currentPage > 0 || !this.hidePrevious && this.checkout.canGoToPreviousStep;
    }
  },
  watch: {
    userMetadata: {
      deep: true,
      handler: function handler() {
        if (this.debouncedSaveMetadata) {
          this.debouncedSaveMetadata();
        }
      }
    }
  },
  created: function () {
    var _created = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this = this;

      var _yield$listItemsInBas, basketItems;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return listItemsInBasket();

            case 2:
              _yield$listItemsInBas = _context.sent;
              basketItems = _yield$listItemsInBas.data;

              if (basketItems && basketItems instanceof Array) {
                this.orderLines = basketItems;
              }

              getMetadataForBasketItems().then(function (_ref) {
                var basketOrderMetadata = _ref.data;

                _this.log(basketOrderMetadata, "BASKET METADATA: ");

                if (basketOrderMetadata) {
                  basketOrderMetadata.forEach(function (orderMetadata) {
                    if (orderMetadata.metadata instanceof Array && orderMetadata.metadata.length > 0) {
                      var orderLineId = orderMetadata.orderLineId,
                          metadata = orderMetadata.metadata;
                      var mappedMetadata = metadata.map(function (metaDatum) {
                        var _this$getOrderLine$pr, _this$getOrderLine;

                        return _objectSpread$6({}, metaDatum, {
                          productDisplayName: (_this$getOrderLine$pr = (_this$getOrderLine = _this.getOrderLine(orderLineId)) === null || _this$getOrderLine === void 0 ? void 0 : _this$getOrderLine.productDisplayName) !== null && _this$getOrderLine$pr !== void 0 ? _this$getOrderLine$pr : undefined
                        });
                      });

                      _this.$set(_this.orderMetadataCollection, orderLineId, mappedMetadata);
                    }
                  });
                }
              }).finally(function () {
                _this.log(_this.orderMetadataCollection, "Order meta data collection: ");

                _this.setUserMetadata();

                _this.loading = false;
              });
              this.debouncedSaveMetadata = debounce(function () {
                return _this.saveMetadata(_this.userMetadata.metadata).then(function (result) {
                  _this.log(result, "Saved metadata: ");
                });
              }, 1000);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    log: function log(data) {
      var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ">>> ";

      if (process.env.NODE_ENV !== "production") {
        console.log(label, data);
      }
    },

    /**
     * Set or initialise the userMetadata value for the active page
     * @param {Object} metadata The meta data to set
     */
    setUserMetadata: function setUserMetadata(metadata) {
      if (metadata) {
        this.userMetadata = metadata;
      } else if (this.userMetadataArc[this.currentPageId]) {
        this.userMetadata = this.userMetadataArc[this.currentPageId];
      } else {
        this.userMetadata = {
          id: this.currentPageId,
          metadata: this.orderMetadataCollection[this.currentPageId]
        };
      }
    },
    saveMetadata: function saveMetadata() {
      var _this2 = this;

      var metadata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      this.saving = true;
      return new Promise(function (resolve, reject) {
        var payload = metadata === undefined ? _this2.orderMetadataCollection[_this2.currentPageId] : metadata;

        if (payload) {
          saveOrderLineMetadata(_this2.currentPageId, payload).then(function (_ref2) {
            var data = _ref2.data;
            resolve(data);
          }).catch(function (e) {
            return reject(e);
          }).finally(function () {
            _this2.saving = false;
          });
        }
      });
    },

    /**
     * Store the current visible userMetadata page data.
     * Needed to repopulate when switching back forth between meta data pages
     */
    storeMetadataPage: function storeMetadataPage() {
      this.userMetadataArc[this.currentPageId] = this.userMetadata;
    },
    isActiveProductPage: function isActiveProductPage(pageId) {
      return this.currentPageId === pageId;
    },
    goToPreviousPage: function goToPreviousPage(step) {
      var _this3 = this;

      this.storeMetadataPage();
      this.saveMetadata().then(function () {
        if (_this3.currentPage > 0) {
          _this3.currentPage -= 1;

          _this3.setUserMetadata();
        } else {
          step.goToPreviousStep();
        }
      });
    },
    goToNextPage: function goToNextPage(step) {
      var _this$userMetadata,
          _this4 = this;

      this.performValidation = true;
      if (this.showPageValidation(this.currentPageId)) return;
      this.storeMetadataPage();
      this.saveMetadata((_this$userMetadata = this.userMetadata) === null || _this$userMetadata === void 0 ? void 0 : _this$userMetadata.metadata).then(function () {
        _this4.performValidation = false;

        if (_this4.lastPage) {
          step.goToNextStep();
        } else {
          _this4.$scrollTo("#vue-scrollto-anchor-metadata", 300, {
            offset: -50
          });

          _this4.currentPage += 1;

          _this4.setUserMetadata();
        }
      });
    },
    getOrderLine: function getOrderLine(id) {
      var result = {};
      var match = this.orderLines.find(function (x) {
        return x.id === id;
      });

      if (match) {
        result = match;
      }

      return result;
    },

    /**
     * Should validation be shown for the supplied metadata page
     * @param {String} pageId Id of the value to validate (will be an orderLineId)
     */
    showPageValidation: function showPageValidation(pageId) {
      if (!this.showValidation) return false;
      if (!this.performValidation) return false;
      var invalidFields = false;

      if (this.userMetadata && this.userMetadata.id === pageId) {
        invalidFields = this.userMetadata.metadata.some(function (md) {
          return md.mandatory && !md.value;
        });
      }

      return invalidFields;
    }
  }
};

/* script */
var __vue_script__$1e = script$N;
/* template */

var __vue_render__$1c = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "metadata-step"
  }, [_vm.numPages > 0 ? _c('tabbed-step', {
    attrs: {
      "name": "Additional Info",
      "loaded": !_vm.loading,
      "valid": _vm.lastPage,
      "sealed": _vm.sealed,
      "hide-previous": _vm.hidePrevious,
      "button-class": _vm.buttonClass,
      "stateless": _vm.stateless,
      "hide-unloaded": ""
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function fn(ref) {
        var step = ref.step;
        return [_c('step-status', {
          attrs: {
            "step": step
          }
        })];
      }
    }, {
      key: "loading",
      fn: function fn() {
        return [_vm._t("loading")];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('div', {
          staticClass: "metadata-step__nav",
          attrs: {
            "id": "vue-scrollto-anchor-metadata"
          }
        }, [_vm._v("\n        Product " + _vm._s(_vm.currentPage + 1) + " of " + _vm._s(_vm.numPages) + "\n      ")]), _vm._v(" "), _c('div', {
          staticClass: "metadata-step__body"
        }, _vm._l(_vm.orderMetadataCollection, function (metaDatum, id) {
          return _c('div', {
            key: id,
            staticClass: "metadata-step__pages"
          }, [_c('div', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: _vm.isActiveProductPage(id),
              expression: "isActiveProductPage(id)"
            }],
            staticClass: "metadata-step__page"
          }, [_c('MetadataPage', {
            attrs: {
              "id": id,
              "name": _vm.orderMetadataCollection[id][0].productDisplayName,
              "message": _vm.metadataPageMessage,
              "show-validation": _vm.showPageValidation(id)
            },
            on: {
              "user-metadata": _vm.setUserMetadata
            },
            model: {
              value: _vm.orderMetadataCollection[id],
              callback: function callback($$v) {
                _vm.$set(_vm.orderMetadataCollection, id, $$v);
              },
              expression: "orderMetadataCollection[id]"
            }
          })], 1)]);
        }), 0), _vm._v(" "), _c('div', {
          staticClass: "metadata-step__nav"
        }, [_vm._v("\n        Product " + _vm._s(_vm.currentPage + 1) + " of " + _vm._s(_vm.numPages) + "\n      ")])];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function fn(ref) {
        var step = ref.step;
        return [_c('div', {
          staticClass: "metadata-step__footer"
        }, [_vm._t("metadataFooter"), _vm._v(" "), !_vm.lastPage ? [_c('button', {
          staticClass: "step__footer-button step__continue no-disabled",
          class: _vm.buttonClass,
          on: {
            "click": function click($event) {
              return _vm.goToNextPage();
            }
          }
        }, [_vm.saving ? [_c('font-awesome-icon', {
          attrs: {
            "icon": "spinner",
            "spin": ""
          }
        })] : [_vm._v("\n              Continue\n            ")]], 2)] : [_c('button', {
          staticClass: "step__footer-button step__continue",
          class: _vm.buttonClass,
          on: {
            "click": function click($event) {
              return _vm.goToNextPage(step);
            }
          }
        }, [_vm._v("\n            Continue\n          ")])], _vm._v(" "), _vm.canGoPrevious ? _c('button', {
          staticClass: "btn btn-link",
          class: _vm.buttonClass,
          on: {
            "click": function click($event) {
              return _vm.goToPreviousPage();
            }
          }
        }, [_vm._v("\n          Back\n        ")]) : _vm._e()], 2)];
      }
    }], null, true)
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__$1c = [];
/* style */

var __vue_inject_styles__$1e = undefined;
/* scoped */

var __vue_scope_id__$1e = "data-v-b13aee56";
/* module identifier */

var __vue_module_identifier__$1e = undefined;
/* functional template */

var __vue_is_functional_template__$1e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1c,
  staticRenderFns: __vue_staticRenderFns__$1c
}, __vue_inject_styles__$1e, __vue_script__$1e, __vue_scope_id__$1e, __vue_is_functional_template__$1e, __vue_module_identifier__$1e, false, undefined, undefined, undefined);

/* script */
var __vue_script__$1f = script$J;
/* template */

var __vue_render__$1d = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.hasCarriageOptions ? _c('div', {
    class: _vm.classes
  }, [_c('label', {
    staticClass: "address-carriage__address-label"
  }, [_vm._v("\n    " + _vm._s(_vm.addressLabel) + "\n  ")]), _vm._v(" "), _c('pre', {
    staticClass: "address-carriage__address"
  }, [_vm._v("    " + _vm._s(_vm.formattedAddress) + "\n  ")]), _vm._v(" "), _vm.carriageLabel ? _c('label', {
    staticClass: "address-carriage__carriage-label"
  }, [_vm._v("\n    " + _vm._s(_vm.carriageLabel) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('b-form-select', {
    staticClass: "address-carriage__carriage",
    attrs: {
      "value": _vm.carriageId,
      "options": _vm.carriageOptions,
      "value-field": "id",
      "text-field": "description"
    },
    on: {
      "input": _vm.onCarriageSelect
    }
  }), _vm._v(" "), _vm.validate && !_vm.isValid ? _c('label', {
    staticClass: "address-carriage__validate"
  }, [_vm._v("\n    " + _vm._s(_vm.validationError) + "\n  ")]) : _vm._e()], 1) : _vm._e();
};

var __vue_staticRenderFns__$1d = [];
/* style */

var __vue_inject_styles__$1f = undefined;
/* scoped */

var __vue_scope_id__$1f = "data-v-1b420ead";
/* module identifier */

var __vue_module_identifier__$1f = undefined;
/* functional template */

var __vue_is_functional_template__$1f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1d,
  staticRenderFns: __vue_staticRenderFns__$1d
}, __vue_inject_styles__$1f, __vue_script__$1f, __vue_scope_id__$1f, __vue_is_functional_template__$1f, __vue_module_identifier__$1f, false, undefined, undefined, undefined);

var script$O = {
  name: "MultiCarriageStep",
  components: {
    AddressCarriage: __vue_component__$1f
  },
  mixins: [StyleMixin],
  props: {
    /**
     * Whether this step is stateless
     */
    stateless: {
      type: Boolean,
      default: false
    },

    /**
     * Step heading
     */
    heading: {
      type: String,
      default: null
    },

    /**
     * Whether we can go back to the previous step
     */
    hidePrevious: {
      type: Boolean,
      default: true
    },

    /**
     * If this is true then we will load the step when it is mounted
     * this is useful if it is the first step or there is no Your Details step
     */
    loadOnMount: {
      type: Boolean,
      default: false
    },

    /**
     * Default title text for each address
     */
    addressLabel: {
      type: String,
      default: "Address:"
    },

    /**
     * Text to use for the please select message
     */
    pleaseSelectText: {
      type: String,
      default: "Please select carriage for this address..."
    },

    /**
     * Carriage options label
     */
    carriageLabel: {
      type: String,
      default: "The following carriage will be used when delivering to this address"
    },

    /**
     * Back button caption
     */
    backBtn: {
      type: String,
      default: "Back"
    },

    /**
     * Continue button caption
     */
    continueBtn: {
      type: String,
      default: "Continue"
    },

    /**
     * Validation message displayed if no carriage is selected
     */
    validationError: {
      type: String,
      default: "Please select a carriage option for this line"
    }
  },
  data: function data() {
    return {
      // List of address carriage options for each order line
      addresses: [],
      carriageToAdd: [],
      loaded: false,
      saving: false,
      stepId: null,
      showError: false,
      showValidation: false
    };
  },
  computed: {
    /**
     * Whether or not we have addresses with carriage options
     */
    hasAddresses: function hasAddresses() {
      var _this$addresses;

      return ((_this$addresses = this.addresses) === null || _this$addresses === void 0 ? void 0 : _this$addresses.length) > 0;
    },

    /**
     * Whether or not we can go back a step
     */
    canGoPrevious: function canGoPrevious() {
      return !this.hidePrevious && this.checkout.canGoToPreviousStep;
    },

    /**
     * Whether the step is valid or not
     */
    valid: function valid() {
      var _this$carriageToAdd;

      // For the page to be valid alll carriage items to add have to have an ID that
      // does not equal 0 or we have to have no addresses (i.e. no multi-ship carriage data to set)
      return !this.hasAddresses || ((_this$carriageToAdd = this.carriageToAdd) === null || _this$carriageToAdd === void 0 ? void 0 : _this$carriageToAdd.every(function (carriageItem) {
        var _carriageItem$carriag;

        return ((_carriageItem$carriag = carriageItem === null || carriageItem === void 0 ? void 0 : carriageItem.carriageId) !== null && _carriageItem$carriag !== void 0 ? _carriageItem$carriag : 0) !== 0;
      }));
    }
  },
  mounted: function mounted() {
    if (this.loadOnMount) {
      this.load();
    }
  },
  methods: {
    /**
     * Start on the invoice page when ever the address step is shown
     */
    onCurrentStep: function onCurrentStep() {
      if (!this.loadOnMount) {
        // Load the multiship carriage data
        this.load();
      }
    },

    /**
     * The step has "announced" itself to the checkout, so store
     * the ID that check out has given us
     */
    onAnnounce: function onAnnounce(val) {
      this.stepId = val;
    },

    /**
     *
     * @param {Number} carriageId The carriage ID that is being added
     */
    onCarriageChange: function onCarriageChange(carriageId) {
      console.log(carriageId);
    },

    /**
     * Load carriage options for each unique line address in the basket
     */
    load: function load() {
      var _this = this;

      loadMultiCarriageStep().then(function (response) {
        console.log(response);
        _this.addresses = response.data || [];
      }).catch(function () {
        _this.addresses = [];
      }).finally(function () {
        _this.loaded = true; // Initialise the selected carriage items

        _this.setInitialCarriage();
      });
    },

    /**
     * Set the initial carriage values selected
     */
    setInitialCarriage: function setInitialCarriage() {
      var _this2 = this;

      // Use next tick to make sure all the data has settled down
      this.$nextTick(function () {
        _this2.carriageToAdd = [];

        if (_this2.hasAddresses) {
          _this2.addresses.forEach(function (address) {
            var _address$carriageOpti;

            var carriageId = 0;

            if (((_address$carriageOpti = address.carriageOptions) === null || _address$carriageOpti === void 0 ? void 0 : _address$carriageOpti.length) === 1) {
              carriageId = address.carriageOptions[0].id;
            }

            _this2.carriageToAdd.push({
              addressId: address.deliveryAddressId,
              orgId: address.deliveryOrgId,
              carriageId: carriageId
            });
          });
        }
      });
    },

    /**
     * Move to the previous page in this step
     *
     * @param {object} step Reference to the step within the checkout
     */
    onPrevPage: function onPrevPage(step) {
      step.goToPreviousStep();
    },

    /**
     * Move to the next page in this step
     *
     * @param {object} step Reference to the step within the checkout
     */
    onNextPage: function onNextPage(step) {
      var _this3 = this;

      this.showError = false;
      this.showValidation = false;

      if (!this.hasAddresses) {
        // No carriage data to save so just go to the next step
        step.goToNextStep();
      } else if (this.valid) {
        // Save address data
        this.saving = true;
        applyMultiCarriage(this.carriageToAdd).then(function (response) {
          if (response.data) {
            step.goToNextStep();
          } else {
            _this3.showError = true;
          }
        }).catch(function () {
          _this3.showError = true;
        }).finally(function () {
          _this3.saving = false;
        });
      } else {
        // Something must be wrong that is preventing us from attempting to save,
        // Show andy carriage validation errors
        this.showValidation = true;
      }
    }
  }
};

/* script */
var __vue_script__$1g = script$O;
/* template */

var __vue_render__$1e = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "multi-carriage-step"
  }, [_c('tabbed-step', {
    attrs: {
      "name": "Multi-ship Carriage",
      "heading": _vm.heading,
      "valid": _vm.valid,
      "loaded": _vm.loaded,
      "stateless": _vm.stateless,
      "hide-previous": _vm.hidePrevious,
      "button-class": _vm.buttonClass,
      "hide-unloaded": ""
    },
    on: {
      "currentStep": _vm.onCurrentStep
    },
    scopedSlots: _vm._u([{
      key: "loading",
      fn: function fn() {
        return [_vm._t("loading")];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function fn(ref) {
        var step = ref.step;
        return [_c('div', {
          staticClass: "multi-carriage-step__footer"
        }, [_vm._t("multiCarriageFooter"), _vm._v(" "), _vm.canGoPrevious ? _c('button', {
          staticClass: "step__footer-button step__back",
          class: _vm.buttonClass,
          on: {
            "click": function click($event) {
              return _vm.onPrevPage(step);
            }
          }
        }, [_vm._v("\n          " + _vm._s(_vm.backBtn) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
          staticClass: "step__footer-button step__continue no-disabled",
          class: _vm.buttonClass,
          on: {
            "click": function click($event) {
              return _vm.onNextPage(step);
            }
          }
        }, [_vm.saving ? [_c('font-awesome-icon', {
          attrs: {
            "icon": "spinner",
            "spin": ""
          }
        })] : [_vm._v("\n            " + _vm._s(_vm.continueBtn) + "\n          ")]], 2)], 2)];
      }
    }], null, true)
  }, [_vm._v(" "), _vm.$slots.info ? _c('div', {
    staticClass: "multi-carriage-step__page-info"
  }, [_vm._t("info")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "multi-carriage-step__content"
  }, [_vm.hasAddresses ? _c('div', {
    staticClass: "multi-carriage-step__addresses"
  }, [_c('div', {
    staticClass: "multi-carriage-step__addresses-header"
  }, [_vm._t("addressesHeader", [_vm._v("\n            Addresses\n          ")])], 2), _vm._v(" "), _vm._l(_vm.addresses, function (address, index) {
    return _c('AddressCarriage', {
      key: index,
      attrs: {
        "address": address,
        "please-select-text": _vm.pleaseSelectText,
        "carriage-label": _vm.carriageLabel,
        "validation-error": _vm.validationError,
        "address-label": _vm.addressLabel,
        "validate": _vm.showValidation
      },
      model: {
        value: _vm.carriageToAdd[index],
        callback: function callback($$v) {
          _vm.$set(_vm.carriageToAdd, index, $$v);
        },
        expression: "carriageToAdd[index]"
      }
    });
  })], 2) : _c('div', {
    staticClass: "multi-carriage-step__no-addresses"
  }, [_vm._t("noAddresses", [_vm._v("\n          No lines in the basket have delivery addresses or require carriage\n        ")])], 2), _vm._v(" "), _vm.showError ? _c('div', {
    staticClass: "multi-carriage-step__error"
  }, [_vm._t("errorMessage", [_vm._v("\n          Unable to apply selected carriage. If the the problem persists, please contact support.\n        ")])], 2) : _vm._e()])])], 1);
};

var __vue_staticRenderFns__$1e = [];
/* style */

var __vue_inject_styles__$1g = undefined;
/* scoped */

var __vue_scope_id__$1g = undefined;
/* module identifier */

var __vue_module_identifier__$1g = undefined;
/* functional template */

var __vue_is_functional_template__$1g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1e,
  staticRenderFns: __vue_staticRenderFns__$1e
}, __vue_inject_styles__$1g, __vue_script__$1g, __vue_scope_id__$1g, __vue_is_functional_template__$1g, __vue_module_identifier__$1g, false, undefined, undefined, undefined);

// 7.2.9 SameValue(x, y)
var _sameValue = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

// @@search logic
_fixReWks('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = _anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!_sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = _regexpExecAbstract(rx, S);
      if (!_sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

var instance$8 = new HttpService("umbraco/surface/PaymentSurface/");
/* eslint-disable arrow-body-style */
// #region types

/** Card, invoice, direct debit, etc.
 * @typedef {Object} PaymentMethod
 * @property {string} paymentMethodId how the payment is handled in SPIRIT
 * @property {string} paymentMethodName the display name for the method
 * @property {boolean} allowed is this payment method allowed?
 * @property {string} notAllowedReason why isn't this allowed?
 * @property {string} systemCode how we should handle this payment
 */

/** Values required by the payment provider for a card payment
 * @typedef {Object} PaymentInformation
 * @property {string} actionUrl the url to be redirected to
 * @property {number} paymentType an enum that represents which card service to get info for
 * @property {Array<{name:string, value:string}>} paymentParameters
 * values used by the card provider
 */
// #endregion types

/** Make a payment using 1st party means such as invoice or direct debit
 * @param {string} poReference the user's reference for this payment
 * @param {string} paymentMethodId determines how the payment is processed
 * @param {string} orderHeaderId UUID, uses basketId if null
 * @returns {{data:boolean}} true if successful, wrapped in an Axios response
 */

var submitInternalPayment = function submitInternalPayment(poReference, paymentMethodId, orderHeaderId) {
  return instance$8.post("SubmitInternalPayment", null, {
    poReference: poReference,
    paymentMethodId: paymentMethodId,
    orderHeaderId: orderHeaderId
  });
};
/** Lists all available payment methods
 * @param {string} orderHeaderId UUID, uses basketId if null
 * @returns {{data:Array<PaymentMethod>}} an array of payment methods
 */

var listPaymentMethods = function listPaymentMethods() {
  var orderHeaderId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return instance$8.get("ListPaymentMethods", {
    orderHeaderId: orderHeaderId
  });
};
/**
 * Log that an external payment is starting
 * @param {string} paymentMethodId (Optional) The payment method id
 * @param {string} orderHeaderId UUID, uses basketId if null
 */

var logExternalPaymentStart = function logExternalPaymentStart() {
  var paymentMethodId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var orderHeaderId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  instance$8.post("LogExternalPaymentStart", null, {
    paymentMethodId: paymentMethodId,
    orderHeaderId: orderHeaderId
  });
};

var instance$9 = new HttpService("umbraco/api/PaymentStep/");
var orderReferenceRequired = function orderReferenceRequired() {
  return instance$9.get("OrderReferenceRequired");
};

var script$P = {
  name: "PaymentStep",
  components: {
    VSelect: VSelect
  },
  mixins: [StyleMixin],
  props: {
    termsLink: {
      type: String,
      default: null
    },
    redirectNotice: {
      type: String,
      default: "Clicking continue will redirect you to a secure payment site."
    },
    sealed: {
      type: Boolean,
      default: false
    },
    stateless: {
      type: Boolean,
      default: false
    },
    forceInvoice: {
      type: Boolean,
      default: false
    },
    forceInvoiceMessage: {
      type: String,
      default: null
    },
    includeVat: {
      type: Boolean,
      default: false
    },
    cardPaymentIcons: {
      type: Array,
      default: null
    },
    invoiceSubmitButtonLabel: {
      type: String,
      default: "Submit order"
    },
    backBtn: {
      type: String,
      default: "Back"
    },
    hidePrevious: {
      type: Boolean,
      default: true
    },
    orderReferencePlaceholder: {
      type: String,
      default: null
    },
    hideOnOnePaymentMethod: {
      type: Boolean,
      default: false
    },

    /**
     * A list of checkbox options that the user has to tick before
     * the step is valid
     */
    mandatoryChecks: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /**
     * Currency to send to the payment system
     */
    currency: {
      type: String,
      default: "GBP"
    },

    /**
     * Locale for displaying 3rd party payment pages
     */
    locale: {
      type: String,
      default: "en-GB"
    },
    maxPoRefLength: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      intlSealed: false,
      intlForceInvoice: false,
      loading: false,
      submitting: false,
      submitted: false,
      errorSubmitting: false,
      totalValue: null,
      acceptedTerms: false,
      cardSubmitUrl: "",
      poRequired: false,
      poReference: null,
      paymentInfo: null,
      submitAttempted: false,
      paymentMethods: [],
      intlPaymentMethodId: null,
      mandatorySelected: [],
      reason: null,
      intlValid: null,
      intlErrorMessages: []
    };
  },
  computed: {
    /**
     * Whether we have any mandatory check boxes
     */
    hasMandatoryChecks: function hasMandatoryChecks() {
      var _this$mandatoryChecks;

      return ((_this$mandatoryChecks = this.mandatoryChecks) === null || _this$mandatoryChecks === void 0 ? void 0 : _this$mandatoryChecks.length) > 0;
    },

    /**
     * A list of mandatory checkbox IDs
     */
    mandatoryCheckIds: function mandatoryCheckIds() {
      var result = [];

      if (this.hasMandatoryChecks) {
        result = this.mandatoryChecks.map(function (x) {
          return x.id;
        });
      }

      return result;
    },

    /**
     * Whether the mandatory checkboxes have all been ticked or not
     */
    mandatoryChecksValid: function mandatoryChecksValid() {
      var _this = this;

      var result = true;

      if (this.hasMandatoryChecks) {
        result = this.mandatoryCheckIds.every(function (x) {
          return _this.mandatorySelected.includes(x);
        });
      }

      return result;
    },
    poPlaceholder: function poPlaceholder() {
      var result = null;

      if (this.orderReferencePlaceholder) {
        result = this.orderReferencePlaceholder;
      } else {
        result = "Order reference";

        if (!this.poRequired) {
          result += " (optional)";
        }
      }

      return result;
    },
    paymentIcons: function paymentIcons() {
      var result = [{
        src: "/Assets/images/default-payment-icons/jcb.png",
        alt: "JCB"
      }, {
        src: "/Assets/images/default-payment-icons/maestro.png",
        alt: "Maestro"
      }, {
        src: "/Assets/images/default-payment-icons/mastercard.png",
        alt: "Mastercard"
      }, {
        src: "/Assets/images/default-payment-icons/visa.png",
        alt: "VISA"
      }];

      if (this.cardPaymentIcons && this.cardPaymentIcons.length > 0) {
        result = this.cardPaymentIcons;
      }

      return result;
    },
    isFree: function isFree() {
      return this.totalValue === 0;
    },
    isForcedInvoice: {
      get: function get() {
        return this.forceInvoice || this.intlForceInvoice || this.isFree;
      },
      set: function set(val) {
        this.intlForceInvoice = val;
      }
    },
    paymentMethodId: {
      get: function get() {
        return this.isForcedInvoice ? "INV" : this.intlPaymentMethodId;
      },
      set: function set(val) {
        this.intlPaymentMethodId = val;
      }
    },
    name: function name() {
      return this.isForcedInvoice ? "Reference" : "Payment";
    },

    /**
     * Do we have any error messages
     */
    hasErrors: function hasErrors() {
      var _this$errorMessages;

      return ((_this$errorMessages = this.errorMessages) === null || _this$errorMessages === void 0 ? void 0 : _this$errorMessages.length) > 0;
    },
    errorMessages: function errorMessages() {
      var result = _toConsumableArray(this.intlErrorMessages);

      if (this.submitAttempted) {
        if (this.hasMandatoryChecks && !this.acceptedTerms && !this.mandatoryChecksValid) {
          result.push("Please tick all the boxes above and confirm that you have read the terms and conditions.");
        } else if (this.hasMandatoryChecks && !this.mandatoryChecksValid) {
          result.push("Please tick all of the boxes above.");
        } else if (!this.acceptedTerms) {
          result.push("Please tick the box above to confirm that you have read the terms and conditions.");
        }
      }

      if (this.submitAttempted && !this.poValid) {
        result.push("Please enter an order reference.");
      }

      if (this.submitAttempted && this.paymentMethod === null) {
        result.push("No payment method has been selected.");
      }

      return result;
    },
    poValid: function poValid() {
      return !this.poRequired || this.isCardPayment || this.poRequired && this.poReference !== null && this.poReference.trim().length !== 0;
    },
    valid: {
      get: function get() {
        return this.intlValid === true || this.paymentMethod !== null && this.acceptedTerms === true && this.poValid && this.mandatoryChecksValid;
      },
      set: function set(val) {
        this.intlValid = val;
      }
    },
    isSealed: {
      get: function get() {
        return this.intlSealed || this.sealed;
      },
      set: function set(val) {
        this.intlSealed = val;
        this.$emit("update:sealed", val);
      }
    },
    paymentInfoArrayKeys: function paymentInfoArrayKeys() {
      var _this2 = this;

      var result = [];

      if (this.paymentInfo !== null) {
        Object.keys(this.paymentInfo).forEach(function (key) {
          if (Array.isArray(_this2.paymentInfo[key])) {
            result.push(key);
          }
        });
      }

      return result;
    },
    paymentInfoKeys: function paymentInfoKeys() {
      var _this3 = this;

      var result = [];

      if (this.paymentInfo !== null) {
        Object.keys(this.paymentInfo).forEach(function (key) {
          if (!Array.isArray(_this3.paymentInfo[key])) {
            result.push(key);
          }
        });
      }

      return result;
    },
    isInternalPayment: function isInternalPayment() {
      return this.isForcedInvoice || !!this.paymentMethod && this.paymentMethod.systemCode === "INVOICE";
    },
    isCardPayment: function isCardPayment() {
      return !this.isInternalPayment && !!this.paymentMethod && this.paymentMethod.systemCode === "CARD";
    },
    validPaymentMethods: function validPaymentMethods() {
      var result = [];

      if (this.paymentMethods && this.paymentMethods.length > 0) {
        result = this.paymentMethods.filter(function (m) {
          return m.allowed === true;
        });
      }

      return result;
    },
    showPaymentMethods: function showPaymentMethods() {
      if (this.hideOnOnePaymentMethod && this.validPaymentMethods.length <= 1) {
        return false;
      }

      return !this.isForcedInvoice;
    },
    paymentMethod: function paymentMethod() {
      var _this4 = this;

      var result = null; // eslint-disable-next-line

      if (this.paymentMethodId !== null && this.paymentMethods && this.paymentMethods.length > 0) {
        if (this.paymentMethodId === "INV") {
          result = this.paymentMethods.find(function (m) {
            return m.systemCode === "INVOICE";
          }) || null;
        } else {
          result = this.paymentMethods.find(function (m) {
            return m.paymentMethodId === _this4.paymentMethodId.paymentMethodId;
          }) || null;
        }
      }

      return result;
    },

    /**
     * Whether or not we can go back a page or step
     */
    canGoPrevious: function canGoPrevious() {
      return !this.hidePrevious && this.checkout.canGoToPreviousStep;
    }
  },
  inject: {
    checkout: {
      default: function _default() {
        throw new Error("A step must be within a <checkout>");
      }
    }
  },
  watch: {
    validPaymentMethods: {
      immediate: true,
      handler: function handler(val) {
        if (val.length === 1) {
          var _val = _slicedToArray(val, 1);

          this.paymentMethodId = _val[0];
        }
      }
    },
    isForcedInvoice: {
      handler: function handler(val) {
        this.$emit("update:force-update", val);
      }
    },
    isCardPayment: {
      immediate: true,
      handler: function handler(val) {
        if (val) {
          this.loadCardPaymentInfo();
        }
      }
    },
    paymentMethod: {
      handler: function handler() {
        if (this.intlValid === false) {
          this.resetValidation();
        }
      }
    }
  },
  created: function created() {
    var uri = new Uri(window.document.location.href);
    var queryString = uri.search(true);

    if (queryString && queryString.reason) {
      this.reason = queryString.reason;
    }

    var alertMessage = null;
    this.loading = false;

    switch (this.reason) {
      case "accepted":
        this.valid = true;
        break;

      case "cancelled":
        alertMessage = "Payment was cancelled.";
        break;

      case "declined":
        alertMessage = "Payment was declined.";
        break;

      case "exception":
        alertMessage = "Something went wrong during payment.";
        break;
    }

    if (alertMessage) {
      var notification = new NotificationModule.SwAlert(alertMessage, {
        namespace: "checkout",
        variant: "danger"
      });
      this.$notifications.add(notification);
    }

    if (queryString && queryString.debug === "true") {
      this.debug = true;
    }
  },
  methods: {
    submit: function submit(step) {
      var _this5 = this;

      this.submitAttempted = true;

      if (this.valid && !this.submitting && !this.submitted) {
        this.submitting = true;
        this.$gtag.onEvent({
          ecommerce: null
        });
        this.$gtag.onEvent({
          event: "checkoutOption",
          ecommerce: {
            checkout_option: {
              actionField: {
                step: this.checkout.currentStepIndex + 1,
                option: this.paymentMethod.paymentMethodName
              }
            }
          }
        });

        if (this.isInternalPayment) {
          var methodId = null;

          if (this.paymentMethodId === "INV") {
            methodId = this.paymentMethod.paymentMethodId;
          } else {
            methodId = this.paymentMethodId.paymentMethodId;
          }

          submitInternalPayment(this.poReference, methodId).then(function (response) {
            if (response.data === true || response.data === "true" || response.data === "True") {
              _this5.submitted = true;
              _this5.valid = true;

              _this5.checkout.setOrderReference("tbc"); // todo: return this from the api


              step.goToNextStep();
              _this5.intlSealed = true;
            } else {
              throw new Error("Something went wrong!");
            }
          }).catch(function (err) {
            _this5.errorSubmitting = true;
            throw err;
          }).finally(function () {
            _this5.submitting = false;
          });
        } else if (this.isCardPayment) {
          if (this.paymentInfo !== null) {
            logExternalPaymentStart(this.paymentMethod.paymentMethodId);
            this.$refs.cardPaymentForm.submit();
          } else {
            throw new Error("No Payment info available");
          }
        }
      }
    },
    addError: function addError(msg) {
      this.valid = false;

      if (this.intlErrorMessages.findIndex(function (m) {
        return m === msg;
      }) === -1) {
        this.intlErrorMessages.push(msg);
      }
    },
    resetValidation: function resetValidation() {
      this.valid = null;
      this.intlErrorMessages = [];
    },
    fetchData: function fetchData() {
      var _this6 = this;

      var promises = [];
      promises.push(axios.get("/umbraco/api/Basket/GetBasketTotalCost?includeVat=".concat(this.includeVat)).then(function (_ref) {
        var data = _ref.data;
        _this6.totalValue = data;
      }));
      promises.push(listPaymentMethods(null).then(function (_ref2) {
        var data = _ref2.data;
        _this6.paymentMethods = data;
      }));
      promises.push(orderReferenceRequired().then(function (_ref3) {
        var data = _ref3.data;
        _this6.poRequired = data;
      })); // eslint-disable-next-line

      if (this.isCardPayment && (!this.paymentInfo || Object.keys(this.paymentInfo).length === 0)) {
        promises.push(this.loadCardPaymentInfo());
      }

      return Promise.all(promises).finally(function () {
        _this6.loading = false;
      });
    },
    updatePaymentMethods: function updatePaymentMethods() {
      var _this7 = this;

      return axios.get("/umbraco/surface/PaymentStep/AllowedToPayByInvoice").then(function (response) {
        _this7.allowedToPayByInvoice = _this7.toBool(response.data);
      }).catch(function () {
        _this7.allowedToPayByInvoice = false;
      });
    },
    loadCardPaymentInfo: function loadCardPaymentInfo() {
      var _this8 = this;

      this.intlLoaded = false;
      this.loading = true;
      axios.get("/umbraco/surface/PaymentSurface/GetPaymentInformation?currency=".concat(this.currency, "&locale=").concat(this.locale)).then(function (response) {
        var _response$data$action, _response$data;

        _this8.cardSubmitUrl = (_response$data$action = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.actionUrl) !== null && _response$data$action !== void 0 ? _response$data$action : "";
        _this8.paymentInfo = {};

        if (response.data.paymentParameters && response.data.paymentParameters.length > 0) {
          response.data.paymentParameters.forEach(function (param) {
            if (param.name) {
              _this8.paymentInfo[param.name] = param.value;
            }
          });
        }
      }).finally(function () {
        if (_this8.paymentInfoKeys.length === 0) {
          _this8.paymentInfo = null;
        }

        _this8.intlLoaded = true;
        _this8.loading = false;
      });
    },
    onCurrentStep: function () {
      var _onCurrentStep = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loading = true;
                _context.next = 3;
                return this.fetchData();

              case 3:
                this.loading = false;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onCurrentStep() {
        return _onCurrentStep.apply(this, arguments);
      }

      return onCurrentStep;
    }(),
    toBool: function toBool(val) {
      var result;
      var v = val; // Checks to see if val is a number in disguise

      var num = Number(val);

      if (!Number.isNaN(num)) {
        v = num;
      } // preparing an error message, just in case


      var errorMessage = "Invalid response data, '".concat(v, "' cannot be resolved as a boolean.");

      switch (_typeof(v)) {
        case "boolean":
          {
            result = v;
            break;
          }

        case "number":
          {
            if (v !== 1 && v !== 0) {
              throw new Error(errorMessage);
            }

            result = v === 1;
            break;
          }

        case "string":
          {
            var temp = v.toLowerCase();
            result = temp === "true";
            break;
          }

        default:
          {
            throw new Error(errorMessage);
          }
      }

      return result;
    }
  }
};

var __vue_script__$1h = script$P;
/* template */

var __vue_render__$1f = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "payment-step"
  }, [_c('tabbed-step', {
    attrs: {
      "name": _vm.name,
      "loaded": !_vm.loading,
      "valid": _vm.valid,
      "sealed": _vm.isSealed,
      "stateless": _vm.stateless,
      "hide-previous": _vm.hidePrevious,
      "button-class": _vm.buttonClass,
      "hide-unloaded": ""
    },
    on: {
      "currentStep": _vm.onCurrentStep
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function fn(ref) {
        var step = ref.step;
        return [_c('step-status', {
          attrs: {
            "step": step
          }
        })];
      }
    }, {
      key: "loading",
      fn: function fn() {
        return [_vm._t("loading")];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('div', {
          staticClass: "payment-step__content"
        }, [_vm.isForcedInvoice ? _c('p', [_vm._v("\n          " + _vm._s(_vm.forceInvoiceMessage) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.showPaymentMethods,
            expression: "showPaymentMethods"
          }],
          staticClass: "payment-step__method"
        }, [_c('b-form-group', {
          attrs: {
            "id": "payment-method-group",
            "label": "Select your payment method:",
            "label-for": "payment-method"
          }
        }, [_c('VSelect', {
          attrs: {
            "id": "payment-method",
            "options": _vm.validPaymentMethods,
            "clearable": false,
            "filterable": false,
            "searchable": false,
            "index": "paymentMethodId",
            "label": "paymentMethodName",
            "placeholder": "Choose payment method"
          },
          model: {
            value: _vm.paymentMethodId,
            callback: function callback($$v) {
              _vm.paymentMethodId = $$v;
            },
            expression: "paymentMethodId"
          }
        }), _vm._v(" "), _vm.submitAttempted && !_vm.paymentMethod ? _c('div', {
          staticClass: "validation-error"
        }, [_vm._v("\n                Please select a payment method.\n              ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "payment-step__reference"
        }, [!_vm.isCardPayment ? _c('b-form-group', {
          attrs: {
            "id": "payment-reference-group",
            "label-for": "payment-reference"
          }
        }, [_c('b-form-input', {
          attrs: {
            "required": _vm.poRequired,
            "placeholder": _vm.poPlaceholder,
            "maxlength": _vm.maxPoRefLength
          },
          model: {
            value: _vm.poReference,
            callback: function callback($$v) {
              _vm.poReference = $$v;
            },
            expression: "poReference"
          }
        })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
          staticClass: "payment-step__terms"
        }, [_c('b-form-group', {
          attrs: {
            "id": "payment-terms-group"
          }
        }, [_c('b-form-checkbox', {
          attrs: {
            "id": "payment-terms",
            "name": "payment-terms"
          },
          model: {
            value: _vm.acceptedTerms,
            callback: function callback($$v) {
              _vm.acceptedTerms = $$v;
            },
            expression: "acceptedTerms"
          }
        }, [_vm._t("terms-and-conditions", [_vm._v("\n                  I have read the\n                  "), _vm.termsLink ? [_c('a', {
          attrs: {
            "href": _vm.termsLink,
            "target": "_blank"
          }
        }, [_vm._v("\n                      terms and conditions\n                    ")])] : [_vm._v("\n                    terms and conditions\n                  ")]])], 2)], 1)], 1), _vm._v(" "), _c('b-form-group', {
          attrs: {
            "id": "payment-step__mandatory-checks-group"
          }
        }, [_vm.hasMandatoryChecks ? _c('b-form-checkbox-group', {
          staticClass: "payment-step__mandatory-checks",
          attrs: {
            "name": "mandatoryChecks"
          },
          model: {
            value: _vm.mandatorySelected,
            callback: function callback($$v) {
              _vm.mandatorySelected = $$v;
            },
            expression: "mandatorySelected"
          }
        }, _vm._l(_vm.mandatoryChecks, function (mandatoryCheck, key) {
          return _c('b-form-checkbox', {
            key: key,
            staticClass: "payment-step__mandatory-check",
            attrs: {
              "value": mandatoryCheck.id
            }
          }, [_c('span', {
            domProps: {
              "innerHTML": _vm._s(mandatoryCheck.label)
            }
          })]);
        }), 1) : _vm._e()], 1), _vm._v(" "), _c('b-alert', {
          attrs: {
            "show": _vm.hasErrors,
            "variant": "danger"
          }
        }, [_c('ul', {
          staticClass: "payment-step__errors"
        }, _vm._l(_vm.errorMessages, function (message) {
          return _c('li', {
            key: message,
            staticClass: "payment-step__error"
          }, [_vm._v("\n                " + _vm._s(message) + "\n              ")]);
        }), 0)]), _vm._v(" "), _vm.isCardPayment ? _c('div', {
          staticClass: "payment-step__redirect-notice"
        }, [_c('p', [_vm._v(_vm._s(_vm.redirectNotice))]), _vm._v(" "), _c('div', {
          staticClass: "payment-method-icons"
        }, _vm._l(_vm.paymentIcons, function (icon, index) {
          return _c('img', {
            key: index,
            staticClass: "loading",
            attrs: {
              "alt": icon.alt,
              "src": icon.src,
              "data-was-processed": "true"
            }
          });
        }), 0), _vm._v(" "), _c('form', {
          ref: "cardPaymentForm",
          attrs: {
            "id": "CardPaymentForm",
            "method": "POST",
            "name": "CardPaymentForm",
            "action": _vm.cardSubmitUrl
          }
        }, [_vm._l(_vm.paymentInfoKeys, function (key) {
          return _c('input', {
            key: key,
            attrs: {
              "name": key,
              "type": "hidden"
            },
            domProps: {
              "value": _vm.paymentInfo[key]
            }
          });
        }), _vm._v(" "), _vm._l(_vm.paymentInfoArrayKeys, function (key) {
          return _vm._l(_vm.paymentInfo[key], function (value, index) {
            return _c('input', {
              key: index,
              attrs: {
                "name": key,
                "type": "hidden"
              },
              domProps: {
                "value": value
              }
            });
          });
        })], 2)]) : _vm._e()], 1)])];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function fn(ref) {
        var step = ref.step;
        return [_c('div', {
          staticClass: "payment-step__footer"
        }, [_vm._t("paymentFooter"), _vm._v(" "), _vm.canGoPrevious ? _c('button', {
          staticClass: "step__footer-button step__back",
          class: _vm.buttonClass,
          on: {
            "click": function click($event) {
              return step.goToPreviousStep();
            }
          }
        }, [_vm._v("\n          " + _vm._s(_vm.backBtn) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
          staticClass: "step__footer-button step__continue no-disabled",
          class: _vm.buttonClass,
          on: {
            "click": function click($event) {
              return _vm.submit(step);
            }
          }
        }, [_vm.submitting ? [_c('font-awesome-icon', {
          attrs: {
            "icon": "spinner",
            "spin": ""
          }
        })] : _vm.submitted ? [_c('font-awesome-icon', {
          attrs: {
            "icon": "check"
          }
        })] : _vm.errorSubmitting ? [_c('font-awesome-icon', {
          attrs: {
            "icon": "times"
          }
        })] : [!_vm.isCardPayment ? [_vm._v("\n              " + _vm._s(_vm.invoiceSubmitButtonLabel) + "\n            ")] : [_vm._v("\n              Continue to payment\n            ")]]], 2)], 2)];
      }
    }], null, true)
  })], 1);
};

var __vue_staticRenderFns__$1f = [];
/* style */

var __vue_inject_styles__$1h = undefined;
/* scoped */

var __vue_scope_id__$1h = "data-v-3a6c1e54";
/* module identifier */

var __vue_module_identifier__$1h = undefined;
/* functional template */

var __vue_is_functional_template__$1h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1f,
  staticRenderFns: __vue_staticRenderFns__$1f
}, __vue_inject_styles__$1h, __vue_script__$1h, __vue_scope_id__$1h, __vue_is_functional_template__$1h, __vue_module_identifier__$1h, false, undefined, undefined, undefined);

//
var script$Q = {
  name: "SimpleAddressStep",
  component: {
    UberSearch: UberSearch,
    AddressDisplay: __vue_component__$5,
    Postage: __vue_component__$19
  },
  props: {
    /**
     * Whether this step is stateless
     */
    stateless: {
      type: Boolean,
      default: false
    },

    /**
     * Whether ot always load all carriage items
     */
    showAllCarriageItems: {
      type: Boolean,
      default: false
    },

    /**
     * Currency for carriage
     */
    currency: {
      type: String,
      default: "GBP"
    },

    /**
     * Locale for carriage
     */
    locale: {
      type: String,
      default: "en-GB"
    },

    /**
     * Error message to display on delivery page
     */
    deliveryErrorMsg: {
      type: String,
      default: "Please select an address and postage before continuing"
    },

    /**
     * Error message to display on delivery page if no carriage is required
     */
    deliveryNoCarriageErrorMsg: {
      type: String,
      default: "Please select an address continuing"
    },

    /**
     * Org ID for web account
     * Used for searching for default addresses
     */
    webAccountOrgId: {
      type: String,
      default: null
    },

    /**
     * Continue button caption
     */
    continueBtn: {
      type: String,
      default: "Continue"
    }
  },
  data: function data() {
    return {
      deliveryAddress: blankAddress(),
      invoiceAddressId: null,
      carriageId: null,
      carriageItems: [],
      countries: [],
      userType: {},
      saving: false,
      currentPage: 0,
      deliveryAddressRequired: false,
      noCarriageRequired: false,
      useInvoiceForDelivery: false,
      showError: false,
      loaded: false,
      showValidation: false,
      ADDRESS_TYPE: "D",
      ADDRESS_PAGE: 0,
      CARRIAGE_PAGE: 1
    };
  },
  computed: {
    /**
     * True if we have completeted this step
     */
    valid: function valid() {
      return this.deliveryValid && this.carriageValid;
    },

    /**
     * Selected Org Address ID for the invoice address
     */
    deliveryAddressId: function deliveryAddressId() {
      var _this$deliveryAddress;

      return this.deliveryAddressRequired ? (_this$deliveryAddress = this.deliveryAddress) === null || _this$deliveryAddress === void 0 ? void 0 : _this$deliveryAddress.addressId : null;
    },

    /**
     * The selected carriage ID to save
     */
    carriageIdToSave: function carriageIdToSave() {
      return this.noCarriageRequired ? null : this.carriageId;
    },

    /**
     * Whether the delivery address is valid
     */
    deliveryValid: function deliveryValid() {
      return !!this.deliveryAddressId || !this.deliveryAddressRequired;
    },

    /**
     * Whether carriage is valid
     */
    carriageValid: function carriageValid() {
      var _this$carriageItems;

      return ((_this$carriageItems = this.carriageItems) === null || _this$carriageItems === void 0 ? void 0 : _this$carriageItems.length) > 0 && !!this.carriageId || !this.deliveryAddressRequired || this.noCarriageRequired;
    },

    /**
     * Whether we have enough data to show the postage options
     */
    showCarriage: function showCarriage() {
      var _this$carriageItems2;

      return this.deliveryAddressRequired && !this.noCarriageRequired && this.deliveryAddressId && ((_this$carriageItems2 = this.carriageItems) === null || _this$carriageItems2 === void 0 ? void 0 : _this$carriageItems2.length) > 0 && this.currentPage === this.CARRIAGE_PAGE;
    },

    /**
     * The delivery address post code (if any)
     */
    deliveryPostcode: function deliveryPostcode() {
      var _this$deliveryAddress2;

      return (_this$deliveryAddress2 = this.deliveryAddress) === null || _this$deliveryAddress2 === void 0 ? void 0 : _this$deliveryAddress2.postcode;
    },

    /**
     * Validation message
     */
    errorMessage: function errorMessage() {
      var msg = null;

      if (this.showCarriage) {
        msg = this.deliveryErrorMsg;
      } else {
        msg = this.deliveryNoCarriageErrorMsg;
      }

      return msg;
    }
  },
  mounted: function mounted() {
    this.load();
  },
  methods: {
    /**
     * The user has edited the address. We need to blank out ID values so that it will
     * force a new address to be saved
     */
    onManualAddressChanged: function onManualAddressChanged() {
      var _this$deliveryAddress3;

      if ((_this$deliveryAddress3 = this.deliveryAddress) !== null && _this$deliveryAddress3 !== void 0 && _this$deliveryAddress3.orgId) {
        this.deliveryAddress.orgId = null;
        this.deliveryAddress.addressId = null;
        this.deliveryAddress.sopAddressId = null;
      }
    },

    /**
     * Move to the previous page in this step
     *
     * @param {object} step Reference to the step within the checkout
     */
    onPrevPage: function onPrevPage(step) {
      if (this.currentPage > 0) {
        this.currentPage -= 1;
      } else {
        step.goToPreviousStep();
      }
    },

    /**
     * Move to the next page in this step
     *
     * @param {object} step Reference to the step within the checkout
     */
    onNextPage: function onNextPage(step) {
      if (this.validate) {
        if (this.currentPage === this.ADDRESS_PAGE) {
          // Move to the carriage page
          this.loadCarriagePage(step);
        } else {
          // Save and move to the next step in the basket
          this.save(step);
        }
      }
    },

    /**
     * Set up the step
     */
    load: function load() {
      var _this = this;

      loadAddressStep().then(function (response) {
        var _response$data$delive, _response$data, _response$data2, _response$data3, _response$data$noCarr, _response$data4, _response$data5, _response$data6;

        _this.deliveryAddressRequired = (_response$data$delive = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.deliveryAddressRequired) !== null && _response$data$delive !== void 0 ? _response$data$delive : false;
        _this.userType = (response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.userType) || {};
        _this.countries = (response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.countries) || [];
        _this.noCarriageRequired = (_response$data$noCarr = response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.noCarriageRequired) !== null && _response$data$noCarr !== void 0 ? _response$data$noCarr : false;
        _this.invoiceAddressId = response === null || response === void 0 ? void 0 : (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.invoiceAddressId;
        _this.deliveryAddress = (response === null || response === void 0 ? void 0 : (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.deliveryAddress) || blankAddress();
      }).catch(function () {
        _this.deliveryAddressRequired = false;
      }).finally(function () {
        _this.loaded = true;
      });
    },

    /**
     * Load data for the carriage step
     *
     * @param {object} step Reference to the step within the checkout
     */
    loadCarriagePage: function loadCarriagePage(step) {
      var _this2 = this;

      this.saving = true;
      this.carriageItems = [];

      if (this.noCarriageRequired) {
        // We don't need carriage so do a full save and move to the next step
        step.save(step);
      }

      updateAddressAndCarriage(this.invoiceAddressId, this.deliveryAddressId, null, true, this.showAllCarriageItems).then(function (response) {
        var _this2$carriageItems;

        _this2.carriageItems = response.data;

        if (((_this2$carriageItems = _this2.carriageItems) === null || _this2$carriageItems === void 0 ? void 0 : _this2$carriageItems.length) > 0) {
          // We have carriage
          _this2.currentPage = _this2.CARRIAGE_PAGE;
        } else {
          // No carriage so do a full save and move to the
          // next step
          _this2.save(step);
        }
      }).catch(function () {// Ignore errors
      }).finally(function () {
        _this2.saving = false;
      });
    },

    /**
     * Save the addresses and carriage against the basket and continue
     *
     * @param {object} step Reference to the step within the checkout
     */
    save: function save(step) {
      var _this3 = this;

      if (this.validate()) {
        this.saving = true;
        updateAddressAndCarriage(this.invoiceAddressId, this.deliveryAddressId, this.carriageIdToSave).then(function (response) {
          if (response.data) {
            step.goToNextStep();
          } else {
            _this3.showError = true;
          }
        }).catch(function () {
          _this3.showError = true;
        }).finally(function () {
          _this3.saving = false;
        });
      }
    },

    /**
     * Validate the step
     */
    validate: function validate() {
      this.showValidation = true;
      this.showError = this.deliveryAddress.line1 && this.deliveryAddress.countryId && this.deliveryAddress.postcode && this.deliveryAddress.region;
      return this.showError;
    }
  }
};

/* script */
var __vue_script__$1i = script$Q;
/* template */

var __vue_render__$1g = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "address-step"
  }, [_c('tabbed-step', {
    attrs: {
      "name": "Address",
      "heading": "Addresses",
      "valid": _vm.valid,
      "loaded": _vm.loaded,
      "stateless": _vm.stateless,
      "hide-previous": "",
      "hide-unloaded": ""
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function fn(ref) {
        var step = ref.step;
        return [_c('div', {
          staticClass: "address-step__footer"
        }, [_vm.currentPage > 0 ? _c('button', {
          staticClass: "step__footer-button step__back",
          on: {
            "click": function click($event) {
              return _vm.onPrevPage(step);
            }
          }
        }, [_vm._v("\n          " + _vm._s(_vm.backBtn) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
          staticClass: "step__footer-button step__continue no-disabled",
          on: {
            "click": function click($event) {
              return _vm.save(step);
            }
          }
        }, [_vm.saving ? [_c('font-awesome-icon', {
          attrs: {
            "icon": "spinner",
            "spin": ""
          }
        })] : [_vm._v("\n            " + _vm._s(_vm.continueBtn) + "\n          ")]], 2)])];
      }
    }])
  }, [_c('div', {
    staticClass: "address-step__container"
  }, [_c('div', {
    staticClass: "address-step__info"
  }, [_vm._v("\n        Please confirm your Delivery Address\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "address-step__details"
  }, [_c('div', {
    staticClass: "address-step__address"
  }, [_vm.currentPage === _vm.ADDRESS_PAGE ? _c('uber-search', {
    staticClass: "address-step__search",
    attrs: {
      "show-validation": _vm.showValidation,
      "user-type": _vm.userType
    },
    model: {
      value: _vm.deliveryAddress,
      callback: function callback($$v) {
        _vm.deliveryAddress = $$v;
      },
      expression: "deliveryAddress"
    }
  }) : _vm._e(), _vm._v(" "), _c('address-display', {
    staticClass: "address-step__delivery",
    attrs: {
      "show-validation": _vm.showValidation,
      "disabled": _vm.currentPage === _vm.CARRIAGE_PAGE,
      "countries": _vm.countries
    },
    on: {
      "addressChanged": _vm.onManualAddressChanged
    },
    model: {
      value: _vm.deliveryAddress,
      callback: function callback($$v) {
        _vm.deliveryAddress = $$v;
      },
      expression: "deliveryAddress"
    }
  })], 1), _vm._v(" "), _c('postage', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showCarriage,
      expression: "showCarriage"
    }],
    staticClass: "address-step__carriage",
    attrs: {
      "currency": _vm.currency,
      "locale": _vm.locale,
      "carriage-items": _vm.carriageItems,
      "postcode": _vm.deliveryPostcode
    },
    model: {
      value: _vm.carriageId,
      callback: function callback($$v) {
        _vm.carriageId = $$v;
      },
      expression: "carriageId"
    }
  })], 1), _vm._v(" "), _vm.showError ? _c('div', {
    staticClass: "address-step__error"
  }, [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")]) : _vm._e()])])], 1);
};

var __vue_staticRenderFns__$1g = [];
/* style */

var __vue_inject_styles__$1i = undefined;
/* scoped */

var __vue_scope_id__$1i = "data-v-584dcc38";
/* module identifier */

var __vue_module_identifier__$1i = undefined;
/* functional template */

var __vue_is_functional_template__$1i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1g,
  staticRenderFns: __vue_staticRenderFns__$1g
}, __vue_inject_styles__$1i, __vue_script__$1i, __vue_scope_id__$1i, __vue_is_functional_template__$1i, __vue_module_identifier__$1i, false, undefined, undefined, undefined);

var script$R = {
  name: "YourDetailsStep",
  components: {
    LoginForm: LoginForm,
    RegistrationWizard: RegistrationWizard
  },
  props: {
    sealed: {
      type: Boolean,
      default: false
    },
    stateless: {
      type: Boolean,
      default: false
    },
    showRegisterNowButton: {
      type: Boolean,
      default: false
    },
    loginButtonClass: {
      type: String,
      default: null
    },
    showScreenName: {
      type: Boolean,
      default: false
    },
    enableMarketing: {
      type: Boolean,
      default: false
    },
    webUserTypeParentId: {
      type: Number,
      default: null
    },
    webAccountId: {
      type: String,
      default: null
    },
    preLoadGuestOnly: {
      type: Boolean,
      default: false
    },
    allowGuestRegistration: {
      type: Boolean,
      default: false
    },
    allowFullRegistration: {
      type: Boolean,
      default: true
    },
    allowAccountDetailsEdit: {
      type: Boolean,
      default: false
    },
    allowLogin: {
      type: Boolean,
      default: true
    },
    heading: {
      type: String,
      default: "Log in"
    },
    registrationHeading: {
      type: String,
      default: "Create an account"
    },
    hideTitle: {
      type: Boolean,
      default: false
    },
    hideTelephone: {
      type: Boolean,
      default: true
    }
  },
  inject: {
    checkout: {
      default: function _default() {
        throw new Error("A step must be within a <checkout>");
      }
    }
  },
  data: function data() {
    return {
      showRegistration: false,
      showGuestRegistration: false,
      canGoToNextStepWatchEnabled: true,
      stepStatus: null,
      isLoggedIn: false,
      loading: true,
      stepId: null,
      submitted: false
    };
  },
  computed: {
    intlSealed: function intlSealed() {
      var result = this.sealed;

      if (this.isLoggedIn && !this.allowAccountDetailsEdit) {
        // We are logged in and we are not allowed to edit account
        // details after registration, so we must force the step to be sealed
        result = true;
      }

      return result;
    },
    intlStateless: function intlStateless() {
      var result = this.stateless;

      if (this.isLoggedIn && !this.allowAccountDetailsEdit) {
        result = true;
      }

      return result;
    },
    intlheading: function intlheading() {
      var result = this.heading;

      if (this.showRegistration) {
        result = this.registrationHeading;
      }

      return result;
    },
    valid: function valid() {
      return this.isLoggedIn;
    },

    /**
     * Work out if guest registration process should be used
     * based on what the user has selected and what configuration
     * allows us to do
     */
    useGuestRegistration: function useGuestRegistration() {
      var result = false;

      if (this.allowGuestRegistration && !this.allowFullRegistration) {
        result = true;
      } else if (this.allowGuestRegistration) {
        result = this.showGuestRegistration;
      }

      return result;
    }
  },
  watch: {
    "checkout.canGoToNextStep": {
      immediate: true,
      handler: function handler(val) {
        if (this.canGoToNextStepWatchEnabled && val) {
          // We only want to move to the next step the first time this watch triggers
          this.canGoToNextStepWatchEnabled = false;
          this.nextStep();
        }
      }
    }
  },
  created: function created() {
    var _this = this;

    // If we are logged in with a full account then flag the step
    // as beign logged in and valid straight away
    this.loading = true;
    WebAccountResource.isFullLogin().then(function (response) {
      if (response && response.data) {
        _this.isLoggedIn = true;
      }
    }).finally(function () {
      _this.loading = false;
    });
  },
  methods: {
    onSubmitted: function onSubmitted() {
      this.submitted = true;
    },
    getStepId: function getStepId(val) {
      this.stepId = val;
    },
    onDetailsFormLoading: function onDetailsFormLoading(val) {
      this.loading = val;
    },
    updateStepStatus: function updateStepStatus(val) {
      this.stepStatus = val;
    },

    /**
     * Toggle between showing a registration form or the login form
     *
     * @param {boolean} val If supplied then force the toggle to this value
     */
    toggleRegistration: function toggleRegistration(val) {
      if (val !== null && val !== undefined) {
        this.showRegistration = val;
      } else {
        this.showRegistration = !this.showRegistration;
      }
    },

    /**
     * Toggle between logging in as a guest or a normal account
     *
     * @param {boolean} val If supplied then force the toggle to this value
     */
    toggleGuest: function toggleGuest(val) {
      if (val !== null && val !== undefined) {
        this.showGuestRegistration = val;
      } else {
        this.showGuestRegistration = !this.showGuestRegistration;
      }
    },

    /**
     * Call upon successful log in or registration
     */
    onSuccess: function onSuccess() {
      if (!this.isLoggedIn) {
        // Toggling isLoggedIn to true will automatically validate and move to the next step
        this.isLoggedIn = true;
      } else {
        // If isLoggedIn was already true then we are revisiting this step, so we can just
        // move to the next step as everything will be in place
        this.nextStep();
      }
    },

    /**
     * Move to the next step if we are logged in
     */
    nextStep: function nextStep() {
      if (this.isLoggedIn && this.checkout.currentStepId === this.stepId) {
        this.checkout.goToNextStep();
      }
    }
  }
};

/* script */
var __vue_script__$1j = script$R;
/* template */

var __vue_render__$1h = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('tabbed-step', {
    attrs: {
      "name": "Your Details",
      "valid": _vm.valid,
      "loaded": !_vm.loading,
      "no-footer": "",
      "sealed": _vm.intlSealed,
      "stateless": _vm.intlStateless,
      "heading": _vm.intlheading,
      "hide-unloaded": ""
    },
    on: {
      "announce": _vm.getStepId,
      "change": _vm.updateStepStatus,
      "submitted": _vm.onSubmitted
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function fn(ref) {
        var step = ref.step;
        return [_c('step-status', {
          attrs: {
            "step": step
          }
        })];
      }
    }, {
      key: "loading",
      fn: function fn() {
        return [_vm._t("loading")];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn(ref) {
        var step = ref.step;
        return [!_vm.isLoggedIn || _vm.allowAccountDetailsEdit ? [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !_vm.showRegistration && _vm.allowLogin,
            expression: "!showRegistration && allowLogin"
          }],
          staticClass: "bootleg-row"
        }, [_c('div', {
          staticClass: "bootleg-column"
        }, [_vm._t("login"), _vm._v(" "), _c('login-form', {
          attrs: {
            "login-button-class": _vm.loginButtonClass
          },
          on: {
            "logged-in": _vm.onSuccess
          }
        })], 2), _vm._v(" "), _c('div', {
          staticClass: "bootleg-column"
        }, [_vm._t("why-register", [_c('h2', [_vm._v("Create an account")]), _vm._v(" "), _c('p', [_vm._v("\n              You will need an account to have full access to our website.\n            ")]), _vm._v(" "), _vm.showRegisterNowButton ? _c('div', {
          staticClass: "register-button-wrapper"
        }, [_c('button', {
          staticClass: "btn btn-accent-6 btn-rounded",
          on: {
            "click": function click($event) {
              return _vm.toggleRegistration();
            }
          }
        }, [_vm._v("\n                Register now\n              ")])]) : _vm._e()], {
          "toggleRegistration": _vm.toggleRegistration,
          "showRegisterNowButton": _vm.showRegisterNowButton,
          "step": step
        })], 2)]), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.showRegistration || !_vm.allowLogin,
            expression: "showRegistration || !allowLogin"
          }]
        }, [_vm._t("register", [_c('div', {
          staticClass: "registration-wrapper"
        }, [_c('registration-wizard', {
          attrs: {
            "success-redirect": null,
            "show-screen-name": _vm.showScreenName,
            "pre-load-guest-only": _vm.preLoadGuestOnly,
            "web-account-id": _vm.webAccountId,
            "web-user-type-parent-id": _vm.webUserTypeParentId,
            "enable-marketing": _vm.enableMarketing,
            "guest-registration": _vm.useGuestRegistration,
            "hide-title": _vm.hideTitle,
            "hide-telephone": _vm.hideTelephone
          },
          on: {
            "registered": _vm.onSuccess
          },
          scopedSlots: _vm._u([{
            key: "marketing",
            fn: function fn() {
              return [_vm._t("marketing")];
            },
            proxy: true
          }, {
            key: "back",
            fn: function fn() {
              return [_vm._t("back-btn")];
            },
            proxy: true
          }, {
            key: "continue",
            fn: function fn() {
              return [_vm._t("continue-btn")];
            },
            proxy: true
          }, {
            key: "register",
            fn: function fn() {
              return [_vm._t("register-btn")];
            },
            proxy: true
          }], null, true)
        }), _vm._v(" "), _vm.allowLogin ? _c('button', {
          staticClass: "btn btn-link",
          staticStyle: {
            "display": "block"
          },
          on: {
            "click": function click($event) {
              return _vm.toggleRegistration();
            }
          }
        }, [_vm._v("\n              I already have an account\n            ")]) : _vm._e(), _vm._v(" "), _vm.allowLogin && _vm.allowGuestRegistration && !_vm.showGuestRegistration ? _c('button', {
          staticClass: "btn btn-link",
          staticStyle: {
            "display": "block"
          },
          on: {
            "click": function click($event) {
              return _vm.toggleGuest();
            }
          }
        }, [_vm._v("\n              Continue as Guest\n            ")]) : _vm._e()], 1)])], 2)] : [_vm._t("logged-in", [_c('button', {
          staticClass: "step__footer-button step__continue tabbed-step__continue",
          on: {
            "click": function click($event) {
              return step.goToNextStep();
            }
          }
        }, [_vm._v("\n          Continue\n        ")])])]];
      }
    }], null, true)
  });
};

var __vue_staticRenderFns__$1h = [];
/* style */

var __vue_inject_styles__$1j = undefined;
/* scoped */

var __vue_scope_id__$1j = "data-v-61ee557e";
/* module identifier */

var __vue_module_identifier__$1j = undefined;
/* functional template */

var __vue_is_functional_template__$1j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1h,
  staticRenderFns: __vue_staticRenderFns__$1h
}, __vue_inject_styles__$1j, __vue_script__$1j, __vue_scope_id__$1j, __vue_is_functional_template__$1j, __vue_module_identifier__$1j, false, undefined, undefined, undefined);

/* script */
var __vue_script__$1k = script$q;
/* template */

var __vue_render__$1i = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.hasData ? _c('div', {
    staticClass: "btn btn-primary cta-download",
    on: {
      "click": _vm.exportHandler
    }
  }, [_vm._v("\n  " + _vm._s(_vm.label) + "\n")]) : _vm._e();
};

var __vue_staticRenderFns__$1i = [];
/* style */

var __vue_inject_styles__$1k = undefined;
/* scoped */

var __vue_scope_id__$1k = "data-v-43b59423";
/* module identifier */

var __vue_module_identifier__$1k = undefined;
/* functional template */

var __vue_is_functional_template__$1k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1i,
  staticRenderFns: __vue_staticRenderFns__$1i
}, __vue_inject_styles__$1k, __vue_script__$1k, __vue_scope_id__$1k, __vue_is_functional_template__$1k, __vue_module_identifier__$1k, false, undefined, undefined, undefined);

//
var script$S = {
  name: "DownloadItem",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    buttonText: function buttonText() {
      var result = "Download";

      if (this.item.contentType === 3) {
        result = "Access Site";
      }

      return result;
    },
    buttonLink: function buttonLink() {
      var result = "#";

      if (this.item.content) {
        if (this.item.contentType === 2) {
          result = "/product-downloads/".concat(this.item.content.toLowerCase());
        } else if (this.item.contentType === 3) {
          result = this.item.content;
        }
      }

      return result;
    }
  },
  methods: {
    formatDate: function formatDate(input) {
      return dateFns_50(new Date(input), "dd/MM/yyyy");
    }
  }
};

/* script */
var __vue_script__$1l = script$S;
/* template */

var __vue_render__$1j = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "download-item"
  }, [_c('div', {
    staticClass: "download-item__header"
  }, [_c('div', [_vm._v("\n      " + _vm._s(_vm.item.productName) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "download-item__header-date"
  }, [_vm._v("\n      Ordered " + _vm._s(_vm.formatDate(_vm.item.dateAdded)) + "\n    ")])]), _vm._v(" "), _vm.item.imageUrl ? _c('div', {
    staticClass: "download-item__image-container"
  }, [_c('img', {
    staticClass: "download-item__image-blur",
    attrs: {
      "src": _vm.item.imageUrl,
      "alt": "Download item blured image"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "download-item__image",
    attrs: {
      "src": _vm.item.imageUrl,
      "alt": "Download item image"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "download-item__description",
    domProps: {
      "innerHTML": _vm._s(_vm.item.productDescription)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "download-item__action"
  }, [_c('a', {
    staticClass: "btn btn-accent-1 btn-full-width",
    attrs: {
      "href": _vm.buttonLink
    }
  }, [_vm._v("\n      " + _vm._s(_vm.buttonText) + "\n    ")])])]);
};

var __vue_staticRenderFns__$1j = [];
/* style */

var __vue_inject_styles__$1l = undefined;
/* scoped */

var __vue_scope_id__$1l = "data-v-3fd67492";
/* module identifier */

var __vue_module_identifier__$1l = undefined;
/* functional template */

var __vue_is_functional_template__$1l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1j,
  staticRenderFns: __vue_staticRenderFns__$1j
}, __vue_inject_styles__$1l, __vue_script__$1l, __vue_scope_id__$1l, __vue_is_functional_template__$1l, __vue_module_identifier__$1l, false, undefined, undefined, undefined);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;

    defineProperty$1(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

// 19.1.2.9 Object.getPrototypeOf(O)



_objectSap$1('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return _objectGpo$1(_toObject$1(it));
  };
});

var getPrototypeOf = _core$1.Object.getPrototypeOf;

var getPrototypeOf$1 = getPrototypeOf;

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */


var check$1 = function (O, proto) {
  _anObject$1(O);
  if (!_isObject$1(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
var _setProto$1 = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = _ctx$1(Function.call, _objectGopd$1.f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check$1(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check$1
};

// 19.1.3.19 Object.setPrototypeOf(O, proto)

_export$1(_export$1.S, 'Object', { setPrototypeOf: _setProto$1.set });

var setPrototypeOf$1 = _core$1.Object.setPrototypeOf;

var setPrototypeOf$2 = setPrototypeOf$1;

function _getPrototypeOf(o) {
  _getPrototypeOf = setPrototypeOf$2 ? getPrototypeOf$1 : function _getPrototypeOf(o) {
    return o.__proto__ || getPrototypeOf$1(o);
  };
  return _getPrototypeOf(o);
}

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)

var $getOwnPropertyDescriptor$1 = _objectGopd$1.f;

_objectSap$1('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor$1(_toIobject$1(it), key);
  };
});

var $Object$1 = _core$1.Object;
var getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  return $Object$1.getOwnPropertyDescriptor(it, key);
};

var getOwnPropertyDescriptor$1 = getOwnPropertyDescriptor;

// 26.1.6 Reflect.get(target, propertyKey [, receiver])







function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (_anObject$1(target) === receiver) return target[propertyKey];
  if (desc = _objectGopd$1.f(target, propertyKey)) return _has$1(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (_isObject$1(proto = _objectGpo$1(target))) return get(proto, propertyKey, receiver);
}

_export$1(_export$1.S, 'Reflect', { get: get });

var get$1 = _core$1.Reflect.get;

var get$2 = get$1;

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && get$2) {
    _get = get$2;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);
      if (!base) return;

      var desc = getOwnPropertyDescriptor$1(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
_export$1(_export$1.S, 'Object', { create: _objectCreate$1 });

var $Object$2 = _core$1.Object;
var create = function create(P, D) {
  return $Object$2.create(P, D);
};

var create$1 = create;

function _setPrototypeOf(o, p) {
  _setPrototypeOf = setPrototypeOf$2 || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = create$1(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

var _validateCollection = function (it, TYPE) {
  if (!_isObject$1(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};

var dP$5 = _objectDp$1.f;









var fastKey = _meta.fastKey;

var SIZE = _descriptors$1 ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

var _collectionStrong = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      _anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = _objectCreate$1(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) _forOf(iterable, IS_MAP, that[ADDER], that);
    });
    _redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = _validateCollection(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = _validateCollection(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        _validateCollection(this, NAME);
        var f = _ctx$1(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(_validateCollection(this, NAME), key);
      }
    });
    if (_descriptors$1) dP$5(C.prototype, 'size', {
      get: function () {
        return _validateCollection(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    _iterDefine$1(C, NAME, function (iterated, kind) {
      this._t = _validateCollection(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return _iterStep$1(1);
      }
      // return step by kind
      if (kind == 'keys') return _iterStep$1(0, entry.k);
      if (kind == 'values') return _iterStep$1(0, entry.v);
      return _iterStep$1(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    _setSpecies(NAME);
  }
};

var SPECIES$5 = _wks$1('species');

var _arraySpeciesConstructor$1 = function (original) {
  var C;
  if (_isArray$1(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || _isArray$1(C.prototype))) C = undefined;
    if (_isObject$1(C)) {
      C = C[SPECIES$5];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)


var _arraySpeciesCreate$1 = function (original, length) {
  return new (_arraySpeciesConstructor$1(original))(length);
};

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex





var _arrayMethods$1 = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || _arraySpeciesCreate$1;
  return function ($this, callbackfn, that) {
    var O = _toObject$1($this);
    var self = _iobject$1(O);
    var f = _ctx$1(callbackfn, that, 3);
    var length = _toLength$1(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

var dP$6 = _objectDp$1.f;
var each = _arrayMethods$1(0);


var _collection = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = _global$1[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!_descriptors$1 || typeof C != 'function' || !(IS_WEAK || proto.forEach && !_fails$1(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    _redefineAll(C.prototype, methods);
    _meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      _anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) _forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) _hide$1(C.prototype, KEY, function (a, b) {
        _anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !_isObject$1(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP$6(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  _setToStringTag$1(C, NAME);

  O[NAME] = C;
  _export$1(_export$1.G + _export$1.W + _export$1.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};

var MAP = 'Map';

// 23.1 Map Objects
var es6_map = _collection(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = _collectionStrong.getEntry(_validateCollection(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return _collectionStrong.def(_validateCollection(this, MAP), key === 0 ? 0 : key, value);
  }
}, _collectionStrong, true);

var _arrayFromIterable = function (iter, ITERATOR) {
  var result = [];
  _forOf(iter, false, result.push, result, ITERATOR);
  return result;
};

// https://github.com/DavidBruant/Map-Set.prototype.toJSON


var _collectionToJson = function (NAME) {
  return function toJSON() {
    if (_classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return _arrayFromIterable(this);
  };
};

// https://github.com/DavidBruant/Map-Set.prototype.toJSON


_export$1(_export$1.P + _export$1.R, 'Map', { toJSON: _collectionToJson('Map') });

// https://tc39.github.io/proposal-setmap-offrom/


var _setCollectionOf = function (COLLECTION) {
  _export$1(_export$1.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
_setCollectionOf('Map');

// https://tc39.github.io/proposal-setmap-offrom/





var _setCollectionFrom = function (COLLECTION) {
  _export$1(_export$1.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    _aFunction$1(this);
    mapping = mapFn !== undefined;
    if (mapping) _aFunction$1(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = _ctx$1(mapFn, arguments[2], 2);
      _forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      _forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
_setCollectionFrom('Map');

var map = _core$1.Map;

var map$1 = map;

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

var _bind = Function.bind || function bind(that /* , ...args */) {
  var fn = _aFunction$1(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : _invoke(fn, args, that);
  };
  if (_isObject$1(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])







var rConstruct = (_global$1.Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = _fails$1(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !_fails$1(function () {
  rConstruct(function () { /* empty */ });
});

_export$1(_export$1.S + _export$1.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    _aFunction$1(Target);
    _anObject$1(args);
    var newTarget = arguments.length < 3 ? Target : _aFunction$1(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (_bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = _objectCreate$1(_isObject$1(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return _isObject$1(result) ? result : instance;
  }
});

var construct$1 = _core$1.Reflect.construct;

var construct$2 = construct$1;

function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !construct$2) return false;
  if (construct$2.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(construct$2(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    _construct = construct$2;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _wrapNativeSuper(Class) {
  var _cache = typeof map$1 === "function" ? new map$1() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = create$1(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

var environment = document.querySelector("meta[name=\"environment\"]").getAttribute("content");

/**
 * @preserve
 * An Error specific to Spirit ApiAccessExceptions
 */

var SpiritApiError = /*#__PURE__*/function (_Error) {
  _inherits(SpiritApiError, _Error);

  /**
   * @preserve
   * @param {string} message The Error.message
   * @param {number} code The responseCode, can be either an ApiAccessCode or an ErrorCode
   * @param {*} data The response data, if available
   */
  function SpiritApiError(message, code, data) {
    var _this;

    _classCallCheck(this, SpiritApiError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SpiritApiError).call(this, message));

    _defineProperty(_assertThisInitialized(_this), "responseCode", void 0);

    _defineProperty(_assertThisInitialized(_this), "responseData", void 0);

    _defineProperty(_assertThisInitialized(_this), "isSpiritError", true);

    _this.responseCode = code;
    _this.responseData = data;
    return _this;
  }
  /**
   * @preserve
   * @type {string}
   * return the error's message property
   */


  _createClass(SpiritApiError, [{
    key: "responseMessage",
    get: function get() {
      return _get(_getPrototypeOf(SpiritApiError.prototype), "message", this);
    }
    /**
     * @preserve
     * @type {number}
     * The Spirit Access/Error code
     */

  }]);

  return SpiritApiError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
   * @preserve
 * A service for making HTTP requests to our API
 * server. Wraps an axios instance and sets defaults
 * such as provides the JWT with each request.
 */

var HttpService$1 = /*#__PURE__*/function () {
  /**
   * @preserve
   * Create an HttpService instance
   * @param {string} resourcePath Provide a common path to the resource
   */
  function HttpService(resourcePath) {
    _classCallCheck(this, HttpService);

    this.instance = axios.create({
      baseURL: HttpService._createBaseUrl(resourcePath),
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      withCredentials: true
    });
    this.instance.interceptors.response.use(HttpService._spiritApiErrorResponseInterceptor, HttpService._handleErrors); // mocks( this.instance, true );
  }
  /**
   * @preserve
   * Sends a GET request to our API server to the resource
   * at the given path.
   * @param {string} path The relative path to the resource
   * @param {*} params Data to be added to the querystring
   */


  _createClass(HttpService, [{
    key: "get",
    value: function get(path, params) {
      // console.group( `${this.instance.baseURL}/${path}` );
      return this.instance.get(path, {
        params: params
      }).finally(function () {// console.groupEnd( `${this.instance.baseURL}/${path}` );
      });
    }
    /**
     * @preserve
     * Sends a PATCH request to our API server to the resource
     * at the given path.
     * @param {string} path  The relative path to the resource
     * @param {*} payload Any data to send as a part of the request
     * @param {*} params Data to be added to the querystring
     */

  }, {
    key: "patch",
    value: function patch(path, payload, params) {
      // console.group( `${this.instance.baseURL}/${path}` );
      return this.instance.patch(path, payload, {
        params: params
      }).finally(function () {// console.groupEnd( `${this.instance.baseURL}/${path}` );
      });
    }
    /**
     * @preserve
     * Sends a POST request to our API server to the resource
     * at the given path.
     * @param {string} path The relative path to the resource
     * @param {*} payload Any data to send as a part of the request
     * @param {*} params Data to be added to the querystring
     */

  }, {
    key: "post",
    value: function post(path, payload, params) {
      // console.group( `${this.instance.baseURL}/${path}` );
      return this.instance.post(path, payload, {
        params: params
      }).finally(function () {// console.groupEnd( `${this.instance.baseURL}/${path}` );
      });
    }
    /**
     * @preserve
     * Sends a PUT request to our API server to the resource
     * at the given path.
     * @param {string} path The relative path to the resource
     * @param {*} payload Any data to send as a part of the request
     * @param {*} params Data to be added to the querystring
     */

  }, {
    key: "put",
    value: function put(path, payload, params) {
      // console.group( `${this.instance.baseURL}/${path}` );
      return this.instance.put(path, payload, {
        params: params
      }).finally(function () {// console.groupEnd( `${this.instance.baseURL}/${path}` );
      });
    }
    /**
     * @preserve
     * Sends a DELETE request to our API server to the resource
     * at the given path.
     * @param {string} path The relative path to the resource
     * @param {*} params Data to be added to the querystring
     */

  }, {
    key: "delete",
    value: function _delete(path, params) {
      return this.instance.delete(path, {
        params: params
      });
    }
    /**
     * @preserve
     * Create the baseUrl that we'll use for all axios requests.
     * @param {*} resourcePath The sub-path for the resource (e.g. forms/)
     */

  }], [{
    key: "_createBaseUrl",
    value: function _createBaseUrl(resourcePath) {
      var result = "/";

      if (result.slice(-1) !== "/") {
        result += "/";
      }

      if (resourcePath) {
        // Strip out a trailing slash if given,
        // we'll provide our own to be consistent.
        var trimmedResourcePath = resourcePath.replace(/\/$/, "");
        result += "".concat(trimmedResourcePath, "/");
      }

      return result;
    }
  }]);

  return HttpService;
}();

_defineProperty(HttpService$1, "_normaliseHeaders", function (headers) {
  return Object.fromEntries(Object.entries(headers).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    return [k.toLowerCase(), v];
  }));
});

_defineProperty(HttpService$1, "_spiritApiErrorResponseInterceptor", function (response) {
  var result = response; // console.table( response.headers );

  var headers = HttpService$1._normaliseHeaders(response.headers);

  var isSpiritError = headers["is-error"];

  if (isSpiritError) {
    // console.group( "_spiritApiErrorResponseInterceptor (Happens to all API calls)" );
    var _HttpService$_extract = HttpService$1._extractSpiritApiError(response, headers),
        _HttpService$_extract2 = _slicedToArray(_HttpService$_extract, 1),
        error = _HttpService$_extract2[0]; // console.groupEnd();


    if (error) {
      result = Promise.reject(error);
    }
  }

  return result;
});

_defineProperty(HttpService$1, "_handleErrors", function (error) {
  // console.group( "_handleErrors (Axios reported this error)" );
  var result;

  var headers = HttpService$1._normaliseHeaders(error.response.config.headers);

  var _HttpService$_extract3 = HttpService$1._extractSpiritApiError(error.response, headers, true),
      _HttpService$_extract4 = _slicedToArray(_HttpService$_extract3, 2),
      spiritApiError = _HttpService$_extract4[0],
      message = _HttpService$_extract4[1];

  if (spiritApiError) {
    result = spiritApiError;
  } else {
    result = error;
    result.message = message;
  } // console.groupEnd();


  return Promise.reject(result);
});

_defineProperty(HttpService$1, "_extractSpiritApiError", function (response, headers) {
  var _response$data, _response$response;

  var isError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isSpiritError = headers["is-error"],
      responseMessage = headers["response-message"],
      responseCode = headers["response-code"]; // console.group( "_extractSpiritApiError" );

  var error;
  var message = responseMessage || "Something has gone wrong, please try again later.";
  var responseData = (_response$data = response.data) !== null && _response$data !== void 0 ? _response$data : (_response$response = response.response) === null || _response$response === void 0 ? void 0 : _response$response.data;

  if (isSpiritError) {
    error = new SpiritApiError(message, Number.parseInt(responseCode, 10), responseData);
  }

  if (!isError) {
    message = undefined;
  } // console.groupEnd();


  return [error, message];
});

var api = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SpiritApiError: SpiritApiError,
  HttpService: HttpService$1,
  'default': HttpService$1
});

function renderPrice$1(price, currency, locale) {
  var config = {
    style: "currency",
    currency: currency
  };
  var number = new Intl.NumberFormat(locale, config);
  return number.format(price || 0);
}
function createAlias$1(text) {
  var result;

  if (text.length > 0) {
    result = text; // Convert string to title case

    result = result.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }); // Remove all whitespace and non-alphanumeric characters

    result = result.replace(/[^0-9a-z]/gi, ""); // Convert first character to lower case

    result = result.charAt(0).toLowerCase() + result.slice(1);
  }

  return result;
}

var ecommerce = /*#__PURE__*/Object.freeze({
  __proto__: null,
  renderPrice: renderPrice$1,
  createAlias: createAlias$1
});

// import { library, config } from "@fortawesome/fontawesome-svg-core";
// import {
//  faTimes as falTimes,
//  faEnvelope,
//  faUsers,
//  faLock,
// } from "@fortawesome/pro-light-svg-icons";
// import {
//  faCaretUp,
//  faCaretDown,
//  faSpinner,
//  faCheck,
//  faExclamationCircle,
//  faChevronLeft,
//  faTrash,
//  faPlus,
//  faPlusSquare as fasPlusSquare,
//  faPencil,
//  faCheckCircle as fasCheckCircle,
//  faSyncAlt,
//  faEdit,
//  faEye,
//  faUserCog,
//  faUsersCog,
//  faKey,
//  faExternalLinkAlt,
// } from "@fortawesome/pro-solid-svg-icons";
// import {
//  faPlusSquare as farPlusSquare,
//  faCheckCircle as farCheckCircle,
//  faTrashAlt as farTrashAlt,
// } from "@fortawesome/pro-regular-svg-icons";
// config.autoReplaceSvg = false;
// config.observeMutations = false;
// // Light
// library.add( faEnvelope );
// library.add( faUsers );
// library.add( falTimes );
// library.add( faLock );
// // Solid
// library.add( faCaretUp );
// library.add( faCaretDown );
// library.add( faSpinner );
// library.add( faCheck );
// library.add( faExclamationCircle );
// library.add( faChevronLeft );
// library.add( faTrash );
// library.add( faPlus );
// library.add( fasPlusSquare );
// library.add( farPlusSquare );
// library.add( faPencil );
// library.add( faSyncAlt );
// library.add( faEdit );
// library.add( faEye );
// library.add( faUserCog );
// library.add( faUsersCog );
// library.add( faKey );
// library.add( faExternalLinkAlt );
// // Regular
// library.add( farCheckCircle );
// library.add( fasCheckCircle );
// library.add( farTrashAlt );
var fontAwesome = {};

var fontAwesome$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': fontAwesome
});

function diff$1(original, updated) {
  if (!updated || Object.prototype.toString.call(updated) !== "[object Object]") {
    return original;
  }

  if (!original || Object.prototype.toString.call(original) !== "[object Object]") {
    return updated;
  }

  var diffs = {};
  Object.keys(original).forEach(function (key) {
    if (original[key] !== updated[key]) {
      if (Array.isArray(original[key])) {
        if (original[key].toString() !== updated[key].toString()) {
          diffs[key] = updated[key];
        }
      } else if (_typeof(original[key]) === "object") {
        var oResult = diff$1(original[key], updated[key]);

        if (oResult && Object.keys(oResult).length > 0) {
          diffs[key] = oResult;
        }
      } else {
        diffs[key] = updated[key];
      }
    }
  });
  return diffs;
}

var objectUtilities = /*#__PURE__*/Object.freeze({
  __proto__: null,
  diff: diff$1
});

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$7(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var gtagPlugin = {
  initialized: false,
  currentBasketId: null,
  products: null,
  useUaAnalytics: false,
  onEvent: function onEvent(data) {
    // console.log( "gtag event", data );
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  },
  onAddToBasket: function () {
    var _onAddToBasket = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(products) {
      var productData, response, mapped, eventData;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.loadBasketEventData(true);

            case 2:
              if (!(products && products.length > 0)) {
                _context.next = 8;
                break;
              }

              productData = products.map(function (p) {
                return {
                  Id: p.id,
                  Price: p.price,
                  Quantity: p.quantity
                };
              });
              _context.next = 6;
              return getEventData(productData);

            case 6:
              response = _context.sent;

              if (response && response.data) {
                mapped = response.data.map(this.parseAdditionalData);
                this.onEvent({
                  ecommerce: null
                }); // Clear the previous ecommerce object

                if (this.useUaAnalytics === "true") {
                  eventData = {
                    event: "addToCart",
                    ecommerce: {
                      currencyCode: "GBP",
                      // TODO: Might need to be config
                      add: {
                        products: mapped
                      }
                    }
                  };
                } else {
                  eventData = {
                    event: "add_to_cart",
                    ecommerce: {
                      currency: "GBP",
                      // TODO: Might need to be config
                      add: {
                        products: mapped
                      }
                    }
                  };
                }

                this.onEvent(eventData);
              }

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function onAddToBasket(_x) {
      return _onAddToBasket.apply(this, arguments);
    }

    return onAddToBasket;
  }(),
  onRemoveFromBasket: function () {
    var _onRemoveFromBasket = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(productIds) {
      var productsToRemove, eventData;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (this.products) {
                _context2.next = 3;
                break;
              }

              _context2.next = 3;
              return this.loadBasketEventData(true);

            case 3:
              productsToRemove = this.products.filter(function (p) {
                return productIds.findIndex(function (a) {
                  return a === p.id;
                }) !== -1;
              });
              this.products = this.products.filter(function (p) {
                return productIds.findIndex(function (a) {
                  return a === p.id;
                }) === -1;
              });
              this.onEvent({
                ecommerce: null
              }); // Clear the previous ecommerce object

              if (this.useUaAnalytics === "true") {
                eventData = {
                  event: "removeFromCart",
                  ecommerce: {
                    remove: {
                      products: productsToRemove
                    }
                  }
                };
              } else {
                eventData = {
                  event: "remove_from_cart",
                  ecommerce: {
                    remove: {
                      products: productsToRemove
                    }
                  }
                };
              }

              this.onEvent(eventData);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function onRemoveFromBasket(_x2) {
      return _onRemoveFromBasket.apply(this, arguments);
    }

    return onRemoveFromBasket;
  }(),
  onCheckoutStep: function () {
    var _onCheckoutStep = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(step) {
      var eventData;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.loadBasketEventData();

            case 2:
              eventData = {
                event: "checkout",
                ecommerce: {
                  checkout: {
                    actionField: {
                      step: step
                    },
                    products: this.products
                  }
                }
              };
              this.onEvent({
                ecommerce: null
              }); // Clear the previous ecommerce object

              this.onEvent(eventData);

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function onCheckoutStep(_x3) {
      return _onCheckoutStep.apply(this, arguments);
    }

    return onCheckoutStep;
  }(),
  loadBasketEventData: function () {
    var _loadBasketEventData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(forceLoad) {
      var getCookie, basketId, response;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              getCookie = function getCookie(name) {
                return document.cookie.split("; ").reduce(function (r, v) {
                  var parts = v.split("=");
                  return parts[0] === name ? decodeURIComponent(parts[2]) : r;
                }, "");
              };

              basketId = getCookie("sw-basket-id");

              if (!this.products) {
                this.products = [];
              }

              if (!(!this.currentBasketId || this.currentBasketId !== basketId || forceLoad)) {
                _context4.next = 8;
                break;
              }

              _context4.next = 6;
              return getBasketEventData();

            case 6:
              response = _context4.sent;

              if (response && response.data) {
                this.currentBasketId = basketId;
                this.products = response.data.map(this.parseAdditionalData);
              }

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function loadBasketEventData(_x4) {
      return _loadBasketEventData.apply(this, arguments);
    }

    return loadBasketEventData;
  }(),
  parseAdditionalData: function parseAdditionalData(input) {
    var result = input;

    if (input.additionalData) {
      result = _objectSpread$7({}, result, {}, input.additionalData);
    }

    result.additionalData = undefined;
    return result;
  },
  install: function install(Vue) {
    if (!this.initialized) {
      var uaAnalyticElement = document.querySelector("meta[name=\"useua\"]");

      if (uaAnalyticElement) {
        this.useUaAnalytics = uaAnalyticElement.getAttribute("content");
      }

      Vue.prototype.$gtag = this;
      this.initialized = true;
    }
  }
};

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$8(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var environment$1 = document.querySelector("meta[name=\"environment\"]").getAttribute("content");

var _captureException = function captureException(error) {
  return _captureException();
};

var _setContext = function setContext$1(name, data) {
  return setContext(name, data);
};
var addBreadcrumb = function addBreadcrumb(category, message, severity) {
  var sev;

  switch (severity) {
    case "debug":
      sev = Severity.Debug;
      break;

    case "info":
      sev = Severity.Info;
      break;

    case "warning":
      sev = Severity.Warning;
      break;

    case "error":
      sev = Severity.Error;
      break;

    case "fatal":
      sev = Severity.Fatal;
      break;

    default:
      sev = Severity.Info;
      break;
  }

  addBreadcrumb$1({
    category: category,
    message: message,
    level: sev
  });
};

function getSampleRate() {
  var result;

  switch (environment$1.toLowerCase().trim()) {
    case "live":
      result = 0.05;
      break;

    case "staging":
    case "dev":
      result = 1.0;
      break;

    default:
      result = 1.0;
      break;
  }

  return result;
}
/**
 */


var logPlugin = {
  /**
   * @preserve
   * @param {object} Vue Vue instance
   *
   */
  install: function install(Vue$1) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        sentry = _ref.sentry;

    if (!sentry) {
      if (environment$1 !== "Live") {
        console.warn("sentry config not provided to the plugin");
      }
    } else if (environment$1 !== "Local") {
      init(_objectSpread$8({
        Vue: Vue$1,
        environment: environment$1,
        integrations: [new Integrations.BrowserTracing(), new Vue({
          Vue: Vue$1,
          attachProps: true,
          logErrors: true,
          tracing: true,
          tracingOptions: {
            trackComponents: true
          }
        })],
        denyUrls: [// Facebook flakiness
        /graph\.facebook\.com/i, // Facebook blocked
        /connect\.facebook\.net\/en_US\/all\.js/i, // Woopra flakiness
        /eatdifferent\.com\.woopra-ns\.com/i, /static\.woopra\.com\/js\/woopra\.js/i, // Chrome extensions
        /extensions\//i, /^chrome:\/\//i, // Other plugins
        /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
        /webappstoolbarba\.texthelp\.com\//i, /metrics\.itunes\.apple\.com\.edgesuite\.net\//i],
        tracesSampleRate: getSampleRate()
      }, sentry)); // eslint-disable-next-line no-param-reassign

      Vue$1.prototype.$logger = {
        setContext: function setContext(name, data) {
          return _setContext(name, data);
        },
        captureException: function captureException(error) {
          return _captureException();
        }
      }; // eslint-disable-next-line no-param-reassign

      Vue$1.prototype.$logger.breadcrumbs = {
        error: function error(category, message) {
          return addBreadcrumb(category, message, "error");
        },
        info: function info(category, message) {
          return addBreadcrumb(category, message, "info");
        },
        fatal: function fatal(category, message) {
          return addBreadcrumb(category, message, "fatal");
        },
        debug: function debug(category, message) {
          return addBreadcrumb(category, message, "debug");
        },
        warning: function warning(category, message) {
          return addBreadcrumb(category, message, "warning");
        }
      };
    }
  }
};

var instance$a = new HttpService("umbraco/api/Basket/");
/* eslint-disable arrow-body-style */

/**
 * Add a product to the basket.
 * @param {*} productId The product identifier.
 * @param {*} quantity An optional quantity.
 * @param {*} options Optional paramaters.
 */

var addProduct$1 = function addProduct(productId, quantity, options) {
  var endpoint = "AddProductByCode";
  var isGuid = false;
  var guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  if ("".concat(productId).match(guidPattern)) {
    isGuid = true;
  }

  var isInt = Number.isInteger(Number.parseInt(productId, 10));

  if (isGuid) {
    endpoint = "AddProductByGuid";
  } else if (isInt) {
    endpoint = "AddProductByIntId";
  }

  return instance$a.post(endpoint, options, {
    productId: productId,
    quantity: quantity
  });
};
/**
 * Add multiple products to the basket.
 * @param {*} products The list of products to add.
 */

var bulkAddProducts$1 = function bulkAddProducts(products) {
  var endPoint = "BulkAddProductsByCode";
  var isGuid = false;
  var guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  if (products && products.length > 0) {
    var firstId = products[0].id;

    if ("".concat(firstId).match(guidPattern)) {
      isGuid = true;
    }

    var isInt = Number.isInteger(Number.parseInt(firstId, 10));

    if (isGuid) {
      endPoint = "BulkAddProductsByGuid";
    } else if (isInt) {
      endPoint = "BulkAddProductsByInt";
    }
  }

  return instance$a.post(endPoint, products);
};
/**
 * Updates the quantity by a specified amount.
 * @param {*} orderLineId The order line to update.
 * @param {*} amount The amount by which you alter the quantity.
 */

var updateQuantityBy = function updateQuantityBy(orderLineId, amount) {
  return instance$a.put("UpdateQuantityBy", null, {
    orderLineId: orderLineId,
    amount: amount
  });
};
/**
 * Sets the quantity to a specified amount.
 * @param {*} orderLineId The order line to update.
 * @param {*} quantity The new quantity to set.
 */

var setQuantity$1 = function setQuantity(orderLineId, quantity) {
  return instance$a.put("SetQuantity", null, {
    orderLineId: orderLineId,
    quantity: quantity
  });
};
/**
 * Lists the items in basket.
 * @param {*} includeCarriage Whether to include carriage lines or not
 */

var listItems$1 = function listItems() {
  var includeCarriage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return instance$a.get("ListItemsInBasket?includeCarriage=".concat(includeCarriage));
};
/**
 * Get a list of basket itens and basket configuration data
 * @param {Boolean} includeCarriage Whether to include carriage lines or not
 */

var listItemsEx$1 = function listItemsEx() {
  var includeCarriage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return instance$a.get("ListItemsInBasketEx", {
    includeCarriage: includeCarriage
  });
};
/**
 * Get the basket order header ID.
 */

var getId = function getId() {
  return instance$a.get("GetBasketId");
};
/**
 * Get the basket item count.
 */

var getItemCount$1 = function getItemCount() {
  return instance$a.get("GetItemCount");
};
/**
 * Removes an order line from the basket.
 * @param {*} orderLineId The order line to remove.
 */

var removeItem$1 = function removeItem(orderLineId) {
  return instance$a.delete("RemoveItem", {
    orderLineId: orderLineId
  });
};
/**
 * Removes a product from the basket.
 * @param {*} productId The order line to remove.
 */

var removeProduct = function removeProduct(productId) {
  return instance$a.delete("RemoveProduct", {
    productId: productId
  });
};
/**
 * Removes all products from the basket.
 */

var clearBasket$1 = function clearBasket() {
  return instance$a.delete("EmptyBasket");
};
/**
 * Applies the given voucher code to the basket
 * @param {string} voucherCode The voucher code to apply
 * @param {bool} removeExistingVouchers Should we remove existing vouchers?
 */

var applyVoucher$1 = function applyVoucher(voucherCode) {
  var removeExistingVouchers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return instance$a.post("ApplyVoucher", null, {
    voucherCode: voucherCode,
    removeExistingVouchers: removeExistingVouchers
  });
};
/**
 * Gets the voucher codes applied to the basker.
 */

var getVoucher$1 = function getVoucher() {
  return instance$a.get("GetVoucher");
};
/**
 * Removes a voucher code from the basket.
 * @param {string} code The voucher code to remove
 */

var removeVoucher$1 = function removeVoucher(code) {
  return instance$a.delete("RemoveVoucher", {
    code: code
  });
};
/**
 * get the total cost of the basket
 * @param {bool} includeVat
 */

var getBasketTotalCost = function getBasketTotalCost(includeVat) {
  return instance$a.get("GetBasketTotalCost", {
    includeVat: includeVat
  });
};
/**
 * Check to see if the basket contains any items that require stock
 */

var hasStockItems = function hasStockItems() {
  return instance$a.get("HasStockItems");
};
/**
 * Check to see if the basket has been submitted
 */

var hasBeenSubmitted = function hasBeenSubmitted() {
  return instance$a.get("HasBeenSubmitted");
};
/**
 * Load data needed to use the alternate delivery address for basket lines
 * @param {Number} productId The product ID we want to link a delivery address to
 * @param {Array} orderLines A list of current order lines in the basket, saves having to
 *                            load them each time the modal is displayed which greatly speeds
 *                            things up
 */

var getDeliveryAddressSetup$1 = function getDeliveryAddressSetup(productId, orderLines) {
  return instance$a.post("LoadDeliveryAddressSetup", orderLines, {
    productId: productId
  });
};
/**
 * Update an existing order lines delivery address
 * @param {Object} lineAddress Address aetails to save against the order line, contains:
 *
 * {
 *  addressId: <the id of the address linked to the order line>
 *  orgId: the id of the org linked to the order line
 *  orderLineId: the id of the order line
 *  addNew: If this is true then we will split the order line and create a new
 *          order line for the new address instead of updating the existing order line
 *  newAddress: If this populated and the addressId is null then these details are used
 *              to create a new address first before updating the order line
 * }
 */

var updateLineDeliveryAddress$1 = function updateLineDeliveryAddress(lineAddress) {
  return instance$a.post("UpdateLineDeliveryAddress", lineAddress);
};
/**
 * Update all lines in the basket that do not have a delivery address to have a default
 * delivery organisation and address
 * @param {string} orgId The ID of the organisation to set against all order lines
 * @param {string} addressId The ID of the organisations address to set against all order lines
 */

var setDefaultLineDeliveryAddress$1 = function setDefaultLineDeliveryAddress(orgId, addressId) {
  return instance$a.post("SetDefaultLineDeliveryAddress", {
    orgId: orgId,
    addressId: addressId
  });
};
/**
 * Load a list of delivery addresses to use for order lines when sending different order lines
 * to different delivery addresses
 */

var loadOrderLineAddresses$1 = function loadOrderLineAddresses() {
  return instance$a.post("LoadOrderLineAddresses");
};
/**
 * Update an existing order line with a delivery person
 * @param {Object} linePerson Person details to save against the order line
 */

var updateLineDeliveryPerson$1 = function updateLineDeliveryPerson(linePerson) {
  return instance$a.post("UpdateLineDeliveryPerson", linePerson);
};
var removeLineDeliveryPerson$1 = function removeLineDeliveryPerson(orderLineId) {
  return instance$a.post("RemoveLineDeliveryPerson", null, {
    orderLineId: orderLineId
  });
};
/**
 * Load a person details in a format that can be edited in an order line
 * @param {String} personId The ID of the person to load
 */

var loadOrderLineDeliveryPerson$1 = function loadOrderLineDeliveryPerson(personId) {
  return instance$a.get("LoadOrderLineDeliveryPerson", {
    personId: personId
  });
};

var basketResource = /*#__PURE__*/Object.freeze({
  __proto__: null,
  addProduct: addProduct$1,
  bulkAddProducts: bulkAddProducts$1,
  updateQuantityBy: updateQuantityBy,
  setQuantity: setQuantity$1,
  listItems: listItems$1,
  listItemsEx: listItemsEx$1,
  getId: getId,
  getItemCount: getItemCount$1,
  removeItem: removeItem$1,
  removeProduct: removeProduct,
  clearBasket: clearBasket$1,
  applyVoucher: applyVoucher$1,
  getVoucher: getVoucher$1,
  removeVoucher: removeVoucher$1,
  getBasketTotalCost: getBasketTotalCost,
  hasStockItems: hasStockItems,
  hasBeenSubmitted: hasBeenSubmitted,
  getDeliveryAddressSetup: getDeliveryAddressSetup$1,
  updateLineDeliveryAddress: updateLineDeliveryAddress$1,
  setDefaultLineDeliveryAddress: setDefaultLineDeliveryAddress$1,
  loadOrderLineAddresses: loadOrderLineAddresses$1,
  updateLineDeliveryPerson: updateLineDeliveryPerson$1,
  removeLineDeliveryPerson: removeLineDeliveryPerson$1,
  loadOrderLineDeliveryPerson: loadOrderLineDeliveryPerson$1
});

var instance$b = new HttpService("umbraco/api/BasketStep/");
var getBasketProducts = function getBasketProducts() {
  return instance$b.get("GetBasketProducts");
};
var validateOrder$1 = function validateOrder() {
  return instance$b.get("ValidateOrder");
};
var validateAddresses$1 = function validateAddresses() {
  return instance$b.get("ValidateAddresses");
};
var basketHasOrderLines$1 = function basketHasOrderLines() {
  return instance$b.get("BasketHasOrderLines");
};
/**
 * Load data needed for the Multi Carriage step when checking out a basket
 */

var loadMultiCarriageStep$1 = function loadMultiCarriageStep() {
  return instance$b.get("LoadMultiCarriageStep");
};
/**
 * Apply a list of multi-ship carriage items to the current basket
 * @param {Array} carriageItems array of carriage IDs and address ID
 */

var applyMultiCarriage$1 = function applyMultiCarriage(carriageItems) {
  return instance$b.post("ApplyMultiCarriage", carriageItems);
};
/**
 * Load data needed for the Address Step when checking out a basket
 */

var loadAddressStep$1 = function loadAddressStep() {
  return instance$b.get("LoadAddressStep");
};
/**
 * Update the basket with the supplied invoice and delivery address
 * @param {GUID} invoiceAddressId The ID of the Invoice Address
 * @param {GUID} deliveryAddressId The ID of the delivery address
 * @param {int} carriageId The ID of the carriage item to apply to the basket
 * @param {boolean} returnCarriage If true then return a list of carriage items that
 * are compatible with the order now that it has a delivery address
 * @param {boolean} allCarriageItems If true and "returnCarriage" is true then just return
 * all carriage items no matter that the delivery address
 * @param {GUID} deliveryPersonId The ID of the delivery person to use
 * @param {GUID} invociePersonId The ID of the invoice person to use
 */

var updateAddressAndCarriage$1 = function updateAddressAndCarriage(invoiceAddressId, deliveryAddressId, carriageId, returnCarriage, allCarriageItems, deliveryPersonId, invoicePersonId) {
  return instance$b.post("UpdateAddressAndCarriage", null, {
    invoiceAddressId: invoiceAddressId,
    deliveryAddressId: deliveryAddressId,
    carriageId: carriageId,
    returnCarriage: returnCarriage,
    allCarriageItems: allCarriageItems,
    deliveryPersonId: deliveryPersonId,
    invoicePersonId: invoicePersonId
  });
};
/**
 * Blank address
*/

var blankAddress$1 = function blankAddress() {
  return {
    addressId: null,
    sopAddressId: null,
    orgId: null,
    orgTypeId: null,
    addressType: null,
    orgName: null,
    line1: null,
    line2: null,
    line3: null,
    town: null,
    region: null,
    poastcode: null,
    countryId: null
  };
};
var savePerson$1 = function savePerson(person) {
  return instance$b.post("SavePerson", person);
};

var basketStepResource = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getBasketProducts: getBasketProducts,
  validateOrder: validateOrder$1,
  validateAddresses: validateAddresses$1,
  basketHasOrderLines: basketHasOrderLines$1,
  loadMultiCarriageStep: loadMultiCarriageStep$1,
  applyMultiCarriage: applyMultiCarriage$1,
  loadAddressStep: loadAddressStep$1,
  updateAddressAndCarriage: updateAddressAndCarriage$1,
  blankAddress: blankAddress$1,
  savePerson: savePerson$1
});

var instance$c = new HttpService("umbraco/api/Checkout/");
var getSubmittedOrderReference$1 = function getSubmittedOrderReference() {
  return instance$c.get("GetSubmittedOrderReference");
};

var checkoutResource = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getSubmittedOrderReference: getSubmittedOrderReference$1
});

var instance$d = new HttpService("umbraco/api/ConfirmationStep/");
var getConfirmedOrder$1 = function getConfirmedOrder() {
  return instance$d.get("GetConfirmedOrder");
};

var confirmationStepResource = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getConfirmedOrder: getConfirmedOrder$1
});

var instance$e = new HttpService("umbraco/api/Events/");
var basketStepInstance$1 = new HttpService("umbraco/api/BasketStep/");
var getInstance = function getInstance(instanceId, pricingScheduleId) {
  return instance$e.get("GetInstance", {
    instanceId: instanceId,
    pricingScheduleId: pricingScheduleId
  });
};
var listBookings = function listBookings(orderHeaderId) {
  return instance$e.get("ListBookings", {
    orderHeaderId: orderHeaderId
  });
};
var validateBookings$1 = function validateBookings() {
  return basketStepInstance$1.get("ValidateBookings");
};

var eventsResource = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getInstance: getInstance,
  listBookings: listBookings,
  validateBookings: validateBookings$1
});

var instance$f = new HttpService("umbraco/api/Gtag/");
var getBasketEventData$1 = function getBasketEventData() {
  return instance$f.get("GetBasketEventData");
};
var getEventData$1 = function getEventData(productData) {
  return instance$f.post("GetEventData", productData);
};

var gtagResource = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getBasketEventData: getBasketEventData$1,
  getEventData: getEventData$1
});

var instance$g = new HttpService("umbraco/api/Basket/");
var listItemsInBasket$1 = function listItemsInBasket() {
  return instance$g.get("ListItemsInBasket");
};
var getMetadataForBasketItems$1 = function getMetadataForBasketItems() {
  return instance$g.get("GetMetadataForBasketItems");
};
var saveOrderLineMetadata$1 = function saveOrderLineMetadata(orderLineId, metadata) {
  return instance$g.put("SaveOrderLineMetadata", metadata, {
    orderLineId: orderLineId
  });
};

var metadataStepResource = /*#__PURE__*/Object.freeze({
  __proto__: null,
  listItemsInBasket: listItemsInBasket$1,
  getMetadataForBasketItems: getMetadataForBasketItems$1,
  saveOrderLineMetadata: saveOrderLineMetadata$1
});

var instance$h = new HttpService("umbraco/api/OrdersApi");
/* eslint-disable arrow-body-style */

/* eslint-disable object-shorthand */

/**
 * Get the order history for the current logged in user
 */

var loadOrderHistory$1 = function loadOrderHistory() {
  return instance$h.get("LoadOrderHistory");
};
/**
 * Get order header data
 * @param {string} orderId The order header id
 */

var getOrderHeader$1 = function getOrderHeader(orderId) {
  return instance$h.get("LoadOrderRefundSummary?orderHeaderId=".concat(orderId));
};
/**
 * Get the order line summary data
 * @param {string} orderId The order header id
 * @param {string} creditOrderId The order header id
 * @param {string} creditOrderLineId The order line id
 */

var getRefundOrderLine$1 = function getRefundOrderLine(orderId, creditOrderId, creditOrderLineId) {
  return instance$h.get("LoadOrderLineRefundSummary?orderId=".concat(orderId, "&creditOrderId=").concat(creditOrderId, "&creditOrderLineId=").concat(creditOrderLineId));
};
/**
 * Post submit order refund data
 * @param {string} orderHeader The order header
 */

var submitRefund$1 = function submitRefund(orderHeader) {
  return instance$h.post("SubmitRefund", orderHeader);
};
/**
 * Post cancel refund order line
 * @param {string} creditOrderId The order header id
 * @param {string} creditOrderLineId The order line id
 */

var cancelRefundOrderLine$1 = function cancelRefundOrderLine(creditOrderId, creditOrderLineId) {
  return instance$h.post("CancelRefundOrderLine?creditOrderId=".concat(creditOrderId, "&creditOrderLineId=").concat(creditOrderLineId));
};
/*
 * Order line transfer model helper
 */

var transferOrderLineModel = function transferOrderLineModel(id) {
  var bookingStatusCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : encodeURI(null);
  var transferAsCopy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    orderLineId: id,
    bookingStatusCode: bookingStatusCode,
    transferAsCopy: transferAsCopy
  };
};
/**
 * transfers order lines from one header to another (basket to basket)
 * @param {string} fromOrderHeaderId
 * @param {string} toOrderHeaderId
 * @param {Array<Object>} orderLineToTransfer
 */

var transferOrderLines = function transferOrderLines(fromOrderHeaderId, toOrderHeaderId, orderLinesToTransfer) {
  return instance$h.post("TransferOrderLines", orderLinesToTransfer, {
    fromOrderHeaderId: fromOrderHeaderId,
    toOrderHeaderId: toOrderHeaderId
  });
};

var ordersResource = /*#__PURE__*/Object.freeze({
  __proto__: null,
  loadOrderHistory: loadOrderHistory$1,
  getOrderHeader: getOrderHeader$1,
  getRefundOrderLine: getRefundOrderLine$1,
  submitRefund: submitRefund$1,
  cancelRefundOrderLine: cancelRefundOrderLine$1,
  transferOrderLineModel: transferOrderLineModel,
  transferOrderLines: transferOrderLines
});

var instance$i = new HttpService("umbraco/surface/PaymentSurface/");
/* eslint-disable arrow-body-style */
// #region types

/** Card, invoice, direct debit, etc.
 * @typedef {Object} PaymentMethod
 * @property {string} paymentMethodId how the payment is handled in SPIRIT
 * @property {string} paymentMethodName the display name for the method
 * @property {boolean} allowed is this payment method allowed?
 * @property {string} notAllowedReason why isn't this allowed?
 * @property {string} systemCode how we should handle this payment
 */

/** Values required by the payment provider for a card payment
 * @typedef {Object} PaymentInformation
 * @property {string} actionUrl the url to be redirected to
 * @property {number} paymentType an enum that represents which card service to get info for
 * @property {Array<{name:string, value:string}>} paymentParameters
 * values used by the card provider
 */
// #endregion types

/** Make a payment using 1st party means such as invoice or direct debit
 * @param {string} poReference the user's reference for this payment
 * @param {string} paymentMethodId determines how the payment is processed
 * @param {string} orderHeaderId UUID, uses basketId if null
 * @returns {{data:boolean}} true if successful, wrapped in an Axios response
 */

var submitInternalPayment$1 = function submitInternalPayment(poReference, paymentMethodId, orderHeaderId) {
  return instance$i.post("SubmitInternalPayment", null, {
    poReference: poReference,
    paymentMethodId: paymentMethodId,
    orderHeaderId: orderHeaderId
  });
};
/** Gets the data required by the configured card vender
 * @param {string} orderHeaderId UUID, uses basketId if null
 * @returns {{data:Array<PaymentMethod>}} an array of payment methods
 */

var getCardPaymentInfo = function getCardPaymentInfo() {
  var orderHeaderId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return instance$i.get("GetPaymentInformation", {
    orderHeaderId: orderHeaderId
  });
};
/** Lists all available payment methods
 * @param {string} orderHeaderId UUID, uses basketId if null
 * @returns {{data:Array<PaymentMethod>}} an array of payment methods
 */

var listPaymentMethods$1 = function listPaymentMethods() {
  var orderHeaderId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return instance$i.get("ListPaymentMethods", {
    orderHeaderId: orderHeaderId
  });
};
/**
 * Log that an external payment is starting
 * @param {string} paymentMethodId (Optional) The payment method id
 * @param {string} orderHeaderId UUID, uses basketId if null
 */

var logExternalPaymentStart$1 = function logExternalPaymentStart() {
  var paymentMethodId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var orderHeaderId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  instance$i.post("LogExternalPaymentStart", null, {
    paymentMethodId: paymentMethodId,
    orderHeaderId: orderHeaderId
  });
};

var paymentResource = /*#__PURE__*/Object.freeze({
  __proto__: null,
  submitInternalPayment: submitInternalPayment$1,
  getCardPaymentInfo: getCardPaymentInfo,
  listPaymentMethods: listPaymentMethods$1,
  logExternalPaymentStart: logExternalPaymentStart$1
});

var instance$j = new HttpService("umbraco/api/PaymentStep/");
var submitPayment = function submitPayment(action, poReference) {
  return instance$j.post("".concat(action, "?poReference=").concat(poReference));
};
var orderReferenceRequired$1 = function orderReferenceRequired() {
  return instance$j.get("OrderReferenceRequired");
};

var paymentStepResource = /*#__PURE__*/Object.freeze({
  __proto__: null,
  submitPayment: submitPayment,
  orderReferenceRequired: orderReferenceRequired$1
});

var LibraryModule = {
  install: function install(Vue, config) {
    // Prevent installing multiple times
    if (this.install.installed) return;
    this.install.installed = true; // Register components with Vue

    Vue.component(__vue_component__.name, __vue_component__);
    Vue.component(__vue_component__$1.name, __vue_component__$1);
    Vue.component(__vue_component__$2.name, __vue_component__$2);
    Vue.component(__vue_component__$3.name, __vue_component__$3);
    Vue.component(__vue_component__$4.name, __vue_component__$4);
    Vue.component(__vue_component__$6.name, __vue_component__$6);
    Vue.component(__vue_component__$8.name, __vue_component__$8);
    Vue.component(__vue_component__$9.name, __vue_component__$9);
    Vue.component(__vue_component__$a.name, __vue_component__$a);
    Vue.component(__vue_component__$b.name, __vue_component__$b);
    Vue.component(__vue_component__$c.name, __vue_component__$c);
    Vue.component(__vue_component__$d.name, __vue_component__$d);
    Vue.component(__vue_component__$f.name, __vue_component__$f);
    Vue.component(__vue_component__$g.name, __vue_component__$g);
    Vue.component(__vue_component__$h.name, __vue_component__$h);
    Vue.component(__vue_component__$i.name, __vue_component__$i);
    Vue.component(__vue_component__$t.name, __vue_component__$t);
    Vue.component(__vue_component__$u.name, __vue_component__$u);
    Vue.component(__vue_component__$v.name, __vue_component__$v);
    Vue.component(__vue_component__$C.name, __vue_component__$C);
    Vue.component(__vue_component__$D.name, __vue_component__$D);
    Vue.component(__vue_component__$E.name, __vue_component__$E);
    Vue.component(__vue_component__$F.name, __vue_component__$F);
    Vue.component(__vue_component__$G.name, __vue_component__$G);
    Vue.component(__vue_component__$H.name, __vue_component__$H);
    Vue.component(__vue_component__$I.name, __vue_component__$I);
    Vue.component(__vue_component__$J.name, __vue_component__$J);
    Vue.component(__vue_component__$K.name, __vue_component__$K);
    Vue.component(__vue_component__$L.name, __vue_component__$L);
    Vue.component(__vue_component__$N.name, __vue_component__$N);
    Vue.component(__vue_component__$O.name, __vue_component__$O);
    Vue.component(__vue_component__$P.name, __vue_component__$P);
    Vue.component(__vue_component__$Q.name, __vue_component__$Q);
    Vue.component(__vue_component__$R.name, __vue_component__$R);
    Vue.component(__vue_component__$T.name, __vue_component__$T);
    Vue.component(__vue_component__$U.name, __vue_component__$U);
    Vue.component(__vue_component__$V.name, __vue_component__$V);
    Vue.component(__vue_component__$10.name, __vue_component__$10);
    Vue.component(__vue_component__$11.name, __vue_component__$11);
    Vue.component(__vue_component__$12.name, __vue_component__$12);
    Vue.component(__vue_component__$13.name, __vue_component__$13);
    Vue.component(__vue_component__$14.name, __vue_component__$14);
    Vue.component(__vue_component__$15.name, __vue_component__$15);
    Vue.component(__vue_component__$16.name, __vue_component__$16);
    Vue.component(__vue_component__$17.name, __vue_component__$17);
    Vue.component(__vue_component__$1a.name, __vue_component__$1a);
    Vue.component(__vue_component__$1b.name, __vue_component__$1b);
    Vue.component(__vue_component__$1c.name, __vue_component__$1c);
    Vue.component(__vue_component__$1e.name, __vue_component__$1e);
    Vue.component(__vue_component__$1g.name, __vue_component__$1g);
    Vue.component(__vue_component__$1h.name, __vue_component__$1h);
    Vue.component(__vue_component__$1i.name, __vue_component__$1i);
    Vue.component(__vue_component__$1j.name, __vue_component__$1j);
    Vue.component(__vue_component__$1k.name, __vue_component__$1k);
    Vue.component(__vue_component__$1l.name, __vue_component__$1l); // Register directives with Vue
    // Register plugins with Vue

    Vue.use(gtagPlugin, config);
    Vue.use(logPlugin, config); // Register mixins with Vue
  }
}; // Export library

export default LibraryModule;
export { __vue_component__ as AddToBasket, __vue_component__$17 as AddressCarriage, __vue_component__$Q as AddressDisplay, __vue_component__$R as AddressList, __vue_component__$T as AddressSelector, __vue_component__$1a as AddressStep, __vue_component__$U as AlternativePerson, api as ApiModule, __vue_component__$1 as ApplyVoucher, __vue_component__$2 as BaseBasket, __vue_component__$I as BaseCheckoutStep, __vue_component__$3 as BaseQuantity, __vue_component__$J as Basket, __vue_component__$4 as BasketItemQuantity, __vue_component__$6 as BasketOrderLineAddress, __vue_component__$8 as BasketQuantity, basketResource as BasketResource, __vue_component__$1b as BasketStep, basketStepResource as BasketStepResource, __vue_component__$11 as CheckboxField, __vue_component__$12 as CheckboxListField, __vue_component__$K as Checkout, __vue_component__$L as CheckoutProgress, checkoutResource as CheckoutResource, __vue_component__$1c as ConfirmationStep, confirmationStepResource as ConfirmationStepResource, __vue_component__$9 as ConvertToBasket, __vue_component__$13 as CurrencyField, __vue_component__$a as DebugPanel, __vue_component__$b as DeleteAllOrderLines, __vue_component__$c as DeleteOrderLine, __vue_component__$1k as DownloadCsv, __vue_component__$1l as DownloadItem, __vue_component__$14 as DropdownField, ecommerce as EcommerceModule, __vue_component__$d as ErrorBoundary, eventsResource as EventsResource, fontAwesome$1 as FontAwesomeModule, gtagPlugin as GtagPlugin, gtagResource as GtagResource, logPlugin as LogPlugin, __vue_component__$10 as MetadataPage, __vue_component__$1e as MetadataStep, metadataStepResource as MetadataStepResource, __vue_component__$1g as MultiCarriageStep, objectUtilities as ObjectUtilitiesModule, __vue_component__$C as OrderHistory, __vue_component__$D as OrderItem, __vue_component__$E as OrderItemProduct, __vue_component__$f as OrderLineQuantity, __vue_component__$F as OrderLineRefundModal, __vue_component__$G as OrderRefundsModal, __vue_component__$H as OrderTable, __vue_component__$g as OrderTotals, ordersResource as OrdersResource, paymentResource as PaymentResource, __vue_component__$1h as PaymentStep, paymentStepResource as PaymentStepResource, __vue_component__$V as Postage, __vue_component__$h as PricingBandsTable, __vue_component__$i as SaveAsWishlist, __vue_component__$1i as SimpleAddressStep, __vue_component__$t as SimpleBasket, __vue_component__$u as SimpleBasketOrderLine, __vue_component__$v as SimpleBasketOrderLinesList, __vue_component__$N as StackedStep, __vue_component__$O as StepStatus, __vue_component__$P as TabbedStep, __vue_component__$15 as TextareaField, __vue_component__$16 as TextboxField, __vue_component__$1j as YourDetailsStep };
